(() => {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire30f5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire30f5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6RNdh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4ffdde0480e6966f$export$2e2bcd8739ae039);

var $1urVZ = parcelRequire("1urVZ");
const $4ffdde0480e6966f$var$props = {
    animation: {
        twoWay: true,
        type: Number
    },
    attribution: {
        type: Object
    },
    clickable: {
        type: Boolean,
        twoWay: true,
        default: true
    },
    cursor: {
        type: String,
        twoWay: true
    },
    draggable: {
        type: Boolean,
        twoWay: true,
        default: false
    },
    icon: {
        twoWay: true
    },
    label: {},
    opacity: {
        type: Number,
        default: 1
    },
    options: {
        type: Object
    },
    place: {
        type: Object
    },
    position: {
        type: Object,
        twoWay: true
    },
    shape: {
        type: Object,
        twoWay: true
    },
    title: {
        type: String,
        twoWay: true
    },
    zIndex: {
        type: Number,
        twoWay: true
    },
    visible: {
        twoWay: true,
        default: true
    }
};
const $4ffdde0480e6966f$var$events = [
    "click",
    "rightclick",
    "dblclick",
    "drag",
    "dragstart",
    "dragend",
    "mouseup",
    "mousedown",
    "mouseover",
    "mouseout"
];
var $4ffdde0480e6966f$export$2e2bcd8739ae039 = (0, $1urVZ.default)({
    mappedProps: $4ffdde0480e6966f$var$props,
    events: $4ffdde0480e6966f$var$events,
    name: "marker",
    ctr: ()=>google.maps.Marker,
    inject: {
        $clusterPromise: {
            default: null
        }
    },
    emits: $4ffdde0480e6966f$var$events,
    unmounted () {
        if (!this.$markerObject) return;
        if (this.$clusterObject) // Repaint will be performed in `updated()` of cluster
        this.$clusterObject.removeMarker(this.$markerObject, true);
        else this.$markerObject.setMap(null);
    },
    beforeCreate (options) {
        if (this.$clusterPromise) options.map = null;
        return this.$clusterPromise;
    },
    afterCreate (inst) {
        $4ffdde0480e6966f$var$events.forEach((event)=>{
            inst.addListener(event, (payload)=>{
                this.$emit(event, payload);
            });
        });
        if (this.$clusterPromise) this.$clusterPromise.then((co)=>{
            this.$clusterObject = co;
            co.addMarker(inst);
        });
    }
});

});
parcelRegister("1urVZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $115e42f4773b1eca$export$2e2bcd8739ae039);
$parcel$export(module.exports, "mappedPropsToVueProps", () => $115e42f4773b1eca$export$bd7b79bb25ad60be);

var $dNXnK = parcelRequire("dNXnK");

var $jWtid = parcelRequire("jWtid");

var $buWLO = parcelRequire("buWLO");
function $115e42f4773b1eca$export$2e2bcd8739ae039(options) {
    const { mappedProps: mappedProps, name: name, ctr: ctr, ctrArgs: ctrArgs, events: events, beforeCreate: beforeCreate, afterCreate: afterCreate, props: props, ...rest } = options;
    const promiseName = `$${name}Promise`;
    const instanceName = `$${name}Object`;
    $115e42f4773b1eca$var$assert(!(rest.props instanceof Array), "`props` should be an object, not Array");
    return {
        ...typeof GENERATE_DOC !== "undefined" ? {
            $vgmOptions: options
        } : {},
        mixins: [
            (0, $buWLO.default)
        ],
        props: {
            ...props,
            ...$115e42f4773b1eca$export$bd7b79bb25ad60be(mappedProps)
        },
        render () {
            return "";
        },
        provide () {
            const promise = this.$mapPromise.then((map)=>{
                // Infowindow needs this to be immediately available
                this.$map = map;
                // Initialize the maps with the given options
                const options = {
                    ...this.options,
                    map: map,
                    ...(0, $jWtid.getPropsValues)(this, mappedProps)
                };
                delete options.options // delete the extra options
                ;
                if (beforeCreate) {
                    const result = beforeCreate.bind(this)(options);
                    if (result instanceof Promise) return result.then(()=>({
                            options: options
                        }));
                }
                return {
                    options: options
                };
            }).then(({ options: options })=>{
                const ConstructorObject = ctr();
                // https://stackoverflow.com/questions/1606797/use-of-apply-with-new-operator-is-this-possible
                this[instanceName] = ctrArgs ? new (Function.prototype.bind.call(ConstructorObject, null, ...ctrArgs(options, (0, $jWtid.getPropsValues)(this, props || {}))))() : new ConstructorObject(options);
                (0, $jWtid.bindProps)(this, this[instanceName], mappedProps);
                (0, $dNXnK.default)(this, this[instanceName], events);
                if (afterCreate) afterCreate.bind(this)(this[instanceName]);
                return this[instanceName];
            });
            this[promiseName] = promise;
            return {
                [promiseName]: promise
            };
        },
        unmounted () {
            // Note: not all Google Maps components support maps
            if (this[instanceName] && this[instanceName].setMap) this[instanceName].setMap(null);
        },
        ...rest
    };
}
function $115e42f4773b1eca$var$assert(v, message) {
    if (!v) throw new Error(message);
}
function $115e42f4773b1eca$export$bd7b79bb25ad60be(mappedProps) {
    return Object.entries(mappedProps).map(([key, prop])=>{
        const value = {};
        if ("type" in prop) value.type = prop.type;
        if ("default" in prop) value.default = prop.default;
        if ("required" in prop) value.required = prop.required;
        return [
            key,
            value
        ];
    }).reduce((acc, [key, val])=>{
        acc[key] = val;
        return acc;
    }, {});
}

});
parcelRegister("dNXnK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0cdea0065e32884$export$2e2bcd8739ae039);
var $a0cdea0065e32884$export$2e2bcd8739ae039 = (vueInst, googleMapsInst, events)=>{
    for (let eventName of events){
        const propName = `on${eventName.charAt(0).toUpperCase()}${eventName.slice(1)}`.replace(/[-_]+(.)?/g, (_, c)=>c ? c.toUpperCase() : "");
        if (vueInst.$props[propName] || vueInst.$attrs[propName]) googleMapsInst.addListener(eventName, (ev)=>{
            vueInst.$emit(eventName, ev);
        });
        else if (vueInst.$gmapOptions.autobindAllEvents || vueInst.$attrs[eventName]) googleMapsInst.addListener(eventName, (ev)=>{
            vueInst.$emit(eventName, ev);
        });
    }
};

});

parcelRegister("jWtid", function(module, exports) {

$parcel$export(module.exports, "getPropsValues", () => $e84a280e7dee8e49$export$977e7f16ae91e622);
$parcel$export(module.exports, "bindProps", () => $e84a280e7dee8e49$export$b89d4640a29d673a);

var $5aVAo = parcelRequire("5aVAo");

var $5fsYe = parcelRequire("5fsYe");
function $e84a280e7dee8e49$export$977e7f16ae91e622(vueInst, props) {
    return Object.keys(props).reduce((acc, prop)=>{
        if (vueInst[prop] !== undefined) acc[prop] = vueInst[prop];
        return acc;
    }, {});
}
function $e84a280e7dee8e49$export$b89d4640a29d673a(vueInst, googleMapsInst, props) {
    for(let attribute in props){
        let { twoWay: twoWay, type: type, trackProperties: trackProperties, noBind: noBind } = props[attribute];
        if (noBind) continue;
        const setMethodName = "set" + (0, $5fsYe.Str).capitalizeFirstLetter(attribute);
        const getMethodName = "get" + (0, $5fsYe.Str).capitalizeFirstLetter(attribute);
        const eventName = attribute.toLowerCase() + "_changed";
        const initialValue = vueInst[attribute];
        if (typeof googleMapsInst[setMethodName] === "undefined") throw new Error(`${setMethodName} is not a method of (the Maps object corresponding to) ${vueInst.$options._componentTag}`);
        // We need to avoid an endless
        // propChanged -> event $emitted -> propChanged -> event $emitted loop
        // although this may really be the user's responsibility
        if (type !== Object || !trackProperties) // Track the object deeply
        vueInst.$watch(attribute, ()=>{
            const attributeValue = vueInst[attribute];
            googleMapsInst[setMethodName](attributeValue);
        }, {
            immediate: typeof initialValue !== "undefined",
            deep: type === Object
        });
        else (0, $5aVAo.default)(vueInst, trackProperties.map((prop)=>`${attribute}.${prop}`), ()=>{
            googleMapsInst[setMethodName](vueInst[attribute]);
        }, vueInst[attribute] !== undefined);
        if (twoWay && (vueInst.$gmapOptions.autobindAllEvents || vueInst.$attrs[eventName])) googleMapsInst.addListener(eventName, ()=>{
            // eslint-disable-line no-unused-vars
            vueInst.$emit(eventName, googleMapsInst[getMethodName]());
        });
    }
}

});
parcelRegister("5aVAo", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c4a8e4ead0170db$export$2e2bcd8739ae039);
/**
 * Watch the individual properties of a PoD object, instead of the object
 * per se. This is different from a deep watch where both the reference
 * and the individual values are watched.
 *
 * In effect, it throttles the multiple $watch to execute at most once per tick.
 */ function $3c4a8e4ead0170db$export$2e2bcd8739ae039(vueInst, propertiesToTrack, handler, immediate = false) {
    let isHandled = false;
    function requestHandle() {
        if (!isHandled) {
            isHandled = true;
            vueInst.$nextTick(()=>{
                isHandled = false;
                handler();
            });
        }
    }
    for (let prop of propertiesToTrack)vueInst.$watch(prop, requestHandle, {
        immediate: immediate
    });
}

});

parcelRegister("5fsYe", function(module, exports) {

$parcel$export(module.exports, "Str", () => $3d24d36cb2c69bf7$export$ed61451db706e904);
class $3d24d36cb2c69bf7$export$ed61451db706e904 {
    static capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
}

});


parcelRegister("buWLO", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f015998759350c$export$2e2bcd8739ae039);
/**
 * @class MapElementMixin
 *
 * Extends components to include the following fields:
 *
 * @property $map        The Google map (valid only after the promise returns)
 *
 *
 * */ var $85f015998759350c$export$2e2bcd8739ae039 = {
    inject: {
        $mapPromise: {
            default: "abcdef"
        }
    },
    provide () {
        // Note: although this mixin is not "providing" anything,
        // components' expect the `$map` property to be present on the component.
        // In order for that to happen, this mixin must intercept the $mapPromise
        // .then(() =>) first before its component does so.
        //
        // Since a provide() on a mixin is executed before a provide() on the
        // component, putting this code in provide() ensures that the $map is
        // already set by the time the
        // component's provide() is called.
        this.$mapPromise.then((map)=>{
            this.$map = map;
        });
        return {};
    }
};

});



parcelRegister("agJEu", function(module, exports) {

$parcel$export(module.exports, "render", () => $779ecf8fdc33230c$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
function $779ecf8fdc33230c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        onClick: _cache[0] || (_cache[0] = ()=>{
            console.log("sdfsd");
        })
    }, [
        (0, $ani5R.renderSlot)(_ctx.$slots, "default")
    ]);
}

});
parcelRegister("ey4ci", function(module, exports) {
$parcel$export(module.exports, "createApp", () => (parcelRequire("dDLnc")).createApp);
$parcel$export(module.exports, "withKeys", () => (parcelRequire("dDLnc")).withKeys);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("dDLnc")).vModelText);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("dDLnc")).withModifiers);
$parcel$export(module.exports, "vModelSelect", () => (parcelRequire("dDLnc")).vModelSelect);
$parcel$export(module.exports, "vShow", () => (parcelRequire("dDLnc")).vShow);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("ani5R")).openBlock);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("ani5R")).createElementBlock);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("ani5R")).renderSlot);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("3LSrV")).normalizeClass);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("ani5R")).createElementVNode);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("3LSrV")).normalizeStyle);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("ani5R")).mergeProps);
$parcel$export(module.exports, "toHandlers", () => (parcelRequire("ani5R")).toHandlers);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("ani5R")).Fragment);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("ani5R")).withDirectives);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("ani5R")).createCommentVNode);
$parcel$export(module.exports, "renderList", () => (parcelRequire("ani5R")).renderList);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("ani5R")).resolveComponent);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("ani5R")).createVNode);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("ani5R")).withCtx);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("ani5R")).createBlock);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("ani5R")).createTextVNode);
$parcel$export(module.exports, "reactive", () => (parcelRequire("8bTPG")).reactive);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("ani5R")).createStaticVNode);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("ani5R")).initCustomFormatter);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("3LSrV")).toDisplayString);
parcelRequire("dDLnc");
var $ani5R = parcelRequire("ani5R");parcelRequire("3LSrV");
function $a9777f2bcb9d7de1$var$initDev() {
    (0, $ani5R.initCustomFormatter)();
}
const $a9777f2bcb9d7de1$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("dDLnc", function(module, exports) {
$parcel$export(module.exports, "openBlock", () => (parcelRequire("ani5R")).openBlock);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("ani5R")).createElementBlock);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("ani5R")).renderSlot);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("3LSrV")).normalizeClass);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("ani5R")).createElementVNode);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("3LSrV")).normalizeStyle);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("ani5R")).mergeProps);
$parcel$export(module.exports, "toHandlers", () => (parcelRequire("ani5R")).toHandlers);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("ani5R")).Fragment);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("ani5R")).withDirectives);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("ani5R")).createCommentVNode);
$parcel$export(module.exports, "renderList", () => (parcelRequire("ani5R")).renderList);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("ani5R")).resolveComponent);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("ani5R")).createVNode);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("ani5R")).withCtx);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("ani5R")).createBlock);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("ani5R")).createTextVNode);
$parcel$export(module.exports, "reactive", () => (parcelRequire("8bTPG")).reactive);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("ani5R")).createStaticVNode);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("ani5R")).initCustomFormatter);
$parcel$export(module.exports, "camelize", () => (parcelRequire("3LSrV")).camelize);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("ani5R")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("ani5R")).defineComponent);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("ani5R")).nextTick);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("ani5R")).getCurrentInstance);
$parcel$export(module.exports, "watchPostEffect", () => (parcelRequire("ani5R")).watchPostEffect);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("ani5R")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("ani5R")).onUnmounted);
$parcel$export(module.exports, "Static", () => (parcelRequire("ani5R")).Static);
$parcel$export(module.exports, "h", () => (parcelRequire("ani5R")).h);
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("ani5R")).BaseTransition);
$parcel$export(module.exports, "warn", () => (parcelRequire("ani5R")).warn);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("ani5R")).useTransitionState);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("ani5R")).onUpdated);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("8bTPG")).toRaw);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("ani5R")).getTransitionRawChildren);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("ani5R")).setTransitionHooks);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("ani5R")).resolveTransitionHooks);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("ani5R")).createRenderer);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("ani5R")).createHydrationRenderer);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("ani5R")).isRuntimeOnly);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("3LSrV")).toDisplayString);

$parcel$export(module.exports, "vModelText", () => $9ee3aa3420ae2c81$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelSelect", () => $9ee3aa3420ae2c81$export$87d227567b51ca39);
$parcel$export(module.exports, "withModifiers", () => $9ee3aa3420ae2c81$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "withKeys", () => $9ee3aa3420ae2c81$export$f691a8759658f782);
$parcel$export(module.exports, "vShow", () => $9ee3aa3420ae2c81$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "createApp", () => $9ee3aa3420ae2c81$export$4e373c34abfa8c68);

var $ani5R = parcelRequire("ani5R");
var $3LSrV = parcelRequire("3LSrV");
var $8bTPG = parcelRequire("8bTPG");parcelRequire("3LSrV");

var $dXRf9 = parcelRequire("dXRf9");
const $9ee3aa3420ae2c81$var$svgNS = "http://www.w3.org/2000/svg";
const $9ee3aa3420ae2c81$var$doc = typeof document !== "undefined" ? document : null;
const $9ee3aa3420ae2c81$var$templateContainer = $9ee3aa3420ae2c81$var$doc && /*#__PURE__*/ $9ee3aa3420ae2c81$var$doc.createElement("template");
const $9ee3aa3420ae2c81$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, isSVG, is, props)=>{
        const el = isSVG ? $9ee3aa3420ae2c81$var$doc.createElementNS($9ee3aa3420ae2c81$var$svgNS, tag) : $9ee3aa3420ae2c81$var$doc.createElement(tag, is ? {
            is: is
        } : undefined);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$9ee3aa3420ae2c81$var$doc.createTextNode(text),
    createComment: (text)=>$9ee3aa3420ae2c81$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$9ee3aa3420ae2c81$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    cloneNode (el) {
        const cloned = el.cloneNode(true);
        // #3072
        // - in `patchDOMProp`, we store the actual value in the `el._value` property.
        // - normally, elements using `:value` bindings will not be hoisted, but if
        //   the bound value is a constant, e.g. `:value="true"` - they do get
        //   hoisted.
        // - in production, hoisted nodes are cloned when subsequent inserts, but
        //   cloneNode() does not copy the custom property we attached.
        // - This may need to account for other custom DOM properties we attach to
        //   elements in addition to `_value` in the future.
        if (`_value` in el) cloned._value = el._value;
        return cloned;
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, isSVG, start, end) {
        // <parent> before | first ... last | anchor </parent>
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        // #5308 can only take cached path if:
        // - has a single root node
        // - nextSibling info is still available
        if (start && (start === end || start.nextSibling)) // cached
        while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            // fresh insert
            $9ee3aa3420ae2c81$var$templateContainer.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
            const template = $9ee3aa3420ae2c81$var$templateContainer.content;
            if (isSVG) {
                // remove outer svg wrapper
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
// compiler should normalize class + :class bindings on the same element
// into a single binding ['staticClass', dynamic]
function $9ee3aa3420ae2c81$var$patchClass(el, value, isSVG) {
    // directly setting className should be faster than setAttribute in theory
    // if this is an element during a transition, take the temporary transition
    // classes into account.
    const transitionClasses = el._vtc;
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
function $9ee3aa3420ae2c81$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $dXRf9.isString)(next);
    if (next && !isCssString) {
        for(const key in next)$9ee3aa3420ae2c81$var$setStyle(style, key, next[key]);
        if (prev && !(0, $dXRf9.isString)(prev)) {
            for(const key in prev)if (next[key] == null) $9ee3aa3420ae2c81$var$setStyle(style, key, "");
        }
    } else {
        const currentDisplay = style.display;
        if (isCssString) {
            if (prev !== next) style.cssText = next;
        } else if (prev) el.removeAttribute("style");
        // indicates that the `display` of the element is controlled by `v-show`,
        // so we always keep the current `display` value regardless of the `style`
        // value, thus handing over control to `v-show`.
        if ("_vod" in el) style.display = currentDisplay;
    }
}
const $9ee3aa3420ae2c81$var$importantRE = /\s*!important$/;
function $9ee3aa3420ae2c81$var$setStyle(style, name, val) {
    if ((0, $dXRf9.isArray)(val)) val.forEach((v)=>$9ee3aa3420ae2c81$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) // custom property definition
        style.setProperty(name, val);
        else {
            const prefixed = $9ee3aa3420ae2c81$var$autoPrefix(style, name);
            if ($9ee3aa3420ae2c81$var$importantRE.test(val)) // !important
            style.setProperty((0, $dXRf9.hyphenate)(prefixed), val.replace($9ee3aa3420ae2c81$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $9ee3aa3420ae2c81$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $9ee3aa3420ae2c81$var$prefixCache = {};
function $9ee3aa3420ae2c81$var$autoPrefix(style, rawName) {
    const cached = $9ee3aa3420ae2c81$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $3LSrV.camelize)(rawName);
    if (name !== "filter" && name in style) return $9ee3aa3420ae2c81$var$prefixCache[rawName] = name;
    name = (0, $dXRf9.capitalize)(name);
    for(let i = 0; i < $9ee3aa3420ae2c81$var$prefixes.length; i++){
        const prefixed = $9ee3aa3420ae2c81$var$prefixes[i] + name;
        if (prefixed in style) return $9ee3aa3420ae2c81$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $9ee3aa3420ae2c81$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $9ee3aa3420ae2c81$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($9ee3aa3420ae2c81$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($9ee3aa3420ae2c81$var$xlinkNS, key, value);
    } else {
        // note we are only checking boolean attributes that don't have a
        // corresponding dom prop of the same name here.
        const isBoolean = (0, $dXRf9.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $dXRf9.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
// __UNSAFE__
// functions. The user is responsible for using them with only trusted content.
function $9ee3aa3420ae2c81$var$patchDOMProp(el, key, value, // the following args are passed only due to potential innerHTML/textContent
// overriding existing VNodes, in which case the old tree must be properly
// unmounted.
prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    if (key === "value" && el.tagName !== "PROGRESS" && // custom elements may use _value internally
    !el.tagName.includes("-")) {
        // store value as _value as well since
        // non-string values will be stringified.
        el._value = value;
        const newValue = value == null ? "" : value;
        if (el.value !== newValue || // #4956: always set for OPTION elements because its value falls back to
        // textContent if no value attribute is present. And setting .value for
        // OPTION has no side effect
        el.tagName === "OPTION") el.value = newValue;
        if (value == null) el.removeAttribute(key);
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") // e.g. <select multiple> compiles to { multiple: '' }
        value = (0, $dXRf9.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            // e.g. <div :id="null">
            value = "";
            needRemove = true;
        } else if (type === "number") {
            // e.g. <img :width="null">
            // the value of some IDL attr must be greater than 0, e.g. input.size = 0 -> error
            value = 0;
            needRemove = true;
        }
    }
    // some properties perform value validation and throw,
    // some properties has getter, no setter, will error in 'use strict'
    // eg. <select :type="null"></select> <select :willValidate="null"></select>
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
// Async edge case fix requires storing an event listener's attach timestamp.
const [$9ee3aa3420ae2c81$var$_getNow, $9ee3aa3420ae2c81$var$skipTimestampCheck] = /*#__PURE__*/ (()=>{
    let _getNow = Date.now;
    let skipTimestampCheck = false;
    if (typeof window !== "undefined") {
        // Determine what event timestamp the browser is using. Annoyingly, the
        // timestamp can either be hi-res (relative to page load) or low-res
        // (relative to UNIX epoch), so in order to compare time we have to use the
        // same timestamp type when saving the flush timestamp.
        if (Date.now() > document.createEvent("Event").timeStamp) // if the low-res timestamp which is bigger than the event timestamp
        // (which is evaluated AFTER) it means the event is using a hi-res timestamp,
        // and we need to use the hi-res version for event listeners as well.
        _getNow = performance.now.bind(performance);
        // #3485: Firefox <= 53 has incorrect Event.timeStamp implementation
        // and does not fire microtasks in between event propagation, so safe to exclude.
        const ffMatch = navigator.userAgent.match(/firefox\/(\d+)/i);
        skipTimestampCheck = !!(ffMatch && Number(ffMatch[1]) <= 53);
    }
    return [
        _getNow,
        skipTimestampCheck
    ];
})();
// To avoid the overhead of repeatedly calling performance.now(), we cache
// and use the same timestamp for all event listeners attached in the same tick.
let $9ee3aa3420ae2c81$var$cachedNow = 0;
const $9ee3aa3420ae2c81$var$p = /*#__PURE__*/ Promise.resolve();
const $9ee3aa3420ae2c81$var$reset = ()=>{
    $9ee3aa3420ae2c81$var$cachedNow = 0;
};
const $9ee3aa3420ae2c81$var$getNow = ()=>$9ee3aa3420ae2c81$var$cachedNow || ($9ee3aa3420ae2c81$var$p.then($9ee3aa3420ae2c81$var$reset), $9ee3aa3420ae2c81$var$cachedNow = $9ee3aa3420ae2c81$var$_getNow());
function $9ee3aa3420ae2c81$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $9ee3aa3420ae2c81$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
function $9ee3aa3420ae2c81$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    // vei = vue event invokers
    const invokers = el._vei || (el._vei = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) // patch
    existingInvoker.value = nextValue;
    else {
        const [name, options] = $9ee3aa3420ae2c81$var$parseName(rawName);
        if (nextValue) {
            // add
            const invoker = invokers[rawName] = $9ee3aa3420ae2c81$var$createInvoker(nextValue, instance);
            $9ee3aa3420ae2c81$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            // remove
            $9ee3aa3420ae2c81$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = undefined;
        }
    }
}
const $9ee3aa3420ae2c81$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $9ee3aa3420ae2c81$var$parseName(name) {
    let options;
    if ($9ee3aa3420ae2c81$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($9ee3aa3420ae2c81$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    return [
        (0, $dXRf9.hyphenate)(name.slice(2)),
        options
    ];
}
function $9ee3aa3420ae2c81$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        // async edge case #6566: inner click event triggers patch, event handler
        // attached to outer element during patch, and triggered again. This
        // happens because browsers fire microtask ticks between event propagation.
        // the solution is simple: we save the timestamp when a handler is attached,
        // and the handler would only fire if the event passed to it was fired
        // AFTER it was attached.
        const timeStamp = e.timeStamp || $9ee3aa3420ae2c81$var$_getNow();
        if ($9ee3aa3420ae2c81$var$skipTimestampCheck || timeStamp >= invoker.attached - 1) (0, $ani5R.callWithAsyncErrorHandling)($9ee3aa3420ae2c81$var$patchStopImmediatePropagation(e, invoker.value), instance, 5 /* NATIVE_EVENT_HANDLER */ , [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $9ee3aa3420ae2c81$var$getNow();
    return invoker;
}
function $9ee3aa3420ae2c81$var$patchStopImmediatePropagation(e, value) {
    if ((0, $dXRf9.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e)=>!e._stopped && fn && fn(e));
    } else return value;
}
const $9ee3aa3420ae2c81$var$nativeOnRE = /^on[a-z]/;
const $9ee3aa3420ae2c81$var$patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    if (key === "class") $9ee3aa3420ae2c81$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $9ee3aa3420ae2c81$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $dXRf9.isOn)(key)) // ignore v-model listeners
    {
        if (!(0, $dXRf9.isModelListener)(key)) $9ee3aa3420ae2c81$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $9ee3aa3420ae2c81$var$shouldSetAsProp(el, key, nextValue, isSVG)) $9ee3aa3420ae2c81$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        // special case for <input v-model type="checkbox"> with
        // :true-value & :false-value
        // store value as dom properties since non-string values will be
        // stringified.
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $9ee3aa3420ae2c81$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $9ee3aa3420ae2c81$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        // most keys must be set as attribute on svg elements to work
        // ...except innerHTML & textContent
        if (key === "innerHTML" || key === "textContent") return true;
        // or native onclick with function values
        if (key in el && $9ee3aa3420ae2c81$var$nativeOnRE.test(key) && (0, $dXRf9.isFunction)(value)) return true;
        return false;
    }
    // these are enumerated attrs, however their corresponding DOM properties
    // are actually booleans - this leads to setting it with a string "false"
    // value leading it to be coerced to `true`, so we need to always treat
    // them as attributes.
    // Note that `contentEditable` doesn't have this problem: its DOM
    // property is also enumerated string values.
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    // #1787, #2840 form property on form elements is readonly and must be set as
    // attribute.
    if (key === "form") return false;
    // #1526 <input list> must be set as attribute
    if (key === "list" && el.tagName === "INPUT") return false;
    // #2766 <textarea type> must be set as attribute
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    // native onclick with string value, must be set as attribute
    if ($9ee3aa3420ae2c81$var$nativeOnRE.test(key) && (0, $dXRf9.isString)(value)) return false;
    return key in el;
}
function $9ee3aa3420ae2c81$export$a00e2346eabbdbef(options, hydrate) {
    const Comp = (0, $ani5R.defineComponent)(options);
    class VueCustomElement extends $9ee3aa3420ae2c81$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $9ee3aa3420ae2c81$export$6debb2e68f212638 = (options)=>{
    // @ts-ignore
    return $9ee3aa3420ae2c81$export$a00e2346eabbdbef(options, $9ee3aa3420ae2c81$export$fa8d919ba61d84db);
};
const $9ee3aa3420ae2c81$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $9ee3aa3420ae2c81$export$b337c1a55163dbe3 extends $9ee3aa3420ae2c81$var$BaseClass {
    constructor(_def, _props = {}, hydrate){
        super();
        this._def = _def;
        this._props = _props;
        /**
         * @internal
         */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        if (this.shadowRoot && hydrate) hydrate(this._createVNode(), this.shadowRoot);
        else this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) this._resolveDef();
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $ani5R.nextTick)(()=>{
            if (!this._connected) {
                $9ee3aa3420ae2c81$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
     * resolve inner component definition (handle possible async component)
     */ _resolveDef() {
        if (this._resolved) return;
        this._resolved = true;
        // set initial attrs
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        // watch future attr changes
        new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        }).observe(this, {
            attributes: true
        });
        const resolve = (def)=>{
            const { props: props, styles: styles } = def;
            const hasOptions = !(0, $dXRf9.isArray)(props);
            const rawKeys = props ? hasOptions ? Object.keys(props) : props : [];
            // cast Number-type props set before resolve
            let numberProps;
            if (hasOptions) for(const key in this._props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    this._props[key] = (0, $dXRf9.toNumber)(this._props[key]);
                    (numberProps || (numberProps = Object.create(null)))[key] = true;
                }
            }
            this._numberProps = numberProps;
            // check if there are props set pre-upgrade or connect
            for (const key of Object.keys(this))if (key[0] !== "_") this._setProp(key, this[key], true, false);
            // defining getter/setters on prototype
            for (const key of rawKeys.map((0, $dXRf9.camelize)))Object.defineProperty(this, key, {
                get () {
                    return this._getProp(key);
                },
                set (val) {
                    this._setProp(key, val);
                }
            });
            // apply CSS
            this._applyStyles(styles);
            // initial render
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then(resolve);
        else resolve(this._def);
    }
    _setAttr(key) {
        let value = this.getAttribute(key);
        if (this._numberProps && this._numberProps[key]) value = (0, $dXRf9.toNumber)(value);
        this._setProp((0, $dXRf9.camelize)(key), value, false);
    }
    /**
     * @internal
     */ _getProp(key) {
        return this._props[key];
    }
    /**
     * @internal
     */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            // reflect
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $dXRf9.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $dXRf9.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $dXRf9.hyphenate)(key));
            }
        }
    }
    _update() {
        $9ee3aa3420ae2c81$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $ani5R.createVNode)(this._def, (0, $dXRf9.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            // intercept emit
            instance.emit = (event, ...args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            // locate nearest Vue custom element parent for provide/inject
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $9ee3aa3420ae2c81$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function $9ee3aa3420ae2c81$export$9300d5b90d56e3d1(name = "$style") {
    /* istanbul ignore else */ {
        const instance = (0, $ani5R.getCurrentInstance)();
        if (!instance) return 0, $dXRf9.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $dXRf9.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $dXRf9.EMPTY_OBJ;
        return mod;
    }
}
/**
 * Runtime helper for SFC's CSS variable injection feature.
 * @private
 */ function $9ee3aa3420ae2c81$export$ef28b76f07940108(getter) {
    const instance = (0, $ani5R.getCurrentInstance)();
    /* istanbul ignore next */ if (!instance) return;
    const setVars = ()=>$9ee3aa3420ae2c81$var$setVarsOnVNode(instance.subTree, getter(instance.proxy));
    (0, $ani5R.watchPostEffect)(setVars);
    (0, $ani5R.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $ani5R.onUnmounted)(()=>ob.disconnect());
    });
}
function $9ee3aa3420ae2c81$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128 /* SUSPENSE */ ) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $9ee3aa3420ae2c81$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    // drill down HOCs until it's a non-component vnode
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 /* ELEMENT */  && vnode.el) $9ee3aa3420ae2c81$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $ani5R.Fragment)) vnode.children.forEach((c)=>$9ee3aa3420ae2c81$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $ani5R.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $9ee3aa3420ae2c81$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $9ee3aa3420ae2c81$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        for(const key in vars)style.setProperty(`--${key}`, vars[key]);
    }
}
const $9ee3aa3420ae2c81$var$TRANSITION = "transition";
const $9ee3aa3420ae2c81$var$ANIMATION = "animation";
// DOM Transition is a higher-order-component based on the platform-agnostic
// base Transition component, with DOM-specific logic.
const $9ee3aa3420ae2c81$export$be58926105124dd4 = (props, { slots: slots })=>(0, $ani5R.h)((0, $ani5R.BaseTransition), $9ee3aa3420ae2c81$var$resolveTransitionProps(props), slots);
$9ee3aa3420ae2c81$export$be58926105124dd4.displayName = "Transition";
const $9ee3aa3420ae2c81$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $9ee3aa3420ae2c81$var$TransitionPropsValidators = $9ee3aa3420ae2c81$export$be58926105124dd4.props = /*#__PURE__*/ (0, $dXRf9.extend)({}, (0, $ani5R.BaseTransition).props, $9ee3aa3420ae2c81$var$DOMTransitionPropsValidators);
/**
 * #3227 Incoming hooks may be merged into arrays when wrapping Transition
 * with custom HOCs.
 */ const $9ee3aa3420ae2c81$var$callHook = (hook, args = [])=>{
    if ((0, $dXRf9.isArray)(hook)) hook.forEach((h)=>h(...args));
    else if (hook) hook(...args);
};
/**
 * Check if a hook expects a callback (2nd arg), which means the user
 * intends to explicitly control the end of the transition.
 */ const $9ee3aa3420ae2c81$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $dXRf9.isArray)(hook) ? hook.some((h)=>h.length > 1) : hook.length > 1 : false;
};
function $9ee3aa3420ae2c81$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $9ee3aa3420ae2c81$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $9ee3aa3420ae2c81$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, leaveFromClass);
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, leaveToClass);
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $9ee3aa3420ae2c81$var$callHook(hook, [
                el,
                resolve
            ]);
            $9ee3aa3420ae2c81$var$nextFrame(()=>{
                $9ee3aa3420ae2c81$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $9ee3aa3420ae2c81$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$9ee3aa3420ae2c81$var$hasExplicitCallback(hook)) $9ee3aa3420ae2c81$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $dXRf9.extend)(baseProps, {
        onBeforeEnter (el) {
            $9ee3aa3420ae2c81$var$callHook(onBeforeEnter, [
                el
            ]);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, enterFromClass);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $9ee3aa3420ae2c81$var$callHook(onBeforeAppear, [
                el
            ]);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, appearFromClass);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, leaveFromClass);
            // force reflow so *-leave-from classes immediately take effect (#2593)
            $9ee3aa3420ae2c81$var$forceReflow();
            $9ee3aa3420ae2c81$var$addTransitionClass(el, leaveActiveClass);
            $9ee3aa3420ae2c81$var$nextFrame(()=>{
                if (!el._isLeaving) // cancelled
                return;
                $9ee3aa3420ae2c81$var$removeTransitionClass(el, leaveFromClass);
                $9ee3aa3420ae2c81$var$addTransitionClass(el, leaveToClass);
                if (!$9ee3aa3420ae2c81$var$hasExplicitCallback(onLeave)) $9ee3aa3420ae2c81$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $9ee3aa3420ae2c81$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $9ee3aa3420ae2c81$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $9ee3aa3420ae2c81$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $9ee3aa3420ae2c81$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $9ee3aa3420ae2c81$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $dXRf9.isObject)(duration)) return [
        $9ee3aa3420ae2c81$var$NumberOf(duration.enter),
        $9ee3aa3420ae2c81$var$NumberOf(duration.leave)
    ];
    else {
        const n = $9ee3aa3420ae2c81$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $9ee3aa3420ae2c81$var$NumberOf(val) {
    const res = (0, $dXRf9.toNumber)(val);
    return res;
}
function $9ee3aa3420ae2c81$var$validateDuration(val) {
    if (typeof val !== "number") (0, $ani5R.warn)(`<transition> explicit duration is not a valid number - ` + `got ${JSON.stringify(val)}.`);
    else if (isNaN(val)) (0, $ani5R.warn)(`<transition> explicit duration is NaN - ` + "the duration expression might be incorrect.");
}
function $9ee3aa3420ae2c81$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el._vtc || (el._vtc = new Set())).add(cls);
}
function $9ee3aa3420ae2c81$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const { _vtc: _vtc } = el;
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el._vtc = undefined;
    }
}
function $9ee3aa3420ae2c81$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $9ee3aa3420ae2c81$var$endId = 0;
function $9ee3aa3420ae2c81$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$9ee3aa3420ae2c81$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $9ee3aa3420ae2c81$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $9ee3aa3420ae2c81$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties($9ee3aa3420ae2c81$var$TRANSITION + "Delay");
    const transitionDurations = getStyleProperties($9ee3aa3420ae2c81$var$TRANSITION + "Duration");
    const transitionTimeout = $9ee3aa3420ae2c81$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties($9ee3aa3420ae2c81$var$ANIMATION + "Delay");
    const animationDurations = getStyleProperties($9ee3aa3420ae2c81$var$ANIMATION + "Duration");
    const animationTimeout = $9ee3aa3420ae2c81$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    /* istanbul ignore if */ if (expectedType === $9ee3aa3420ae2c81$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $9ee3aa3420ae2c81$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $9ee3aa3420ae2c81$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $9ee3aa3420ae2c81$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $9ee3aa3420ae2c81$var$TRANSITION : $9ee3aa3420ae2c81$var$ANIMATION : null;
        propCount = type ? type === $9ee3aa3420ae2c81$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $9ee3aa3420ae2c81$var$TRANSITION && /\b(transform|all)(,|$)/.test(styles[$9ee3aa3420ae2c81$var$TRANSITION + "Property"]);
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $9ee3aa3420ae2c81$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$9ee3aa3420ae2c81$var$toMs(d) + $9ee3aa3420ae2c81$var$toMs(delays[i])));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer
// numbers in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down
// (i.e. acting as a floor function) causing unexpected behaviors
function $9ee3aa3420ae2c81$var$toMs(s) {
    return Number(s.slice(0, -1).replace(",", ".")) * 1000;
}
// synchronously force layout to put elements into a certain state
function $9ee3aa3420ae2c81$var$forceReflow() {
    return document.body.offsetHeight;
}
const $9ee3aa3420ae2c81$var$positionMap = new WeakMap();
const $9ee3aa3420ae2c81$var$newPositionMap = new WeakMap();
const $9ee3aa3420ae2c81$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /*#__PURE__*/ (0, $dXRf9.extend)({}, $9ee3aa3420ae2c81$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $ani5R.getCurrentInstance)();
        const state = (0, $ani5R.useTransitionState)();
        let prevChildren;
        let children;
        (0, $ani5R.onUpdated)(()=>{
            // children is guaranteed to exist after initial render
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$9ee3aa3420ae2c81$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            // we divide the work into three loops to avoid mixing DOM reads and writes
            // in each iteration - which helps prevent layout thrashing.
            prevChildren.forEach($9ee3aa3420ae2c81$var$callPendingCbs);
            prevChildren.forEach($9ee3aa3420ae2c81$var$recordPosition);
            const movedChildren = prevChildren.filter($9ee3aa3420ae2c81$var$applyTranslation);
            // force reflow to put everything in position
            $9ee3aa3420ae2c81$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $9ee3aa3420ae2c81$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el._moveCb = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el._moveCb = null;
                        $9ee3aa3420ae2c81$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $8bTPG.toRaw)(props);
            const cssTransitionProps = $9ee3aa3420ae2c81$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $ani5R.Fragment);
            prevChildren = children;
            children = slots.default ? (0, $ani5R.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $ani5R.setTransitionHooks)(child, (0, $ani5R.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren) for(let i = 0; i < prevChildren.length; i++){
                const child = prevChildren[i];
                (0, $ani5R.setTransitionHooks)(child, (0, $ani5R.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                $9ee3aa3420ae2c81$var$positionMap.set(child, child.el.getBoundingClientRect());
            }
            return (0, $ani5R.createVNode)(tag, null, children);
        };
    }
};
const $9ee3aa3420ae2c81$export$19ffa8f511f7bc2e = $9ee3aa3420ae2c81$var$TransitionGroupImpl;
function $9ee3aa3420ae2c81$var$callPendingCbs(c) {
    const el = c.el;
    if (el._moveCb) el._moveCb();
    if (el._enterCb) el._enterCb();
}
function $9ee3aa3420ae2c81$var$recordPosition(c) {
    $9ee3aa3420ae2c81$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $9ee3aa3420ae2c81$var$applyTranslation(c) {
    const oldPos = $9ee3aa3420ae2c81$var$positionMap.get(c);
    const newPos = $9ee3aa3420ae2c81$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $9ee3aa3420ae2c81$var$hasCSSTransform(el, root, moveClass) {
    // Detect whether an element with the move class applied has
    // CSS transitions. Since the element may be inside an entering
    // transition at this very moment, we make a clone of it and remove
    // all other transition classes applied to ensure only the move class
    // is applied.
    const clone = el.cloneNode();
    if (el._vtc) el._vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $9ee3aa3420ae2c81$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $9ee3aa3420ae2c81$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $dXRf9.isArray)(fn) ? (value)=>(0, $dXRf9.invokeArrayFns)(fn, value) : fn;
};
function $9ee3aa3420ae2c81$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $9ee3aa3420ae2c81$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
// We are exporting the v-model runtime directly as vnode hooks so that it can
// be tree-shaken in case v-model is never used.
const $9ee3aa3420ae2c81$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $9ee3aa3420ae2c81$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $dXRf9.toNumber)(domValue);
            el._assign(domValue);
        });
        if (trim) $9ee3aa3420ae2c81$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $9ee3aa3420ae2c81$var$addEventListener(el, "compositionstart", $9ee3aa3420ae2c81$var$onCompositionStart);
            $9ee3aa3420ae2c81$var$addEventListener(el, "compositionend", $9ee3aa3420ae2c81$var$onCompositionEnd);
            // Safari < 10.2 & UIWebView doesn't fire compositionend when
            // switching focus before confirming composition choice
            // this also fixes the issue where some browsers e.g. iOS Chrome
            // fires "change" instead of "input" on autocomplete.
            $9ee3aa3420ae2c81$var$addEventListener(el, "change", $9ee3aa3420ae2c81$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        // avoid clearing unresolved text. #2302
        if (el.composing) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === value) return;
            if ((number || el.type === "number") && (0, $dXRf9.toNumber)(el.value) === value) return;
        }
        const newValue = value == null ? "" : value;
        if (el.value !== newValue) el.value = newValue;
    }
};
const $9ee3aa3420ae2c81$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el._assign = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        $9ee3aa3420ae2c81$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $9ee3aa3420ae2c81$var$getValue(el);
            const checked = el.checked;
            const assign = el._assign;
            if ((0, $dXRf9.isArray)(modelValue)) {
                const index = (0, $dXRf9.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $dXRf9.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($9ee3aa3420ae2c81$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $9ee3aa3420ae2c81$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el._assign = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        $9ee3aa3420ae2c81$var$setChecked(el, binding, vnode);
    }
};
function $9ee3aa3420ae2c81$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $dXRf9.isArray)(value)) el.checked = (0, $dXRf9.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $dXRf9.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $dXRf9.looseEqual)(value, $9ee3aa3420ae2c81$var$getCheckboxValue(el, true));
}
const $9ee3aa3420ae2c81$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $dXRf9.looseEqual)(value, vnode.props.value);
        el._assign = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        $9ee3aa3420ae2c81$var$addEventListener(el, "change", ()=>{
            el._assign($9ee3aa3420ae2c81$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el._assign = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $dXRf9.looseEqual)(value, vnode.props.value);
    }
};
const $9ee3aa3420ae2c81$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $dXRf9.isSet)(value);
        $9ee3aa3420ae2c81$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $dXRf9.toNumber)($9ee3aa3420ae2c81$var$getValue(o)) : $9ee3aa3420ae2c81$var$getValue(o));
            el._assign(el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
        });
        el._assign = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $9ee3aa3420ae2c81$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el._assign = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        $9ee3aa3420ae2c81$var$setSelected(el, value);
    }
};
function $9ee3aa3420ae2c81$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    if (isMultiple && !(0, $dXRf9.isArray)(value) && !(0, $dXRf9.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $9ee3aa3420ae2c81$var$getValue(option);
        if (isMultiple) {
            if ((0, $dXRf9.isArray)(value)) option.selected = (0, $dXRf9.looseIndexOf)(value, optionValue) > -1;
            else option.selected = value.has(optionValue);
        } else if ((0, $dXRf9.looseEqual)($9ee3aa3420ae2c81$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
// retrieve raw value set via :value bindings
function $9ee3aa3420ae2c81$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
// retrieve raw value for true-value and false-value set via :true-value or :false-value bindings
function $9ee3aa3420ae2c81$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $9ee3aa3420ae2c81$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $9ee3aa3420ae2c81$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $9ee3aa3420ae2c81$export$87d227567b51ca39;
        case "TEXTAREA":
            return $9ee3aa3420ae2c81$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $9ee3aa3420ae2c81$export$8847c2e532b35714;
                case "radio":
                    return $9ee3aa3420ae2c81$export$b4356c59b38b7aa9;
                default:
                    return $9ee3aa3420ae2c81$export$f1f88689f5728478;
            }
    }
}
function $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $9ee3aa3420ae2c81$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
// SSR vnode transforms, only used when user includes client-oriented render
// function in SSR
function $9ee3aa3420ae2c81$var$initVModelForSSR() {
    $9ee3aa3420ae2c81$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $9ee3aa3420ae2c81$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $dXRf9.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $9ee3aa3420ae2c81$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $dXRf9.isArray)(value)) {
            if (vnode.props && (0, $dXRf9.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $dXRf9.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $9ee3aa3420ae2c81$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $9ee3aa3420ae2c81$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $9ee3aa3420ae2c81$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $9ee3aa3420ae2c81$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$9ee3aa3420ae2c81$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
/**
 * @private
 */ const $9ee3aa3420ae2c81$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    return (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $9ee3aa3420ae2c81$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    };
};
// Kept for 2.x compat.
// Note: IE11 compat for `spacebar` and `del` is removed for now.
const $9ee3aa3420ae2c81$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
/**
 * @private
 */ const $9ee3aa3420ae2c81$export$f691a8759658f782 = (fn, modifiers)=>{
    return (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $dXRf9.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $9ee3aa3420ae2c81$var$keyNames[k] === eventKey)) return fn(event);
    };
};
const $9ee3aa3420ae2c81$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el._vod = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $9ee3aa3420ae2c81$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $9ee3aa3420ae2c81$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $9ee3aa3420ae2c81$var$setDisplay(el, false);
            });
        } else $9ee3aa3420ae2c81$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $9ee3aa3420ae2c81$var$setDisplay(el, value);
    }
};
function $9ee3aa3420ae2c81$var$setDisplay(el, value) {
    el.style.display = value ? el._vod : "none";
}
// SSR vnode transforms, only used when user includes client-oriented render
// function in SSR
function $9ee3aa3420ae2c81$var$initVShowForSSR() {
    $9ee3aa3420ae2c81$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $9ee3aa3420ae2c81$var$rendererOptions = /*#__PURE__*/ (0, $dXRf9.extend)({
    patchProp: $9ee3aa3420ae2c81$var$patchProp
}, $9ee3aa3420ae2c81$var$nodeOps);
// lazy create the renderer - this makes core renderer logic tree-shakable
// in case the user only imports reactivity utilities from Vue.
let $9ee3aa3420ae2c81$var$renderer;
let $9ee3aa3420ae2c81$var$enabledHydration = false;
function $9ee3aa3420ae2c81$var$ensureRenderer() {
    return $9ee3aa3420ae2c81$var$renderer || ($9ee3aa3420ae2c81$var$renderer = (0, $ani5R.createRenderer)($9ee3aa3420ae2c81$var$rendererOptions));
}
function $9ee3aa3420ae2c81$var$ensureHydrationRenderer() {
    $9ee3aa3420ae2c81$var$renderer = $9ee3aa3420ae2c81$var$enabledHydration ? $9ee3aa3420ae2c81$var$renderer : (0, $ani5R.createHydrationRenderer)($9ee3aa3420ae2c81$var$rendererOptions);
    $9ee3aa3420ae2c81$var$enabledHydration = true;
    return $9ee3aa3420ae2c81$var$renderer;
}
// use explicit type casts here to avoid import() calls in rolled-up d.ts
const $9ee3aa3420ae2c81$export$b3890eb0ae9dca99 = (...args)=>{
    $9ee3aa3420ae2c81$var$ensureRenderer().render(...args);
};
const $9ee3aa3420ae2c81$export$fa8d919ba61d84db = (...args)=>{
    $9ee3aa3420ae2c81$var$ensureHydrationRenderer().hydrate(...args);
};
const $9ee3aa3420ae2c81$export$4e373c34abfa8c68 = (...args)=>{
    const app = $9ee3aa3420ae2c81$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $9ee3aa3420ae2c81$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $dXRf9.isFunction)(component) && !component.render && !component.template) // __UNSAFE__
        // Reason: potential execution of JS expressions in in-DOM template.
        // The user must make sure the in-DOM template is trusted. If it's
        // rendered by the server, the template should not contain any user data.
        component.template = container.innerHTML;
        // clear content before mounting
        container.innerHTML = "";
        const proxy = mount(container, false, container instanceof SVGElement);
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $9ee3aa3420ae2c81$export$35800275c0037383 = (...args)=>{
    const app = $9ee3aa3420ae2c81$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $9ee3aa3420ae2c81$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, container instanceof SVGElement);
    };
    return app;
};
function $9ee3aa3420ae2c81$var$injectNativeTagCheck(app) {
    // Inject `isNativeTag`
    // this is used for component name validation (dev only)
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $dXRf9.isHTMLTag)(tag) || (0, $dXRf9.isSVGTag)(tag),
        writable: false
    });
}
// dev only
function $9ee3aa3420ae2c81$var$injectCompilerOptionsCheck(app) {
    if ((0, $ani5R.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $ani5R.warn)(`The \`isCustomElement\` config option is deprecated. Use ` + `\`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using ` + `a build of Vue.js that includes the runtime compiler (aka "full build"). ` + `Since you are using the runtime-only build, \`compilerOptions\` ` + `must be passed to \`@vue/compiler-dom\` in the build setup instead.\n` + `- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.\n` + `- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n` + `- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-dom`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $ani5R.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $ani5R.warn)(msg);
            }
        });
    }
}
function $9ee3aa3420ae2c81$var$normalizeContainer(container) {
    if ((0, $dXRf9.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $9ee3aa3420ae2c81$var$ssrDirectiveInitialized = false;
/**
 * @internal
 */ const $9ee3aa3420ae2c81$export$800b28255aa678d9 = ()=>{
    if (!$9ee3aa3420ae2c81$var$ssrDirectiveInitialized) {
        $9ee3aa3420ae2c81$var$ssrDirectiveInitialized = true;
        $9ee3aa3420ae2c81$var$initVModelForSSR();
        $9ee3aa3420ae2c81$var$initVShowForSSR();
    }
};

});
parcelRegister("ani5R", function(module, exports) {

$parcel$export(module.exports, "warn", () => $78da16583ad93b9f$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $78da16583ad93b9f$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $78da16583ad93b9f$export$bdd553fddd433dcb);
$parcel$export(module.exports, "Fragment", () => $78da16583ad93b9f$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $78da16583ad93b9f$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $78da16583ad93b9f$export$694b237e827a3d23);
$parcel$export(module.exports, "createVNode", () => $78da16583ad93b9f$export$bf5c4cf060303d58);
$parcel$export(module.exports, "openBlock", () => $78da16583ad93b9f$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "watchPostEffect", () => $78da16583ad93b9f$export$b7f27ea67102d543);
$parcel$export(module.exports, "useTransitionState", () => $78da16583ad93b9f$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $78da16583ad93b9f$export$6d1641039221b5cb);
$parcel$export(module.exports, "getCurrentInstance", () => $78da16583ad93b9f$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $78da16583ad93b9f$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $78da16583ad93b9f$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $78da16583ad93b9f$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $78da16583ad93b9f$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $78da16583ad93b9f$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "onUpdated", () => $78da16583ad93b9f$export$5876c47052fb88b1);
$parcel$export(module.exports, "onUnmounted", () => $78da16583ad93b9f$export$13348a43ccacfe58);
$parcel$export(module.exports, "withDirectives", () => $78da16583ad93b9f$export$49729353e7c1e6c5);
$parcel$export(module.exports, "resolveComponent", () => $78da16583ad93b9f$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "renderList", () => $78da16583ad93b9f$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "renderSlot", () => $78da16583ad93b9f$export$4abee4c34694ada1);
$parcel$export(module.exports, "createBlock", () => $78da16583ad93b9f$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "toHandlers", () => $78da16583ad93b9f$export$2fb94ff667a6a1a);
$parcel$export(module.exports, "createTextVNode", () => $78da16583ad93b9f$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "createRenderer", () => $78da16583ad93b9f$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $78da16583ad93b9f$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $78da16583ad93b9f$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $78da16583ad93b9f$export$42098e0eaa15c48e);
$parcel$export(module.exports, "mergeProps", () => $78da16583ad93b9f$export$9d1611c77c2fe928);
$parcel$export(module.exports, "createStaticVNode", () => $78da16583ad93b9f$export$33a9f6dd2840e6bb);
$parcel$export(module.exports, "createCommentVNode", () => $78da16583ad93b9f$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $78da16583ad93b9f$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $78da16583ad93b9f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $78da16583ad93b9f$export$aed4979be6a60047);
$parcel$export(module.exports, "reactive", () => (parcelRequire("8bTPG")).reactive);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("8bTPG")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("3LSrV")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("3LSrV")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("3LSrV")).normalizeStyle);

var $8bTPG = parcelRequire("8bTPG");

var $3LSrV = parcelRequire("3LSrV");
const $78da16583ad93b9f$var$stack = [];
function $78da16583ad93b9f$var$pushWarningContext(vnode) {
    $78da16583ad93b9f$var$stack.push(vnode);
}
function $78da16583ad93b9f$var$popWarningContext() {
    $78da16583ad93b9f$var$stack.pop();
}
function $78da16583ad93b9f$export$c106dd0671a0fc2d(msg, ...args) {
    // avoid props formatting or warn handler tracking deps that might be mutated
    // during patch, leading to infinite recursion.
    (0, $8bTPG.pauseTracking)();
    const instance = $78da16583ad93b9f$var$stack.length ? $78da16583ad93b9f$var$stack[$78da16583ad93b9f$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $78da16583ad93b9f$var$getComponentTrace();
    if (appWarnHandler) $78da16583ad93b9f$export$b22fcaf88446e9bf(appWarnHandler, instance, 11 /* APP_WARN_HANDLER */ , [
        msg + args.join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$78da16583ad93b9f$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        /* istanbul ignore if */ if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`\n`, ...$78da16583ad93b9f$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $8bTPG.resetTracking)();
}
function $78da16583ad93b9f$var$getComponentTrace() {
    let currentVNode = $78da16583ad93b9f$var$stack[$78da16583ad93b9f$var$stack.length - 1];
    if (!currentVNode) return [];
    // we can't just use the stack because it will be incomplete during updates
    // that did not start from the root. Re-construct the parent chain using
    // instance parent pointers.
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
/* istanbul ignore next */ function $78da16583ad93b9f$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `\n`
        ], ...$78da16583ad93b9f$var$formatTraceEntry(entry));
    });
    return logs;
}
function $78da16583ad93b9f$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$78da16583ad93b9f$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$78da16583ad93b9f$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
/* istanbul ignore next */ function $78da16583ad93b9f$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$78da16583ad93b9f$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
/* istanbul ignore next */ function $78da16583ad93b9f$var$formatProp(key, value, raw) {
    if ((0, $3LSrV.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $8bTPG.isRef)(value)) {
        value = $78da16583ad93b9f$var$formatProp(key, (0, $8bTPG.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $3LSrV.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $8bTPG.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
const $78da16583ad93b9f$var$ErrorTypeStrings = {
    ["sp" /* SERVER_PREFETCH */ ]: "serverPrefetch hook",
    ["bc" /* BEFORE_CREATE */ ]: "beforeCreate hook",
    ["c" /* CREATED */ ]: "created hook",
    ["bm" /* BEFORE_MOUNT */ ]: "beforeMount hook",
    ["m" /* MOUNTED */ ]: "mounted hook",
    ["bu" /* BEFORE_UPDATE */ ]: "beforeUpdate hook",
    ["u" /* UPDATED */ ]: "updated",
    ["bum" /* BEFORE_UNMOUNT */ ]: "beforeUnmount hook",
    ["um" /* UNMOUNTED */ ]: "unmounted hook",
    ["a" /* ACTIVATED */ ]: "activated hook",
    ["da" /* DEACTIVATED */ ]: "deactivated hook",
    ["ec" /* ERROR_CAPTURED */ ]: "errorCaptured hook",
    ["rtc" /* RENDER_TRACKED */ ]: "renderTracked hook",
    ["rtg" /* RENDER_TRIGGERED */ ]: "renderTriggered hook",
    [0 /* SETUP_FUNCTION */ ]: "setup function",
    [1 /* RENDER_FUNCTION */ ]: "render function",
    [2 /* WATCH_GETTER */ ]: "watcher getter",
    [3 /* WATCH_CALLBACK */ ]: "watcher callback",
    [4 /* WATCH_CLEANUP */ ]: "watcher cleanup function",
    [5 /* NATIVE_EVENT_HANDLER */ ]: "native event handler",
    [6 /* COMPONENT_EVENT_HANDLER */ ]: "component event handler",
    [7 /* VNODE_HOOK */ ]: "vnode hook",
    [8 /* DIRECTIVE_HOOK */ ]: "directive hook",
    [9 /* TRANSITION_HOOK */ ]: "transition hook",
    [10 /* APP_ERROR_HANDLER */ ]: "app errorHandler",
    [11 /* APP_WARN_HANDLER */ ]: "app warnHandler",
    [12 /* FUNCTION_REF */ ]: "ref function",
    [13 /* ASYNC_COMPONENT_LOADER */ ]: "async component loader",
    [14 /* SCHEDULER */ ]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function $78da16583ad93b9f$export$b22fcaf88446e9bf(fn, instance, type, args) {
    let res;
    try {
        res = args ? fn(...args) : fn();
    } catch (err) {
        $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, type);
    }
    return res;
}
function $78da16583ad93b9f$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $3LSrV.isFunction)(fn)) {
        const res = $78da16583ad93b9f$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $3LSrV.isPromise)(res)) res.catch((err)=>{
            $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    const values = [];
    for(let i = 0; i < fn.length; i++)values.push($78da16583ad93b9f$export$dae85862a8d94378(fn[i], instance, type, args));
    return values;
}
function $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        // the exposed instance is the render proxy to keep it consistent with 2.x
        const exposedInstance = instance.proxy;
        // in production the hook receives only the error code
        const errorInfo = type;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        // app-level handling
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            $78da16583ad93b9f$export$b22fcaf88446e9bf(appErrorHandler, null, 10 /* APP_ERROR_HANDLER */ , [
                err,
                exposedInstance,
                errorInfo
            ]);
            return;
        }
    }
    $78da16583ad93b9f$var$logError(err, type, contextVNode, throwInDev);
}
function $78da16583ad93b9f$var$logError(err, type, contextVNode, throwInDev = true) {
    // recover in prod to reduce the impact on end-user
    console.error(err);
}
let $78da16583ad93b9f$var$isFlushing = false;
let $78da16583ad93b9f$var$isFlushPending = false;
const $78da16583ad93b9f$var$queue = [];
let $78da16583ad93b9f$var$flushIndex = 0;
const $78da16583ad93b9f$var$pendingPreFlushCbs = [];
let $78da16583ad93b9f$var$activePreFlushCbs = null;
let $78da16583ad93b9f$var$preFlushIndex = 0;
const $78da16583ad93b9f$var$pendingPostFlushCbs = [];
let $78da16583ad93b9f$var$activePostFlushCbs = null;
let $78da16583ad93b9f$var$postFlushIndex = 0;
const $78da16583ad93b9f$var$resolvedPromise = /*#__PURE__*/ Promise.resolve();
let $78da16583ad93b9f$var$currentFlushPromise = null;
let $78da16583ad93b9f$var$currentPreFlushParentJob = null;
const $78da16583ad93b9f$var$RECURSION_LIMIT = 100;
function $78da16583ad93b9f$export$bdd553fddd433dcb(fn) {
    const p = $78da16583ad93b9f$var$currentFlushPromise || $78da16583ad93b9f$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
// #2768
// Use binary-search to find a suitable position in the queue,
// so that the queue maintains the increasing order of job's id,
// which can prevent the job from being skipped and also can avoid repeated patching.
function $78da16583ad93b9f$var$findInsertionIndex(id) {
    // the start index should be `flushIndex + 1`
    let start = $78da16583ad93b9f$var$flushIndex + 1;
    let end = $78da16583ad93b9f$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJobId = $78da16583ad93b9f$var$getId($78da16583ad93b9f$var$queue[middle]);
        middleJobId < id ? start = middle + 1 : end = middle;
    }
    return start;
}
function $78da16583ad93b9f$var$queueJob(job) {
    // the dedupe search uses the startIndex argument of Array.includes()
    // by default the search index includes the current job that is being run
    // so it cannot recursively trigger itself again.
    // if the job is a watch() callback, the search will start with a +1 index to
    // allow it recursively trigger itself - it is the user's responsibility to
    // ensure it doesn't end up in an infinite loop.
    if ((!$78da16583ad93b9f$var$queue.length || !$78da16583ad93b9f$var$queue.includes(job, $78da16583ad93b9f$var$isFlushing && job.allowRecurse ? $78da16583ad93b9f$var$flushIndex + 1 : $78da16583ad93b9f$var$flushIndex)) && job !== $78da16583ad93b9f$var$currentPreFlushParentJob) {
        if (job.id == null) $78da16583ad93b9f$var$queue.push(job);
        else $78da16583ad93b9f$var$queue.splice($78da16583ad93b9f$var$findInsertionIndex(job.id), 0, job);
        $78da16583ad93b9f$var$queueFlush();
    }
}
function $78da16583ad93b9f$var$queueFlush() {
    if (!$78da16583ad93b9f$var$isFlushing && !$78da16583ad93b9f$var$isFlushPending) {
        $78da16583ad93b9f$var$isFlushPending = true;
        $78da16583ad93b9f$var$currentFlushPromise = $78da16583ad93b9f$var$resolvedPromise.then($78da16583ad93b9f$var$flushJobs);
    }
}
function $78da16583ad93b9f$var$invalidateJob(job) {
    const i = $78da16583ad93b9f$var$queue.indexOf(job);
    if (i > $78da16583ad93b9f$var$flushIndex) $78da16583ad93b9f$var$queue.splice(i, 1);
}
function $78da16583ad93b9f$var$queueCb(cb, activeQueue, pendingQueue, index) {
    if (!(0, $3LSrV.isArray)(cb)) {
        if (!activeQueue || !activeQueue.includes(cb, cb.allowRecurse ? index + 1 : index)) pendingQueue.push(cb);
    } else // if cb is an array, it is a component lifecycle hook which can only be
    // triggered by a job, which is already deduped in the main queue, so
    // we can skip duplicate check here to improve perf
    pendingQueue.push(...cb);
    $78da16583ad93b9f$var$queueFlush();
}
function $78da16583ad93b9f$var$queuePreFlushCb(cb) {
    $78da16583ad93b9f$var$queueCb(cb, $78da16583ad93b9f$var$activePreFlushCbs, $78da16583ad93b9f$var$pendingPreFlushCbs, $78da16583ad93b9f$var$preFlushIndex);
}
function $78da16583ad93b9f$export$59536a0199721cab(cb) {
    $78da16583ad93b9f$var$queueCb(cb, $78da16583ad93b9f$var$activePostFlushCbs, $78da16583ad93b9f$var$pendingPostFlushCbs, $78da16583ad93b9f$var$postFlushIndex);
}
function $78da16583ad93b9f$var$flushPreFlushCbs(seen, parentJob = null) {
    if ($78da16583ad93b9f$var$pendingPreFlushCbs.length) {
        $78da16583ad93b9f$var$currentPreFlushParentJob = parentJob;
        $78da16583ad93b9f$var$activePreFlushCbs = [
            ...new Set($78da16583ad93b9f$var$pendingPreFlushCbs)
        ];
        $78da16583ad93b9f$var$pendingPreFlushCbs.length = 0;
        for($78da16583ad93b9f$var$preFlushIndex = 0; $78da16583ad93b9f$var$preFlushIndex < $78da16583ad93b9f$var$activePreFlushCbs.length; $78da16583ad93b9f$var$preFlushIndex++)$78da16583ad93b9f$var$activePreFlushCbs[$78da16583ad93b9f$var$preFlushIndex]();
        $78da16583ad93b9f$var$activePreFlushCbs = null;
        $78da16583ad93b9f$var$preFlushIndex = 0;
        $78da16583ad93b9f$var$currentPreFlushParentJob = null;
        // recursively flush until it drains
        $78da16583ad93b9f$var$flushPreFlushCbs(seen, parentJob);
    }
}
function $78da16583ad93b9f$var$flushPostFlushCbs(seen) {
    // flush any pre cbs queued during the flush (e.g. pre watchers)
    $78da16583ad93b9f$var$flushPreFlushCbs();
    if ($78da16583ad93b9f$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($78da16583ad93b9f$var$pendingPostFlushCbs)
        ];
        $78da16583ad93b9f$var$pendingPostFlushCbs.length = 0;
        // #1947 already has active queue, nested flushPostFlushCbs call
        if ($78da16583ad93b9f$var$activePostFlushCbs) {
            $78da16583ad93b9f$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $78da16583ad93b9f$var$activePostFlushCbs = deduped;
        $78da16583ad93b9f$var$activePostFlushCbs.sort((a, b)=>$78da16583ad93b9f$var$getId(a) - $78da16583ad93b9f$var$getId(b));
        for($78da16583ad93b9f$var$postFlushIndex = 0; $78da16583ad93b9f$var$postFlushIndex < $78da16583ad93b9f$var$activePostFlushCbs.length; $78da16583ad93b9f$var$postFlushIndex++)$78da16583ad93b9f$var$activePostFlushCbs[$78da16583ad93b9f$var$postFlushIndex]();
        $78da16583ad93b9f$var$activePostFlushCbs = null;
        $78da16583ad93b9f$var$postFlushIndex = 0;
    }
}
const $78da16583ad93b9f$var$getId = (job)=>job.id == null ? Infinity : job.id;
function $78da16583ad93b9f$var$flushJobs(seen) {
    $78da16583ad93b9f$var$isFlushPending = false;
    $78da16583ad93b9f$var$isFlushing = true;
    $78da16583ad93b9f$var$flushPreFlushCbs(seen);
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child so its render effect will have smaller
    //    priority number)
    // 2. If a component is unmounted during a parent component's update,
    //    its update can be skipped.
    $78da16583ad93b9f$var$queue.sort((a, b)=>$78da16583ad93b9f$var$getId(a) - $78da16583ad93b9f$var$getId(b));
    // conditional usage of checkRecursiveUpdate must be determined out of
    // try ... catch block since Rollup by default de-optimizes treeshaking
    // inside try-catch. This can leave all warning code unshaked. Although
    // they would get eventually shaken by a minifier like terser, some minifiers
    // would fail to do that (e.g. https://github.com/evanw/esbuild/issues/1610)
    const check = (0, $3LSrV.NOOP);
    try {
        for($78da16583ad93b9f$var$flushIndex = 0; $78da16583ad93b9f$var$flushIndex < $78da16583ad93b9f$var$queue.length; $78da16583ad93b9f$var$flushIndex++){
            const job = $78da16583ad93b9f$var$queue[$78da16583ad93b9f$var$flushIndex];
            if (job && job.active !== false) // console.log(`running:`, job.id)
            $78da16583ad93b9f$export$b22fcaf88446e9bf(job, null, 14 /* SCHEDULER */ );
        }
    } finally{
        $78da16583ad93b9f$var$flushIndex = 0;
        $78da16583ad93b9f$var$queue.length = 0;
        $78da16583ad93b9f$var$flushPostFlushCbs(seen);
        $78da16583ad93b9f$var$isFlushing = false;
        $78da16583ad93b9f$var$currentFlushPromise = null;
        // some postFlushCb queued jobs!
        // keep flushing until it drains.
        if ($78da16583ad93b9f$var$queue.length || $78da16583ad93b9f$var$pendingPreFlushCbs.length || $78da16583ad93b9f$var$pendingPostFlushCbs.length) $78da16583ad93b9f$var$flushJobs(seen);
    }
}
function $78da16583ad93b9f$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $78da16583ad93b9f$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $78da16583ad93b9f$var$getComponentName(instance.type);
            $78da16583ad93b9f$export$c106dd0671a0fc2d(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. ` + `This means you have a reactive effect that is mutating its own ` + `dependencies and thus recursively triggering itself. Possible sources ` + `include component template, render function, updated hook or ` + `watcher source function.`);
            return true;
        } else seen.set(fn, count + 1);
    }
}
/* eslint-disable no-restricted-globals */ let $78da16583ad93b9f$var$isHmrUpdating = false;
const $78da16583ad93b9f$var$hmrDirtyComponents = new Set();
const $78da16583ad93b9f$var$map = new Map();
function $78da16583ad93b9f$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $78da16583ad93b9f$var$map.get(id);
    if (!record) {
        $78da16583ad93b9f$var$createRecord(id, instance.type);
        record = $78da16583ad93b9f$var$map.get(id);
    }
    record.instances.add(instance);
}
function $78da16583ad93b9f$var$unregisterHMR(instance) {
    $78da16583ad93b9f$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $78da16583ad93b9f$var$createRecord(id, initialDef) {
    if ($78da16583ad93b9f$var$map.has(id)) return false;
    $78da16583ad93b9f$var$map.set(id, {
        initialDef: $78da16583ad93b9f$var$normalizeClassComponent(initialDef),
        instances: new Set()
    });
    return true;
}
function $78da16583ad93b9f$var$normalizeClassComponent(component) {
    return $78da16583ad93b9f$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $78da16583ad93b9f$var$rerender(id, newRender) {
    const record = $78da16583ad93b9f$var$map.get(id);
    if (!record) return;
    // update initial record (for not-yet-rendered component)
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $78da16583ad93b9f$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        // this flag forces child components with slot content to update
        $78da16583ad93b9f$var$isHmrUpdating = true;
        instance.update();
        $78da16583ad93b9f$var$isHmrUpdating = false;
    });
}
function $78da16583ad93b9f$var$reload(id, newComp) {
    const record = $78da16583ad93b9f$var$map.get(id);
    if (!record) return;
    newComp = $78da16583ad93b9f$var$normalizeClassComponent(newComp);
    // update initial def (for not-yet-rendered components)
    $78da16583ad93b9f$var$updateComponentDef(record.initialDef, newComp);
    // create a snapshot which avoids the set being mutated during updates
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $78da16583ad93b9f$var$normalizeClassComponent(instance.type);
        if (!$78da16583ad93b9f$var$hmrDirtyComponents.has(oldComp)) {
            // 1. Update existing comp definition to match new one
            if (oldComp !== record.initialDef) $78da16583ad93b9f$var$updateComponentDef(oldComp, newComp);
            // 2. mark definition dirty. This forces the renderer to replace the
            // component on patch.
            $78da16583ad93b9f$var$hmrDirtyComponents.add(oldComp);
        }
        // 3. invalidate options resolution cache
        instance.appContext.optionsCache.delete(instance.type);
        // 4. actually update
        if (instance.ceReload) {
            // custom element
            $78da16583ad93b9f$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $78da16583ad93b9f$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) {
            // 4. Force the parent instance to re-render. This will cause all updated
            // components to be unmounted and re-mounted. Queue the update so that we
            // don't end up forcing the same parent to re-render multiple times.
            $78da16583ad93b9f$var$queueJob(instance.parent.update);
            // instance is the inner component of an async custom element
            // invoke to reset styles
            if (instance.parent.type.__asyncLoader && instance.parent.ceReload) instance.parent.ceReload(newComp.styles);
        } else if (instance.appContext.reload) // root instance mounted via createApp() has a reload method
        instance.appContext.reload();
        else if (typeof window !== "undefined") // root instance inside tree created via raw render(). Force reload.
        window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    // 5. make sure to cleanup dirty hmr components after update
    $78da16583ad93b9f$export$59536a0199721cab(()=>{
        for (const instance of instances)$78da16583ad93b9f$var$hmrDirtyComponents.delete($78da16583ad93b9f$var$normalizeClassComponent(instance.type));
    });
}
function $78da16583ad93b9f$var$updateComponentDef(oldComp, newComp) {
    (0, $3LSrV.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $78da16583ad93b9f$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. ` + `Full reload required.`);
        }
    };
}
let $78da16583ad93b9f$export$6922d3b3a607469e;
let $78da16583ad93b9f$var$buffer = [];
let $78da16583ad93b9f$var$devtoolsNotInstalled = false;
function $78da16583ad93b9f$var$emit(event, ...args) {
    if ($78da16583ad93b9f$export$6922d3b3a607469e) $78da16583ad93b9f$export$6922d3b3a607469e.emit(event, ...args);
    else if (!$78da16583ad93b9f$var$devtoolsNotInstalled) $78da16583ad93b9f$var$buffer.push({
        event: event,
        args: args
    });
}
function $78da16583ad93b9f$export$b0c258b32c26c785(hook, target) {
    var _a, _b;
    $78da16583ad93b9f$export$6922d3b3a607469e = hook;
    if ($78da16583ad93b9f$export$6922d3b3a607469e) {
        $78da16583ad93b9f$export$6922d3b3a607469e.enabled = true;
        $78da16583ad93b9f$var$buffer.forEach(({ event: event, args: args })=>$78da16583ad93b9f$export$6922d3b3a607469e.emit(event, ...args));
        $78da16583ad93b9f$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) === null || _b === void 0 ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $78da16583ad93b9f$export$b0c258b32c26c785(newHook, target);
        });
        // clear buffer after 3s - the user probably doesn't have devtools installed
        // at all, and keeping the buffer will cause memory leaks (#4738)
        setTimeout(()=>{
            if (!$78da16583ad93b9f$export$6922d3b3a607469e) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $78da16583ad93b9f$var$devtoolsNotInstalled = true;
                $78da16583ad93b9f$var$buffer = [];
            }
        }, 3000);
    } else {
        // non-browser env, assume not installed
        $78da16583ad93b9f$var$devtoolsNotInstalled = true;
        $78da16583ad93b9f$var$buffer = [];
    }
}
function $78da16583ad93b9f$var$devtoolsInitApp(app, version) {
    $78da16583ad93b9f$var$emit("app:init" /* APP_INIT */ , app, version, {
        Fragment: $78da16583ad93b9f$export$ffb0004e005737fa,
        Text: $78da16583ad93b9f$export$5f1af8db9871e1d6,
        Comment: $78da16583ad93b9f$export$4d299b491347818a,
        Static: $78da16583ad93b9f$export$c1b9a1d3af45b7b6
    });
}
function $78da16583ad93b9f$var$devtoolsUnmountApp(app) {
    $78da16583ad93b9f$var$emit("app:unmount" /* APP_UNMOUNT */ , app);
}
const $78da16583ad93b9f$var$devtoolsComponentAdded = /*#__PURE__*/ $78da16583ad93b9f$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $78da16583ad93b9f$var$devtoolsComponentUpdated = /*#__PURE__*/ $78da16583ad93b9f$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $78da16583ad93b9f$var$devtoolsComponentRemoved = /*#__PURE__*/ $78da16583ad93b9f$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
function $78da16583ad93b9f$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $78da16583ad93b9f$var$emit(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : undefined, component);
    };
}
const $78da16583ad93b9f$var$devtoolsPerfStart = /*#__PURE__*/ $78da16583ad93b9f$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $78da16583ad93b9f$var$devtoolsPerfEnd = /*#__PURE__*/ $78da16583ad93b9f$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $78da16583ad93b9f$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $78da16583ad93b9f$var$emit(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $78da16583ad93b9f$var$devtoolsComponentEmit(component, event, params) {
    $78da16583ad93b9f$var$emit("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $78da16583ad93b9f$var$emit$1(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $3LSrV.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    // for v-model update:xxx events, apply modifiers on args
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $3LSrV.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>a.trim());
        if (number) args = rawArgs.map((0, $3LSrV.toNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $3LSrV.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $3LSrV.toHandlerKey)((0, $3LSrV.camelize)(event))];
    // for v-model update:xxx events, also trigger kebab-case equivalent
    // for props passed via kebab-case
    if (!handler && isModelListener) handler = props[handlerName = (0, $3LSrV.toHandlerKey)((0, $3LSrV.hyphenate)(event))];
    if (handler) $78da16583ad93b9f$export$dae85862a8d94378(handler, instance, 6 /* COMPONENT_EVENT_HANDLER */ , args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $78da16583ad93b9f$export$dae85862a8d94378(onceHandler, instance, 6 /* COMPONENT_EVENT_HANDLER */ , args);
    }
}
function $78da16583ad93b9f$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== undefined) return cached;
    const raw = comp.emits;
    let normalized = {};
    // apply mixin/extends props
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $3LSrV.isFunction)(comp)) {
        const extendEmits = (raw)=>{
            const normalizedFromExtend = $78da16583ad93b9f$var$normalizeEmitsOptions(raw, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $3LSrV.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        cache.set(comp, null);
        return null;
    }
    if ((0, $3LSrV.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $3LSrV.extend)(normalized, raw);
    cache.set(comp, normalized);
    return normalized;
}
// Check if an incoming prop key is a declared emit event listener.
// e.g. With `emits: { click: null }`, props named `onClick` and `onclick` are
// both considered matched listeners.
function $78da16583ad93b9f$var$isEmitListener(options, key) {
    if (!options || !(0, $3LSrV.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $3LSrV.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $3LSrV.hasOwn)(options, (0, $3LSrV.hyphenate)(key)) || (0, $3LSrV.hasOwn)(options, key);
}
/**
 * mark the current rendering instance for asset resolution (e.g.
 * resolveComponent, resolveDirective) during render
 */ let $78da16583ad93b9f$var$currentRenderingInstance = null;
let $78da16583ad93b9f$var$currentScopeId = null;
/**
 * Note: rendering calls maybe nested. The function returns the parent rendering
 * instance if present, which should be restored after the render is done:
 *
 * ```js
 * const prev = setCurrentRenderingInstance(i)
 * // ...render
 * setCurrentRenderingInstance(prev)
 * ```
 */ function $78da16583ad93b9f$var$setCurrentRenderingInstance(instance) {
    const prev = $78da16583ad93b9f$var$currentRenderingInstance;
    $78da16583ad93b9f$var$currentRenderingInstance = instance;
    $78da16583ad93b9f$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
/**
 * Set scope id when creating hoisted vnodes.
 * @private compiler helper
 */ function $78da16583ad93b9f$export$ac020265ca2cc4cd(id) {
    $78da16583ad93b9f$var$currentScopeId = id;
}
/**
 * Technically we no longer need this after 3.0.8 but we need to keep the same
 * API for backwards compat w/ code generated by compilers.
 * @private
 */ function $78da16583ad93b9f$export$f2dc6805dc11834e() {
    $78da16583ad93b9f$var$currentScopeId = null;
}
/**
 * Only for backwards compat
 * @private
 */ const $78da16583ad93b9f$export$15ba313e13f3dd04 = (_id)=>$78da16583ad93b9f$export$694b237e827a3d23;
/**
 * Wrap a slot function to memoize current rendering instance
 * @private compiler helper
 */ function $78da16583ad93b9f$export$694b237e827a3d23(fn, ctx = $78da16583ad93b9f$var$currentRenderingInstance, isNonScopedSlot // false only
) {
    if (!ctx) return fn;
    // already normalized
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        // If a user calls a compiled slot inside a template expression (#1745), it
        // can mess up block tracking, so by default we disable block tracking and
        // force bail out when invoking a compiled slot (indicated by the ._d flag).
        // This isn't necessary if rendering a compiled `<slot>`, so we flip the
        // ._d flag off when invoking the wrapped fn inside `renderSlot`.
        if (renderFnWithContext._d) $78da16583ad93b9f$export$c20bee82f26f1e27(-1);
        const prevInstance = $78da16583ad93b9f$var$setCurrentRenderingInstance(ctx);
        const res = fn(...args);
        $78da16583ad93b9f$var$setCurrentRenderingInstance(prevInstance);
        if (renderFnWithContext._d) $78da16583ad93b9f$export$c20bee82f26f1e27(1);
        if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    // mark normalized to avoid duplicated wrapping
    renderFnWithContext._n = true;
    // mark this as compiled by default
    // this is used in vnode.ts -> normalizeChildren() to set the slot
    // rendering flag.
    renderFnWithContext._c = true;
    // disable block tracking by default
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
/**
 * dev only flag to track whether $attrs was used during render.
 * If $attrs was used during render then the warning for failed attrs
 * fallthrough can be suppressed.
 */ let $78da16583ad93b9f$var$accessedAttrs = false;
function $78da16583ad93b9f$var$markAttrsAccessed() {
    $78da16583ad93b9f$var$accessedAttrs = true;
}
function $78da16583ad93b9f$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, props: props, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    let result;
    let fallthroughAttrs;
    const prev = $78da16583ad93b9f$var$setCurrentRenderingInstance(instance);
    try {
        if (vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */ ) {
            // withProxy is a proxy with a different `has` trap only for
            // runtime-compiled render functions using `with` block.
            const proxyToUse = withProxy || proxy;
            result = $78da16583ad93b9f$var$normalizeVNode(render.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            // functional
            const render = Component;
            result = $78da16583ad93b9f$var$normalizeVNode(render.length > 1 ? render(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render(props, null));
            fallthroughAttrs = Component.props ? attrs : $78da16583ad93b9f$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $78da16583ad93b9f$var$blockStack.length = 0;
        $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, 1 /* RENDER_FUNCTION */ );
        result = $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a);
    }
    // attr merging
    // in dev mode, comments are preserved, and it's possible for a template
    // to have comments along side the root element which makes it a fragment
    let root = result;
    let setRoot = undefined;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7 /* COMPONENT */ ) {
                if (propsOptions && keys.some((0, $3LSrV.isModelListener))) // If a v-model listener (onUpdate:xxx) has a corresponding declared
                // prop, it indicates this component expects to handle v-model and
                // it should not fallthrough.
                // related: #1543, #1643, #1989
                fallthroughAttrs = $78da16583ad93b9f$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    // inherit directives
    if (vnode.dirs) {
        // clone before mutating since the root may be a hoisted vnode
        root = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(root);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    // inherit transition data
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $78da16583ad93b9f$var$setCurrentRenderingInstance(prev);
    return result;
}
/**
 * dev only
 * In dev mode, template root level comments are rendered, which turns the
 * template into a fragment root, but we need to locate the single element
 * root for attrs and scope id processing.
 */ const $78da16583ad93b9f$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $78da16583ad93b9f$var$filterSingleRoot(rawChildren);
    if (!childRoot) return [
        vnode,
        undefined
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $78da16583ad93b9f$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $78da16583ad93b9f$var$filterSingleRoot(children) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($78da16583ad93b9f$export$3868d13f8734ae81(child)) // ignore user comment
        {
            if (child.type !== $78da16583ad93b9f$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) // has more than 1 non-comment child, return now
                return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $78da16583ad93b9f$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $3LSrV.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $78da16583ad93b9f$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $3LSrV.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $78da16583ad93b9f$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 /* ELEMENT */  || vnode.type === $78da16583ad93b9f$export$4d299b491347818a // potential v-if branch switch
    ;
};
function $78da16583ad93b9f$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    // force child update for runtime directive or transition on component vnode.
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024 /* DYNAMIC_SLOTS */ ) // slot content that references values that might have changed,
        // e.g. in a v-for
        return true;
        if (patchFlag & 16 /* FULL_PROPS */ ) {
            if (!prevProps) return !!nextProps;
            // presence of this flag indicates props are always non-null
            return $78da16583ad93b9f$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8 /* PROPS */ ) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$78da16583ad93b9f$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        // this path is only taken by manually written render functions
        // so presence of any children leads to a forced update
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $78da16583ad93b9f$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $78da16583ad93b9f$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$78da16583ad93b9f$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $78da16583ad93b9f$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el // HostNode
) {
    while(parent && parent.subTree === vnode){
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
    }
}
const $78da16583ad93b9f$var$isSuspense = (type)=>type.__isSuspense;
// Suspense exposes a component-like API, and is treated like a component
// in the compiler, but internally it's a special built-in type that hooks
// directly into the renderer.
const $78da16583ad93b9f$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, // platform-specific impl passed from renderer
    rendererInternals) {
        if (n1 == null) $78da16583ad93b9f$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals);
        else $78da16583ad93b9f$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, rendererInternals);
    },
    hydrate: $78da16583ad93b9f$var$hydrateSuspense,
    create: $78da16583ad93b9f$var$createSuspenseBoundary,
    normalize: $78da16583ad93b9f$var$normalizeSuspenseChildren
};
// Force-casted public typing for h and TSX props inference
const $78da16583ad93b9f$export$74bf444e3cd11ea5 = $78da16583ad93b9f$var$SuspenseImpl;
function $78da16583ad93b9f$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $3LSrV.isFunction)(eventListener)) eventListener();
}
function $78da16583ad93b9f$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $78da16583ad93b9f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals);
    // start mounting the content subtree in an off-dom container
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds);
    // now check if we have encountered any async deps
    if (suspense.deps > 0) {
        // has async
        // invoke @fallback event
        $78da16583ad93b9f$var$triggerEvent(vnode, "onPending");
        $78da16583ad93b9f$var$triggerEvent(vnode, "onFallback");
        // mount the fallback tree
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds);
        $78da16583ad93b9f$var$setActiveBranch(suspense, vnode.ssFallback);
    } else // Suspense has no async deps. Just resolve.
    suspense.resolve();
}
function $78da16583ad93b9f$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($78da16583ad93b9f$var$isSameVNodeType(newBranch, pendingBranch)) {
            // same root type but content may have changed.
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                patch(activeBranch, newFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                $78da16583ad93b9f$var$setActiveBranch(suspense, newFallback);
            }
        } else {
            // toggled before pending tree is resolved
            suspense.pendingId++;
            if (isHydrating) {
                // if toggled before hydration is finished, the current DOM tree is
                // no longer valid. set it as the active branch so it will be unmounted
                // when resolved
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            // increment pending ID. this is used to invalidate async callbacks
            // reset suspense state
            suspense.deps = 0;
            // discard effects from pending branch
            suspense.effects.length = 0;
            // discard previous container
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                // already in fallback state
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                    $78da16583ad93b9f$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $78da16583ad93b9f$var$isSameVNodeType(newBranch, activeBranch)) {
                // toggled "back" to current active branch
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                // force resolve
                suspense.resolve(true);
            } else {
                // switched to a 3rd branch
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $78da16583ad93b9f$var$isSameVNodeType(newBranch, activeBranch)) {
        // root did not change, just normal patch
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        $78da16583ad93b9f$var$setActiveBranch(suspense, newBranch);
    } else {
        // root node toggled
        // invoke @pending event
        $78da16583ad93b9f$var$triggerEvent(n2, "onPending");
        // mount pending branch in off-dom container
        suspense.pendingBranch = newBranch;
        suspense.pendingId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        if (suspense.deps <= 0) // incoming branch has no async deps, resolve now.
        suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $78da16583ad93b9f$var$hasWarned = false;
function $78da16583ad93b9f$var$createSuspenseBoundary(vnode, parent, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    const timeout = (0, $3LSrV.toNumber)(vnode.props && vnode.props.timeout);
    const suspense = {
        vnode: vnode,
        parent: parent,
        parentComponent: parentComponent,
        isSVG: isSVG,
        container: container,
        hiddenContainer: hiddenContainer,
        anchor: anchor,
        deps: 0,
        pendingId: 0,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: true,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false) {
            const { vnode: vnode, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent, container: container } = suspense;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                const delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) move(pendingBranch, container, anchor, 0 /* ENTER */ );
                };
                // this is initial anchor on mount
                let { anchor: anchor } = suspense;
                // unmount current active tree
                if (activeBranch) {
                    // if the fallback tree was mounted, it may have been moved
                    // as part of a parent suspense. get the latest anchor for insertion
                    anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent, suspense, true);
                }
                if (!delayEnter) // move content from off-dom container to actual container
                move(pendingBranch, container, anchor, 0 /* ENTER */ );
            }
            $78da16583ad93b9f$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            // flush buffered effects
            // check if there is a pending parent suspense
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    // found a pending parent suspense, merge buffered post jobs
                    // into that parent
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            // no pending parent suspense, flush all jobs
            if (!hasUnresolvedAncestor) $78da16583ad93b9f$export$59536a0199721cab(effects);
            suspense.effects = [];
            // invoke @resolve event
            $78da16583ad93b9f$var$triggerEvent(vnode, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode, activeBranch: activeBranch, parentComponent: parentComponent, container: container, isSVG: isSVG } = suspense;
            // invoke @fallback event
            $78da16583ad93b9f$var$triggerEvent(vnode, "onFallback");
            const anchor = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                // mount the fallback tree
                patch(null, fallbackVNode, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                $78da16583ad93b9f$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            // unmount current active branch
            unmount(activeBranch, parentComponent, null, true // shouldRemove
            );
            if (!delayEnter) mountFallback();
        },
        move (container, anchor, type) {
            suspense.activeBranch && move(suspense.activeBranch, container, anchor, type);
            suspense.container = container;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, 0 /* SETUP_FUNCTION */ );
            }).then((asyncSetupResult)=>{
                // retry when the setup() promise resolves.
                // component may have been unmounted before resolve.
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                // retry from this component
                instance.asyncResolved = true;
                const { vnode: vnode } = instance;
                $78da16583ad93b9f$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) // vnode may have been replaced if an update happened before the
                // async dep is resolved.
                vnode.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, isSVG, optimized);
                if (placeholder) remove(placeholder);
                $78da16583ad93b9f$var$updateHOCHostEl(instance, vnode.el);
                // only decrease deps count if suspense is not already resolved
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense, doRemove);
        }
    };
    return suspense;
}
function $78da16583ad93b9f$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    /* eslint-disable no-restricted-globals */ const suspense = vnode.suspense = $78da16583ad93b9f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement("div"), null, isSVG, slotScopeIds, optimized, rendererInternals, true);
    // there are two possible scenarios for server-rendered suspense:
    // - success: ssr content should be fully resolved
    // - failure: ssr content should be the fallback branch.
    // however, on the client we don't really know if it has failed or not
    // attempt to hydrate the DOM assuming it has succeeded, but we still
    // need to construct a suspense boundary first
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve();
    return result;
/* eslint-enable no-restricted-globals */ }
function $78da16583ad93b9f$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32 /* SLOTS_CHILDREN */ ;
    vnode.ssContent = $78da16583ad93b9f$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $78da16583ad93b9f$var$normalizeSuspenseSlot(children.fallback) : $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a);
}
function $78da16583ad93b9f$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $3LSrV.isFunction)(s)) {
        const trackBlock = $78da16583ad93b9f$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            // disableTracking: false
            // allow block tracking for compiled slots
            // (see ./componentRenderContext.ts)
            s._d = false;
            $78da16583ad93b9f$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $78da16583ad93b9f$var$currentBlock;
            $78da16583ad93b9f$var$closeBlock();
        }
    }
    if ((0, $3LSrV.isArray)(s)) {
        const singleChild = $78da16583ad93b9f$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $78da16583ad93b9f$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $78da16583ad93b9f$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $3LSrV.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $78da16583ad93b9f$export$59536a0199721cab(fn);
}
function $78da16583ad93b9f$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    const el = vnode.el = branch.el;
    // in case suspense is the root node of a component,
    // recursively update the HOC el
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $78da16583ad93b9f$var$updateHOCHostEl(parentComponent, el);
    }
}
function $78da16583ad93b9f$export$abe1e183e22e10ad(key, value) {
    if (!$78da16583ad93b9f$var$currentInstance) ;
    else {
        let provides = $78da16583ad93b9f$var$currentInstance.provides;
        // by default an instance inherits its parent's provides object
        // but when it needs to provide values of its own, it creates its
        // own provides object using parent provides object as prototype.
        // this way in `inject` we can simply look up injections from direct
        // parent and let the prototype chain do the work.
        const parentProvides = $78da16583ad93b9f$var$currentInstance.parent && $78da16583ad93b9f$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $78da16583ad93b9f$var$currentInstance.provides = Object.create(parentProvides);
        // TS doesn't allow symbol as index type
        provides[key] = value;
    }
}
function $78da16583ad93b9f$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    // fallback to `currentRenderingInstance` so that this can be called in
    // a functional component
    const instance = $78da16583ad93b9f$var$currentInstance || $78da16583ad93b9f$var$currentRenderingInstance;
    if (instance) {
        // #2400
        // to support `app.use` plugins,
        // fallback to appContext's `provides` if the instance is at root
        const provides = instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides;
        if (provides && key in provides) // TS doesn't allow symbol as index type
        return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $3LSrV.isFunction)(defaultValue) ? defaultValue.call(instance.proxy) : defaultValue;
    }
}
// Simple effect.
function $78da16583ad93b9f$export$ede35fc0e5500309(effect, options) {
    return $78da16583ad93b9f$var$doWatch(effect, null, options);
}
function $78da16583ad93b9f$export$b7f27ea67102d543(effect, options) {
    return $78da16583ad93b9f$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $78da16583ad93b9f$export$2035654f31b0e555(effect, options) {
    return $78da16583ad93b9f$var$doWatch(effect, null, {
        flush: "sync"
    });
}
// initial value for watchers to trigger on undefined initial values
const $78da16583ad93b9f$var$INITIAL_WATCHER_VALUE = {};
// implementation
function $78da16583ad93b9f$export$3db5d71bdb2d5499(source, cb, options) {
    return $78da16583ad93b9f$var$doWatch(source, cb, options);
}
function $78da16583ad93b9f$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, onTrack: onTrack, onTrigger: onTrigger } = (0, $3LSrV.EMPTY_OBJ)) {
    const warnInvalidSource = (s)=>{
        $78da16583ad93b9f$export$c106dd0671a0fc2d(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, ` + `a reactive object, or an array of these types.`);
    };
    const instance = $78da16583ad93b9f$var$currentInstance;
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $8bTPG.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $8bTPG.isShallow)(source);
    } else if ((0, $8bTPG.isReactive)(source)) {
        getter = ()=>source;
        deep = true;
    } else if ((0, $3LSrV.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $8bTPG.isReactive)(s) || (0, $8bTPG.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $8bTPG.isRef)(s)) return s.value;
                else if ((0, $8bTPG.isReactive)(s)) return $78da16583ad93b9f$var$traverse(s);
                else if ((0, $3LSrV.isFunction)(s)) return $78da16583ad93b9f$export$b22fcaf88446e9bf(s, instance, 2 /* WATCH_GETTER */ );
            });
    } else if ((0, $3LSrV.isFunction)(source)) {
        if (cb) // getter with cb
        getter = ()=>$78da16583ad93b9f$export$b22fcaf88446e9bf(source, instance, 2 /* WATCH_GETTER */ );
        else // no cb -> simple effect
        getter = ()=>{
            if (instance && instance.isUnmounted) return;
            if (cleanup) cleanup();
            return $78da16583ad93b9f$export$dae85862a8d94378(source, instance, 3 /* WATCH_CALLBACK */ , [
                onCleanup
            ]);
        };
    } else getter = (0, $3LSrV.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$78da16583ad93b9f$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $78da16583ad93b9f$export$b22fcaf88446e9bf(fn, instance, 4 /* WATCH_CLEANUP */ );
        };
    };
    // in SSR there is no need to setup an actual effect, and it should be noop
    // unless it's eager
    if ($78da16583ad93b9f$var$isInSSRComponentSetup) {
        // we will also not call the invalidate callback (+ runner is not set up)
        onCleanup = (0, $3LSrV.NOOP);
        if (!cb) getter();
        else if (immediate) $78da16583ad93b9f$export$dae85862a8d94378(cb, instance, 3 /* WATCH_CALLBACK */ , [
            getter(),
            isMultiSource ? [] : undefined,
            onCleanup
        ]);
        return 0, $3LSrV.NOOP;
    }
    let oldValue = isMultiSource ? [] : $78da16583ad93b9f$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active) return;
        if (cb) {
            // watch(source, cb)
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $3LSrV.hasChanged)(v1, oldValue[i])) : (0, $3LSrV.hasChanged)(newValue, oldValue)) || false) {
                // cleanup before running cb again
                if (cleanup) cleanup();
                $78da16583ad93b9f$export$dae85862a8d94378(cb, instance, 3 /* WATCH_CALLBACK */ , [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $78da16583ad93b9f$var$INITIAL_WATCHER_VALUE ? undefined : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else // watchEffect
        effect.run();
    };
    // important: mark the job as a watcher callback so that scheduler knows
    // it is allowed to self-trigger (#1727)
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job; // the scheduler function gets called directly
    else if (flush === "post") scheduler = ()=>$78da16583ad93b9f$var$queuePostRenderEffect(job, instance && instance.suspense);
    else // default: 'pre'
    scheduler = ()=>$78da16583ad93b9f$var$queuePreFlushCb(job);
    const effect = new (0, $8bTPG.ReactiveEffect)(getter, scheduler);
    // initial run
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $78da16583ad93b9f$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    return ()=>{
        effect.stop();
        if (instance && instance.scope) (0, $3LSrV.remove)(instance.scope.effects, effect);
    };
}
// this.$watch
function $78da16583ad93b9f$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $3LSrV.isString)(source) ? source.includes(".") ? $78da16583ad93b9f$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $3LSrV.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const cur = $78da16583ad93b9f$var$currentInstance;
    $78da16583ad93b9f$var$setCurrentInstance(this);
    const res = $78da16583ad93b9f$var$doWatch(getter, cb.bind(publicThis), options);
    if (cur) $78da16583ad93b9f$var$setCurrentInstance(cur);
    else $78da16583ad93b9f$var$unsetCurrentInstance();
    return res;
}
function $78da16583ad93b9f$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $78da16583ad93b9f$var$traverse(value, seen) {
    if (!(0, $3LSrV.isObject)(value) || value["__v_skip" /* SKIP */ ]) return value;
    seen = seen || new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    if ((0, $8bTPG.isRef)(value)) $78da16583ad93b9f$var$traverse(value.value, seen);
    else if ((0, $3LSrV.isArray)(value)) for(let i = 0; i < value.length; i++)$78da16583ad93b9f$var$traverse(value[i], seen);
    else if ((0, $3LSrV.isSet)(value) || (0, $3LSrV.isMap)(value)) value.forEach((v1)=>{
        $78da16583ad93b9f$var$traverse(v1, seen);
    });
    else if ((0, $3LSrV.isPlainObject)(value)) for(const key in value)$78da16583ad93b9f$var$traverse(value[key], seen);
    return value;
}
function $78da16583ad93b9f$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: new Map()
    };
    $78da16583ad93b9f$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $78da16583ad93b9f$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $78da16583ad93b9f$var$TransitionHookValidator = [
    Function,
    Array
];
const $78da16583ad93b9f$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: {
        mode: String,
        appear: Boolean,
        persisted: Boolean,
        // enter
        onBeforeEnter: $78da16583ad93b9f$var$TransitionHookValidator,
        onEnter: $78da16583ad93b9f$var$TransitionHookValidator,
        onAfterEnter: $78da16583ad93b9f$var$TransitionHookValidator,
        onEnterCancelled: $78da16583ad93b9f$var$TransitionHookValidator,
        // leave
        onBeforeLeave: $78da16583ad93b9f$var$TransitionHookValidator,
        onLeave: $78da16583ad93b9f$var$TransitionHookValidator,
        onAfterLeave: $78da16583ad93b9f$var$TransitionHookValidator,
        onLeaveCancelled: $78da16583ad93b9f$var$TransitionHookValidator,
        // appear
        onBeforeAppear: $78da16583ad93b9f$var$TransitionHookValidator,
        onAppear: $78da16583ad93b9f$var$TransitionHookValidator,
        onAfterAppear: $78da16583ad93b9f$var$TransitionHookValidator,
        onAppearCancelled: $78da16583ad93b9f$var$TransitionHookValidator
    },
    setup (props, { slots: slots }) {
        const instance = $78da16583ad93b9f$export$f13e630aa3915748();
        const state = $78da16583ad93b9f$export$d2a0a1bc267c90f6();
        let prevTransitionKey;
        return ()=>{
            const children = slots.default && $78da16583ad93b9f$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                // locate first non-comment child
                for (const c of children)if (c.type !== $78da16583ad93b9f$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            // there's no need to track reactivity for these props so use the raw
            // props for a bit better perf
            const rawProps = (0, $8bTPG.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $78da16583ad93b9f$var$emptyPlaceholder(child);
            // in the case of <transition><keep-alive/></transition>, we need to
            // compare the type of the kept-alive children.
            const innerChild = $78da16583ad93b9f$var$getKeepAliveChild(child);
            if (!innerChild) return $78da16583ad93b9f$var$emptyPlaceholder(child);
            const enterHooks = $78da16583ad93b9f$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $78da16583ad93b9f$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $78da16583ad93b9f$var$getKeepAliveChild(oldChild);
            let transitionKeyChanged = false;
            const { getTransitionKey: getTransitionKey } = innerChild.type;
            if (getTransitionKey) {
                const key = getTransitionKey();
                if (prevTransitionKey === undefined) prevTransitionKey = key;
                else if (key !== prevTransitionKey) {
                    prevTransitionKey = key;
                    transitionKeyChanged = true;
                }
            }
            // handle mode
            if (oldInnerChild && oldInnerChild.type !== $78da16583ad93b9f$export$4d299b491347818a && (!$78da16583ad93b9f$var$isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
                const leavingHooks = $78da16583ad93b9f$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                // update old tree's hooks in case of dynamic transition
                $78da16583ad93b9f$export$7770a22486565649(oldInnerChild, leavingHooks);
                // switching between different views
                if (mode === "out-in") {
                    state.isLeaving = true;
                    // return placeholder node and queue update when leave finishes
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        instance.update();
                    };
                    return $78da16583ad93b9f$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $78da16583ad93b9f$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $78da16583ad93b9f$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    // early removal callback
                    el._leaveCb = ()=>{
                        earlyRemove();
                        el._leaveCb = undefined;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
const $78da16583ad93b9f$export$abd95b5f5e8a8837 = $78da16583ad93b9f$var$BaseTransitionImpl;
function $78da16583ad93b9f$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
// The transition hooks are attached to the vnode as vnode.transition
// and will be called at appropriate timing in the renderer.
function $78da16583ad93b9f$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $78da16583ad93b9f$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $78da16583ad93b9f$export$dae85862a8d94378(hook, instance, 9 /* TRANSITION_HOOK */ , args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $3LSrV.isArray)(hook)) {
            if (hook.every((hook)=>hook.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            // for same element (v-show)
            if (el._leaveCb) el._leaveCb(true);
            // for toggled element with same key (v-if)
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $78da16583ad93b9f$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el._leaveCb) // force early removal (not cancelled)
            leavingVNode.el._leaveCb();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el._enterCb = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el._enterCb = undefined;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key = String(vnode.key);
            if (el._enterCb) el._enterCb(true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el._leaveCb = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el._leaveCb = undefined;
                if (leavingVNodesCache[key] === vnode) delete leavingVNodesCache[key];
            };
            leavingVNodesCache[key] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode) {
            return $78da16583ad93b9f$export$76ac1779589cd824(vnode, props, state, instance);
        }
    };
    return hooks;
}
// the placeholder really only handles one special case: KeepAlive
// in the case of a KeepAlive in a leave phase we need to return a KeepAlive
// placeholder with empty content to avoid the KeepAlive instance from being
// unmounted.
function $78da16583ad93b9f$var$emptyPlaceholder(vnode) {
    if ($78da16583ad93b9f$var$isKeepAlive(vnode)) {
        vnode = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $78da16583ad93b9f$var$getKeepAliveChild(vnode) {
    return $78da16583ad93b9f$var$isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : undefined : vnode;
}
function $78da16583ad93b9f$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 /* COMPONENT */  && vnode.component) $78da16583ad93b9f$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128 /* SUSPENSE */ ) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $78da16583ad93b9f$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        // #5360 inherit parent key in case of <template v-for>
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        // handle fragment children case, e.g. v-for
        if (child.type === $78da16583ad93b9f$export$ffb0004e005737fa) {
            if (child.patchFlag & 128 /* KEYED_FRAGMENT */ ) keyedFragmentCount++;
            ret = ret.concat($78da16583ad93b9f$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $78da16583ad93b9f$export$4d299b491347818a) ret.push(key != null ? $78da16583ad93b9f$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    // #1126 if a transition children list contains multiple sub fragments, these
    // fragments will be merged into a flat children array. Since each v-for
    // fragment may contain different static bindings inside, we need to de-op
    // these children to force full diffs to ensure correct behavior.
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2 /* BAIL */ ;
    return ret;
}
// implementation, close to no-op
function $78da16583ad93b9f$export$afa64b67e5a01c3b(options) {
    return (0, $3LSrV.isFunction)(options) ? {
        setup: options,
        name: options.name
    } : options;
}
const $78da16583ad93b9f$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
function $78da16583ad93b9f$export$d75d499b4c16cf21(source) {
    if ((0, $3LSrV.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            // interop module default
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $78da16583ad93b9f$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $78da16583ad93b9f$var$currentInstance;
            // already resolved
            if (resolvedComp) return ()=>$78da16583ad93b9f$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, 13 /* ASYNC_COMPONENT_LOADER */ , !errorComponent /* do not throw in dev if user provided error component */ );
            };
            // suspense-controlled or SSR.
            if (suspensible && instance.suspense || $78da16583ad93b9f$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$78da16583ad93b9f$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $78da16583ad93b9f$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $8bTPG.ref)(false);
            const error = (0, $8bTPG.ref)();
            const delayed = (0, $8bTPG.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $78da16583ad93b9f$var$isKeepAlive(instance.parent.vnode)) // parent is keep-alive, force update so the loaded component's
                // name is taken into account
                $78da16583ad93b9f$var$queueJob(instance.parent.update);
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $78da16583ad93b9f$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $78da16583ad93b9f$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $78da16583ad93b9f$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $78da16583ad93b9f$var$createInnerComp(comp, { vnode: { ref: ref, props: props, children: children, shapeFlag: shapeFlag }, parent: parent }) {
    const vnode = $78da16583ad93b9f$export$bf5c4cf060303d58(comp, props, children);
    // ensure inner component inherits the async wrapper's ref owner
    vnode.ref = ref;
    return vnode;
}
const $78da16583ad93b9f$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $78da16583ad93b9f$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $78da16583ad93b9f$export$f13e630aa3915748();
        // KeepAlive communicates with the instantiated renderer via the
        // ctx where the renderer passes in its internals,
        // and the KeepAlive instance exposes activate/deactivate implementations.
        // The whole point of this is to avoid importing KeepAlive directly in the
        // renderer to facilitate tree-shaking.
        const sharedContext = instance.ctx;
        // if the internal renderer is not registered, it indicates that this is server-side rendering,
        // for KeepAlive, we just need to render its children
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = new Map();
        const keys = new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, isSVG, optimized)=>{
            const instance = vnode.component;
            move(vnode, container, anchor, 0 /* ENTER */ , parentSuspense);
            // in case props have changed
            patch(instance.vnode, vnode, container, anchor, instance, parentSuspense, isSVG, vnode.slotScopeIds, optimized);
            $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
                instance.isDeactivated = false;
                if (instance.a) (0, $3LSrV.invokeArrayFns)(instance.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, instance.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) // Update components tree
            $78da16583ad93b9f$var$devtoolsComponentAdded(instance);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance = vnode.component;
            move(vnode, storageContainer, null, 1 /* LEAVE */ , parentSuspense);
            $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
                if (instance.da) (0, $3LSrV.invokeArrayFns)(instance.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, instance.parent, vnode);
                instance.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) // Update components tree
            $78da16583ad93b9f$var$devtoolsComponentAdded(instance);
        };
        function unmount(vnode) {
            // reset the shapeFlag so it can be properly unmounted
            $78da16583ad93b9f$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $78da16583ad93b9f$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || cached.type !== current.type) unmount(cached);
            else if (current) // current active instance should no longer be kept-alive.
            // we can't unmount it now but it might be later, so reset its flag now.
            $78da16583ad93b9f$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        // prune cache on include/exclude prop change
        $78da16583ad93b9f$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$78da16583ad93b9f$var$matches(include, name));
            exclude && pruneCache((name)=>!$78da16583ad93b9f$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        // cache sub tree after render
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            // fix #1621, the pendingCacheKey could be 0
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $78da16583ad93b9f$var$getInnerChild(instance.subTree));
        };
        $78da16583ad93b9f$export$6d1641039221b5cb(cacheSubtree);
        $78da16583ad93b9f$export$5876c47052fb88b1(cacheSubtree);
        $78da16583ad93b9f$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $78da16583ad93b9f$var$getInnerChild(subTree);
                if (cached.type === vnode.type) {
                    // current instance will be unmounted as part of keep-alive's unmount
                    $78da16583ad93b9f$var$resetShapeFlag(vnode);
                    // but invoke its deactivated hook here
                    const da = vnode.component.da;
                    da && $78da16583ad93b9f$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$78da16583ad93b9f$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4 /* STATEFUL_COMPONENT */ ) && !(rawVNode.shapeFlag & 128 /* SUSPENSE */ )) {
                current = null;
                return rawVNode;
            }
            let vnode = $78da16583ad93b9f$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            // for async components, name check should be based in its loaded
            // inner component if available
            const name = $78da16583ad93b9f$var$getComponentName($78da16583ad93b9f$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$78da16583ad93b9f$var$matches(include, name)) || exclude && name && $78da16583ad93b9f$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            // clone vnode if it's reused because we are going to mutate it
            if (vnode.el) {
                vnode = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128 /* SUSPENSE */ ) rawVNode.ssContent = vnode;
            }
            // #1513 it's possible for the returned vnode to be cloned due to attr
            // fallthrough or scopeId, so the vnode here may not be the final vnode
            // that is mounted. Instead of caching it directly, we store the pending
            // key and cache `instance.subTree` (the normalized vnode) in
            // beforeMount/beforeUpdate hooks.
            pendingCacheKey = key;
            if (cachedVNode) {
                // copy over mounted state
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) // recursively update transition hooks on subTree
                $78da16583ad93b9f$export$7770a22486565649(vnode, vnode.transition);
                // avoid vnode being mounted as fresh
                vnode.shapeFlag |= 512 /* COMPONENT_KEPT_ALIVE */ ;
                // make this key the freshest
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                // prune oldest entry
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            // avoid vnode being unmounted
            vnode.shapeFlag |= 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ;
            current = vnode;
            return $78da16583ad93b9f$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
const $78da16583ad93b9f$export$70eb8a58709972df = $78da16583ad93b9f$var$KeepAliveImpl;
function $78da16583ad93b9f$var$matches(pattern, name) {
    if ((0, $3LSrV.isArray)(pattern)) return pattern.some((p)=>$78da16583ad93b9f$var$matches(p, name));
    else if ((0, $3LSrV.isString)(pattern)) return pattern.split(",").includes(name);
    else if (pattern.test) return pattern.test(name);
    /* istanbul ignore next */ return false;
}
function $78da16583ad93b9f$export$ba52d824b95a2154(hook, target) {
    $78da16583ad93b9f$var$registerKeepAliveHook(hook, "a" /* ACTIVATED */ , target);
}
function $78da16583ad93b9f$export$bf1440eeaf5fa709(hook, target) {
    $78da16583ad93b9f$var$registerKeepAliveHook(hook, "da" /* DEACTIVATED */ , target);
}
function $78da16583ad93b9f$var$registerKeepAliveHook(hook, type, target = $78da16583ad93b9f$var$currentInstance) {
    // cache the deactivate branch check wrapper for injected hooks so the same
    // hook can be properly deduped by the scheduler. "__wdc" stands for "with
    // deactivation check".
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        // only fire the hook if the target instance is NOT in a deactivated branch.
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $78da16583ad93b9f$var$injectHook(type, wrappedHook, target);
    // In addition to registering it on the target instance, we walk up the parent
    // chain and register it on all ancestor instances that are keep-alive roots.
    // This avoids the need to walk the entire component tree when invoking these
    // hooks, and more importantly, avoids the need to track child components in
    // arrays.
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($78da16583ad93b9f$var$isKeepAlive(current.parent.vnode)) $78da16583ad93b9f$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $78da16583ad93b9f$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    // injectHook wraps the original for error handling, so make sure to remove
    // the wrapped version.
    const injected = $78da16583ad93b9f$var$injectHook(type, hook, keepAliveRoot, true);
    $78da16583ad93b9f$export$13348a43ccacfe58(()=>{
        (0, $3LSrV.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $78da16583ad93b9f$var$resetShapeFlag(vnode) {
    let shapeFlag = vnode.shapeFlag;
    if (shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ) shapeFlag -= 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ;
    if (shapeFlag & 512 /* COMPONENT_KEPT_ALIVE */ ) shapeFlag -= 512 /* COMPONENT_KEPT_ALIVE */ ;
    vnode.shapeFlag = shapeFlag;
}
function $78da16583ad93b9f$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 /* SUSPENSE */  ? vnode.ssContent : vnode;
}
function $78da16583ad93b9f$var$injectHook(type, hook, target = $78da16583ad93b9f$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        // cache the error handling wrapper for injected hooks so the same hook
        // can be properly deduped by the scheduler. "__weh" stands for "with error
        // handling".
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            // disable tracking inside all lifecycle hooks
            // since they can potentially be called inside effects.
            (0, $8bTPG.pauseTracking)();
            // Set currentInstance during hook invocation.
            // This assumes the hook does not synchronously trigger other hooks, which
            // can only be false when the user does something really funky.
            $78da16583ad93b9f$var$setCurrentInstance(target);
            const res = $78da16583ad93b9f$export$dae85862a8d94378(hook, target, type, args);
            $78da16583ad93b9f$var$unsetCurrentInstance();
            (0, $8bTPG.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $78da16583ad93b9f$var$createHook = (lifecycle)=>(hook, target = $78da16583ad93b9f$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$78da16583ad93b9f$var$isInSSRComponentSetup || lifecycle === "sp" /* SERVER_PREFETCH */ ) && $78da16583ad93b9f$var$injectHook(lifecycle, hook, target);
const $78da16583ad93b9f$export$23b7aeb0d671f804 = $78da16583ad93b9f$var$createHook("bm" /* BEFORE_MOUNT */ );
const $78da16583ad93b9f$export$6d1641039221b5cb = $78da16583ad93b9f$var$createHook("m" /* MOUNTED */ );
const $78da16583ad93b9f$export$ab91988a13872e4c = $78da16583ad93b9f$var$createHook("bu" /* BEFORE_UPDATE */ );
const $78da16583ad93b9f$export$5876c47052fb88b1 = $78da16583ad93b9f$var$createHook("u" /* UPDATED */ );
const $78da16583ad93b9f$export$40c420df62d2614 = $78da16583ad93b9f$var$createHook("bum" /* BEFORE_UNMOUNT */ );
const $78da16583ad93b9f$export$13348a43ccacfe58 = $78da16583ad93b9f$var$createHook("um" /* UNMOUNTED */ );
const $78da16583ad93b9f$export$ebf0c601f267bceb = $78da16583ad93b9f$var$createHook("sp" /* SERVER_PREFETCH */ );
const $78da16583ad93b9f$export$898295a813d662eb = $78da16583ad93b9f$var$createHook("rtg" /* RENDER_TRIGGERED */ );
const $78da16583ad93b9f$export$2b41f4235363e921 = $78da16583ad93b9f$var$createHook("rtc" /* RENDER_TRACKED */ );
function $78da16583ad93b9f$export$6a3a15856e50ad19(hook, target = $78da16583ad93b9f$var$currentInstance) {
    $78da16583ad93b9f$var$injectHook("ec" /* ERROR_CAPTURED */ , hook, target);
}
/**
Runtime helper for applying directives to a vnode. Example usage:

const comp = resolveComponent('comp')
const foo = resolveDirective('foo')
const bar = resolveDirective('bar')

return withDirectives(h(comp), [
  [foo, this.x],
  [bar, this.y]
])
*/ function $78da16583ad93b9f$var$validateDirectiveName(name) {
    if ((0, $3LSrV.isBuiltInDirective)(name)) $78da16583ad93b9f$export$c106dd0671a0fc2d("Do not use built-in directive ids as custom directive id: " + name);
}
/**
 * Adds directives to a VNode.
 */ function $78da16583ad93b9f$export$49729353e7c1e6c5(vnode, directives) {
    const internalInstance = $78da16583ad93b9f$var$currentRenderingInstance;
    if (internalInstance === null) return vnode;
    const instance = $78da16583ad93b9f$var$getExposeProxy(internalInstance) || internalInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $3LSrV.EMPTY_OBJ)] = directives[i];
        if ((0, $3LSrV.isFunction)(dir)) dir = {
            mounted: dir,
            updated: dir
        };
        if (dir.deep) $78da16583ad93b9f$var$traverse(value);
        bindings.push({
            dir: dir,
            instance: instance,
            value: value,
            oldValue: void 0,
            arg: arg,
            modifiers: modifiers
        });
    }
    return vnode;
}
function $78da16583ad93b9f$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            // disable tracking inside all lifecycle hooks
            // since they can potentially be called inside effects.
            (0, $8bTPG.pauseTracking)();
            $78da16583ad93b9f$export$dae85862a8d94378(hook, instance, 8 /* DIRECTIVE_HOOK */ , [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $8bTPG.resetTracking)();
        }
    }
}
const $78da16583ad93b9f$var$COMPONENTS = "components";
const $78da16583ad93b9f$var$DIRECTIVES = "directives";
/**
 * @private
 */ function $78da16583ad93b9f$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $78da16583ad93b9f$var$resolveAsset($78da16583ad93b9f$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $78da16583ad93b9f$var$NULL_DYNAMIC_COMPONENT = Symbol();
/**
 * @private
 */ function $78da16583ad93b9f$export$b44c564a05ca975(component) {
    if ((0, $3LSrV.isString)(component)) return $78da16583ad93b9f$var$resolveAsset($78da16583ad93b9f$var$COMPONENTS, component, false) || component;
    else // invalid types will fallthrough to createVNode and raise warning
    return component || $78da16583ad93b9f$var$NULL_DYNAMIC_COMPONENT;
}
/**
 * @private
 */ function $78da16583ad93b9f$export$a1989e995cd481be(name) {
    return $78da16583ad93b9f$var$resolveAsset($78da16583ad93b9f$var$DIRECTIVES, name);
}
// implementation
function $78da16583ad93b9f$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $78da16583ad93b9f$var$currentRenderingInstance || $78da16583ad93b9f$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        // explicit self name has highest priority
        if (type === $78da16583ad93b9f$var$COMPONENTS) {
            const selfName = $78da16583ad93b9f$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $3LSrV.camelize)(name) || selfName === (0, $3LSrV.capitalize)((0, $3LSrV.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $78da16583ad93b9f$var$resolve(instance[type] || Component[type], name) || // global registration
        $78da16583ad93b9f$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) // fallback to implicit self-reference
        return Component;
        return res;
    }
}
function $78da16583ad93b9f$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $3LSrV.camelize)(name)] || registry[(0, $3LSrV.capitalize)((0, $3LSrV.camelize)(name))]);
}
/**
 * Actual implementation
 */ function $78da16583ad93b9f$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $3LSrV.isArray)(source) || (0, $3LSrV.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, undefined, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, undefined, cached && cached[i]);
    } else if ((0, $3LSrV.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, undefined, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
/**
 * Compiler runtime helper for creating dynamic slots object
 * @private
 */ function $78da16583ad93b9f$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        // array of dynamic slot generated by <template v-for="..." #[...]>
        if ((0, $3LSrV.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) // conditional single slot generated by <template v-if="..." #foo>
        slots[slot.name] = slot.fn;
    }
    return slots;
}
/**
 * Compiler runtime helper for rendering `<slot/>`
 * @private
 */ function $78da16583ad93b9f$export$4abee4c34694ada1(slots, name, props = {}, // this is not a user-facing function, so the fallback is always generated by
// the compiler and guaranteed to be a function returning an array
fallback, noSlotted) {
    if ($78da16583ad93b9f$var$currentRenderingInstance.isCE || $78da16583ad93b9f$var$currentRenderingInstance.parent && $78da16583ad93b9f$var$isAsyncWrapper($78da16583ad93b9f$var$currentRenderingInstance.parent) && $78da16583ad93b9f$var$currentRenderingInstance.parent.isCE) return $78da16583ad93b9f$export$bf5c4cf060303d58("slot", name === "default" ? null : {
        name: name
    }, fallback && fallback());
    let slot = slots[name];
    // a compiled slot disables block tracking by default to avoid manual
    // invocation interfering with template-based block tracking, but in
    // `renderSlot` we can be sure that it's template-based so we can force
    // enable it.
    if (slot && slot._c) slot._d = false;
    $78da16583ad93b9f$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $78da16583ad93b9f$var$ensureValidVNode(slot(props));
    const rendered = $78da16583ad93b9f$export$9f2dfe8048dfb22b($78da16583ad93b9f$export$ffb0004e005737fa, {
        key: props.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 /* STABLE */  ? 64 /* STABLE_FRAGMENT */  : -2 /* BAIL */ );
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $78da16583ad93b9f$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$78da16583ad93b9f$export$3868d13f8734ae81(child)) return true;
        if (child.type === $78da16583ad93b9f$export$4d299b491347818a) return false;
        if (child.type === $78da16583ad93b9f$export$ffb0004e005737fa && !$78da16583ad93b9f$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
/**
 * For prefixing keys in v-on="obj" with "on"
 * @private
 */ function $78da16583ad93b9f$export$2fb94ff667a6a1a(obj) {
    const ret = {};
    for(const key in obj)ret[(0, $3LSrV.toHandlerKey)(key)] = obj[key];
    return ret;
}
/**
 * #2437 In Vue 3, functional components do not have a public instance proxy but
 * they exist in the internal parent chain. For code that relies on traversing
 * public $parent chains, skip functional ones and go to the parent instead.
 */ const $78da16583ad93b9f$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($78da16583ad93b9f$var$isStatefulComponent(i)) return $78da16583ad93b9f$var$getExposeProxy(i) || i.proxy;
    return $78da16583ad93b9f$var$getPublicInstance(i.parent);
};
const $78da16583ad93b9f$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/*#__PURE__*/ (0, $3LSrV.extend)(Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$78da16583ad93b9f$var$getPublicInstance(i.parent),
    $root: (i)=>$78da16583ad93b9f$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $78da16583ad93b9f$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>$78da16583ad93b9f$var$queueJob(i.update)),
    $nextTick: (i)=>i.n || (i.n = $78da16583ad93b9f$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $78da16583ad93b9f$var$instanceWatch.bind(i) : (0, $3LSrV.NOOP)
});
const $78da16583ad93b9f$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $78da16583ad93b9f$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        // data / props / ctx
        // This getter gets called for every property access on the render context
        // during render and is a major hotspot. The most expensive part of this
        // is the multiple hasOwn() calls. It's much faster to do a simple property
        // access on a plain object, so we use an accessCache object (with null
        // prototype) to memoize what access type a key corresponds to.
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== undefined) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if (setupState !== (0, $3LSrV.EMPTY_OBJ) && (0, $3LSrV.hasOwn)(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $3LSrV.EMPTY_OBJ) && (0, $3LSrV.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $3LSrV.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $3LSrV.EMPTY_OBJ) && (0, $3LSrV.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $78da16583ad93b9f$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $78da16583ad93b9f$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        // public $xxx properties
        if (publicGetter) {
            if (key === "$attrs") (0, $8bTPG.track)(instance, "get" /* GET */ , key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $3LSrV.EMPTY_OBJ) && (0, $3LSrV.hasOwn)(ctx, key)) {
            // user may set custom properties to `this` that start with `$`
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $3LSrV.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if (setupState !== (0, $3LSrV.EMPTY_OBJ) && (0, $3LSrV.hasOwn)(setupState, key)) {
            setupState[key] = value;
            return true;
        } else if (data !== (0, $3LSrV.EMPTY_OBJ) && (0, $3LSrV.hasOwn)(data, key)) {
            data[key] = value;
            return true;
        } else if ((0, $3LSrV.hasOwn)(instance.props, key)) return false;
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $3LSrV.EMPTY_OBJ) && (0, $3LSrV.hasOwn)(data, key) || setupState !== (0, $3LSrV.EMPTY_OBJ) && (0, $3LSrV.hasOwn)(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $3LSrV.hasOwn)(normalizedProps, key) || (0, $3LSrV.hasOwn)(ctx, key) || (0, $3LSrV.hasOwn)($78da16583ad93b9f$var$publicPropertiesMap, key) || (0, $3LSrV.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) // invalidate key cache of a getter based property #5417
        target._.accessCache[key] = 0;
        else if ((0, $3LSrV.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $78da16583ad93b9f$var$target;
const $78da16583ad93b9f$var$RuntimeCompiledPublicInstanceProxyHandlers = /*#__PURE__*/ (0, $3LSrV.extend)({}, $78da16583ad93b9f$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        // fast path for unscopables when using `with` block
        if (key === Symbol.unscopables) return;
        return $78da16583ad93b9f$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $3LSrV.isGloballyWhitelisted)(key);
        return has;
    }
});
// dev only
// In dev mode, the proxy target exposes the same properties as seen on `this`
// for easier console inspection. In prod mode it will be an empty object so
// these properties definitions can be skipped.
function $78da16583ad93b9f$var$createDevRenderContext(instance) {
    const target = {};
    // expose internal instance for proxy handlers
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    // expose public properties
    Object.keys($78da16583ad93b9f$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$78da16583ad93b9f$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $3LSrV.NOOP)
        });
    });
    return target;
}
// dev only
function $78da16583ad93b9f$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $3LSrV.NOOP)
        });
    });
}
// dev only
function $78da16583ad93b9f$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $8bTPG.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($78da16583ad93b9f$var$isReservedPrefix(key[0])) {
                $78da16583ad93b9f$export$c106dd0671a0fc2d(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" ` + `which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $3LSrV.NOOP)
            });
        }
    });
}
function $78da16583ad93b9f$var$createDuplicateChecker() {
    const cache = Object.create(null);
    return (type, key)=>{
        if (cache[key]) $78da16583ad93b9f$export$c106dd0671a0fc2d(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $78da16583ad93b9f$var$shouldCacheAccess = true;
function $78da16583ad93b9f$var$applyOptions(instance) {
    const options = $78da16583ad93b9f$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    // do not cache property access on public proxy during state initialization
    $78da16583ad93b9f$var$shouldCacheAccess = false;
    // call beforeCreate first before accessing other options since
    // the hook may mutate resolved options (#2791)
    if (options.beforeCreate) $78da16583ad93b9f$var$callHook(options.beforeCreate, instance, "bc" /* BEFORE_CREATE */ );
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    // options initialization order (to be consistent with Vue 2):
    // - props (already done outside of this function)
    // - inject
    // - methods
    // - data (deferred since it relies on `this` access)
    // - computed
    // - watch (deferred since it relies on `this` access)
    if (injectOptions) $78da16583ad93b9f$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties, instance.appContext.config.unwrapInjectedRef);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $3LSrV.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $3LSrV.isObject)(data)) ;
        else instance.data = (0, $8bTPG.reactive)(data);
    }
    // state initialization complete at this point - start caching access
    $78da16583ad93b9f$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $3LSrV.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $3LSrV.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $3LSrV.NOOP);
        const set = !(0, $3LSrV.isFunction)(opt) && (0, $3LSrV.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $3LSrV.NOOP);
        const c = $78da16583ad93b9f$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$78da16583ad93b9f$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $3LSrV.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $78da16583ad93b9f$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $78da16583ad93b9f$var$callHook(created, instance, "c" /* CREATED */ );
    function registerLifecycleHook(register, hook) {
        if ((0, $3LSrV.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($78da16583ad93b9f$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($78da16583ad93b9f$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($78da16583ad93b9f$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($78da16583ad93b9f$export$5876c47052fb88b1, updated);
    registerLifecycleHook($78da16583ad93b9f$export$ba52d824b95a2154, activated);
    registerLifecycleHook($78da16583ad93b9f$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($78da16583ad93b9f$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($78da16583ad93b9f$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($78da16583ad93b9f$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($78da16583ad93b9f$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($78da16583ad93b9f$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($78da16583ad93b9f$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $3LSrV.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    // options that are handled when creating the instance but also need to be
    // applied from mixins
    if (render && instance.render === (0, $3LSrV.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    // asset options.
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $78da16583ad93b9f$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $3LSrV.NOOP), unwrapRef = false) {
    if ((0, $3LSrV.isArray)(injectOptions)) injectOptions = $78da16583ad93b9f$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $3LSrV.isObject)(opt)) {
            if ("default" in opt) injected = $78da16583ad93b9f$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $78da16583ad93b9f$export$a976684a0efeb93f(opt.from || key);
        } else injected = $78da16583ad93b9f$export$a976684a0efeb93f(opt);
        if ((0, $8bTPG.isRef)(injected)) {
            // TODO remove the check in 3.3
            if (unwrapRef) Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>injected.value,
                set: (v1)=>injected.value = v1
            });
            else ctx[key] = injected;
        } else ctx[key] = injected;
    }
}
function $78da16583ad93b9f$var$callHook(hook, instance, type) {
    $78da16583ad93b9f$export$dae85862a8d94378((0, $3LSrV.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $78da16583ad93b9f$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $78da16583ad93b9f$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $3LSrV.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $3LSrV.isFunction)(handler)) $78da16583ad93b9f$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $3LSrV.isFunction)(raw)) $78da16583ad93b9f$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $3LSrV.isObject)(raw)) {
        if ((0, $3LSrV.isArray)(raw)) raw.forEach((r)=>$78da16583ad93b9f$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $3LSrV.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $3LSrV.isFunction)(handler)) $78da16583ad93b9f$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
/**
 * Resolve merged options and cache it on the component.
 * This is done only once per-component since the merging does not involve
 * instances.
 */ function $78da16583ad93b9f$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$78da16583ad93b9f$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $78da16583ad93b9f$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    cache.set(base, resolved);
    return resolved;
}
function $78da16583ad93b9f$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $78da16583ad93b9f$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$78da16583ad93b9f$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $78da16583ad93b9f$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $78da16583ad93b9f$var$internalOptionMergeStrats = {
    data: $78da16583ad93b9f$var$mergeDataFn,
    props: $78da16583ad93b9f$var$mergeObjectOptions,
    emits: $78da16583ad93b9f$var$mergeObjectOptions,
    // objects
    methods: $78da16583ad93b9f$var$mergeObjectOptions,
    computed: $78da16583ad93b9f$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $78da16583ad93b9f$var$mergeAsArray,
    created: $78da16583ad93b9f$var$mergeAsArray,
    beforeMount: $78da16583ad93b9f$var$mergeAsArray,
    mounted: $78da16583ad93b9f$var$mergeAsArray,
    beforeUpdate: $78da16583ad93b9f$var$mergeAsArray,
    updated: $78da16583ad93b9f$var$mergeAsArray,
    beforeDestroy: $78da16583ad93b9f$var$mergeAsArray,
    beforeUnmount: $78da16583ad93b9f$var$mergeAsArray,
    destroyed: $78da16583ad93b9f$var$mergeAsArray,
    unmounted: $78da16583ad93b9f$var$mergeAsArray,
    activated: $78da16583ad93b9f$var$mergeAsArray,
    deactivated: $78da16583ad93b9f$var$mergeAsArray,
    errorCaptured: $78da16583ad93b9f$var$mergeAsArray,
    serverPrefetch: $78da16583ad93b9f$var$mergeAsArray,
    // assets
    components: $78da16583ad93b9f$var$mergeObjectOptions,
    directives: $78da16583ad93b9f$var$mergeObjectOptions,
    // watch
    watch: $78da16583ad93b9f$var$mergeWatchOptions,
    // provide / inject
    provide: $78da16583ad93b9f$var$mergeDataFn,
    inject: $78da16583ad93b9f$var$mergeInject
};
function $78da16583ad93b9f$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $3LSrV.extend)((0, $3LSrV.isFunction)(to) ? to.call(this, this) : to, (0, $3LSrV.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $78da16583ad93b9f$var$mergeInject(to, from) {
    return $78da16583ad93b9f$var$mergeObjectOptions($78da16583ad93b9f$var$normalizeInject(to), $78da16583ad93b9f$var$normalizeInject(from));
}
function $78da16583ad93b9f$var$normalizeInject(raw) {
    if ((0, $3LSrV.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $78da16583ad93b9f$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $78da16583ad93b9f$var$mergeObjectOptions(to, from) {
    return to ? (0, $3LSrV.extend)((0, $3LSrV.extend)(Object.create(null), to), from) : from;
}
function $78da16583ad93b9f$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $3LSrV.extend)(Object.create(null), to);
    for(const key in from)merged[key] = $78da16583ad93b9f$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $78da16583ad93b9f$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = {};
    (0, $3LSrV.def)(attrs, $78da16583ad93b9f$var$InternalObjectKey, 1);
    instance.propsDefaults = Object.create(null);
    $78da16583ad93b9f$var$setFullProps(instance, rawProps, props, attrs);
    // ensure all declared prop keys are present
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = undefined;
    if (isStateful) // stateful
    instance.props = isSSR ? props : (0, $8bTPG.shallowReactive)(props);
    else if (!instance.type.props) // functional w/ optional props, props === attrs
    instance.props = attrs;
    else // functional w/ declared props
    instance.props = props;
    instance.attrs = attrs;
}
function $78da16583ad93b9f$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $8bTPG.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16 /* FULL_PROPS */ )) {
        if (patchFlag & 8 /* PROPS */ ) {
            // Compiler-generated props & no keys change, just set the updated
            // the props.
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                // skip if the prop key is a declared emit event listener
                if ($78da16583ad93b9f$var$isEmitListener(instance.emitsOptions, key)) continue;
                // PROPS flag guarantees rawProps to be non-null
                const value = rawProps[key];
                if (options) {
                    // attr / props separation was done on init and will be consistent
                    // in this code path, so just check if attrs have it.
                    if ((0, $3LSrV.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $3LSrV.camelize)(key);
                        props[camelizedKey] = $78da16583ad93b9f$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        // full props update.
        if ($78da16583ad93b9f$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        // in case of dynamic props, check if we need to delete keys from
        // the props object
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $3LSrV.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $3LSrV.hyphenate)(key)) === key || !(0, $3LSrV.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== undefined || // for kebab-case
                rawPrevProps[kebabKey] !== undefined)) props[key] = $78da16583ad93b9f$var$resolvePropValue(options, rawCurrentProps, key, undefined, instance, true);
            } else delete props[key];
        }
        // in the case of functional component w/o props declaration, props and
        // attrs point to the same object so it should already have been updated.
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $3LSrV.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    // trigger updates for $attrs in case it's used in component slots
    if (hasAttrsChanged) (0, $8bTPG.trigger)(instance, "set" /* SET */ , "$attrs");
}
function $78da16583ad93b9f$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        // key, ref are reserved and never passed down
        if ((0, $3LSrV.isReservedProp)(key)) continue;
        const value = rawProps[key];
        // prop option names are camelized during normalization, so to support
        // kebab -> camel conversion here we need to camelize the key.
        let camelKey;
        if (options && (0, $3LSrV.hasOwn)(options, camelKey = (0, $3LSrV.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$78da16583ad93b9f$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $8bTPG.toRaw)(props);
        const castValues = rawCastValues || (0, $3LSrV.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $78da16583ad93b9f$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $3LSrV.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $78da16583ad93b9f$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $3LSrV.hasOwn)(opt, "default");
        // default values
        if (hasDefault && value === undefined) {
            const defaultValue = opt.default;
            if (opt.type !== Function && (0, $3LSrV.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    $78da16583ad93b9f$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    $78da16583ad93b9f$var$unsetCurrentInstance();
                }
            } else value = defaultValue;
        }
        // boolean casting
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $3LSrV.hyphenate)(key))) value = true;
        }
    }
    return value;
}
function $78da16583ad93b9f$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    // apply mixin/extends props
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $3LSrV.isFunction)(comp)) {
        const extendProps = (raw)=>{
            hasExtends = true;
            const [props, keys] = $78da16583ad93b9f$var$normalizePropsOptions(raw, appContext, true);
            (0, $3LSrV.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        cache.set(comp, (0, $3LSrV.EMPTY_ARR));
        return 0, $3LSrV.EMPTY_ARR;
    }
    if ((0, $3LSrV.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $3LSrV.camelize)(raw[i]);
        if ($78da16583ad93b9f$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $3LSrV.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $3LSrV.camelize)(key);
        if ($78da16583ad93b9f$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $3LSrV.isArray)(opt) || (0, $3LSrV.isFunction)(opt) ? {
                type: opt
            } : opt;
            if (prop) {
                const booleanIndex = $78da16583ad93b9f$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $78da16583ad93b9f$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                // if the prop needs boolean casting or default value
                if (booleanIndex > -1 || (0, $3LSrV.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    cache.set(comp, res);
    return res;
}
function $78da16583ad93b9f$var$validatePropName(key) {
    if (key[0] !== "$") return true;
    return false;
}
// use function string name to check type constructors
// so that it works across vms / iframes.
function $78da16583ad93b9f$var$getType(ctor) {
    const match = ctor && ctor.toString().match(/^\s*function (\w+)/);
    return match ? match[1] : ctor === null ? "null" : "";
}
function $78da16583ad93b9f$var$isSameType(a, b) {
    return $78da16583ad93b9f$var$getType(a) === $78da16583ad93b9f$var$getType(b);
}
function $78da16583ad93b9f$var$getTypeIndex(type, expectedTypes) {
    if ((0, $3LSrV.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$78da16583ad93b9f$var$isSameType(t, type));
    else if ((0, $3LSrV.isFunction)(expectedTypes)) return $78da16583ad93b9f$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
/**
 * dev only
 */ function $78da16583ad93b9f$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $8bTPG.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $78da16583ad93b9f$var$validateProp(key, resolvedValues[key], opt, !(0, $3LSrV.hasOwn)(rawProps, key) && !(0, $3LSrV.hasOwn)(rawProps, (0, $3LSrV.hyphenate)(key)));
    }
}
/**
 * dev only
 */ function $78da16583ad93b9f$var$validateProp(name, value, prop, isAbsent) {
    const { type: type, required: required, validator: validator } = prop;
    // required!
    if (required && isAbsent) {
        $78da16583ad93b9f$export$c106dd0671a0fc2d('Missing required prop: "' + name + '"');
        return;
    }
    // missing but optional
    if (value == null && !prop.required) return;
    // type check
    if (type != null && type !== true) {
        let isValid = false;
        const types = (0, $3LSrV.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        // value is valid as long as one of the specified types match
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $78da16583ad93b9f$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $78da16583ad93b9f$export$c106dd0671a0fc2d($78da16583ad93b9f$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    // custom validator
    if (validator && !validator(value)) $78da16583ad93b9f$export$c106dd0671a0fc2d('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $78da16583ad93b9f$var$isSimpleType = /*#__PURE__*/ (0, $3LSrV.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
/**
 * dev only
 */ function $78da16583ad93b9f$var$assertType(value, type) {
    let valid;
    const expectedType = $78da16583ad93b9f$var$getType(type);
    if ($78da16583ad93b9f$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $3LSrV.isObject)(value);
    else if (expectedType === "Array") valid = (0, $3LSrV.isArray)(value);
    else if (expectedType === "null") valid = value === null;
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
/**
 * dev only
 */ function $78da16583ad93b9f$var$getInvalidTypeMessage(name, value, expectedTypes) {
    let message = `Invalid prop: type check failed for prop "${name}".` + ` Expected ${expectedTypes.map((0, $3LSrV.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $3LSrV.toRawType)(value);
    const expectedValue = $78da16583ad93b9f$var$styleValue(value, expectedType);
    const receivedValue = $78da16583ad93b9f$var$styleValue(value, receivedType);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 && $78da16583ad93b9f$var$isExplicable(expectedType) && !$78da16583ad93b9f$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    // check if we need to specify received value
    if ($78da16583ad93b9f$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
/**
 * dev only
 */ function $78da16583ad93b9f$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
/**
 * dev only
 */ function $78da16583ad93b9f$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
/**
 * dev only
 */ function $78da16583ad93b9f$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $78da16583ad93b9f$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $78da16583ad93b9f$var$normalizeSlotValue = (value)=>(0, $3LSrV.isArray)(value) ? value.map($78da16583ad93b9f$var$normalizeVNode) : [
        $78da16583ad93b9f$var$normalizeVNode(value)
    ];
const $78da16583ad93b9f$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) // already normalized - #5353
    return rawSlot;
    const normalized = $78da16583ad93b9f$export$694b237e827a3d23((...args)=>{
        return $78da16583ad93b9f$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $78da16583ad93b9f$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($78da16583ad93b9f$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $3LSrV.isFunction)(value)) slots[key] = $78da16583ad93b9f$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $78da16583ad93b9f$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $78da16583ad93b9f$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $78da16583ad93b9f$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $78da16583ad93b9f$var$initSlots = (instance, children)=>{
    if (instance.vnode.shapeFlag & 32 /* SLOTS_CHILDREN */ ) {
        const type = children._;
        if (type) {
            // users can get the shallow readonly version of the slots object through `this.$slots`,
            // we should avoid the proxy object polluting the slots of the internal instance
            instance.slots = (0, $8bTPG.toRaw)(children);
            // make compiler marker non-enumerable
            (0, $3LSrV.def)(children, "_", type);
        } else $78da16583ad93b9f$var$normalizeObjectSlots(children, instance.slots = {});
    } else {
        instance.slots = {};
        if (children) $78da16583ad93b9f$var$normalizeVNodeSlots(instance, children);
    }
    (0, $3LSrV.def)(instance.slots, $78da16583ad93b9f$var$InternalObjectKey, 1);
};
const $78da16583ad93b9f$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $3LSrV.EMPTY_OBJ);
    if (vnode.shapeFlag & 32 /* SLOTS_CHILDREN */ ) {
        const type = children._;
        if (type) {
            if (optimized && type === 1 /* STABLE */ ) // compiled AND stable.
            // no need to update, and skip stale slots removal.
            needDeletionCheck = false;
            else {
                // compiled but dynamic (v-if/v-for on slots) - update slots, but skip
                // normalization.
                (0, $3LSrV.extend)(slots, children);
                // #2893
                // when rendering the optimized slots by manually written render function,
                // we need to delete the `slots._` flag if necessary to make subsequent updates reliable,
                // i.e. let the `renderSlot` create the bailed Fragment
                if (!optimized && type === 1 /* STABLE */ ) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $78da16583ad93b9f$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        // non slot object children (direct value) passed to a component
        $78da16583ad93b9f$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    // delete stale slots
    if (needDeletionCheck) {
        for(const key in slots)if (!$78da16583ad93b9f$var$isInternalKey(key) && !(key in deletionComparisonTarget)) delete slots[key];
    }
};
function $78da16583ad93b9f$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $3LSrV.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: undefined,
            warnHandler: undefined,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: Object.create(null),
        optionsCache: new WeakMap(),
        propsCache: new WeakMap(),
        emitsCache: new WeakMap()
    };
}
let $78da16583ad93b9f$var$uid = 0;
function $78da16583ad93b9f$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $3LSrV.isFunction)(rootComponent)) rootComponent = Object.assign({}, rootComponent);
        if (rootProps != null && !(0, $3LSrV.isObject)(rootProps)) rootProps = null;
        const context = $78da16583ad93b9f$var$createAppContext();
        const installedPlugins = new Set();
        let isMounted = false;
        const app = context.app = {
            _uid: $78da16583ad93b9f$var$uid++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $78da16583ad93b9f$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $3LSrV.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $3LSrV.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, isSVG) {
                if (!isMounted) {
                    const vnode = $78da16583ad93b9f$export$bf5c4cf060303d58(rootComponent, rootProps);
                    // store app context on the root VNode.
                    // this will be set on the root instance on initial mount.
                    vnode.appContext = context;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, isSVG);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $78da16583ad93b9f$var$devtoolsInitApp(app, $78da16583ad93b9f$export$83d89fbfd8236492);
                    }
                    return $78da16583ad93b9f$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $78da16583ad93b9f$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            }
        };
        return app;
    };
}
/**
 * Function for handling a template ref
 */ function $78da16583ad93b9f$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $3LSrV.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$78da16583ad93b9f$var$setRef(r, oldRawRef && ((0, $3LSrV.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($78da16583ad93b9f$var$isAsyncWrapper(vnode) && !isUnmount) // when mounting async components, nothing needs to be done,
    // because the template ref is forwarded to inner component
    return;
    const refValue = vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */  ? $78da16583ad93b9f$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $3LSrV.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    // dynamic ref changed. unset old ref
    if (oldRef != null && oldRef !== ref) {
        if ((0, $3LSrV.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $3LSrV.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $8bTPG.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $3LSrV.isFunction)(ref)) $78da16583ad93b9f$export$b22fcaf88446e9bf(ref, owner, 12 /* FUNCTION_REF */ , [
        value,
        refs
    ]);
    else {
        const _isString = (0, $3LSrV.isString)(ref);
        const _isRef = (0, $8bTPG.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? refs[ref] : ref.value;
                    if (isUnmount) (0, $3LSrV.isArray)(existing) && (0, $3LSrV.remove)(existing, refValue);
                    else {
                        if (!(0, $3LSrV.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $3LSrV.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if ((0, $3LSrV.hasOwn)(setupState, ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $78da16583ad93b9f$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $78da16583ad93b9f$var$hasMismatch = false;
const $78da16583ad93b9f$var$isSVGContainer = (container)=>/svg/.test(container.namespaceURI) && container.tagName !== "foreignObject";
const $78da16583ad93b9f$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
// Note: hydration is DOM-specific
// But we have to place it in core due to tight coupling with core - splitting
// it out creates a ton of unnecessary complexity.
// Hydration also depends on some renderer internal logic which needs to be
// passed in via arguments.
function $78da16583ad93b9f$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            patch(null, vnode, container);
            $78da16583ad93b9f$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $78da16583ad93b9f$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $78da16583ad93b9f$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($78da16583ad93b9f$var$hasMismatch && true) // this error should show up in production
        console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        const isFragmentStart = $78da16583ad93b9f$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        const domType = node.nodeType;
        vnode.el = node;
        if (patchFlag === -2 /* BAIL */ ) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $78da16583ad93b9f$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    // #5728 empty text node inside a slot can cause hydration failure
                    // because the server rendered HTML won't contain a text node
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $78da16583ad93b9f$var$hasMismatch = true;
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $78da16583ad93b9f$export$4d299b491347818a:
                if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $78da16583ad93b9f$export$c1b9a1d3af45b7b6:
                if (domType !== 1 /* ELEMENT */  && domType !== 3 /* TEXT */ ) nextNode = onMismatch();
                else {
                    // determine anchor, adopt content
                    nextNode = node;
                    // if the static vnode has its content stripped during build,
                    // adopt it from the server-rendered HTML.
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return nextNode;
                }
                break;
            case $78da16583ad93b9f$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1 /* ELEMENT */ ) {
                    if (domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6 /* COMPONENT */ ) {
                    // when setting up the render effect, if the initial vnode already
                    // has .el set, the component will perform hydration instead of mount
                    // on its sub-tree.
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $78da16583ad93b9f$var$isSVGContainer(container), optimized);
                    // component may be async, so in the case of fragments we cannot rely
                    // on component's rendered output to determine the end of the fragment
                    // instead, we do a lookahead to find the end anchor node.
                    nextNode = isFragmentStart ? locateClosingAsyncAnchor(node) : nextSibling(node);
                    // #4293 teleport as component root
                    if (nextNode && $78da16583ad93b9f$var$isComment(nextNode) && nextNode.data === "teleport end") nextNode = nextSibling(nextNode);
                    // #3787
                    // if component is async, it may get moved / unmounted before its
                    // inner component is loaded, so we need to give it a placeholder
                    // vnode that matches its adopted DOM.
                    if ($78da16583ad93b9f$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $78da16583ad93b9f$export$22f9b5ffd89dac9("") : $78da16583ad93b9f$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64 /* TELEPORT */ ) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128 /* SUSPENSE */ ) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $78da16583ad93b9f$var$isSVGContainer(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
        }
        if (ref != null) $78da16583ad93b9f$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs } = vnode;
        // #4006 for form elements with non-string v-model value bindings
        // e.g. <option :value="obj">, <input type="checkbox" :true-value="1">
        const forcePatchValue = type === "input" && dirs || type === "option";
        // skip props & children if this is hoisted static nodes
        // #5405 in dev, always hydrate children for HMR
        if (forcePatchValue || patchFlag !== -1 /* HOISTED */ ) {
            if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            // props
            if (props) {
                if (forcePatchValue || !optimized || patchFlag & 48 /* HYDRATE_EVENTS */ ) {
                    for(const key in props)if (forcePatchValue && key.endsWith("value") || (0, $3LSrV.isOn)(key) && !(0, $3LSrV.isReservedProp)(key)) patchProp(el, key, null, props[key], false, undefined, parentComponent);
                } else if (props.onClick) // Fast path for click listeners (which is most often) to avoid
                // iterating through props.
                patchProp(el, "onClick", null, props.onClick, false, undefined, parentComponent);
            }
            // vnode / directive hooks
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs) $78da16583ad93b9f$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $78da16583ad93b9f$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                dirs && $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
            // children
            if (shapeFlag & 16 /* ARRAY_CHILDREN */  && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $78da16583ad93b9f$var$hasMismatch = true;
                    // The SSRed DOM contains more nodes than it should. Remove them.
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8 /* TEXT_CHILDREN */ ) {
                if (el.textContent !== vnode.children) {
                    $78da16583ad93b9f$var$hasMismatch = true;
                    el.textContent = vnode.children;
                }
            }
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $78da16583ad93b9f$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $78da16583ad93b9f$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $78da16583ad93b9f$var$hasMismatch = true;
                // the SSRed DOM didn't contain enough nodes. Mount the missing ones.
                patch(null, vnode, container, null, parentComponent, parentSuspense, $78da16583ad93b9f$var$isSVGContainer(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $78da16583ad93b9f$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            // fragment didn't hydrate successfully, since we didn't get a end anchor
            // back. This should have led to node/children mismatch warnings.
            $78da16583ad93b9f$var$hasMismatch = true;
            // since the anchor is missing, we need to create one and insert it
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $78da16583ad93b9f$var$hasMismatch = true;
        vnode.el = null;
        if (isFragment) {
            // remove excessive fragment nodes
            const end = locateClosingAsyncAnchor(node);
            while(true){
                const next = nextSibling(node);
                if (next && next !== end) remove(next);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $78da16583ad93b9f$var$isSVGContainer(container), slotScopeIds);
        return next;
    };
    const locateClosingAsyncAnchor = (node)=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $78da16583ad93b9f$var$isComment(node)) {
                if (node.data === "[") match++;
                if (node.data === "]") {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    return [
        hydrate,
        hydrateNode
    ];
}
/* eslint-disable no-restricted-globals */ let $78da16583ad93b9f$var$supported;
let $78da16583ad93b9f$var$perf;
function $78da16583ad93b9f$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $78da16583ad93b9f$var$isSupported()) $78da16583ad93b9f$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsPerfStart(instance, type, $78da16583ad93b9f$var$isSupported() ? $78da16583ad93b9f$var$perf.now() : Date.now());
}
function $78da16583ad93b9f$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $78da16583ad93b9f$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $78da16583ad93b9f$var$perf.mark(endTag);
        $78da16583ad93b9f$var$perf.measure(`<${$78da16583ad93b9f$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $78da16583ad93b9f$var$perf.clearMarks(startTag);
        $78da16583ad93b9f$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsPerfEnd(instance, type, $78da16583ad93b9f$var$isSupported() ? $78da16583ad93b9f$var$perf.now() : Date.now());
}
function $78da16583ad93b9f$var$isSupported() {
    if ($78da16583ad93b9f$var$supported !== undefined) return $78da16583ad93b9f$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $78da16583ad93b9f$var$supported = true;
        $78da16583ad93b9f$var$perf = window.performance;
    } else $78da16583ad93b9f$var$supported = false;
    return $78da16583ad93b9f$var$supported;
}
/**
 * This is only called in esm-bundler builds.
 * It is called when a renderer is created, in `baseCreateRenderer` so that
 * importing runtime-core is side-effects free.
 *
 * istanbul-ignore-next
 */ function $78da16583ad93b9f$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $3LSrV.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $3LSrV.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
}
const $78da16583ad93b9f$var$queuePostRenderEffect = $78da16583ad93b9f$var$queueEffectWithSuspense;
/**
 * The createRenderer function accepts two generic arguments:
 * HostNode and HostElement, corresponding to Node and Element types in the
 * host environment. For example, for runtime-dom, HostNode would be the DOM
 * `Node` interface and HostElement would be the DOM `Element` interface.
 *
 * Custom renderers can pass in the platform specific types like this:
 *
 * ``` js
 * const { render, createApp } = createRenderer<Node, Element>({
 *   patchProp,
 *   ...nodeOps
 * })
 * ```
 */ function $78da16583ad93b9f$export$53ae2f996c64e9a(options) {
    return $78da16583ad93b9f$var$baseCreateRenderer(options);
}
// Separate API for creating hydration-enabled renderer.
// Hydration logic is only used when calling this function, making it
// tree-shakable.
function $78da16583ad93b9f$export$200524cf0d997ff0(options) {
    return $78da16583ad93b9f$var$baseCreateRenderer(options, $78da16583ad93b9f$var$createHydrationFunctions);
}
// implementation
function $78da16583ad93b9f$var$baseCreateRenderer(options, createHydrationFns) {
    $78da16583ad93b9f$var$initFeatureFlags();
    const target = (0, $3LSrV.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$export$b0c258b32c26c785(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $3LSrV.NOOP), cloneNode: hostCloneNode, insertStaticContent: hostInsertStaticContent } = options;
    // Note: functions inside this closure should use `const xxx = () => {}`
    // style in order to prevent being inlined by minifiers.
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        // patching & not same type, unmount old tree
        if (n1 && !$78da16583ad93b9f$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2 /* BAIL */ ) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $78da16583ad93b9f$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $78da16583ad93b9f$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $78da16583ad93b9f$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, isSVG);
                break;
            case $78da16583ad93b9f$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1 /* ELEMENT */ ) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 6 /* COMPONENT */ ) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 64 /* TELEPORT */ ) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128 /* SUSPENSE */ ) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        }
        // set ref
        if (ref != null && parentComponent) $78da16583ad93b9f$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else // there's no support for dynamic comments
        n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, isSVG)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG, n2.el, n2.anchor);
    };
    /**
     * Dev / HMR only
     */ const patchStaticNode = (n1, n2, container, isSVG)=>{
        // static nodes are only patched during dev for HMR
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            // remove existing
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        isSVG = isSVG || n2.type === "svg";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { type: type, props: props, shapeFlag: shapeFlag, transition: transition, patchFlag: patchFlag, dirs: dirs } = vnode;
        if ((0, vnode.el) && hostCloneNode !== undefined && patchFlag === -1 /* HOISTED */ ) // If a vnode has non-null el, it means it's being reused.
        // Only static vnodes can be reused, so its mounted DOM nodes should be
        // exactly the same, and we can simply do a clone here.
        // only do this in production since cloned trees cannot be HMR updated.
        el = vnode.el = hostCloneNode(vnode.el);
        else {
            el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
            // mount children first, since some props may rely on child content
            // being already rendered, e.g. `<select value>`
            if (shapeFlag & 8 /* TEXT_CHILDREN */ ) hostSetElementText(el, vnode.children);
            else if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
            if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            // props
            if (props) {
                for(const key in props)if (key !== "value" && !(0, $3LSrV.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
                /**
                 * Special case for setting value on DOM elements:
                 * - it can be order-sensitive (e.g. should be set *after* min/max, #2325, #4024)
                 * - it needs to be forced (#1471)
                 * #2353 proposes adding another renderer option to configure this, but
                 * the properties affects are so finite it is worth special casing it
                 * here to reduce the complexity. (Special casing it also should not
                 * affect non-DOM renderers)
                 */ if ("value" in props) hostPatchProp(el, "value", null, props.value);
                if (vnodeHook = props.onVnodeBeforeMount) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            }
            // scopeId
            setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        // #1583 For inside suspense + suspense not resolved case, enter hook should call when suspense resolved
        // #1689 For inside suspense + suspense resolved case, just call it
        const needCallTransitionHooks = (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
            vnodeHook && $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(children[i]) : $78da16583ad93b9f$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        // #1426 take the old vnode's patch flag into account since user may clone a
        // compiler-generated vnode, which de-opts to FULL_PROPS
        patchFlag |= n1.patchFlag & 16 /* FULL_PROPS */ ;
        const oldProps = n1.props || (0, $3LSrV.EMPTY_OBJ);
        const newProps = n2.props || (0, $3LSrV.EMPTY_OBJ);
        let vnodeHook;
        // disable recurse in beforeUpdate hooks
        parentComponent && $78da16583ad93b9f$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $78da16583ad93b9f$var$toggleRecurse(parentComponent, true);
        const areChildrenSVG = isSVG && n2.type !== "foreignObject";
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
        else if (!optimized) // full diff
        patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
        if (patchFlag > 0) {
            // the presence of a patchFlag means this element's render code was
            // generated by the compiler and can take the fast path.
            // in this path old node and new node are guaranteed to have the same shape
            // (i.e. at the exact same position in the source template)
            if (patchFlag & 16 /* FULL_PROPS */ ) // element props contain dynamic keys, full diff needed
            patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
            else {
                // class
                // this flag is matched when the element has dynamic class bindings.
                if (patchFlag & 2 /* CLASS */ ) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, isSVG);
                }
                // style
                // this flag is matched when the element has dynamic style bindings
                if (patchFlag & 4 /* STYLE */ ) hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
                // props
                // This flag is matched when the element has dynamic prop/attr bindings
                // other than class and style. The keys of dynamic prop/attrs are saved for
                // faster iteration.
                // Note dynamic keys like :[foo]="bar" will cause this optimization to
                // bail out and go through a full diff because we need to unset the old key
                if (patchFlag & 8 /* PROPS */ ) {
                    // if the flag is present then dynamicProps must be non-null
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        // #1471 force patch value
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            // text
            // This flag is matched when the element has only dynamic text children.
            if (patchFlag & 1 /* TEXT */ ) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) // unoptimized, full diff
        patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
            vnodeHook && $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $78da16583ad93b9f$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    // The fast path for blocks.
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            // Determine the container (parent element) for the patch.
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $78da16583ad93b9f$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$78da16583ad93b9f$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70 /* TELEPORT */ ) ? hostParentNode(oldVNode.el) : // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG)=>{
        if (oldProps !== newProps) {
            for(const key in newProps){
                // empty string is not valid prop
                if ((0, $3LSrV.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                // defer patching value
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if (oldProps !== (0, $3LSrV.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $3LSrV.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        // check if this is a slot fragment with :slotted scope ids
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            // a fragment can only have array children
            // since they are either generated by the compiler, or implicitly created
            // from arrays.
            mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 /* STABLE_FRAGMENT */  && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            // a stable fragment (template root or <template v-for>) doesn't need to
            // patch children order, but it may contain dynamicChildren.
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $78da16583ad93b9f$var$traverseStaticChildren(n1, n2, true);
        } else // keyed / unkeyed, or manual fragments.
        // for keyed & unkeyed, since they are compiler generated from v-for,
        // each child is guaranteed to be a block so the fragment will never
        // have dynamicChildren.
        patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512 /* COMPONENT_KEPT_ALIVE */ ) parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized)=>{
        const instance = initialVNode.component = $78da16583ad93b9f$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        // inject renderer internals for keepAlive
        if ($78da16583ad93b9f$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $78da16583ad93b9f$var$setupComponent(instance);
        // setup() is async. This component relies on async logic to be resolved
        // before proceeding
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            // Give it a placeholder if this is not hydration
            // TODO handle self-defined fallback
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
            return;
        }
        setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($78da16583ad93b9f$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                // normal update
                instance.next = n2;
                // in case the child component is also queued, remove it to avoid
                // double updating the same child component in the same flush.
                $78da16583ad93b9f$var$invalidateJob(instance.update);
                // instance.update is the reactive effect.
                instance.update();
            }
        } else {
            // no update needed. just copy over properties
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $78da16583ad93b9f$var$isAsyncWrapper(initialVNode);
                $78da16583ad93b9f$var$toggleRecurse(instance, false);
                // beforeMount hook
                if (bm) (0, $3LSrV.invokeArrayFns)(bm);
                // onVnodeBeforeMount
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $78da16583ad93b9f$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    // vnode has adopted host node - perform hydration instead of mount.
                    const hydrateSubTree = ()=>{
                        instance.subTree = $78da16583ad93b9f$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $78da16583ad93b9f$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
                    initialVNode.el = subTree.el;
                }
                // mounted hook
                if (m) $78da16583ad93b9f$var$queuePostRenderEffect(m, parentSuspense);
                // onVnodeMounted
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $78da16583ad93b9f$var$queuePostRenderEffect(()=>$78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                // activated hook for keep-alive roots.
                // #1742 activated hook must be accessed after first render
                // since the hook may be injected by a child keep-alive
                if (initialVNode.shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */  || parent && $78da16583ad93b9f$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ) instance.a && $78da16583ad93b9f$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentAdded(instance);
                // #2458: deference mount-only object parameters to prevent memleaks
                initialVNode = container = anchor = null;
            } else {
                // updateComponent
                // This is triggered by mutation of component's own state (next: null)
                // OR parent calling processComponent (next: VNode)
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                let originNext = next;
                let vnodeHook;
                // Disallow component effect recursion during pre-lifecycle hooks.
                $78da16583ad93b9f$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                // beforeUpdate hook
                if (bu) (0, $3LSrV.invokeArrayFns)(bu);
                // onVnodeBeforeUpdate
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $78da16583ad93b9f$var$toggleRecurse(instance, true);
                const nextTree = $78da16583ad93b9f$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, isSVG);
                next.el = nextTree.el;
                if (originNext === null) // self-triggered update. In case of HOC, update parent component
                // vnode el. HOC is indicated by parent instance's subTree pointing
                // to child component's vnode
                $78da16583ad93b9f$var$updateHOCHostEl(instance, nextTree.el);
                // updated hook
                if (u) $78da16583ad93b9f$var$queuePostRenderEffect(u, parentSuspense);
                // onVnodeUpdated
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $78da16583ad93b9f$var$queuePostRenderEffect(()=>$78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentUpdated(instance);
            }
        };
        // create reactive effect for rendering
        const effect = instance.effect = new (0, $8bTPG.ReactiveEffect)(componentUpdateFn, ()=>$78da16583ad93b9f$var$queueJob(update), instance.scope // track it in component's effect scope
        );
        const update = instance.update = ()=>effect.run();
        update.id = instance.uid;
        // allowRecurse
        // #1801, #2043 component render effects should allow recursive updates
        $78da16583ad93b9f$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $78da16583ad93b9f$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $78da16583ad93b9f$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $8bTPG.pauseTracking)();
        // props update may have triggered pre-flush watchers.
        // flush them before the render update.
        $78da16583ad93b9f$var$flushPreFlushCbs(undefined, instance.update);
        (0, $8bTPG.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        // fast path
        if (patchFlag > 0) {
            if (patchFlag & 128 /* KEYED_FRAGMENT */ ) {
                // this could be either fully-keyed or mixed (some keyed some not)
                // presence of patchFlag means children are guaranteed to be arrays
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256 /* UNKEYED_FRAGMENT */ ) {
                // unkeyed
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            }
        }
        // children has 3 possibilities: text, array or no children.
        if (shapeFlag & 8 /* TEXT_CHILDREN */ ) {
            // text children fast path
            if (prevShapeFlag & 16 /* ARRAY_CHILDREN */ ) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16 /* ARRAY_CHILDREN */ ) {
            // prev children was array
            if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) // two arrays, cannot assume anything, do full diff
            patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else // no new children, just unmount old
            unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            // prev children was text OR null
            // new children is array OR null
            if (prevShapeFlag & 8 /* TEXT_CHILDREN */ ) hostSetElementText(container, "");
            // mount new if array
            if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $3LSrV.EMPTY_ARR);
        c2 = c2 || (0, $3LSrV.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[i]) : $78da16583ad93b9f$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        if (oldLength > newLength) // remove old
        unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else // mount new
        mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    };
    // can be all-keyed or mixed
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1; // prev ending index
        let e2 = l2 - 1; // next ending index
        // 1. sync from start
        // (a b) c
        // (a b) d e
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[i]) : $78da16583ad93b9f$var$normalizeVNode(c2[i]);
            if ($78da16583ad93b9f$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            i++;
        }
        // 2. sync from end
        // a (b c)
        // d e (b c)
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[e2]) : $78da16583ad93b9f$var$normalizeVNode(c2[e2]);
            if ($78da16583ad93b9f$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        // 3. common sequence + mount
        // (a b)
        // (a b) c
        // i = 2, e1 = 1, e2 = 2
        // (a b)
        // c (a b)
        // i = 0, e1 = -1, e2 = 0
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[i]) : $78da16583ad93b9f$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i; // prev starting index
            const s2 = i; // next starting index
            // 5.1 build key:index map for newChildren
            const keyToNewIndexMap = new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[i]) : $78da16583ad93b9f$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            // 5.2 loop through old children left to be patched and try to patch
            // matching nodes & remove nodes that are no longer present
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            // used to track whether any node has moved
            let maxNewIndexSoFar = 0;
            // works as Map<newIndex, oldIndex>
            // Note that oldIndex is offset by +1
            // and oldIndex = 0 is a special value indicating the new node has
            // no corresponding old node.
            // used for determining longest stable subsequence
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    // all new children have been patched so this can only be a removal
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    // key-less node, try to locate a key-less node of the same type
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $78da16583ad93b9f$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === undefined) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    patched++;
                }
            }
            // 5.3 move and mount
            // generate longest stable subsequence only when nodes have moved
            const increasingNewIndexSequence = moved ? $78da16583ad93b9f$var$getSequence(newIndexToOldIndexMap) : (0, $3LSrV.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            // looping backwards so that we can use last patched node as anchor
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) // mount new
                patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (moved) {
                    // move if:
                    // There is no stable subsequence (e.g. a reverse)
                    // OR current node is not among the stable sequence
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2 /* REORDER */ );
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6 /* COMPONENT */ ) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128 /* SUSPENSE */ ) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64 /* TELEPORT */ ) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $78da16583ad93b9f$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $78da16583ad93b9f$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        // single nodes
        const needTransition = moveType !== 2 /* REORDER */  && shapeFlag & 1 /* ELEMENT */  && transition;
        if (needTransition) {
            if (moveType === 0 /* ENTER */ ) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $78da16583ad93b9f$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        // unset ref
        if (ref != null) $78da16583ad93b9f$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 /* ELEMENT */  && dirs;
        const shouldInvokeVnodeHook = !$78da16583ad93b9f$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6 /* COMPONENT */ ) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128 /* SUSPENSE */ ) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64 /* TELEPORT */ ) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $78da16583ad93b9f$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64 /* STABLE_FRAGMENT */ )) // fast path for block nodes: only need to unmount dynamic children.
            unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $78da16583ad93b9f$export$ffb0004e005737fa && patchFlag & 384 /* UNKEYED_FRAGMENT */  || !optimized && shapeFlag & 16 /* ARRAY_CHILDREN */ ) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
            vnodeHook && $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $78da16583ad93b9f$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $78da16583ad93b9f$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 /* ELEMENT */  && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        // For fragments, directly remove all contained DOM nodes.
        // (fragment child nodes cannot have transition)
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        // beforeUnmount hook
        if (bum) (0, $3LSrV.invokeArrayFns)(bum);
        // stop effects in component scope
        scope.stop();
        // update may be null if a component is unmounted before its async
        // setup has resolved.
        if (update) {
            // so that scheduler will no longer invoke it
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        // unmounted hook
        if (um) $78da16583ad93b9f$var$queuePostRenderEffect(um, parentSuspense);
        $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        // A component with async dep inside a pending suspense is unmounted before
        // its async dep resolves. This should remove the dep from the suspense, and
        // cause the suspense to resolve immediately if that was the last dep.
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6 /* COMPONENT */ ) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128 /* SUSPENSE */ ) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    const render = (vnode, container, isSVG)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, isSVG);
        $78da16583ad93b9f$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $78da16583ad93b9f$var$createAppAPI(render, hydrate)
    };
}
function $78da16583ad93b9f$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
/**
 * #1156
 * When a component is HMR-enabled, we need to make sure that all static nodes
 * inside a block also inherit the DOM element from the previous tree so that
 * HMR updates (which are full updates) can retrieve the element for patching.
 *
 * #2080
 * Inside keyed `template` fragment static children, if a fragment is moved,
 * the children will always be moved. Therefore, in order to ensure correct move
 * position, el should be inherited from previous nodes.
 */ function $78da16583ad93b9f$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $3LSrV.isArray)(ch1) && (0, $3LSrV.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        // this is only called in the optimized path so array children are
        // guaranteed to be vnodes
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 /* ELEMENT */  && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32 /* HYDRATE_EVENTS */ ) {
                c2 = ch2[i] = $78da16583ad93b9f$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $78da16583ad93b9f$var$traverseStaticChildren(c1, c2);
        }
    }
}
// https://en.wikipedia.org/wiki/Longest_increasing_subsequence
function $78da16583ad93b9f$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
const $78da16583ad93b9f$var$isTeleport = (type)=>type.__isTeleport;
const $78da16583ad93b9f$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $78da16583ad93b9f$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $78da16583ad93b9f$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $3LSrV.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $78da16583ad93b9f$var$TeleportImpl = {
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $78da16583ad93b9f$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            // insert anchors in the main view
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $78da16583ad93b9f$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                // #2652 we could be teleporting from a non-SVG tree into an SVG tree
                isSVG = isSVG || $78da16583ad93b9f$var$isTargetSVG(target);
            }
            const mount = (container, anchor)=>{
                // Teleport *always* has Array children. This is enforced in both the
                // compiler and vnode children normalization.
                if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) mountChildren(children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            // update content
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $78da16583ad93b9f$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            isSVG = isSVG || $78da16583ad93b9f$var$isTargetSVG(target);
            if (dynamicChildren) {
                // fast path when the teleport happens to be a block root
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
                // even in block tree mode we need to make sure all root-level nodes
                // in the teleport inherit previous DOM references so that they can
                // be moved in future patches.
                $78da16583ad93b9f$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) // enabled -> disabled
                // move into main container
                $78da16583ad93b9f$var$moveTeleport(n2, container, mainAnchor, internals, 1 /* TOGGLE */ );
            } else {
                // target changed
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $78da16583ad93b9f$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $78da16583ad93b9f$var$moveTeleport(n2, nextTarget, null, internals, 0 /* TARGET_CHANGE */ );
                } else if (wasDisabled) // disabled -> enabled
                // move into teleport target
                $78da16583ad93b9f$var$moveTeleport(n2, target, targetAnchor, internals, 1 /* TOGGLE */ );
            }
        }
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        // an unmounted teleport should always remove its children if not disabled
        if (doRemove || !$78da16583ad93b9f$var$isTeleportDisabled(props)) {
            hostRemove(anchor);
            if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, true, !!child.dynamicChildren);
            }
        }
    },
    move: $78da16583ad93b9f$var$moveTeleport,
    hydrate: $78da16583ad93b9f$var$hydrateTeleport
};
function $78da16583ad93b9f$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2 /* REORDER */ ) {
    // move target anchor if this is a target change.
    if (moveType === 0 /* TARGET_CHANGE */ ) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2 /* REORDER */ ;
    // move main view anchor if this is a re-order.
    if (isReorder) insert(el, container, parentAnchor);
    // if this is a re-order and teleport is enabled (content is in target)
    // do not move children. So the opposite is: only move children if this
    // is not a reorder, or the teleport is disabled
    if (!isReorder || $78da16583ad93b9f$var$isTeleportDisabled(props)) {
        // Teleport has either Array children or no children.
        if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2 /* REORDER */ );
    }
    // move main view anchor if this is a re-order.
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $78da16583ad93b9f$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $78da16583ad93b9f$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        // if multiple teleports rendered to the same target element, we need to
        // pick up from where the last teleport finished instead of the first node
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16 /* ARRAY_CHILDREN */ ) {
            if ($78da16583ad93b9f$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                // lookahead until we find the target anchor
                // we cannot rely on return value of hydrateChildren() because there
                // could be nested teleports
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
// Force-casted public typing for h and TSX props inference
const $78da16583ad93b9f$export$76d55a0304a371f4 = $78da16583ad93b9f$var$TeleportImpl;
const $78da16583ad93b9f$export$ffb0004e005737fa = Symbol(undefined);
const $78da16583ad93b9f$export$5f1af8db9871e1d6 = Symbol(undefined);
const $78da16583ad93b9f$export$4d299b491347818a = Symbol(undefined);
const $78da16583ad93b9f$export$c1b9a1d3af45b7b6 = Symbol(undefined);
// Since v-if and v-for are the two possible ways node structure can dynamically
// change, once we consider v-if branches and each v-for fragment a block, we
// can divide a template into nested blocks, and within each block the node
// structure would be stable. This allows us to skip most children diffing
// and only worry about the dynamic nodes (indicated by patch flags).
const $78da16583ad93b9f$var$blockStack = [];
let $78da16583ad93b9f$var$currentBlock = null;
/**
 * Open a block.
 * This must be called before `createBlock`. It cannot be part of `createBlock`
 * because the children of the block are evaluated before `createBlock` itself
 * is called. The generated code typically looks like this:
 *
 * ```js
 * function render() {
 *   return (openBlock(),createBlock('div', null, [...]))
 * }
 * ```
 * disableTracking is true when creating a v-for fragment block, since a v-for
 * fragment always diffs its children.
 *
 * @private
 */ function $78da16583ad93b9f$export$e7eaa45e502fe5cc(disableTracking = false) {
    $78da16583ad93b9f$var$blockStack.push($78da16583ad93b9f$var$currentBlock = disableTracking ? null : []);
}
function $78da16583ad93b9f$var$closeBlock() {
    $78da16583ad93b9f$var$blockStack.pop();
    $78da16583ad93b9f$var$currentBlock = $78da16583ad93b9f$var$blockStack[$78da16583ad93b9f$var$blockStack.length - 1] || null;
}
// Whether we should be tracking dynamic child nodes inside a block.
// Only tracks when this value is > 0
// We are not using a simple boolean because this value may need to be
// incremented/decremented by nested usage of v-once (see below)
let $78da16583ad93b9f$var$isBlockTreeEnabled = 1;
/**
 * Block tracking sometimes needs to be disabled, for example during the
 * creation of a tree that needs to be cached by v-once. The compiler generates
 * code like this:
 *
 * ``` js
 * _cache[1] || (
 *   setBlockTracking(-1),
 *   _cache[1] = createVNode(...),
 *   setBlockTracking(1),
 *   _cache[1]
 * )
 * ```
 *
 * @private
 */ function $78da16583ad93b9f$export$c20bee82f26f1e27(value) {
    $78da16583ad93b9f$var$isBlockTreeEnabled += value;
}
function $78da16583ad93b9f$var$setupBlock(vnode) {
    // save current block children on the block vnode
    vnode.dynamicChildren = $78da16583ad93b9f$var$isBlockTreeEnabled > 0 ? $78da16583ad93b9f$var$currentBlock || (0, $3LSrV.EMPTY_ARR) : null;
    // close block
    $78da16583ad93b9f$var$closeBlock();
    // a block is always going to be patched, so track it as a child of its
    // parent block
    if ($78da16583ad93b9f$var$isBlockTreeEnabled > 0 && $78da16583ad93b9f$var$currentBlock) $78da16583ad93b9f$var$currentBlock.push(vnode);
    return vnode;
}
/**
 * @private
 */ function $78da16583ad93b9f$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $78da16583ad93b9f$var$setupBlock($78da16583ad93b9f$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
/**
 * Create a block root vnode. Takes the same exact arguments as `createVNode`.
 * A block root keeps track of dynamic nodes within the block in the
 * `dynamicChildren` array.
 *
 * @private
 */ function $78da16583ad93b9f$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $78da16583ad93b9f$var$setupBlock($78da16583ad93b9f$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $78da16583ad93b9f$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $78da16583ad93b9f$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $78da16583ad93b9f$var$vnodeArgsTransformer;
/**
 * Internal API for registering an arguments transform for createVNode
 * used for creating stubs in the test-utils
 * It is *internal* but needs to be exposed for test-utils to pick up proper
 * typings
 */ function $78da16583ad93b9f$export$83beccd3afeeb809(transformer) {
    $78da16583ad93b9f$var$vnodeArgsTransformer = transformer;
}
const $78da16583ad93b9f$var$createVNodeWithArgsTransform = (...args)=>{
    return $78da16583ad93b9f$var$_createVNode(...$78da16583ad93b9f$var$vnodeArgsTransformer ? $78da16583ad93b9f$var$vnodeArgsTransformer(args, $78da16583ad93b9f$var$currentRenderingInstance) : args);
};
const $78da16583ad93b9f$var$InternalObjectKey = `__vInternal`;
const $78da16583ad93b9f$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $78da16583ad93b9f$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    return ref != null ? (0, $3LSrV.isString)(ref) || (0, $8bTPG.isRef)(ref) || (0, $3LSrV.isFunction)(ref) ? {
        i: $78da16583ad93b9f$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $78da16583ad93b9f$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $78da16583ad93b9f$export$ffb0004e005737fa ? 0 : 1 /* ELEMENT */ , isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $78da16583ad93b9f$var$normalizeKey(props),
        ref: props && $78da16583ad93b9f$var$normalizeRef(props),
        scopeId: $78da16583ad93b9f$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null
    };
    if (needFullChildrenNormalization) {
        $78da16583ad93b9f$var$normalizeChildren(vnode, children);
        // normalize suspense children
        if (shapeFlag & 128 /* SUSPENSE */ ) type.normalize(vnode);
    } else if (children) // compiled element vnode - if children is passed, only possible types are
    // string or Array.
    vnode.shapeFlag |= (0, $3LSrV.isString)(children) ? 8 /* TEXT_CHILDREN */  : 16 /* ARRAY_CHILDREN */ ;
    // track vnode for block tree
    if ($78da16583ad93b9f$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $78da16583ad93b9f$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6 /* COMPONENT */ ) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32 /* HYDRATE_EVENTS */ ) $78da16583ad93b9f$var$currentBlock.push(vnode);
    return vnode;
}
const $78da16583ad93b9f$export$bf5c4cf060303d58 = $78da16583ad93b9f$var$_createVNode;
function $78da16583ad93b9f$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $78da16583ad93b9f$var$NULL_DYNAMIC_COMPONENT) type = $78da16583ad93b9f$export$4d299b491347818a;
    if ($78da16583ad93b9f$export$3868d13f8734ae81(type)) {
        // createVNode receiving an existing vnode. This happens in cases like
        // <component :is="vnode"/>
        // #2078 make sure to merge refs during the clone instead of overwriting it
        const cloned = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $78da16583ad93b9f$var$normalizeChildren(cloned, children);
        if ($78da16583ad93b9f$var$isBlockTreeEnabled > 0 && !isBlockNode && $78da16583ad93b9f$var$currentBlock) {
            if (cloned.shapeFlag & 6 /* COMPONENT */ ) $78da16583ad93b9f$var$currentBlock[$78da16583ad93b9f$var$currentBlock.indexOf(type)] = cloned;
            else $78da16583ad93b9f$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2 /* BAIL */ ;
        return cloned;
    }
    // class component normalization.
    if ($78da16583ad93b9f$var$isClassComponent(type)) type = type.__vccOpts;
    // class & style normalization.
    if (props) {
        // for reactive or proxy objects, we need to clone it to enable mutation.
        props = $78da16583ad93b9f$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $3LSrV.isString)(klass)) props.class = (0, $3LSrV.normalizeClass)(klass);
        if ((0, $3LSrV.isObject)(style)) {
            // reactive state objects need to be cloned since they are likely to be
            // mutated
            if ((0, $8bTPG.isProxy)(style) && !(0, $3LSrV.isArray)(style)) style = (0, $3LSrV.extend)({}, style);
            props.style = (0, $3LSrV.normalizeStyle)(style);
        }
    }
    // encode the vnode type information into a bitmap
    const shapeFlag = (0, $3LSrV.isString)(type) ? 1 /* ELEMENT */  : $78da16583ad93b9f$var$isSuspense(type) ? 128 /* SUSPENSE */  : $78da16583ad93b9f$var$isTeleport(type) ? 64 /* TELEPORT */  : (0, $3LSrV.isObject)(type) ? 4 /* STATEFUL_COMPONENT */  : (0, $3LSrV.isFunction)(type) ? 2 /* FUNCTIONAL_COMPONENT */  : 0;
    return $78da16583ad93b9f$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $78da16583ad93b9f$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $8bTPG.isProxy)(props) || $78da16583ad93b9f$var$InternalObjectKey in props ? (0, $3LSrV.extend)({}, props) : props;
}
function $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false) {
    // This is intentionally NOT using spread or extend to avoid the runtime
    // key enumeration cost.
    const { props: props, ref: ref, patchFlag: patchFlag, children: children } = vnode;
    const mergedProps = extraProps ? $78da16583ad93b9f$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $78da16583ad93b9f$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $3LSrV.isArray)(ref) ? ref.concat($78da16583ad93b9f$var$normalizeRef(extraProps)) : [
            ref,
            $78da16583ad93b9f$var$normalizeRef(extraProps)
        ] : $78da16583ad93b9f$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $78da16583ad93b9f$export$ffb0004e005737fa ? patchFlag === -1 // hoisted node
         ? 16 /* FULL_PROPS */  : patchFlag | 16 /* FULL_PROPS */  : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor
    };
    return cloned;
}
/**
 * Dev only, for HMR of hoisted vnodes reused in v-for
 * https://github.com/vitejs/vite/issues/2022
 */ function $78da16583ad93b9f$var$deepCloneVNode(vnode) {
    const cloned = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $3LSrV.isArray)(vnode.children)) cloned.children = vnode.children.map($78da16583ad93b9f$var$deepCloneVNode);
    return cloned;
}
/**
 * @private
 */ function $78da16583ad93b9f$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$5f1af8db9871e1d6, null, text, flag);
}
/**
 * @private
 */ function $78da16583ad93b9f$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    // A static vnode can contain multiple stringified elements, and the number
    // of elements is necessary for hydration.
    const vnode = $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
/**
 * @private
 */ function $78da16583ad93b9f$export$49553837c7236d3c(text = "", // when used as the v-else branch, the comment node must be created as a
// block to ensure correct updates.
asBlock = false) {
    return asBlock ? ($78da16583ad93b9f$export$e7eaa45e502fe5cc(), $78da16583ad93b9f$export$9f2dfe8048dfb22b($78da16583ad93b9f$export$4d299b491347818a, null, text)) : $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a, null, text);
}
function $78da16583ad93b9f$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") // empty placeholder
    return $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a);
    else if ((0, $3LSrV.isArray)(child)) // fragment
    return $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") // already vnode, this should be the most common since compiled templates
    // always produce all-vnode children arrays
    return $78da16583ad93b9f$var$cloneIfMounted(child);
    else // strings and numbers
    return $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$5f1af8db9871e1d6, null, String(child));
}
// optimized normalization for template-compiled render fns
function $78da16583ad93b9f$var$cloneIfMounted(child) {
    return child.el === null || child.memo ? child : $78da16583ad93b9f$export$ee4f9e12c0a92a1a(child);
}
function $78da16583ad93b9f$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $3LSrV.isArray)(children)) type = 16 /* ARRAY_CHILDREN */ ;
    else if (typeof children === "object") {
        if (shapeFlag & 65 /* TELEPORT */ ) {
            // Normalize slot to plain children for plain element and Teleport
            const slot = children.default;
            if (slot) {
                // _c marker is added by withCtx() indicating this is a compiled slot
                slot._c && (slot._d = false);
                $78da16583ad93b9f$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32 /* SLOTS_CHILDREN */ ;
            const slotFlag = children._;
            if (!slotFlag && !($78da16583ad93b9f$var$InternalObjectKey in children)) children._ctx = $78da16583ad93b9f$var$currentRenderingInstance;
            else if (slotFlag === 3 /* FORWARDED */  && $78da16583ad93b9f$var$currentRenderingInstance) {
                // a child component receives forwarded slots from the parent.
                // its slot type is determined by its parent's slot type.
                if ($78da16583ad93b9f$var$currentRenderingInstance.slots._ === 1 /* STABLE */ ) children._ = 1 /* STABLE */ ;
                else {
                    children._ = 2 /* DYNAMIC */ ;
                    vnode.patchFlag |= 1024 /* DYNAMIC_SLOTS */ ;
                }
            }
        }
    } else if ((0, $3LSrV.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $78da16583ad93b9f$var$currentRenderingInstance
        };
        type = 32 /* SLOTS_CHILDREN */ ;
    } else {
        children = String(children);
        // force teleport children to array so it can be moved around
        if (shapeFlag & 64 /* TELEPORT */ ) {
            type = 16 /* ARRAY_CHILDREN */ ;
            children = [
                $78da16583ad93b9f$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8 /* TEXT_CHILDREN */ ;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $78da16583ad93b9f$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $3LSrV.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $3LSrV.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $3LSrV.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $3LSrV.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $78da16583ad93b9f$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $78da16583ad93b9f$export$dae85862a8d94378(hook, instance, 7 /* VNODE_HOOK */ , [
        vnode,
        prevVNode
    ]);
}
const $78da16583ad93b9f$var$emptyAppContext = $78da16583ad93b9f$var$createAppContext();
let $78da16583ad93b9f$var$uid$1 = 0;
function $78da16583ad93b9f$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    // inherit parent app context - or - if root, adopt from root vnode
    const appContext = (parent ? parent.appContext : vnode.appContext) || $78da16583ad93b9f$var$emptyAppContext;
    const instance = {
        uid: $78da16583ad93b9f$var$uid$1++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        next: null,
        subTree: null,
        effect: null,
        update: null,
        scope: new (0, $8bTPG.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $78da16583ad93b9f$var$normalizePropsOptions(type, appContext),
        emitsOptions: $78da16583ad93b9f$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        emitted: null,
        // props default value
        propsDefaults: (0, $3LSrV.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $3LSrV.EMPTY_OBJ),
        data: (0, $3LSrV.EMPTY_OBJ),
        props: (0, $3LSrV.EMPTY_OBJ),
        attrs: (0, $3LSrV.EMPTY_OBJ),
        slots: (0, $3LSrV.EMPTY_OBJ),
        refs: (0, $3LSrV.EMPTY_OBJ),
        setupState: (0, $3LSrV.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $78da16583ad93b9f$var$emit$1.bind(null, instance);
    // apply custom element special handling
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $78da16583ad93b9f$var$currentInstance = null;
const $78da16583ad93b9f$export$f13e630aa3915748 = ()=>$78da16583ad93b9f$var$currentInstance || $78da16583ad93b9f$var$currentRenderingInstance;
const $78da16583ad93b9f$var$setCurrentInstance = (instance)=>{
    $78da16583ad93b9f$var$currentInstance = instance;
    instance.scope.on();
};
const $78da16583ad93b9f$var$unsetCurrentInstance = ()=>{
    $78da16583ad93b9f$var$currentInstance && $78da16583ad93b9f$var$currentInstance.scope.off();
    $78da16583ad93b9f$var$currentInstance = null;
};
const $78da16583ad93b9f$var$isBuiltInTag = /*#__PURE__*/ (0, $3LSrV.makeMap)("slot,component");
function $78da16583ad93b9f$var$validateComponentName(name, config) {
    const appIsNativeTag = config.isNativeTag || (0, $3LSrV.NO);
    if ($78da16583ad93b9f$var$isBuiltInTag(name) || appIsNativeTag(name)) $78da16583ad93b9f$export$c106dd0671a0fc2d("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $78da16583ad93b9f$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */ ;
}
let $78da16583ad93b9f$var$isInSSRComponentSetup = false;
function $78da16583ad93b9f$var$setupComponent(instance, isSSR = false) {
    $78da16583ad93b9f$var$isInSSRComponentSetup = isSSR;
    const { props: props, children: children } = instance.vnode;
    const isStateful = $78da16583ad93b9f$var$isStatefulComponent(instance);
    $78da16583ad93b9f$var$initProps(instance, props, isStateful, isSSR);
    $78da16583ad93b9f$var$initSlots(instance, children);
    const setupResult = isStateful ? $78da16583ad93b9f$var$setupStatefulComponent(instance, isSSR) : undefined;
    $78da16583ad93b9f$var$isInSSRComponentSetup = false;
    return setupResult;
}
function $78da16583ad93b9f$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    // 0. create render proxy property access cache
    instance.accessCache = Object.create(null);
    // 1. create public instance / render proxy
    // also mark it raw so it's never observed
    instance.proxy = (0, $8bTPG.markRaw)(new Proxy(instance.ctx, $78da16583ad93b9f$var$PublicInstanceProxyHandlers));
    // 2. call setup()
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $78da16583ad93b9f$var$createSetupContext(instance) : null;
        $78da16583ad93b9f$var$setCurrentInstance(instance);
        (0, $8bTPG.pauseTracking)();
        const setupResult = $78da16583ad93b9f$export$b22fcaf88446e9bf(setup, instance, 0 /* SETUP_FUNCTION */ , [
            (0, instance.props),
            setupContext
        ]);
        (0, $8bTPG.resetTracking)();
        $78da16583ad93b9f$var$unsetCurrentInstance();
        if ((0, $3LSrV.isPromise)(setupResult)) {
            setupResult.then($78da16583ad93b9f$var$unsetCurrentInstance, $78da16583ad93b9f$var$unsetCurrentInstance);
            if (isSSR) // return the promise so server-renderer can wait on it
            return setupResult.then((resolvedResult)=>{
                $78da16583ad93b9f$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $78da16583ad93b9f$export$d3da1ecaf1206c58(e, instance, 0 /* SETUP_FUNCTION */ );
            });
            else // async setup returned Promise.
            // bail here and wait for re-entry.
            instance.asyncDep = setupResult;
        } else $78da16583ad93b9f$var$handleSetupResult(instance, setupResult, isSSR);
    } else $78da16583ad93b9f$var$finishComponentSetup(instance, isSSR);
}
function $78da16583ad93b9f$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $3LSrV.isFunction)(setupResult)) {
        // setup returned an inline render function
        if (instance.type.__ssrInlineRender) // when the function's name is `ssrRender` (compiled by SFC inline mode),
        // set it as ssrRender instead.
        instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $3LSrV.isObject)(setupResult)) {
        // setup returned bindings.
        // assuming a render function compiled from template is present.
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $8bTPG.proxyRefs)(setupResult);
    }
    $78da16583ad93b9f$var$finishComponentSetup(instance, isSSR);
}
let $78da16583ad93b9f$var$compile;
let $78da16583ad93b9f$var$installWithProxy;
/**
 * For runtime-dom to register the compiler.
 * Note the exported method uses any to avoid d.ts relying on the compiler types.
 */ function $78da16583ad93b9f$export$667bb5a67822b941(_compile) {
    $78da16583ad93b9f$var$compile = _compile;
    $78da16583ad93b9f$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $78da16583ad93b9f$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
// dev only
const $78da16583ad93b9f$export$c93a9c496c5211fa = ()=>!$78da16583ad93b9f$var$compile;
function $78da16583ad93b9f$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    // template / render function normalization
    // could be already set when returned from setup()
    if (!instance.render) {
        // only do on-the-fly compile if not in SSR - SSR on-the-fly compilation
        // is done by server-renderer
        if (!isSSR && $78da16583ad93b9f$var$compile && !Component.render) {
            const template = Component.template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $3LSrV.extend)((0, $3LSrV.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $78da16583ad93b9f$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $3LSrV.NOOP);
        // for runtime-compiled render functions using `with` blocks, the render
        // proxy used needs a different `has` handler which is more performant and
        // also only allows a whitelist of globals to fallthrough.
        if ($78da16583ad93b9f$var$installWithProxy) $78da16583ad93b9f$var$installWithProxy(instance);
    }
    // support for 2.x options
    if (__VUE_OPTIONS_API__ && true) {
        $78da16583ad93b9f$var$setCurrentInstance(instance);
        (0, $8bTPG.pauseTracking)();
        $78da16583ad93b9f$var$applyOptions(instance);
        (0, $8bTPG.resetTracking)();
        $78da16583ad93b9f$var$unsetCurrentInstance();
    }
}
function $78da16583ad93b9f$var$createAttrsProxy(instance) {
    return new Proxy(instance.attrs, {
        get (target, key) {
            (0, $8bTPG.track)(instance, "get" /* GET */ , "$attrs");
            return target[key];
        }
    });
}
function $78da16583ad93b9f$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    let attrs;
    var event, args;
    return {
        get attrs () {
            return attrs || (attrs = $78da16583ad93b9f$var$createAttrsProxy(instance));
        },
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $78da16583ad93b9f$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $8bTPG.proxyRefs)((0, $8bTPG.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $78da16583ad93b9f$var$publicPropertiesMap) return $78da16583ad93b9f$var$publicPropertiesMap[key](instance);
        }
    }));
}
const $78da16583ad93b9f$var$classifyRE = /(?:^|[-_])(\w)/g;
const $78da16583ad93b9f$var$classify = (str)=>str.replace($78da16583ad93b9f$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $78da16583ad93b9f$var$getComponentName(Component, includeInferred = true) {
    return (0, $3LSrV.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
/* istanbul ignore next */ function $78da16583ad93b9f$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $78da16583ad93b9f$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        // try to infer the name based on reverse resolution
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $78da16583ad93b9f$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $78da16583ad93b9f$var$isClassComponent(value) {
    return (0, $3LSrV.isFunction)(value) && "__vccOpts" in value;
}
const $78da16583ad93b9f$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    // @ts-ignore
    return (0, $8bTPG.computed)(getterOrOptions, debugOptions, $78da16583ad93b9f$var$isInSSRComponentSetup);
};
// dev only
const $78da16583ad93b9f$var$warnRuntimeUsage = (method)=>$78da16583ad93b9f$export$c106dd0671a0fc2d(`${method}() is a compiler-hint helper that is only usable inside ` + `<script setup> of a single file component. Its arguments should be ` + `compiled away and passing it at runtime has no effect.`);
// implementation
function $78da16583ad93b9f$export$80b33eababae110e() {
    return null;
}
// implementation
function $78da16583ad93b9f$export$51ecece22fc17ddc() {
    return null;
}
/**
 * Vue `<script setup>` compiler macro for declaring a component's exposed
 * instance properties when it is accessed by a parent component via template
 * refs.
 *
 * `<script setup>` components are closed by default - i.e. variables inside
 * the `<script setup>` scope is not exposed to parent unless explicitly exposed
 * via `defineExpose`.
 *
 * This is only usable inside `<script setup>`, is compiled away in the
 * output and should **not** be actually called at runtime.
 */ function $78da16583ad93b9f$export$da25b65ca24b518a(exposed) {}
/**
 * Vue `<script setup>` compiler macro for providing props default values when
 * using type-based `defineProps` declaration.
 *
 * Example usage:
 * ```ts
 * withDefaults(defineProps<{
 *   size?: number
 *   labels?: string[]
 * }>(), {
 *   size: 3,
 *   labels: () => ['default label']
 * })
 * ```
 *
 * This is only usable inside `<script setup>`, is compiled away in the output
 * and should **not** be actually called at runtime.
 */ function $78da16583ad93b9f$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $78da16583ad93b9f$export$9203a8e84125433c() {
    return $78da16583ad93b9f$var$getContext().slots;
}
function $78da16583ad93b9f$export$75e29435042cd2ea() {
    return $78da16583ad93b9f$var$getContext().attrs;
}
function $78da16583ad93b9f$var$getContext() {
    const i = $78da16583ad93b9f$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $78da16583ad93b9f$var$createSetupContext(i));
}
/**
 * Runtime helper for merging default declarations. Imported by compiled code
 * only.
 * @internal
 */ function $78da16583ad93b9f$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = (0, $3LSrV.isArray)(raw) ? raw.reduce((normalized, p)=>(normalized[p] = {}, normalized), {}) : raw;
    for(const key in defaults){
        const opt = props[key];
        if (opt) {
            if ((0, $3LSrV.isArray)(opt) || (0, $3LSrV.isFunction)(opt)) props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) props[key] = {
            default: defaults[key]
        };
    }
    return props;
}
/**
 * Used to create a proxy for the rest element when destructuring props with
 * defineProps().
 * @internal
 */ function $78da16583ad93b9f$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
/**
 * `<script setup>` helper for persisting the current instance context over
 * async/await flows.
 *
 * `@vue/compiler-sfc` converts the following:
 *
 * ```ts
 * const x = await foo()
 * ```
 *
 * into:
 *
 * ```ts
 * let __temp, __restore
 * const x = (([__temp, __restore] = withAsyncContext(() => foo())),__temp=await __temp,__restore(),__temp)
 * ```
 * @internal
 */ function $78da16583ad93b9f$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $78da16583ad93b9f$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $78da16583ad93b9f$var$unsetCurrentInstance();
    if ((0, $3LSrV.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $78da16583ad93b9f$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$78da16583ad93b9f$var$setCurrentInstance(ctx)
    ];
}
// Actual implementation
function $78da16583ad93b9f$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $3LSrV.isObject)(propsOrChildren) && !(0, $3LSrV.isArray)(propsOrChildren)) {
            // single vnode without props
            if ($78da16583ad93b9f$export$3868d13f8734ae81(propsOrChildren)) return $78da16583ad93b9f$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            // props without children
            return $78da16583ad93b9f$export$bf5c4cf060303d58(type, propsOrChildren);
        } else // omit props
        return $78da16583ad93b9f$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $78da16583ad93b9f$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $78da16583ad93b9f$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
const $78da16583ad93b9f$export$f2549a27e18acf2d = Symbol(``);
const $78da16583ad93b9f$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $78da16583ad93b9f$export$a976684a0efeb93f($78da16583ad93b9f$export$f2549a27e18acf2d);
        if (!ctx) $78da16583ad93b9f$export$c106dd0671a0fc2d(`Server rendering context not provided. Make sure to only call ` + `useSSRContext() conditionally in the server build.`);
        return ctx;
    }
};
function $78da16583ad93b9f$var$isShallow(value) {
    return !!(value && value["__v_isShallow" /* IS_SHALLOW */ ]);
}
function $78da16583ad93b9f$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $8bTPG.toRaw)(instance.props)));
        if (instance.setupState !== (0, $3LSrV.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $3LSrV.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $8bTPG.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $3LSrV.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $3LSrV.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $8bTPG.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $3LSrV.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $3LSrV.isArray)(opts) && opts.includes(key) || (0, $3LSrV.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ($78da16583ad93b9f$var$isShallow(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $78da16583ad93b9f$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $78da16583ad93b9f$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    // shallow clone
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $78da16583ad93b9f$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $3LSrV.hasChanged)(prev[i], memo[i])) return false;
    }
    // make sure to let parent block track it when returning cached
    if ($78da16583ad93b9f$var$isBlockTreeEnabled > 0 && $78da16583ad93b9f$var$currentBlock) $78da16583ad93b9f$var$currentBlock.push(cached);
    return true;
}
// Core API ------------------------------------------------------------------
const $78da16583ad93b9f$export$83d89fbfd8236492 = "3.2.37";
const $78da16583ad93b9f$var$_ssrUtils = {
    createComponentInstance: $78da16583ad93b9f$var$createComponentInstance,
    setupComponent: $78da16583ad93b9f$var$setupComponent,
    renderComponentRoot: $78da16583ad93b9f$var$renderComponentRoot,
    setCurrentRenderingInstance: $78da16583ad93b9f$var$setCurrentRenderingInstance,
    isVNode: $78da16583ad93b9f$export$3868d13f8734ae81,
    normalizeVNode: $78da16583ad93b9f$var$normalizeVNode
};
/**
 * SSR utils for \@vue/server-renderer. Only exposed in ssr-possible builds.
 * @internal
 */ const $78da16583ad93b9f$export$a9679033567b336d = $78da16583ad93b9f$var$_ssrUtils;
/**
 * @internal only exposed in compat builds
 */ const $78da16583ad93b9f$export$83cf26e06ea620e1 = null;
/**
 * @internal only exposed in compat builds.
 */ const $78da16583ad93b9f$export$dc678eddf276286e = null;

});
parcelRegister("8bTPG", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $5f6aa8fade9cc028$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "ReactiveEffect", () => $5f6aa8fade9cc028$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $5f6aa8fade9cc028$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $5f6aa8fade9cc028$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $5f6aa8fade9cc028$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $5f6aa8fade9cc028$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $5f6aa8fade9cc028$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isRef", () => $5f6aa8fade9cc028$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $5f6aa8fade9cc028$export$90a44edba14e47be);
$parcel$export(module.exports, "isShallow", () => $5f6aa8fade9cc028$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "shallowReactive", () => $5f6aa8fade9cc028$export$8d81cefd22d22260);
$parcel$export(module.exports, "isReactive", () => $5f6aa8fade9cc028$export$352205f445242f02);
$parcel$export(module.exports, "isProxy", () => $5f6aa8fade9cc028$export$5f3ca29d057519b3);
$parcel$export(module.exports, "markRaw", () => $5f6aa8fade9cc028$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $5f6aa8fade9cc028$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "proxyRefs", () => $5f6aa8fade9cc028$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "computed", () => $5f6aa8fade9cc028$export$2983e091f1a1e8e2);

var $SJKiR = parcelRequire("SJKiR");
function $5f6aa8fade9cc028$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $5f6aa8fade9cc028$var$activeEffectScope;
class $5f6aa8fade9cc028$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        /**
         * @internal
         */ this.active = true;
        /**
         * @internal
         */ this.effects = [];
        /**
         * @internal
         */ this.cleanups = [];
        if (!detached && $5f6aa8fade9cc028$var$activeEffectScope) {
            this.parent = $5f6aa8fade9cc028$var$activeEffectScope;
            this.index = ($5f6aa8fade9cc028$var$activeEffectScope.scopes || ($5f6aa8fade9cc028$var$activeEffectScope.scopes = [])).push(this) - 1;
        }
    }
    run(fn) {
        if (this.active) {
            const currentEffectScope = $5f6aa8fade9cc028$var$activeEffectScope;
            try {
                $5f6aa8fade9cc028$var$activeEffectScope = this;
                return fn();
            } finally{
                $5f6aa8fade9cc028$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */ on() {
        $5f6aa8fade9cc028$var$activeEffectScope = this;
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */ off() {
        $5f6aa8fade9cc028$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this.active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            // nested scope, dereference from parent to avoid memory leaks
            if (this.parent && !fromParent) {
                // optimized O(1) removal
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.active = false;
        }
    }
}
function $5f6aa8fade9cc028$export$7056603ea81600be(detached) {
    return new $5f6aa8fade9cc028$export$1168ed9dbc71ddbd(detached);
}
function $5f6aa8fade9cc028$var$recordEffectScope(effect, scope = $5f6aa8fade9cc028$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $5f6aa8fade9cc028$export$c7be4b0125a10cba() {
    return $5f6aa8fade9cc028$var$activeEffectScope;
}
function $5f6aa8fade9cc028$export$a780418acd4762da(fn) {
    if ($5f6aa8fade9cc028$var$activeEffectScope) $5f6aa8fade9cc028$var$activeEffectScope.cleanups.push(fn);
}
const $5f6aa8fade9cc028$var$createDep = (effects)=>{
    const dep = new Set(effects);
    dep.w = 0;
    dep.n = 0;
    return dep;
};
const $5f6aa8fade9cc028$var$wasTracked = (dep)=>(dep.w & $5f6aa8fade9cc028$var$trackOpBit) > 0;
const $5f6aa8fade9cc028$var$newTracked = (dep)=>(dep.n & $5f6aa8fade9cc028$var$trackOpBit) > 0;
const $5f6aa8fade9cc028$var$initDepMarkers = ({ deps: deps })=>{
    if (deps.length) for(let i = 0; i < deps.length; i++)deps[i].w |= $5f6aa8fade9cc028$var$trackOpBit; // set was tracked
};
const $5f6aa8fade9cc028$var$finalizeDepMarkers = (effect)=>{
    const { deps: deps } = effect;
    if (deps.length) {
        let ptr = 0;
        for(let i = 0; i < deps.length; i++){
            const dep = deps[i];
            if ($5f6aa8fade9cc028$var$wasTracked(dep) && !$5f6aa8fade9cc028$var$newTracked(dep)) dep.delete(effect);
            else deps[ptr++] = dep;
            // clear bits
            dep.w &= ~$5f6aa8fade9cc028$var$trackOpBit;
            dep.n &= ~$5f6aa8fade9cc028$var$trackOpBit;
        }
        deps.length = ptr;
    }
};
const $5f6aa8fade9cc028$var$targetMap = new WeakMap();
// The number of effects currently being tracked recursively.
let $5f6aa8fade9cc028$var$effectTrackDepth = 0;
let $5f6aa8fade9cc028$var$trackOpBit = 1;
/**
 * The bitwise track markers support at most 30 levels of recursion.
 * This value is chosen to enable modern JS engines to use a SMI on all platforms.
 * When recursion depth is greater, fall back to using a full cleanup.
 */ const $5f6aa8fade9cc028$var$maxMarkerBits = 30;
let $5f6aa8fade9cc028$var$activeEffect;
const $5f6aa8fade9cc028$export$3c41b1a4e06acc14 = Symbol("");
const $5f6aa8fade9cc028$var$MAP_KEY_ITERATE_KEY = Symbol("");
class $5f6aa8fade9cc028$export$28352bb4dd362521 {
    constructor(fn, scheduler = null, scope){
        this.fn = fn;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        this.parent = undefined;
        $5f6aa8fade9cc028$var$recordEffectScope(this, scope);
    }
    run() {
        if (!this.active) return this.fn();
        let parent = $5f6aa8fade9cc028$var$activeEffect;
        let lastShouldTrack = $5f6aa8fade9cc028$var$shouldTrack;
        while(parent){
            if (parent === this) return;
            parent = parent.parent;
        }
        try {
            this.parent = $5f6aa8fade9cc028$var$activeEffect;
            $5f6aa8fade9cc028$var$activeEffect = this;
            $5f6aa8fade9cc028$var$shouldTrack = true;
            $5f6aa8fade9cc028$var$trackOpBit = 1 << ++$5f6aa8fade9cc028$var$effectTrackDepth;
            if ($5f6aa8fade9cc028$var$effectTrackDepth <= $5f6aa8fade9cc028$var$maxMarkerBits) $5f6aa8fade9cc028$var$initDepMarkers(this);
            else $5f6aa8fade9cc028$var$cleanupEffect(this);
            return this.fn();
        } finally{
            if ($5f6aa8fade9cc028$var$effectTrackDepth <= $5f6aa8fade9cc028$var$maxMarkerBits) $5f6aa8fade9cc028$var$finalizeDepMarkers(this);
            $5f6aa8fade9cc028$var$trackOpBit = 1 << --$5f6aa8fade9cc028$var$effectTrackDepth;
            $5f6aa8fade9cc028$var$activeEffect = this.parent;
            $5f6aa8fade9cc028$var$shouldTrack = lastShouldTrack;
            this.parent = undefined;
            if (this.deferStop) this.stop();
        }
    }
    stop() {
        // stopped while running itself - defer the cleanup
        if ($5f6aa8fade9cc028$var$activeEffect === this) this.deferStop = true;
        else if (this.active) {
            $5f6aa8fade9cc028$var$cleanupEffect(this);
            if (this.onStop) this.onStop();
            this.active = false;
        }
    }
}
function $5f6aa8fade9cc028$var$cleanupEffect(effect) {
    const { deps: deps } = effect;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect);
        deps.length = 0;
    }
}
function $5f6aa8fade9cc028$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect) fn = fn.effect.fn;
    const _effect = new $5f6aa8fade9cc028$export$28352bb4dd362521(fn);
    if (options) {
        (0, $SJKiR.extend)(_effect, options);
        if (options.scope) $5f6aa8fade9cc028$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $5f6aa8fade9cc028$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $5f6aa8fade9cc028$var$shouldTrack = true;
const $5f6aa8fade9cc028$var$trackStack = [];
function $5f6aa8fade9cc028$export$938a971395fef855() {
    $5f6aa8fade9cc028$var$trackStack.push($5f6aa8fade9cc028$var$shouldTrack);
    $5f6aa8fade9cc028$var$shouldTrack = false;
}
function $5f6aa8fade9cc028$export$1f8ffc6fd33b1d16() {
    $5f6aa8fade9cc028$var$trackStack.push($5f6aa8fade9cc028$var$shouldTrack);
    $5f6aa8fade9cc028$var$shouldTrack = true;
}
function $5f6aa8fade9cc028$export$c39176b1babaa8b8() {
    const last = $5f6aa8fade9cc028$var$trackStack.pop();
    $5f6aa8fade9cc028$var$shouldTrack = last === undefined ? true : last;
}
function $5f6aa8fade9cc028$export$6b2a7d5132615086(target, type, key) {
    if ($5f6aa8fade9cc028$var$shouldTrack && $5f6aa8fade9cc028$var$activeEffect) {
        let depsMap = $5f6aa8fade9cc028$var$targetMap.get(target);
        if (!depsMap) $5f6aa8fade9cc028$var$targetMap.set(target, depsMap = new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $5f6aa8fade9cc028$var$createDep());
        const eventInfo = undefined;
        $5f6aa8fade9cc028$var$trackEffects(dep, eventInfo);
    }
}
function $5f6aa8fade9cc028$var$trackEffects(dep, debuggerEventExtraInfo) {
    let shouldTrack = false;
    if ($5f6aa8fade9cc028$var$effectTrackDepth <= $5f6aa8fade9cc028$var$maxMarkerBits) {
        if (!$5f6aa8fade9cc028$var$newTracked(dep)) {
            dep.n |= $5f6aa8fade9cc028$var$trackOpBit; // set newly tracked
            shouldTrack = !$5f6aa8fade9cc028$var$wasTracked(dep);
        }
    } else // Full cleanup mode.
    shouldTrack = !dep.has($5f6aa8fade9cc028$var$activeEffect);
    if (shouldTrack) {
        dep.add($5f6aa8fade9cc028$var$activeEffect);
        $5f6aa8fade9cc028$var$activeEffect.deps.push(dep);
    }
}
function $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $5f6aa8fade9cc028$var$targetMap.get(target);
    if (!depsMap) // never been tracked
    return;
    let deps = [];
    if (type === "clear" /* CLEAR */ ) // collection being cleared
    // trigger all effects for target
    deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $SJKiR.isArray)(target)) depsMap.forEach((dep, key)=>{
        if (key === "length" || key >= newValue) deps.push(dep);
    });
    else {
        // schedule runs for SET | ADD | DELETE
        if (key !== void 0) deps.push(depsMap.get(key));
        // also run for iteration key on ADD | DELETE | Map.SET
        switch(type){
            case "add" /* ADD */ :
                if (!(0, $SJKiR.isArray)(target)) {
                    deps.push(depsMap.get($5f6aa8fade9cc028$export$3c41b1a4e06acc14));
                    if ((0, $SJKiR.isMap)(target)) deps.push(depsMap.get($5f6aa8fade9cc028$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $SJKiR.isIntegerKey)(key)) // new index added to array -> length changes
                deps.push(depsMap.get("length"));
                break;
            case "delete" /* DELETE */ :
                if (!(0, $SJKiR.isArray)(target)) {
                    deps.push(depsMap.get($5f6aa8fade9cc028$export$3c41b1a4e06acc14));
                    if ((0, $SJKiR.isMap)(target)) deps.push(depsMap.get($5f6aa8fade9cc028$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set" /* SET */ :
                if ((0, $SJKiR.isMap)(target)) deps.push(depsMap.get($5f6aa8fade9cc028$export$3c41b1a4e06acc14));
                break;
        }
    }
    const eventInfo = undefined;
    if (deps.length === 1) {
        if (deps[0]) $5f6aa8fade9cc028$var$triggerEffects(deps[0]);
    } else {
        const effects = [];
        for (const dep of deps)if (dep) effects.push(...dep);
        $5f6aa8fade9cc028$var$triggerEffects($5f6aa8fade9cc028$var$createDep(effects));
    }
}
function $5f6aa8fade9cc028$var$triggerEffects(dep, debuggerEventExtraInfo) {
    // spread into array for stabilization
    const effects = (0, $SJKiR.isArray)(dep) ? dep : [
        ...dep
    ];
    for (const effect of effects)if (effect.computed) $5f6aa8fade9cc028$var$triggerEffect(effect, debuggerEventExtraInfo);
    for (const effect of effects)if (!effect.computed) $5f6aa8fade9cc028$var$triggerEffect(effect, debuggerEventExtraInfo);
}
function $5f6aa8fade9cc028$var$triggerEffect(effect, debuggerEventExtraInfo) {
    if (effect !== $5f6aa8fade9cc028$var$activeEffect || effect.allowRecurse) {
        if (effect.scheduler) effect.scheduler();
        else effect.run();
    }
}
const $5f6aa8fade9cc028$var$isNonTrackableKeys = /*#__PURE__*/ (0, $SJKiR.makeMap)(`__proto__,__v_isRef,__isVue`);
const $5f6aa8fade9cc028$var$builtInSymbols = new Set(/*#__PURE__*/ Object.getOwnPropertyNames(Symbol)// ios10.x Object.getOwnPropertyNames(Symbol) can enumerate 'arguments' and 'caller'
// but accessing them on Symbol leads to TypeError because Symbol is a strict mode
// function
.filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $SJKiR.isSymbol)));
const $5f6aa8fade9cc028$var$get = /*#__PURE__*/ $5f6aa8fade9cc028$var$createGetter();
const $5f6aa8fade9cc028$var$shallowGet = /*#__PURE__*/ $5f6aa8fade9cc028$var$createGetter(false, true);
const $5f6aa8fade9cc028$var$readonlyGet = /*#__PURE__*/ $5f6aa8fade9cc028$var$createGetter(true);
const $5f6aa8fade9cc028$var$shallowReadonlyGet = /*#__PURE__*/ $5f6aa8fade9cc028$var$createGetter(true, true);
const $5f6aa8fade9cc028$var$arrayInstrumentations = /*#__PURE__*/ $5f6aa8fade9cc028$var$createArrayInstrumentations();
function $5f6aa8fade9cc028$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$5f6aa8fade9cc028$export$6b2a7d5132615086(arr, "get" /* GET */ , i + "");
            // we run the method using the original args first (which may be reactive)
            const res = arr[key](...args);
            if (res === -1 || res === false) // if that didn't work, run it again using raw values.
            return arr[key](...args.map($5f6aa8fade9cc028$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $5f6aa8fade9cc028$export$938a971395fef855();
            const res = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $5f6aa8fade9cc028$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $5f6aa8fade9cc028$var$createGetter(isReadonly = false, shallow = false) {
    return function get(target, key, receiver) {
        if (key === "__v_isReactive" /* IS_REACTIVE */ ) return !isReadonly;
        else if (key === "__v_isReadonly" /* IS_READONLY */ ) return isReadonly;
        else if (key === "__v_isShallow" /* IS_SHALLOW */ ) return shallow;
        else if (key === "__v_raw" /* RAW */  && receiver === (isReadonly ? shallow ? $5f6aa8fade9cc028$var$shallowReadonlyMap : $5f6aa8fade9cc028$var$readonlyMap : shallow ? $5f6aa8fade9cc028$var$shallowReactiveMap : $5f6aa8fade9cc028$var$reactiveMap).get(target)) return target;
        const targetIsArray = (0, $SJKiR.isArray)(target);
        if (!isReadonly && targetIsArray && (0, $SJKiR.hasOwn)($5f6aa8fade9cc028$var$arrayInstrumentations, key)) return Reflect.get($5f6aa8fade9cc028$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ((0, $SJKiR.isSymbol)(key) ? $5f6aa8fade9cc028$var$builtInSymbols.has(key) : $5f6aa8fade9cc028$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $5f6aa8fade9cc028$export$6b2a7d5132615086(target, "get" /* GET */ , key);
        if (shallow) return res;
        if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(res)) // ref unwrapping - skip unwrap for Array + integer key.
        return targetIsArray && (0, $SJKiR.isIntegerKey)(key) ? res : res.value;
        if ((0, $SJKiR.isObject)(res)) // Convert returned value into a proxy as well. we do the isObject check
        // here to avoid invalid value warning. Also need to lazy access readonly
        // and reactive here to avoid circular dependency.
        return isReadonly ? $5f6aa8fade9cc028$export$6ec456bd5b7b3c51(res) : $5f6aa8fade9cc028$export$90a44edba14e47be(res);
        return res;
    };
}
const $5f6aa8fade9cc028$var$set = /*#__PURE__*/ $5f6aa8fade9cc028$var$createSetter();
const $5f6aa8fade9cc028$var$shallowSet = /*#__PURE__*/ $5f6aa8fade9cc028$var$createSetter(true);
function $5f6aa8fade9cc028$var$createSetter(shallow = false) {
    return function set(target, key, value, receiver) {
        let oldValue = target[key];
        if ($5f6aa8fade9cc028$export$92d09b48637741e7(oldValue) && $5f6aa8fade9cc028$export$4f9f5282de18fc69(oldValue) && !$5f6aa8fade9cc028$export$4f9f5282de18fc69(value)) return false;
        if (!shallow && !$5f6aa8fade9cc028$export$92d09b48637741e7(value)) {
            if (!$5f6aa8fade9cc028$export$7f3fe6025abfa26e(value)) {
                value = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(value);
                oldValue = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(oldValue);
            }
            if (!(0, $SJKiR.isArray)(target) && $5f6aa8fade9cc028$export$4f9f5282de18fc69(oldValue) && !$5f6aa8fade9cc028$export$4f9f5282de18fc69(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = (0, $SJKiR.isArray)(target) && (0, $SJKiR.isIntegerKey)(key) ? Number(key) < target.length : (0, $SJKiR.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        // don't trigger if target is something up in the prototype chain of original
        if (target === $5f6aa8fade9cc028$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "add" /* ADD */ , key, value);
            else if ((0, $SJKiR.hasChanged)(value, oldValue)) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "set" /* SET */ , key, value, oldValue);
        }
        return result;
    };
}
function $5f6aa8fade9cc028$var$deleteProperty(target, key) {
    const hadKey = (0, $SJKiR.hasOwn)(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "delete" /* DELETE */ , key, undefined, oldValue);
    return result;
}
function $5f6aa8fade9cc028$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!(0, $SJKiR.isSymbol)(key) || !$5f6aa8fade9cc028$var$builtInSymbols.has(key)) $5f6aa8fade9cc028$export$6b2a7d5132615086(target, "has" /* HAS */ , key);
    return result;
}
function $5f6aa8fade9cc028$var$ownKeys(target) {
    $5f6aa8fade9cc028$export$6b2a7d5132615086(target, "iterate" /* ITERATE */ , (0, $SJKiR.isArray)(target) ? "length" : $5f6aa8fade9cc028$export$3c41b1a4e06acc14);
    return Reflect.ownKeys(target);
}
const $5f6aa8fade9cc028$var$mutableHandlers = {
    get: $5f6aa8fade9cc028$var$get,
    set: $5f6aa8fade9cc028$var$set,
    deleteProperty: $5f6aa8fade9cc028$var$deleteProperty,
    has: $5f6aa8fade9cc028$var$has,
    ownKeys: $5f6aa8fade9cc028$var$ownKeys
};
const $5f6aa8fade9cc028$var$readonlyHandlers = {
    get: $5f6aa8fade9cc028$var$readonlyGet,
    set (target, key) {
        return true;
    },
    deleteProperty (target, key) {
        return true;
    }
};
const $5f6aa8fade9cc028$var$shallowReactiveHandlers = /*#__PURE__*/ (0, $SJKiR.extend)({}, $5f6aa8fade9cc028$var$mutableHandlers, {
    get: $5f6aa8fade9cc028$var$shallowGet,
    set: $5f6aa8fade9cc028$var$shallowSet
});
// Props handlers are special in the sense that it should not unwrap top-level
// refs (in order to allow refs to be explicitly passed down), but should
// retain the reactivity of the normal readonly object.
const $5f6aa8fade9cc028$var$shallowReadonlyHandlers = /*#__PURE__*/ (0, $SJKiR.extend)({}, $5f6aa8fade9cc028$var$readonlyHandlers, {
    get: $5f6aa8fade9cc028$var$shallowReadonlyGet
});
const $5f6aa8fade9cc028$var$toShallow = (value)=>value;
const $5f6aa8fade9cc028$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $5f6aa8fade9cc028$var$get$1(target, key, isReadonly = false, isShallow = false) {
    // #1772: readonly(reactive(Map)) should return readonly + reactive version
    // of the value
    target = target["__v_raw" /* RAW */ ];
    const rawTarget = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(target);
    const rawKey = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "get" /* GET */ , key);
        $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "get" /* GET */ , rawKey);
    }
    const { has: has } = $5f6aa8fade9cc028$var$getProto(rawTarget);
    const wrap = isShallow ? $5f6aa8fade9cc028$var$toShallow : isReadonly ? $5f6aa8fade9cc028$var$toReadonly : $5f6aa8fade9cc028$var$toReactive;
    if (has.call(rawTarget, key)) return wrap(target.get(key));
    else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) // #3602 readonly(reactive(Map))
    // ensure that the nested reactive `Map` can do tracking for itself
    target.get(key);
}
function $5f6aa8fade9cc028$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw" /* RAW */ ];
    const rawTarget = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(target);
    const rawKey = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "has" /* HAS */ , key);
        $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "has" /* HAS */ , rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $5f6aa8fade9cc028$var$size(target, isReadonly = false) {
    target = target["__v_raw" /* RAW */ ];
    !isReadonly && $5f6aa8fade9cc028$export$6b2a7d5132615086($5f6aa8fade9cc028$export$ab18938b9fc5f28e(target), "iterate" /* ITERATE */ , $5f6aa8fade9cc028$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $5f6aa8fade9cc028$var$add(value) {
    value = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(value);
    const target = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
    const proto = $5f6aa8fade9cc028$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "add" /* ADD */ , value, value);
    }
    return this;
}
function $5f6aa8fade9cc028$var$set$1(key, value) {
    value = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(value);
    const target = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
    const { has: has, get: get } = $5f6aa8fade9cc028$var$getProto(target);
    let hadKey = has.call(target, key);
    if (!hadKey) {
        key = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
        hadKey = has.call(target, key);
    }
    const oldValue = get.call(target, key);
    target.set(key, value);
    if (!hadKey) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "add" /* ADD */ , key, value);
    else if ((0, $SJKiR.hasChanged)(value, oldValue)) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "set" /* SET */ , key, value, oldValue);
    return this;
}
function $5f6aa8fade9cc028$var$deleteEntry(key) {
    const target = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
    const { has: has, get: get } = $5f6aa8fade9cc028$var$getProto(target);
    let hadKey = has.call(target, key);
    if (!hadKey) {
        key = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
        hadKey = has.call(target, key);
    }
    const oldValue = get ? get.call(target, key) : undefined;
    // forward the operation before queueing reactions
    const result = target.delete(key);
    if (hadKey) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "delete" /* DELETE */ , key, undefined, oldValue);
    return result;
}
function $5f6aa8fade9cc028$var$clear() {
    const target = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = undefined;
    // forward the operation before queueing reactions
    const result = target.clear();
    if (hadItems) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "clear" /* CLEAR */ , undefined, undefined, oldTarget);
    return result;
}
function $5f6aa8fade9cc028$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw" /* RAW */ ];
        const rawTarget = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $5f6aa8fade9cc028$var$toShallow : isReadonly ? $5f6aa8fade9cc028$var$toReadonly : $5f6aa8fade9cc028$var$toReactive;
        !isReadonly && $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "iterate" /* ITERATE */ , $5f6aa8fade9cc028$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            // important: make sure the callback is
            // 1. invoked with the reactive map as `this` and 3rd arg
            // 2. the value received should be a corresponding reactive/readonly.
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $5f6aa8fade9cc028$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw" /* RAW */ ];
        const rawTarget = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $SJKiR.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $5f6aa8fade9cc028$var$toShallow : isReadonly ? $5f6aa8fade9cc028$var$toReadonly : $5f6aa8fade9cc028$var$toReactive;
        !isReadonly && $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "iterate" /* ITERATE */ , isKeyOnly ? $5f6aa8fade9cc028$var$MAP_KEY_ITERATE_KEY : $5f6aa8fade9cc028$export$3c41b1a4e06acc14);
        // return a wrapped iterator which returns observed versions of the
        // values emitted from the real iterator
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $5f6aa8fade9cc028$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" /* DELETE */  ? false : this;
    };
}
function $5f6aa8fade9cc028$var$createInstrumentations() {
    const mutableInstrumentations = {
        get (key) {
            return $5f6aa8fade9cc028$var$get$1(this, key);
        },
        get size () {
            return $5f6aa8fade9cc028$var$size(this);
        },
        has: $5f6aa8fade9cc028$var$has$1,
        add: $5f6aa8fade9cc028$var$add,
        set: $5f6aa8fade9cc028$var$set$1,
        delete: $5f6aa8fade9cc028$var$deleteEntry,
        clear: $5f6aa8fade9cc028$var$clear,
        forEach: $5f6aa8fade9cc028$var$createForEach(false, false)
    };
    const shallowInstrumentations = {
        get (key) {
            return $5f6aa8fade9cc028$var$get$1(this, key, false, true);
        },
        get size () {
            return $5f6aa8fade9cc028$var$size(this);
        },
        has: $5f6aa8fade9cc028$var$has$1,
        add: $5f6aa8fade9cc028$var$add,
        set: $5f6aa8fade9cc028$var$set$1,
        delete: $5f6aa8fade9cc028$var$deleteEntry,
        clear: $5f6aa8fade9cc028$var$clear,
        forEach: $5f6aa8fade9cc028$var$createForEach(false, true)
    };
    const readonlyInstrumentations = {
        get (key) {
            return $5f6aa8fade9cc028$var$get$1(this, key, true);
        },
        get size () {
            return $5f6aa8fade9cc028$var$size(this, true);
        },
        has (key) {
            return $5f6aa8fade9cc028$var$has$1.call(this, key, true);
        },
        add: $5f6aa8fade9cc028$var$createReadonlyMethod("add" /* ADD */ ),
        set: $5f6aa8fade9cc028$var$createReadonlyMethod("set" /* SET */ ),
        delete: $5f6aa8fade9cc028$var$createReadonlyMethod("delete" /* DELETE */ ),
        clear: $5f6aa8fade9cc028$var$createReadonlyMethod("clear" /* CLEAR */ ),
        forEach: $5f6aa8fade9cc028$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations = {
        get (key) {
            return $5f6aa8fade9cc028$var$get$1(this, key, true, true);
        },
        get size () {
            return $5f6aa8fade9cc028$var$size(this, true);
        },
        has (key) {
            return $5f6aa8fade9cc028$var$has$1.call(this, key, true);
        },
        add: $5f6aa8fade9cc028$var$createReadonlyMethod("add" /* ADD */ ),
        set: $5f6aa8fade9cc028$var$createReadonlyMethod("set" /* SET */ ),
        delete: $5f6aa8fade9cc028$var$createReadonlyMethod("delete" /* DELETE */ ),
        clear: $5f6aa8fade9cc028$var$createReadonlyMethod("clear" /* CLEAR */ ),
        forEach: $5f6aa8fade9cc028$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations[method] = $5f6aa8fade9cc028$var$createIterableMethod(method, false, false);
        readonlyInstrumentations[method] = $5f6aa8fade9cc028$var$createIterableMethod(method, true, false);
        shallowInstrumentations[method] = $5f6aa8fade9cc028$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations[method] = $5f6aa8fade9cc028$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations,
        readonlyInstrumentations,
        shallowInstrumentations,
        shallowReadonlyInstrumentations
    ];
}
const [$5f6aa8fade9cc028$var$mutableInstrumentations, $5f6aa8fade9cc028$var$readonlyInstrumentations, $5f6aa8fade9cc028$var$shallowInstrumentations, $5f6aa8fade9cc028$var$shallowReadonlyInstrumentations] = /* #__PURE__*/ $5f6aa8fade9cc028$var$createInstrumentations();
function $5f6aa8fade9cc028$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $5f6aa8fade9cc028$var$shallowReadonlyInstrumentations : $5f6aa8fade9cc028$var$shallowInstrumentations : isReadonly ? $5f6aa8fade9cc028$var$readonlyInstrumentations : $5f6aa8fade9cc028$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive" /* IS_REACTIVE */ ) return !isReadonly;
        else if (key === "__v_isReadonly" /* IS_READONLY */ ) return isReadonly;
        else if (key === "__v_raw" /* RAW */ ) return target;
        return Reflect.get((0, $SJKiR.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $5f6aa8fade9cc028$var$mutableCollectionHandlers = {
    get: /*#__PURE__*/ $5f6aa8fade9cc028$var$createInstrumentationGetter(false, false)
};
const $5f6aa8fade9cc028$var$shallowCollectionHandlers = {
    get: /*#__PURE__*/ $5f6aa8fade9cc028$var$createInstrumentationGetter(false, true)
};
const $5f6aa8fade9cc028$var$readonlyCollectionHandlers = {
    get: /*#__PURE__*/ $5f6aa8fade9cc028$var$createInstrumentationGetter(true, false)
};
const $5f6aa8fade9cc028$var$shallowReadonlyCollectionHandlers = {
    get: /*#__PURE__*/ $5f6aa8fade9cc028$var$createInstrumentationGetter(true, true)
};
function $5f6aa8fade9cc028$var$checkIdentityKeys(target, has, key) {
    const rawKey = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $SJKiR.toRawType)(target);
        console.warn(`Reactive ${type} contains both the raw and reactive ` + `versions of the same object${type === `Map` ? ` as keys` : ``}, ` + `which can lead to inconsistencies. ` + `Avoid differentiating between the raw and reactive versions ` + `of an object and only use the reactive version if possible.`);
    }
}
const $5f6aa8fade9cc028$var$reactiveMap = new WeakMap();
const $5f6aa8fade9cc028$var$shallowReactiveMap = new WeakMap();
const $5f6aa8fade9cc028$var$readonlyMap = new WeakMap();
const $5f6aa8fade9cc028$var$shallowReadonlyMap = new WeakMap();
function $5f6aa8fade9cc028$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $5f6aa8fade9cc028$var$getTargetType(value) {
    return value["__v_skip" /* SKIP */ ] || !Object.isExtensible(value) ? 0 /* INVALID */  : $5f6aa8fade9cc028$var$targetTypeMap((0, $SJKiR.toRawType)(value));
}
function $5f6aa8fade9cc028$export$90a44edba14e47be(target) {
    // if trying to observe a readonly proxy, return the readonly version.
    if ($5f6aa8fade9cc028$export$92d09b48637741e7(target)) return target;
    return $5f6aa8fade9cc028$var$createReactiveObject(target, false, $5f6aa8fade9cc028$var$mutableHandlers, $5f6aa8fade9cc028$var$mutableCollectionHandlers, $5f6aa8fade9cc028$var$reactiveMap);
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */ function $5f6aa8fade9cc028$export$8d81cefd22d22260(target) {
    return $5f6aa8fade9cc028$var$createReactiveObject(target, false, $5f6aa8fade9cc028$var$shallowReactiveHandlers, $5f6aa8fade9cc028$var$shallowCollectionHandlers, $5f6aa8fade9cc028$var$shallowReactiveMap);
}
/**
 * Creates a readonly copy of the original object. Note the returned copy is not
 * made reactive, but `readonly` can be called on an already reactive object.
 */ function $5f6aa8fade9cc028$export$6ec456bd5b7b3c51(target) {
    return $5f6aa8fade9cc028$var$createReactiveObject(target, true, $5f6aa8fade9cc028$var$readonlyHandlers, $5f6aa8fade9cc028$var$readonlyCollectionHandlers, $5f6aa8fade9cc028$var$readonlyMap);
}
/**
 * Returns a reactive-copy of the original object, where only the root level
 * properties are readonly, and does NOT unwrap refs nor recursively convert
 * returned properties.
 * This is used for creating the props proxy object for stateful components.
 */ function $5f6aa8fade9cc028$export$7c4b5f2b50f09f6b(target) {
    return $5f6aa8fade9cc028$var$createReactiveObject(target, true, $5f6aa8fade9cc028$var$shallowReadonlyHandlers, $5f6aa8fade9cc028$var$shallowReadonlyCollectionHandlers, $5f6aa8fade9cc028$var$shallowReadonlyMap);
}
function $5f6aa8fade9cc028$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $SJKiR.isObject)(target)) return target;
    // target is already a Proxy, return it.
    // exception: calling readonly() on a reactive object
    if (target["__v_raw" /* RAW */ ] && !(isReadonly && target["__v_isReactive" /* IS_REACTIVE */ ])) return target;
    // target already has corresponding Proxy
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    // only specific value types can be observed.
    const targetType = $5f6aa8fade9cc028$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $5f6aa8fade9cc028$export$352205f445242f02(value) {
    if ($5f6aa8fade9cc028$export$92d09b48637741e7(value)) return $5f6aa8fade9cc028$export$352205f445242f02(value["__v_raw" /* RAW */ ]);
    return !!(value && value["__v_isReactive" /* IS_REACTIVE */ ]);
}
function $5f6aa8fade9cc028$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly" /* IS_READONLY */ ]);
}
function $5f6aa8fade9cc028$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow" /* IS_SHALLOW */ ]);
}
function $5f6aa8fade9cc028$export$5f3ca29d057519b3(value) {
    return $5f6aa8fade9cc028$export$352205f445242f02(value) || $5f6aa8fade9cc028$export$92d09b48637741e7(value);
}
function $5f6aa8fade9cc028$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw" /* RAW */ ];
    return raw ? $5f6aa8fade9cc028$export$ab18938b9fc5f28e(raw) : observed;
}
function $5f6aa8fade9cc028$export$995ab8b13ad7a9d0(value) {
    (0, $SJKiR.def)(value, "__v_skip" /* SKIP */ , true);
    return value;
}
const $5f6aa8fade9cc028$var$toReactive = (value)=>(0, $SJKiR.isObject)(value) ? $5f6aa8fade9cc028$export$90a44edba14e47be(value) : value;
const $5f6aa8fade9cc028$var$toReadonly = (value)=>(0, $SJKiR.isObject)(value) ? $5f6aa8fade9cc028$export$6ec456bd5b7b3c51(value) : value;
function $5f6aa8fade9cc028$var$trackRefValue(ref) {
    if ($5f6aa8fade9cc028$var$shouldTrack && $5f6aa8fade9cc028$var$activeEffect) {
        ref = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(ref);
        $5f6aa8fade9cc028$var$trackEffects(ref.dep || (ref.dep = $5f6aa8fade9cc028$var$createDep()));
    }
}
function $5f6aa8fade9cc028$var$triggerRefValue(ref, newVal) {
    ref = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(ref);
    if (ref.dep) $5f6aa8fade9cc028$var$triggerEffects(ref.dep);
}
function $5f6aa8fade9cc028$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $5f6aa8fade9cc028$export$eff4d24c3ff7876e(value) {
    return $5f6aa8fade9cc028$var$createRef(value, false);
}
function $5f6aa8fade9cc028$export$9b7bc5fe3b17c8b3(value) {
    return $5f6aa8fade9cc028$var$createRef(value, true);
}
function $5f6aa8fade9cc028$var$createRef(rawValue, shallow) {
    if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $5f6aa8fade9cc028$var$RefImpl(rawValue, shallow);
}
class $5f6aa8fade9cc028$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = undefined;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $5f6aa8fade9cc028$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $5f6aa8fade9cc028$var$toReactive(value);
    }
    get value() {
        $5f6aa8fade9cc028$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        newVal = this.__v_isShallow ? newVal : $5f6aa8fade9cc028$export$ab18938b9fc5f28e(newVal);
        if ((0, $SJKiR.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = this.__v_isShallow ? newVal : $5f6aa8fade9cc028$var$toReactive(newVal);
            $5f6aa8fade9cc028$var$triggerRefValue(this, newVal);
        }
    }
}
function $5f6aa8fade9cc028$export$f402f86588575ccc(ref) {
    $5f6aa8fade9cc028$var$triggerRefValue(ref, void 0);
}
function $5f6aa8fade9cc028$export$a239a76781616204(ref) {
    return $5f6aa8fade9cc028$export$4f9f5282de18fc69(ref) ? ref.value : ref;
}
const $5f6aa8fade9cc028$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$5f6aa8fade9cc028$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(oldValue) && !$5f6aa8fade9cc028$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $5f6aa8fade9cc028$export$f353fd1b97db3fa0(objectWithRefs) {
    return $5f6aa8fade9cc028$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $5f6aa8fade9cc028$var$shallowUnwrapHandlers);
}
class $5f6aa8fade9cc028$var$CustomRefImpl {
    constructor(factory){
        this.dep = undefined;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$5f6aa8fade9cc028$var$trackRefValue(this), ()=>$5f6aa8fade9cc028$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $5f6aa8fade9cc028$export$a20c2dd6199824cb(factory) {
    return new $5f6aa8fade9cc028$var$CustomRefImpl(factory);
}
function $5f6aa8fade9cc028$export$2e9533675e5e70e0(object) {
    const ret = (0, $SJKiR.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $5f6aa8fade9cc028$export$1f60508e4f47b4b7(object, key);
    return ret;
}
class $5f6aa8fade9cc028$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === undefined ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
}
function $5f6aa8fade9cc028$export$1f60508e4f47b4b7(object, key, defaultValue) {
    const val = object[key];
    return $5f6aa8fade9cc028$export$4f9f5282de18fc69(val) ? val : new $5f6aa8fade9cc028$var$ObjectRefImpl(object, key, defaultValue);
}
class $5f6aa8fade9cc028$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this._setter = _setter;
        this.dep = undefined;
        this.__v_isRef = true;
        this._dirty = true;
        this.effect = new $5f6aa8fade9cc028$export$28352bb4dd362521(getter, ()=>{
            if (!this._dirty) {
                this._dirty = true;
                $5f6aa8fade9cc028$var$triggerRefValue(this);
            }
        });
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly" /* IS_READONLY */ ] = isReadonly;
    }
    get value() {
        // the computed ref may get wrapped by other proxies e.g. readonly() #3376
        const self = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
        $5f6aa8fade9cc028$var$trackRefValue(self);
        if (self._dirty || !self._cacheable) {
            self._dirty = false;
            self._value = self.effect.run();
        }
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
}
function $5f6aa8fade9cc028$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $SJKiR.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $SJKiR.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $5f6aa8fade9cc028$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
var $5f6aa8fade9cc028$var$_a;
const $5f6aa8fade9cc028$var$tick = /*#__PURE__*/ Promise.resolve();
const $5f6aa8fade9cc028$var$queue = [];
let $5f6aa8fade9cc028$var$queued = false;
const $5f6aa8fade9cc028$var$scheduler = (fn)=>{
    $5f6aa8fade9cc028$var$queue.push(fn);
    if (!$5f6aa8fade9cc028$var$queued) {
        $5f6aa8fade9cc028$var$queued = true;
        $5f6aa8fade9cc028$var$tick.then($5f6aa8fade9cc028$var$flush);
    }
};
const $5f6aa8fade9cc028$var$flush = ()=>{
    for(let i = 0; i < $5f6aa8fade9cc028$var$queue.length; i++)$5f6aa8fade9cc028$var$queue[i]();
    $5f6aa8fade9cc028$var$queue.length = 0;
    $5f6aa8fade9cc028$var$queued = false;
};
class $5f6aa8fade9cc028$var$DeferredComputedRefImpl {
    constructor(getter){
        this.dep = undefined;
        this._dirty = true;
        this.__v_isRef = true;
        this[$5f6aa8fade9cc028$var$_a] = true;
        let compareTarget;
        let hasCompareTarget = false;
        let scheduled = false;
        this.effect = new $5f6aa8fade9cc028$export$28352bb4dd362521(getter, (computedTrigger)=>{
            if (this.dep) {
                if (computedTrigger) {
                    compareTarget = this._value;
                    hasCompareTarget = true;
                } else if (!scheduled) {
                    const valueToCompare = hasCompareTarget ? compareTarget : this._value;
                    scheduled = true;
                    hasCompareTarget = false;
                    $5f6aa8fade9cc028$var$scheduler(()=>{
                        if (this.effect.active && this._get() !== valueToCompare) $5f6aa8fade9cc028$var$triggerRefValue(this);
                        scheduled = false;
                    });
                }
                // chained upstream computeds are notified synchronously to ensure
                // value invalidation in case of sync access; normal effects are
                // deferred to be triggered in scheduler.
                for (const e of this.dep)if (e.computed instanceof $5f6aa8fade9cc028$var$DeferredComputedRefImpl) e.scheduler(true);
            }
            this._dirty = true;
        });
        this.effect.computed = this;
    }
    _get() {
        if (this._dirty) {
            this._dirty = false;
            return this._value = this.effect.run();
        }
        return this._value;
    }
    get value() {
        $5f6aa8fade9cc028$var$trackRefValue(this);
        // the computed ref may get wrapped by other proxies e.g. readonly() #3376
        return $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this)._get();
    }
}
$5f6aa8fade9cc028$var$_a = "__v_isReadonly" /* IS_READONLY */ ;
function $5f6aa8fade9cc028$export$483264c4ec4c46ce(getter) {
    return new $5f6aa8fade9cc028$var$DeferredComputedRefImpl(getter);
}

});
parcelRegister("SJKiR", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $0a48876dc15dc362$export$b41394a5437791c8);
$parcel$export(module.exports, "isArray", () => $0a48876dc15dc362$export$43bee75e5e14138e);
$parcel$export(module.exports, "isObject", () => $0a48876dc15dc362$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isSymbol", () => $0a48876dc15dc362$export$a244864fd9645c7f);
$parcel$export(module.exports, "isFunction", () => $0a48876dc15dc362$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isMap", () => $0a48876dc15dc362$export$5c90113a285f2241);
$parcel$export(module.exports, "NOOP", () => $0a48876dc15dc362$export$5702a91a6f42969f);
$parcel$export(module.exports, "extend", () => $0a48876dc15dc362$export$8b58be045bf06082);
$parcel$export(module.exports, "hasOwn", () => $0a48876dc15dc362$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "toRawType", () => $0a48876dc15dc362$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isIntegerKey", () => $0a48876dc15dc362$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "hasChanged", () => $0a48876dc15dc362$export$f619eb8b89076d23);
$parcel$export(module.exports, "def", () => $0a48876dc15dc362$export$8afb76124cf08683);
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 * IMPORTANT: all calls of this function must be prefixed with
 * \/\*#\_\_PURE\_\_\*\/
 * So that rollup can tree-shake them if necessary.
 */ function $0a48876dc15dc362$export$b41394a5437791c8(str, expectsLowerCase) {
    const map = Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
/**
 * dev only flag -> name mapping
 */ const $0a48876dc15dc362$export$def7dc2c2e95a08a = {
    [1 /* TEXT */ ]: `TEXT`,
    [2 /* CLASS */ ]: `CLASS`,
    [4 /* STYLE */ ]: `STYLE`,
    [8 /* PROPS */ ]: `PROPS`,
    [16 /* FULL_PROPS */ ]: `FULL_PROPS`,
    [32 /* HYDRATE_EVENTS */ ]: `HYDRATE_EVENTS`,
    [64 /* STABLE_FRAGMENT */ ]: `STABLE_FRAGMENT`,
    [128 /* KEYED_FRAGMENT */ ]: `KEYED_FRAGMENT`,
    [256 /* UNKEYED_FRAGMENT */ ]: `UNKEYED_FRAGMENT`,
    [512 /* NEED_PATCH */ ]: `NEED_PATCH`,
    [1024 /* DYNAMIC_SLOTS */ ]: `DYNAMIC_SLOTS`,
    [2048 /* DEV_ROOT_FRAGMENT */ ]: `DEV_ROOT_FRAGMENT`,
    [-1 /* HOISTED */ ]: `HOISTED`,
    [-2 /* BAIL */ ]: `BAIL`
};
/**
 * Dev only
 */ const $0a48876dc15dc362$export$624972196ed3745f = {
    [1 /* STABLE */ ]: "STABLE",
    [2 /* DYNAMIC */ ]: "DYNAMIC",
    [3 /* FORWARDED */ ]: "FORWARDED"
};
const $0a48876dc15dc362$var$GLOBALS_WHITE_LISTED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt";
const $0a48876dc15dc362$export$d6571a1911e4f27e = /*#__PURE__*/ $0a48876dc15dc362$export$b41394a5437791c8($0a48876dc15dc362$var$GLOBALS_WHITE_LISTED);
const $0a48876dc15dc362$var$range = 2;
function $0a48876dc15dc362$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    // Split the content into individual lines but capture the newline sequence
    // that separated each line. This is important because the actual sequence is
    // needed to properly take into account the full line length for offset
    // comparison
    let lines = source.split(/(\r?\n)/);
    // Separate the lines and newline sequences into separate arrays for easier referencing
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $0a48876dc15dc362$var$range; j <= i + $0a48876dc15dc362$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    // push underline
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
/**
 * On the client we only need to offer special cases for boolean attributes that
 * have different names from their corresponding dom properties:
 * - itemscope -> N/A
 * - allowfullscreen -> allowFullscreen
 * - formnovalidate -> formNoValidate
 * - ismap -> isMap
 * - nomodule -> noModule
 * - novalidate -> noValidate
 * - readonly -> readOnly
 */ const $0a48876dc15dc362$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $0a48876dc15dc362$export$d186f5eb2e810715 = /*#__PURE__*/ $0a48876dc15dc362$export$b41394a5437791c8($0a48876dc15dc362$var$specialBooleanAttrs);
/**
 * The full list is needed during SSR to produce the correct initial markup.
 */ const $0a48876dc15dc362$export$f763ba3b84e9cd8c = /*#__PURE__*/ $0a48876dc15dc362$export$b41394a5437791c8($0a48876dc15dc362$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,` + `loop,open,required,reversed,scoped,seamless,` + `checked,muted,multiple,selected`);
/**
 * Boolean attributes should be included if the value is truthy or ''.
 * e.g. `<select multiple>` compiles to `{ multiple: '' }`
 */ function $0a48876dc15dc362$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $0a48876dc15dc362$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $0a48876dc15dc362$var$attrValidationCache = {};
function $0a48876dc15dc362$export$d55ef77660f30d12(name) {
    if ($0a48876dc15dc362$var$attrValidationCache.hasOwnProperty(name)) return $0a48876dc15dc362$var$attrValidationCache[name];
    const isUnsafe = $0a48876dc15dc362$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $0a48876dc15dc362$var$attrValidationCache[name] = !isUnsafe;
}
const $0a48876dc15dc362$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
/**
 * CSS properties that accept plain numbers
 */ const $0a48876dc15dc362$export$84da53524c6b1314 = /*#__PURE__*/ $0a48876dc15dc362$export$b41394a5437791c8(`animation-iteration-count,border-image-outset,border-image-slice,` + `border-image-width,box-flex,box-flex-group,box-ordinal-group,column-count,` + `columns,flex,flex-grow,flex-positive,flex-shrink,flex-negative,flex-order,` + `grid-row,grid-row-end,grid-row-span,grid-row-start,grid-column,` + `grid-column-end,grid-column-span,grid-column-start,font-weight,line-clamp,` + `line-height,opacity,order,orphans,tab-size,widows,z-index,zoom,` + // SVG
`fill-opacity,flood-opacity,stop-opacity,stroke-dasharray,stroke-dashoffset,` + `stroke-miterlimit,stroke-opacity,stroke-width`);
/**
 * Known attributes, this is used for stringification of runtime static nodes
 * so that we don't stringify bindings that cannot be set from HTML.
 * Don't also forget to allow `data-*` and `aria-*`!
 * Generated from https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes
 */ const $0a48876dc15dc362$export$f7e7a1cc7da8d5e9 = /*#__PURE__*/ $0a48876dc15dc362$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,` + `autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,` + `border,buffered,capture,challenge,charset,checked,cite,class,code,` + `codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,` + `coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,` + `disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,` + `formaction,formenctype,formmethod,formnovalidate,formtarget,headers,` + `height,hidden,high,href,hreflang,http-equiv,icon,id,importance,integrity,` + `ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,` + `manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,` + `open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,` + `referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,` + `selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,` + `start,step,style,summary,tabindex,target,title,translate,type,usemap,` + `value,width,wrap`);
/**
 * Generated from https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute
 */ const $0a48876dc15dc362$export$80da416f43933831 = /*#__PURE__*/ $0a48876dc15dc362$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,` + `arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,` + `baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,` + `clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,` + `color-interpolation-filters,color-profile,color-rendering,` + `contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,` + `descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,` + `dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,` + `fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,` + `font-family,font-size,font-size-adjust,font-stretch,font-style,` + `font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,` + `glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,` + `gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,` + `horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,` + `k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,` + `lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,` + `marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,` + `mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,` + `name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,` + `overflow,overline-position,overline-thickness,panose-1,paint-order,path,` + `pathLength,patternContentUnits,patternTransform,patternUnits,ping,` + `pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,` + `preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,` + `rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,` + `restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,` + `specularConstant,specularExponent,speed,spreadMethod,startOffset,` + `stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,` + `strikethrough-position,strikethrough-thickness,string,stroke,` + `stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,` + `stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,` + `systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,` + `text-decoration,text-rendering,textLength,to,transform,transform-origin,` + `type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,` + `unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,` + `v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,` + `vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,` + `writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,` + `xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,` + `xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $0a48876dc15dc362$export$8756898546458274(value) {
    if ($0a48876dc15dc362$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $0a48876dc15dc362$export$844ec244b1367d54(item) ? $0a48876dc15dc362$export$76a205ce979d066a(item) : $0a48876dc15dc362$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($0a48876dc15dc362$export$844ec244b1367d54(value)) return value;
    else if ($0a48876dc15dc362$export$a6cdc56e425d0d0a(value)) return value;
}
const $0a48876dc15dc362$var$listDelimiterRE = /;(?![^(]*\))/g;
const $0a48876dc15dc362$var$propertyDelimiterRE = /:(.+)/;
function $0a48876dc15dc362$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.split($0a48876dc15dc362$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($0a48876dc15dc362$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $0a48876dc15dc362$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $0a48876dc15dc362$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $0a48876dc15dc362$export$6e6a0a3676c4b8bb(key);
        if ($0a48876dc15dc362$export$844ec244b1367d54(value) || typeof value === "number" && $0a48876dc15dc362$export$84da53524c6b1314(normalizedKey)) // only render valid values
        ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $0a48876dc15dc362$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($0a48876dc15dc362$export$844ec244b1367d54(value)) res = value;
    else if ($0a48876dc15dc362$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $0a48876dc15dc362$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($0a48876dc15dc362$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $0a48876dc15dc362$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$0a48876dc15dc362$export$844ec244b1367d54(klass)) props.class = $0a48876dc15dc362$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $0a48876dc15dc362$export$8756898546458274(style);
    return props;
}
// These tag configs are shared between compiler-dom and runtime-dom, so they
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element
const $0a48876dc15dc362$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element
const $0a48876dc15dc362$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistanceLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $0a48876dc15dc362$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $0a48876dc15dc362$export$1ccf854a0984f890 = /*#__PURE__*/ $0a48876dc15dc362$export$b41394a5437791c8($0a48876dc15dc362$var$HTML_TAGS);
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $0a48876dc15dc362$export$6328ce7565ea1049 = /*#__PURE__*/ $0a48876dc15dc362$export$b41394a5437791c8($0a48876dc15dc362$var$SVG_TAGS);
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $0a48876dc15dc362$export$e5f2d3d97d9367a4 = /*#__PURE__*/ $0a48876dc15dc362$export$b41394a5437791c8($0a48876dc15dc362$var$VOID_TAGS);
const $0a48876dc15dc362$var$escapeRE = /["'&<>]/;
function $0a48876dc15dc362$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $0a48876dc15dc362$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
// https://www.w3.org/TR/html52/syntax.html#comments
const $0a48876dc15dc362$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $0a48876dc15dc362$export$7b105034a53bde5f(src) {
    return src.replace($0a48876dc15dc362$var$commentStripRE, "");
}
function $0a48876dc15dc362$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $0a48876dc15dc362$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $0a48876dc15dc362$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $0a48876dc15dc362$export$871608497c498473(a);
    let bValidType = $0a48876dc15dc362$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $0a48876dc15dc362$export$a244864fd9645c7f(a);
    bValidType = $0a48876dc15dc362$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $0a48876dc15dc362$export$43bee75e5e14138e(a);
    bValidType = $0a48876dc15dc362$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $0a48876dc15dc362$var$looseCompareArrays(a, b) : false;
    aValidType = $0a48876dc15dc362$export$a6cdc56e425d0d0a(a);
    bValidType = $0a48876dc15dc362$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        /* istanbul ignore if: this if will probably never be called */ if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$0a48876dc15dc362$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $0a48876dc15dc362$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$0a48876dc15dc362$export$ae8015769846262c(item, val));
}
/**
 * For converting {{ interpolation }} values to displayed strings.
 * @private
 */ const $0a48876dc15dc362$export$b5b1545233b45293 = (val)=>{
    return $0a48876dc15dc362$export$844ec244b1367d54(val) ? val : val == null ? "" : $0a48876dc15dc362$export$43bee75e5e14138e(val) || $0a48876dc15dc362$export$a6cdc56e425d0d0a(val) && (val.toString === $0a48876dc15dc362$export$830c053460e5ddf6 || !$0a48876dc15dc362$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $0a48876dc15dc362$var$replacer, 2) : String(val);
};
const $0a48876dc15dc362$var$replacer = (_key, val)=>{
    // can't use isRef here since @vue/shared has no deps
    if (val && val.__v_isRef) return $0a48876dc15dc362$var$replacer(_key, val.value);
    else if ($0a48876dc15dc362$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val])=>{
            entries[`${key} =>`] = val;
            return entries;
        }, {})
    };
    else if ($0a48876dc15dc362$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ]
    };
    else if ($0a48876dc15dc362$export$a6cdc56e425d0d0a(val) && !$0a48876dc15dc362$export$43bee75e5e14138e(val) && !$0a48876dc15dc362$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $0a48876dc15dc362$export$cf583d23ab39677c = {};
const $0a48876dc15dc362$export$6bd8558f433f1cc1 = [];
const $0a48876dc15dc362$export$5702a91a6f42969f = ()=>{};
/**
 * Always return false.
 */ const $0a48876dc15dc362$export$c01351c0af048e39 = ()=>false;
const $0a48876dc15dc362$var$onRE = /^on[^a-z]/;
const $0a48876dc15dc362$export$1a2d97de39ecbb75 = (key)=>$0a48876dc15dc362$var$onRE.test(key);
const $0a48876dc15dc362$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $0a48876dc15dc362$export$8b58be045bf06082 = Object.assign;
const $0a48876dc15dc362$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $0a48876dc15dc362$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $0a48876dc15dc362$export$b5a638e9b3fff9f3 = (val, key)=>$0a48876dc15dc362$var$hasOwnProperty.call(val, key);
const $0a48876dc15dc362$export$43bee75e5e14138e = Array.isArray;
const $0a48876dc15dc362$export$5c90113a285f2241 = (val)=>$0a48876dc15dc362$export$1dccc787cc36538b(val) === "[object Map]";
const $0a48876dc15dc362$export$6750766a7c7ec627 = (val)=>$0a48876dc15dc362$export$1dccc787cc36538b(val) === "[object Set]";
const $0a48876dc15dc362$export$871608497c498473 = (val)=>$0a48876dc15dc362$export$1dccc787cc36538b(val) === "[object Date]";
const $0a48876dc15dc362$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $0a48876dc15dc362$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $0a48876dc15dc362$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $0a48876dc15dc362$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $0a48876dc15dc362$export$4369c812aac99591 = (val)=>{
    return $0a48876dc15dc362$export$a6cdc56e425d0d0a(val) && $0a48876dc15dc362$export$f6e2535fb5126e54(val.then) && $0a48876dc15dc362$export$f6e2535fb5126e54(val.catch);
};
const $0a48876dc15dc362$export$830c053460e5ddf6 = Object.prototype.toString;
const $0a48876dc15dc362$export$1dccc787cc36538b = (value)=>$0a48876dc15dc362$export$830c053460e5ddf6.call(value);
const $0a48876dc15dc362$export$5ad0a3c360b8fbb5 = (value)=>{
    // extract "RawType" from strings like "[object RawType]"
    return $0a48876dc15dc362$export$1dccc787cc36538b(value).slice(8, -1);
};
const $0a48876dc15dc362$export$53b83ca8eaab0383 = (val)=>$0a48876dc15dc362$export$1dccc787cc36538b(val) === "[object Object]";
const $0a48876dc15dc362$export$e2a2b93446ec9fe = (key)=>$0a48876dc15dc362$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $0a48876dc15dc362$export$bf7d3c0236f0aa85 = /*#__PURE__*/ $0a48876dc15dc362$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $0a48876dc15dc362$export$a9c1fdb3030c2a6b = /*#__PURE__*/ $0a48876dc15dc362$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $0a48876dc15dc362$var$cacheStringFunction = (fn)=>{
    const cache = Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $0a48876dc15dc362$var$camelizeRE = /-(\w)/g;
/**
 * @private
 */ const $0a48876dc15dc362$export$161d051f5dd25de7 = $0a48876dc15dc362$var$cacheStringFunction((str)=>{
    return str.replace($0a48876dc15dc362$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $0a48876dc15dc362$var$hyphenateRE = /\B([A-Z])/g;
/**
 * @private
 */ const $0a48876dc15dc362$export$6e6a0a3676c4b8bb = $0a48876dc15dc362$var$cacheStringFunction((str)=>str.replace($0a48876dc15dc362$var$hyphenateRE, "-$1").toLowerCase());
/**
 * @private
 */ const $0a48876dc15dc362$export$9a00dee1beb8f576 = $0a48876dc15dc362$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
/**
 * @private
 */ const $0a48876dc15dc362$export$8c022799eeaaefcd = $0a48876dc15dc362$var$cacheStringFunction((str)=>str ? `on${$0a48876dc15dc362$export$9a00dee1beb8f576(str)}` : ``);
// compare whether a value has changed, accounting for NaN.
const $0a48876dc15dc362$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $0a48876dc15dc362$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $0a48876dc15dc362$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $0a48876dc15dc362$export$a0a81dc3380ce7d3 = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
let $0a48876dc15dc362$var$_globalThis;
const $0a48876dc15dc362$export$ff5f2eeb11fc7e14 = ()=>{
    return $0a48876dc15dc362$var$_globalThis || ($0a48876dc15dc362$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $0a48876dc15dc362$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $0a48876dc15dc362$export$53d5e12f9a1d3cde(name) {
    return $0a48876dc15dc362$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}

});


parcelRegister("3LSrV", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $2befff6b9db23ea3$export$b41394a5437791c8);
$parcel$export(module.exports, "isGloballyWhitelisted", () => $2befff6b9db23ea3$export$d6571a1911e4f27e);
$parcel$export(module.exports, "normalizeStyle", () => $2befff6b9db23ea3$export$8756898546458274);
$parcel$export(module.exports, "isArray", () => $2befff6b9db23ea3$export$43bee75e5e14138e);
$parcel$export(module.exports, "isString", () => $2befff6b9db23ea3$export$844ec244b1367d54);
$parcel$export(module.exports, "isObject", () => $2befff6b9db23ea3$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "hyphenate", () => $2befff6b9db23ea3$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "normalizeClass", () => $2befff6b9db23ea3$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "toDisplayString", () => $2befff6b9db23ea3$export$b5b1545233b45293);
$parcel$export(module.exports, "isFunction", () => $2befff6b9db23ea3$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isMap", () => $2befff6b9db23ea3$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $2befff6b9db23ea3$export$6750766a7c7ec627);
$parcel$export(module.exports, "isPlainObject", () => $2befff6b9db23ea3$export$53b83ca8eaab0383);
$parcel$export(module.exports, "EMPTY_OBJ", () => $2befff6b9db23ea3$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $2befff6b9db23ea3$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $2befff6b9db23ea3$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $2befff6b9db23ea3$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $2befff6b9db23ea3$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $2befff6b9db23ea3$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $2befff6b9db23ea3$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $2befff6b9db23ea3$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $2befff6b9db23ea3$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isPromise", () => $2befff6b9db23ea3$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $2befff6b9db23ea3$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isReservedProp", () => $2befff6b9db23ea3$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $2befff6b9db23ea3$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $2befff6b9db23ea3$export$161d051f5dd25de7);
$parcel$export(module.exports, "capitalize", () => $2befff6b9db23ea3$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $2befff6b9db23ea3$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $2befff6b9db23ea3$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $2befff6b9db23ea3$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $2befff6b9db23ea3$export$8afb76124cf08683);
$parcel$export(module.exports, "toNumber", () => $2befff6b9db23ea3$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $2befff6b9db23ea3$export$ff5f2eeb11fc7e14);
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 * IMPORTANT: all calls of this function must be prefixed with
 * \/\*#\_\_PURE\_\_\*\/
 * So that rollup can tree-shake them if necessary.
 */ function $2befff6b9db23ea3$export$b41394a5437791c8(str, expectsLowerCase) {
    const map = Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
/**
 * dev only flag -> name mapping
 */ const $2befff6b9db23ea3$export$def7dc2c2e95a08a = {
    [1 /* TEXT */ ]: `TEXT`,
    [2 /* CLASS */ ]: `CLASS`,
    [4 /* STYLE */ ]: `STYLE`,
    [8 /* PROPS */ ]: `PROPS`,
    [16 /* FULL_PROPS */ ]: `FULL_PROPS`,
    [32 /* HYDRATE_EVENTS */ ]: `HYDRATE_EVENTS`,
    [64 /* STABLE_FRAGMENT */ ]: `STABLE_FRAGMENT`,
    [128 /* KEYED_FRAGMENT */ ]: `KEYED_FRAGMENT`,
    [256 /* UNKEYED_FRAGMENT */ ]: `UNKEYED_FRAGMENT`,
    [512 /* NEED_PATCH */ ]: `NEED_PATCH`,
    [1024 /* DYNAMIC_SLOTS */ ]: `DYNAMIC_SLOTS`,
    [2048 /* DEV_ROOT_FRAGMENT */ ]: `DEV_ROOT_FRAGMENT`,
    [-1 /* HOISTED */ ]: `HOISTED`,
    [-2 /* BAIL */ ]: `BAIL`
};
/**
 * Dev only
 */ const $2befff6b9db23ea3$export$624972196ed3745f = {
    [1 /* STABLE */ ]: "STABLE",
    [2 /* DYNAMIC */ ]: "DYNAMIC",
    [3 /* FORWARDED */ ]: "FORWARDED"
};
const $2befff6b9db23ea3$var$GLOBALS_WHITE_LISTED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt";
const $2befff6b9db23ea3$export$d6571a1911e4f27e = /*#__PURE__*/ $2befff6b9db23ea3$export$b41394a5437791c8($2befff6b9db23ea3$var$GLOBALS_WHITE_LISTED);
const $2befff6b9db23ea3$var$range = 2;
function $2befff6b9db23ea3$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    // Split the content into individual lines but capture the newline sequence
    // that separated each line. This is important because the actual sequence is
    // needed to properly take into account the full line length for offset
    // comparison
    let lines = source.split(/(\r?\n)/);
    // Separate the lines and newline sequences into separate arrays for easier referencing
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $2befff6b9db23ea3$var$range; j <= i + $2befff6b9db23ea3$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    // push underline
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
/**
 * On the client we only need to offer special cases for boolean attributes that
 * have different names from their corresponding dom properties:
 * - itemscope -> N/A
 * - allowfullscreen -> allowFullscreen
 * - formnovalidate -> formNoValidate
 * - ismap -> isMap
 * - nomodule -> noModule
 * - novalidate -> noValidate
 * - readonly -> readOnly
 */ const $2befff6b9db23ea3$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $2befff6b9db23ea3$export$d186f5eb2e810715 = /*#__PURE__*/ $2befff6b9db23ea3$export$b41394a5437791c8($2befff6b9db23ea3$var$specialBooleanAttrs);
/**
 * The full list is needed during SSR to produce the correct initial markup.
 */ const $2befff6b9db23ea3$export$f763ba3b84e9cd8c = /*#__PURE__*/ $2befff6b9db23ea3$export$b41394a5437791c8($2befff6b9db23ea3$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,` + `loop,open,required,reversed,scoped,seamless,` + `checked,muted,multiple,selected`);
/**
 * Boolean attributes should be included if the value is truthy or ''.
 * e.g. `<select multiple>` compiles to `{ multiple: '' }`
 */ function $2befff6b9db23ea3$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $2befff6b9db23ea3$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $2befff6b9db23ea3$var$attrValidationCache = {};
function $2befff6b9db23ea3$export$d55ef77660f30d12(name) {
    if ($2befff6b9db23ea3$var$attrValidationCache.hasOwnProperty(name)) return $2befff6b9db23ea3$var$attrValidationCache[name];
    const isUnsafe = $2befff6b9db23ea3$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $2befff6b9db23ea3$var$attrValidationCache[name] = !isUnsafe;
}
const $2befff6b9db23ea3$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
/**
 * CSS properties that accept plain numbers
 */ const $2befff6b9db23ea3$export$84da53524c6b1314 = /*#__PURE__*/ $2befff6b9db23ea3$export$b41394a5437791c8(`animation-iteration-count,border-image-outset,border-image-slice,` + `border-image-width,box-flex,box-flex-group,box-ordinal-group,column-count,` + `columns,flex,flex-grow,flex-positive,flex-shrink,flex-negative,flex-order,` + `grid-row,grid-row-end,grid-row-span,grid-row-start,grid-column,` + `grid-column-end,grid-column-span,grid-column-start,font-weight,line-clamp,` + `line-height,opacity,order,orphans,tab-size,widows,z-index,zoom,` + // SVG
`fill-opacity,flood-opacity,stop-opacity,stroke-dasharray,stroke-dashoffset,` + `stroke-miterlimit,stroke-opacity,stroke-width`);
/**
 * Known attributes, this is used for stringification of runtime static nodes
 * so that we don't stringify bindings that cannot be set from HTML.
 * Don't also forget to allow `data-*` and `aria-*`!
 * Generated from https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes
 */ const $2befff6b9db23ea3$export$f7e7a1cc7da8d5e9 = /*#__PURE__*/ $2befff6b9db23ea3$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,` + `autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,` + `border,buffered,capture,challenge,charset,checked,cite,class,code,` + `codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,` + `coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,` + `disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,` + `formaction,formenctype,formmethod,formnovalidate,formtarget,headers,` + `height,hidden,high,href,hreflang,http-equiv,icon,id,importance,integrity,` + `ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,` + `manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,` + `open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,` + `referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,` + `selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,` + `start,step,style,summary,tabindex,target,title,translate,type,usemap,` + `value,width,wrap`);
/**
 * Generated from https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute
 */ const $2befff6b9db23ea3$export$80da416f43933831 = /*#__PURE__*/ $2befff6b9db23ea3$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,` + `arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,` + `baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,` + `clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,` + `color-interpolation-filters,color-profile,color-rendering,` + `contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,` + `descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,` + `dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,` + `fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,` + `font-family,font-size,font-size-adjust,font-stretch,font-style,` + `font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,` + `glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,` + `gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,` + `horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,` + `k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,` + `lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,` + `marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,` + `mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,` + `name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,` + `overflow,overline-position,overline-thickness,panose-1,paint-order,path,` + `pathLength,patternContentUnits,patternTransform,patternUnits,ping,` + `pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,` + `preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,` + `rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,` + `restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,` + `specularConstant,specularExponent,speed,spreadMethod,startOffset,` + `stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,` + `strikethrough-position,strikethrough-thickness,string,stroke,` + `stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,` + `stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,` + `systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,` + `text-decoration,text-rendering,textLength,to,transform,transform-origin,` + `type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,` + `unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,` + `v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,` + `vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,` + `writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,` + `xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,` + `xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $2befff6b9db23ea3$export$8756898546458274(value) {
    if ($2befff6b9db23ea3$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $2befff6b9db23ea3$export$844ec244b1367d54(item) ? $2befff6b9db23ea3$export$76a205ce979d066a(item) : $2befff6b9db23ea3$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($2befff6b9db23ea3$export$844ec244b1367d54(value)) return value;
    else if ($2befff6b9db23ea3$export$a6cdc56e425d0d0a(value)) return value;
}
const $2befff6b9db23ea3$var$listDelimiterRE = /;(?![^(]*\))/g;
const $2befff6b9db23ea3$var$propertyDelimiterRE = /:(.+)/;
function $2befff6b9db23ea3$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.split($2befff6b9db23ea3$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($2befff6b9db23ea3$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $2befff6b9db23ea3$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $2befff6b9db23ea3$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $2befff6b9db23ea3$export$6e6a0a3676c4b8bb(key);
        if ($2befff6b9db23ea3$export$844ec244b1367d54(value) || typeof value === "number" && $2befff6b9db23ea3$export$84da53524c6b1314(normalizedKey)) // only render valid values
        ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $2befff6b9db23ea3$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($2befff6b9db23ea3$export$844ec244b1367d54(value)) res = value;
    else if ($2befff6b9db23ea3$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $2befff6b9db23ea3$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($2befff6b9db23ea3$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $2befff6b9db23ea3$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$2befff6b9db23ea3$export$844ec244b1367d54(klass)) props.class = $2befff6b9db23ea3$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $2befff6b9db23ea3$export$8756898546458274(style);
    return props;
}
// These tag configs are shared between compiler-dom and runtime-dom, so they
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element
const $2befff6b9db23ea3$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element
const $2befff6b9db23ea3$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistanceLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $2befff6b9db23ea3$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $2befff6b9db23ea3$export$1ccf854a0984f890 = /*#__PURE__*/ $2befff6b9db23ea3$export$b41394a5437791c8($2befff6b9db23ea3$var$HTML_TAGS);
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $2befff6b9db23ea3$export$6328ce7565ea1049 = /*#__PURE__*/ $2befff6b9db23ea3$export$b41394a5437791c8($2befff6b9db23ea3$var$SVG_TAGS);
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $2befff6b9db23ea3$export$e5f2d3d97d9367a4 = /*#__PURE__*/ $2befff6b9db23ea3$export$b41394a5437791c8($2befff6b9db23ea3$var$VOID_TAGS);
const $2befff6b9db23ea3$var$escapeRE = /["'&<>]/;
function $2befff6b9db23ea3$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $2befff6b9db23ea3$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
// https://www.w3.org/TR/html52/syntax.html#comments
const $2befff6b9db23ea3$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $2befff6b9db23ea3$export$7b105034a53bde5f(src) {
    return src.replace($2befff6b9db23ea3$var$commentStripRE, "");
}
function $2befff6b9db23ea3$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $2befff6b9db23ea3$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $2befff6b9db23ea3$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $2befff6b9db23ea3$export$871608497c498473(a);
    let bValidType = $2befff6b9db23ea3$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $2befff6b9db23ea3$export$a244864fd9645c7f(a);
    bValidType = $2befff6b9db23ea3$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $2befff6b9db23ea3$export$43bee75e5e14138e(a);
    bValidType = $2befff6b9db23ea3$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $2befff6b9db23ea3$var$looseCompareArrays(a, b) : false;
    aValidType = $2befff6b9db23ea3$export$a6cdc56e425d0d0a(a);
    bValidType = $2befff6b9db23ea3$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        /* istanbul ignore if: this if will probably never be called */ if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$2befff6b9db23ea3$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $2befff6b9db23ea3$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$2befff6b9db23ea3$export$ae8015769846262c(item, val));
}
/**
 * For converting {{ interpolation }} values to displayed strings.
 * @private
 */ const $2befff6b9db23ea3$export$b5b1545233b45293 = (val)=>{
    return $2befff6b9db23ea3$export$844ec244b1367d54(val) ? val : val == null ? "" : $2befff6b9db23ea3$export$43bee75e5e14138e(val) || $2befff6b9db23ea3$export$a6cdc56e425d0d0a(val) && (val.toString === $2befff6b9db23ea3$export$830c053460e5ddf6 || !$2befff6b9db23ea3$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $2befff6b9db23ea3$var$replacer, 2) : String(val);
};
const $2befff6b9db23ea3$var$replacer = (_key, val)=>{
    // can't use isRef here since @vue/shared has no deps
    if (val && val.__v_isRef) return $2befff6b9db23ea3$var$replacer(_key, val.value);
    else if ($2befff6b9db23ea3$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val])=>{
            entries[`${key} =>`] = val;
            return entries;
        }, {})
    };
    else if ($2befff6b9db23ea3$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ]
    };
    else if ($2befff6b9db23ea3$export$a6cdc56e425d0d0a(val) && !$2befff6b9db23ea3$export$43bee75e5e14138e(val) && !$2befff6b9db23ea3$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $2befff6b9db23ea3$export$cf583d23ab39677c = {};
const $2befff6b9db23ea3$export$6bd8558f433f1cc1 = [];
const $2befff6b9db23ea3$export$5702a91a6f42969f = ()=>{};
/**
 * Always return false.
 */ const $2befff6b9db23ea3$export$c01351c0af048e39 = ()=>false;
const $2befff6b9db23ea3$var$onRE = /^on[^a-z]/;
const $2befff6b9db23ea3$export$1a2d97de39ecbb75 = (key)=>$2befff6b9db23ea3$var$onRE.test(key);
const $2befff6b9db23ea3$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $2befff6b9db23ea3$export$8b58be045bf06082 = Object.assign;
const $2befff6b9db23ea3$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $2befff6b9db23ea3$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $2befff6b9db23ea3$export$b5a638e9b3fff9f3 = (val, key)=>$2befff6b9db23ea3$var$hasOwnProperty.call(val, key);
const $2befff6b9db23ea3$export$43bee75e5e14138e = Array.isArray;
const $2befff6b9db23ea3$export$5c90113a285f2241 = (val)=>$2befff6b9db23ea3$export$1dccc787cc36538b(val) === "[object Map]";
const $2befff6b9db23ea3$export$6750766a7c7ec627 = (val)=>$2befff6b9db23ea3$export$1dccc787cc36538b(val) === "[object Set]";
const $2befff6b9db23ea3$export$871608497c498473 = (val)=>$2befff6b9db23ea3$export$1dccc787cc36538b(val) === "[object Date]";
const $2befff6b9db23ea3$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $2befff6b9db23ea3$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $2befff6b9db23ea3$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $2befff6b9db23ea3$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $2befff6b9db23ea3$export$4369c812aac99591 = (val)=>{
    return $2befff6b9db23ea3$export$a6cdc56e425d0d0a(val) && $2befff6b9db23ea3$export$f6e2535fb5126e54(val.then) && $2befff6b9db23ea3$export$f6e2535fb5126e54(val.catch);
};
const $2befff6b9db23ea3$export$830c053460e5ddf6 = Object.prototype.toString;
const $2befff6b9db23ea3$export$1dccc787cc36538b = (value)=>$2befff6b9db23ea3$export$830c053460e5ddf6.call(value);
const $2befff6b9db23ea3$export$5ad0a3c360b8fbb5 = (value)=>{
    // extract "RawType" from strings like "[object RawType]"
    return $2befff6b9db23ea3$export$1dccc787cc36538b(value).slice(8, -1);
};
const $2befff6b9db23ea3$export$53b83ca8eaab0383 = (val)=>$2befff6b9db23ea3$export$1dccc787cc36538b(val) === "[object Object]";
const $2befff6b9db23ea3$export$e2a2b93446ec9fe = (key)=>$2befff6b9db23ea3$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $2befff6b9db23ea3$export$bf7d3c0236f0aa85 = /*#__PURE__*/ $2befff6b9db23ea3$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $2befff6b9db23ea3$export$a9c1fdb3030c2a6b = /*#__PURE__*/ $2befff6b9db23ea3$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $2befff6b9db23ea3$var$cacheStringFunction = (fn)=>{
    const cache = Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $2befff6b9db23ea3$var$camelizeRE = /-(\w)/g;
/**
 * @private
 */ const $2befff6b9db23ea3$export$161d051f5dd25de7 = $2befff6b9db23ea3$var$cacheStringFunction((str)=>{
    return str.replace($2befff6b9db23ea3$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $2befff6b9db23ea3$var$hyphenateRE = /\B([A-Z])/g;
/**
 * @private
 */ const $2befff6b9db23ea3$export$6e6a0a3676c4b8bb = $2befff6b9db23ea3$var$cacheStringFunction((str)=>str.replace($2befff6b9db23ea3$var$hyphenateRE, "-$1").toLowerCase());
/**
 * @private
 */ const $2befff6b9db23ea3$export$9a00dee1beb8f576 = $2befff6b9db23ea3$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
/**
 * @private
 */ const $2befff6b9db23ea3$export$8c022799eeaaefcd = $2befff6b9db23ea3$var$cacheStringFunction((str)=>str ? `on${$2befff6b9db23ea3$export$9a00dee1beb8f576(str)}` : ``);
// compare whether a value has changed, accounting for NaN.
const $2befff6b9db23ea3$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $2befff6b9db23ea3$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $2befff6b9db23ea3$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $2befff6b9db23ea3$export$a0a81dc3380ce7d3 = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
let $2befff6b9db23ea3$var$_globalThis;
const $2befff6b9db23ea3$export$ff5f2eeb11fc7e14 = ()=>{
    return $2befff6b9db23ea3$var$_globalThis || ($2befff6b9db23ea3$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $2befff6b9db23ea3$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $2befff6b9db23ea3$export$53d5e12f9a1d3cde(name) {
    return $2befff6b9db23ea3$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}

});


parcelRegister("dXRf9", function(module, exports) {

$parcel$export(module.exports, "isSpecialBooleanAttr", () => $a2aa160e731f9104$export$d186f5eb2e810715);
$parcel$export(module.exports, "includeBooleanAttr", () => $a2aa160e731f9104$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isArray", () => $a2aa160e731f9104$export$43bee75e5e14138e);
$parcel$export(module.exports, "isString", () => $a2aa160e731f9104$export$844ec244b1367d54);
$parcel$export(module.exports, "isObject", () => $a2aa160e731f9104$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "hyphenate", () => $a2aa160e731f9104$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "isHTMLTag", () => $a2aa160e731f9104$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $a2aa160e731f9104$export$6328ce7565ea1049);
$parcel$export(module.exports, "looseEqual", () => $a2aa160e731f9104$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $a2aa160e731f9104$export$42912a80cedb8bd4);
$parcel$export(module.exports, "isFunction", () => $a2aa160e731f9104$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isSet", () => $a2aa160e731f9104$export$6750766a7c7ec627);
$parcel$export(module.exports, "EMPTY_OBJ", () => $a2aa160e731f9104$export$cf583d23ab39677c);
$parcel$export(module.exports, "isOn", () => $a2aa160e731f9104$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $a2aa160e731f9104$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $a2aa160e731f9104$export$8b58be045bf06082);
$parcel$export(module.exports, "camelize", () => $a2aa160e731f9104$export$161d051f5dd25de7);
$parcel$export(module.exports, "capitalize", () => $a2aa160e731f9104$export$9a00dee1beb8f576);
$parcel$export(module.exports, "invokeArrayFns", () => $a2aa160e731f9104$export$39951422d618a9d3);
$parcel$export(module.exports, "toNumber", () => $a2aa160e731f9104$export$a0a81dc3380ce7d3);
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 * IMPORTANT: all calls of this function must be prefixed with
 * \/\*#\_\_PURE\_\_\*\/
 * So that rollup can tree-shake them if necessary.
 */ function $a2aa160e731f9104$export$b41394a5437791c8(str, expectsLowerCase) {
    const map = Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
/**
 * dev only flag -> name mapping
 */ const $a2aa160e731f9104$export$def7dc2c2e95a08a = {
    [1 /* TEXT */ ]: `TEXT`,
    [2 /* CLASS */ ]: `CLASS`,
    [4 /* STYLE */ ]: `STYLE`,
    [8 /* PROPS */ ]: `PROPS`,
    [16 /* FULL_PROPS */ ]: `FULL_PROPS`,
    [32 /* HYDRATE_EVENTS */ ]: `HYDRATE_EVENTS`,
    [64 /* STABLE_FRAGMENT */ ]: `STABLE_FRAGMENT`,
    [128 /* KEYED_FRAGMENT */ ]: `KEYED_FRAGMENT`,
    [256 /* UNKEYED_FRAGMENT */ ]: `UNKEYED_FRAGMENT`,
    [512 /* NEED_PATCH */ ]: `NEED_PATCH`,
    [1024 /* DYNAMIC_SLOTS */ ]: `DYNAMIC_SLOTS`,
    [2048 /* DEV_ROOT_FRAGMENT */ ]: `DEV_ROOT_FRAGMENT`,
    [-1 /* HOISTED */ ]: `HOISTED`,
    [-2 /* BAIL */ ]: `BAIL`
};
/**
 * Dev only
 */ const $a2aa160e731f9104$export$624972196ed3745f = {
    [1 /* STABLE */ ]: "STABLE",
    [2 /* DYNAMIC */ ]: "DYNAMIC",
    [3 /* FORWARDED */ ]: "FORWARDED"
};
const $a2aa160e731f9104$var$GLOBALS_WHITE_LISTED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt";
const $a2aa160e731f9104$export$d6571a1911e4f27e = /*#__PURE__*/ $a2aa160e731f9104$export$b41394a5437791c8($a2aa160e731f9104$var$GLOBALS_WHITE_LISTED);
const $a2aa160e731f9104$var$range = 2;
function $a2aa160e731f9104$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    // Split the content into individual lines but capture the newline sequence
    // that separated each line. This is important because the actual sequence is
    // needed to properly take into account the full line length for offset
    // comparison
    let lines = source.split(/(\r?\n)/);
    // Separate the lines and newline sequences into separate arrays for easier referencing
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $a2aa160e731f9104$var$range; j <= i + $a2aa160e731f9104$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    // push underline
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
/**
 * On the client we only need to offer special cases for boolean attributes that
 * have different names from their corresponding dom properties:
 * - itemscope -> N/A
 * - allowfullscreen -> allowFullscreen
 * - formnovalidate -> formNoValidate
 * - ismap -> isMap
 * - nomodule -> noModule
 * - novalidate -> noValidate
 * - readonly -> readOnly
 */ const $a2aa160e731f9104$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $a2aa160e731f9104$export$d186f5eb2e810715 = /*#__PURE__*/ $a2aa160e731f9104$export$b41394a5437791c8($a2aa160e731f9104$var$specialBooleanAttrs);
/**
 * The full list is needed during SSR to produce the correct initial markup.
 */ const $a2aa160e731f9104$export$f763ba3b84e9cd8c = /*#__PURE__*/ $a2aa160e731f9104$export$b41394a5437791c8($a2aa160e731f9104$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,` + `loop,open,required,reversed,scoped,seamless,` + `checked,muted,multiple,selected`);
/**
 * Boolean attributes should be included if the value is truthy or ''.
 * e.g. `<select multiple>` compiles to `{ multiple: '' }`
 */ function $a2aa160e731f9104$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $a2aa160e731f9104$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $a2aa160e731f9104$var$attrValidationCache = {};
function $a2aa160e731f9104$export$d55ef77660f30d12(name) {
    if ($a2aa160e731f9104$var$attrValidationCache.hasOwnProperty(name)) return $a2aa160e731f9104$var$attrValidationCache[name];
    const isUnsafe = $a2aa160e731f9104$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $a2aa160e731f9104$var$attrValidationCache[name] = !isUnsafe;
}
const $a2aa160e731f9104$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
/**
 * CSS properties that accept plain numbers
 */ const $a2aa160e731f9104$export$84da53524c6b1314 = /*#__PURE__*/ $a2aa160e731f9104$export$b41394a5437791c8(`animation-iteration-count,border-image-outset,border-image-slice,` + `border-image-width,box-flex,box-flex-group,box-ordinal-group,column-count,` + `columns,flex,flex-grow,flex-positive,flex-shrink,flex-negative,flex-order,` + `grid-row,grid-row-end,grid-row-span,grid-row-start,grid-column,` + `grid-column-end,grid-column-span,grid-column-start,font-weight,line-clamp,` + `line-height,opacity,order,orphans,tab-size,widows,z-index,zoom,` + // SVG
`fill-opacity,flood-opacity,stop-opacity,stroke-dasharray,stroke-dashoffset,` + `stroke-miterlimit,stroke-opacity,stroke-width`);
/**
 * Known attributes, this is used for stringification of runtime static nodes
 * so that we don't stringify bindings that cannot be set from HTML.
 * Don't also forget to allow `data-*` and `aria-*`!
 * Generated from https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes
 */ const $a2aa160e731f9104$export$f7e7a1cc7da8d5e9 = /*#__PURE__*/ $a2aa160e731f9104$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,` + `autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,` + `border,buffered,capture,challenge,charset,checked,cite,class,code,` + `codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,` + `coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,` + `disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,` + `formaction,formenctype,formmethod,formnovalidate,formtarget,headers,` + `height,hidden,high,href,hreflang,http-equiv,icon,id,importance,integrity,` + `ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,` + `manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,` + `open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,` + `referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,` + `selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,` + `start,step,style,summary,tabindex,target,title,translate,type,usemap,` + `value,width,wrap`);
/**
 * Generated from https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute
 */ const $a2aa160e731f9104$export$80da416f43933831 = /*#__PURE__*/ $a2aa160e731f9104$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,` + `arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,` + `baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,` + `clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,` + `color-interpolation-filters,color-profile,color-rendering,` + `contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,` + `descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,` + `dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,` + `fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,` + `font-family,font-size,font-size-adjust,font-stretch,font-style,` + `font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,` + `glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,` + `gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,` + `horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,` + `k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,` + `lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,` + `marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,` + `mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,` + `name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,` + `overflow,overline-position,overline-thickness,panose-1,paint-order,path,` + `pathLength,patternContentUnits,patternTransform,patternUnits,ping,` + `pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,` + `preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,` + `rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,` + `restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,` + `specularConstant,specularExponent,speed,spreadMethod,startOffset,` + `stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,` + `strikethrough-position,strikethrough-thickness,string,stroke,` + `stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,` + `stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,` + `systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,` + `text-decoration,text-rendering,textLength,to,transform,transform-origin,` + `type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,` + `unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,` + `v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,` + `vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,` + `writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,` + `xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,` + `xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $a2aa160e731f9104$export$8756898546458274(value) {
    if ($a2aa160e731f9104$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $a2aa160e731f9104$export$844ec244b1367d54(item) ? $a2aa160e731f9104$export$76a205ce979d066a(item) : $a2aa160e731f9104$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($a2aa160e731f9104$export$844ec244b1367d54(value)) return value;
    else if ($a2aa160e731f9104$export$a6cdc56e425d0d0a(value)) return value;
}
const $a2aa160e731f9104$var$listDelimiterRE = /;(?![^(]*\))/g;
const $a2aa160e731f9104$var$propertyDelimiterRE = /:(.+)/;
function $a2aa160e731f9104$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.split($a2aa160e731f9104$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($a2aa160e731f9104$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $a2aa160e731f9104$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $a2aa160e731f9104$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $a2aa160e731f9104$export$6e6a0a3676c4b8bb(key);
        if ($a2aa160e731f9104$export$844ec244b1367d54(value) || typeof value === "number" && $a2aa160e731f9104$export$84da53524c6b1314(normalizedKey)) // only render valid values
        ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $a2aa160e731f9104$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($a2aa160e731f9104$export$844ec244b1367d54(value)) res = value;
    else if ($a2aa160e731f9104$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $a2aa160e731f9104$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($a2aa160e731f9104$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $a2aa160e731f9104$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$a2aa160e731f9104$export$844ec244b1367d54(klass)) props.class = $a2aa160e731f9104$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $a2aa160e731f9104$export$8756898546458274(style);
    return props;
}
// These tag configs are shared between compiler-dom and runtime-dom, so they
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element
const $a2aa160e731f9104$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element
const $a2aa160e731f9104$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistanceLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $a2aa160e731f9104$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $a2aa160e731f9104$export$1ccf854a0984f890 = /*#__PURE__*/ $a2aa160e731f9104$export$b41394a5437791c8($a2aa160e731f9104$var$HTML_TAGS);
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $a2aa160e731f9104$export$6328ce7565ea1049 = /*#__PURE__*/ $a2aa160e731f9104$export$b41394a5437791c8($a2aa160e731f9104$var$SVG_TAGS);
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $a2aa160e731f9104$export$e5f2d3d97d9367a4 = /*#__PURE__*/ $a2aa160e731f9104$export$b41394a5437791c8($a2aa160e731f9104$var$VOID_TAGS);
const $a2aa160e731f9104$var$escapeRE = /["'&<>]/;
function $a2aa160e731f9104$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $a2aa160e731f9104$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
// https://www.w3.org/TR/html52/syntax.html#comments
const $a2aa160e731f9104$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $a2aa160e731f9104$export$7b105034a53bde5f(src) {
    return src.replace($a2aa160e731f9104$var$commentStripRE, "");
}
function $a2aa160e731f9104$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $a2aa160e731f9104$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $a2aa160e731f9104$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $a2aa160e731f9104$export$871608497c498473(a);
    let bValidType = $a2aa160e731f9104$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $a2aa160e731f9104$export$a244864fd9645c7f(a);
    bValidType = $a2aa160e731f9104$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $a2aa160e731f9104$export$43bee75e5e14138e(a);
    bValidType = $a2aa160e731f9104$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $a2aa160e731f9104$var$looseCompareArrays(a, b) : false;
    aValidType = $a2aa160e731f9104$export$a6cdc56e425d0d0a(a);
    bValidType = $a2aa160e731f9104$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        /* istanbul ignore if: this if will probably never be called */ if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$a2aa160e731f9104$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $a2aa160e731f9104$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$a2aa160e731f9104$export$ae8015769846262c(item, val));
}
/**
 * For converting {{ interpolation }} values to displayed strings.
 * @private
 */ const $a2aa160e731f9104$export$b5b1545233b45293 = (val)=>{
    return $a2aa160e731f9104$export$844ec244b1367d54(val) ? val : val == null ? "" : $a2aa160e731f9104$export$43bee75e5e14138e(val) || $a2aa160e731f9104$export$a6cdc56e425d0d0a(val) && (val.toString === $a2aa160e731f9104$export$830c053460e5ddf6 || !$a2aa160e731f9104$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $a2aa160e731f9104$var$replacer, 2) : String(val);
};
const $a2aa160e731f9104$var$replacer = (_key, val)=>{
    // can't use isRef here since @vue/shared has no deps
    if (val && val.__v_isRef) return $a2aa160e731f9104$var$replacer(_key, val.value);
    else if ($a2aa160e731f9104$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val])=>{
            entries[`${key} =>`] = val;
            return entries;
        }, {})
    };
    else if ($a2aa160e731f9104$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ]
    };
    else if ($a2aa160e731f9104$export$a6cdc56e425d0d0a(val) && !$a2aa160e731f9104$export$43bee75e5e14138e(val) && !$a2aa160e731f9104$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $a2aa160e731f9104$export$cf583d23ab39677c = {};
const $a2aa160e731f9104$export$6bd8558f433f1cc1 = [];
const $a2aa160e731f9104$export$5702a91a6f42969f = ()=>{};
/**
 * Always return false.
 */ const $a2aa160e731f9104$export$c01351c0af048e39 = ()=>false;
const $a2aa160e731f9104$var$onRE = /^on[^a-z]/;
const $a2aa160e731f9104$export$1a2d97de39ecbb75 = (key)=>$a2aa160e731f9104$var$onRE.test(key);
const $a2aa160e731f9104$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $a2aa160e731f9104$export$8b58be045bf06082 = Object.assign;
const $a2aa160e731f9104$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $a2aa160e731f9104$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $a2aa160e731f9104$export$b5a638e9b3fff9f3 = (val, key)=>$a2aa160e731f9104$var$hasOwnProperty.call(val, key);
const $a2aa160e731f9104$export$43bee75e5e14138e = Array.isArray;
const $a2aa160e731f9104$export$5c90113a285f2241 = (val)=>$a2aa160e731f9104$export$1dccc787cc36538b(val) === "[object Map]";
const $a2aa160e731f9104$export$6750766a7c7ec627 = (val)=>$a2aa160e731f9104$export$1dccc787cc36538b(val) === "[object Set]";
const $a2aa160e731f9104$export$871608497c498473 = (val)=>$a2aa160e731f9104$export$1dccc787cc36538b(val) === "[object Date]";
const $a2aa160e731f9104$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $a2aa160e731f9104$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $a2aa160e731f9104$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $a2aa160e731f9104$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $a2aa160e731f9104$export$4369c812aac99591 = (val)=>{
    return $a2aa160e731f9104$export$a6cdc56e425d0d0a(val) && $a2aa160e731f9104$export$f6e2535fb5126e54(val.then) && $a2aa160e731f9104$export$f6e2535fb5126e54(val.catch);
};
const $a2aa160e731f9104$export$830c053460e5ddf6 = Object.prototype.toString;
const $a2aa160e731f9104$export$1dccc787cc36538b = (value)=>$a2aa160e731f9104$export$830c053460e5ddf6.call(value);
const $a2aa160e731f9104$export$5ad0a3c360b8fbb5 = (value)=>{
    // extract "RawType" from strings like "[object RawType]"
    return $a2aa160e731f9104$export$1dccc787cc36538b(value).slice(8, -1);
};
const $a2aa160e731f9104$export$53b83ca8eaab0383 = (val)=>$a2aa160e731f9104$export$1dccc787cc36538b(val) === "[object Object]";
const $a2aa160e731f9104$export$e2a2b93446ec9fe = (key)=>$a2aa160e731f9104$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $a2aa160e731f9104$export$bf7d3c0236f0aa85 = /*#__PURE__*/ $a2aa160e731f9104$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $a2aa160e731f9104$export$a9c1fdb3030c2a6b = /*#__PURE__*/ $a2aa160e731f9104$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $a2aa160e731f9104$var$cacheStringFunction = (fn)=>{
    const cache = Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $a2aa160e731f9104$var$camelizeRE = /-(\w)/g;
/**
 * @private
 */ const $a2aa160e731f9104$export$161d051f5dd25de7 = $a2aa160e731f9104$var$cacheStringFunction((str)=>{
    return str.replace($a2aa160e731f9104$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $a2aa160e731f9104$var$hyphenateRE = /\B([A-Z])/g;
/**
 * @private
 */ const $a2aa160e731f9104$export$6e6a0a3676c4b8bb = $a2aa160e731f9104$var$cacheStringFunction((str)=>str.replace($a2aa160e731f9104$var$hyphenateRE, "-$1").toLowerCase());
/**
 * @private
 */ const $a2aa160e731f9104$export$9a00dee1beb8f576 = $a2aa160e731f9104$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
/**
 * @private
 */ const $a2aa160e731f9104$export$8c022799eeaaefcd = $a2aa160e731f9104$var$cacheStringFunction((str)=>str ? `on${$a2aa160e731f9104$export$9a00dee1beb8f576(str)}` : ``);
// compare whether a value has changed, accounting for NaN.
const $a2aa160e731f9104$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $a2aa160e731f9104$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $a2aa160e731f9104$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $a2aa160e731f9104$export$a0a81dc3380ce7d3 = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
let $a2aa160e731f9104$var$_globalThis;
const $a2aa160e731f9104$export$ff5f2eeb11fc7e14 = ()=>{
    return $a2aa160e731f9104$var$_globalThis || ($a2aa160e731f9104$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $a2aa160e731f9104$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $a2aa160e731f9104$export$53d5e12f9a1d3cde(name) {
    return $a2aa160e731f9104$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}

});




parcelRegister("hTatZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d05fb464a24c03e2$export$2e2bcd8739ae039);
let $d05fb464a24c03e2$var$NOOP = ()=>{};
var $d05fb464a24c03e2$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("d3luP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $980c3ae414d49779$export$2e2bcd8739ae039);

var $fTpiZ = parcelRequire("fTpiZ");

var $1urVZ = parcelRequire("1urVZ");
const $980c3ae414d49779$var$props = {
    maxZoom: {
        type: Number,
        twoWay: false
    },
    batchSizeIE: {
        type: Number,
        twoWay: false
    },
    calculator: {
        type: Function,
        twoWay: false
    },
    enableRetinaIcons: {
        type: Boolean,
        twoWay: false
    },
    gridSize: {
        type: Number,
        twoWay: false
    },
    ignoreHidden: {
        type: Boolean,
        twoWay: false
    },
    imageExtension: {
        type: String,
        twoWay: false
    },
    imagePath: {
        type: String,
        twoWay: false
    },
    imageSizes: {
        type: Array,
        twoWay: false
    },
    minimumClusterSize: {
        type: Number,
        twoWay: false
    },
    styles: {
        type: Array,
        twoWay: false
    },
    zoomOnClick: {
        type: Boolean,
        twoWay: false
    }
};
const $980c3ae414d49779$var$events = [
    "click",
    "rightclick",
    "dblclick",
    "drag",
    "dragstart",
    "dragend",
    "mouseup",
    "mousedown",
    "mouseover",
    "mouseout"
];
var $980c3ae414d49779$export$2e2bcd8739ae039 = (0, $1urVZ.default)({
    mappedProps: $980c3ae414d49779$var$props,
    events: $980c3ae414d49779$var$events,
    name: "cluster",
    ctr: ()=>{
        if (typeof (0, $fTpiZ.MarkerClusterer) === "undefined") {
            const errorMessage = "MarkerClusterer is not installed!";
            console.error(errorMessage);
            throw new Error(errorMessage);
        }
        return 0, $fTpiZ.MarkerClusterer;
    },
    ctrArgs: ({ map: map, ...otherOptions })=>[
            map,
            [],
            otherOptions
        ],
    afterCreate (inst) {
        const reinsertMarkers = ()=>{
            const oldMarkers = inst.getMarkers();
            inst.clearMarkers();
            inst.addMarkers(oldMarkers);
        };
        for(let prop in $980c3ae414d49779$var$props)if ($980c3ae414d49779$var$props[prop].twoWay) this.$on(prop.toLowerCase() + "_changed", reinsertMarkers);
    },
    updated () {
        if (this.$clusterObject) this.$clusterObject.repaint();
    },
    beforeUnmount () {
        /* Performance optimization when destroying a large number of markers */ if (this.$children && this.$children.length) this.$children.forEach((marker)=>{
            if (marker.$clusterObject === this.$clusterObject) marker.$clusterObject = null;
        });
        if (this.$clusterObject) this.$clusterObject.clearMarkers();
    }
});

});
parcelRegister("fTpiZ", function(module, exports) {

$parcel$export(module.exports, "MarkerClusterer", () => $b91f9f2fdb98b359$export$58bd9bb9fcf3dd4f);

var $b0mBv = parcelRequire("b0mBv");

var $e9eQL = parcelRequire("e9eQL");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $b91f9f2fdb98b359$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
/**
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * util class that creates a common set of convenience functions to wrap
 * shared behavior of Advanced Markers and Markers.
 */ class $b91f9f2fdb98b359$export$87c23728007fa1bd {
    static isAdvancedMarkerAvailable(map) {
        return google.maps.marker && map.getMapCapabilities().isAdvancedMarkersAvailable === true;
    }
    static isAdvancedMarker(marker) {
        return google.maps.marker && marker instanceof google.maps.marker.AdvancedMarkerElement;
    }
    static setMap(marker, map) {
        if (this.isAdvancedMarker(marker)) marker.map = map;
        else marker.setMap(map);
    }
    static getPosition(marker) {
        // SuperClusterAlgorithm.calculate expects a LatLng instance so we fake it for Adv Markers
        if (this.isAdvancedMarker(marker)) {
            if (marker.position) {
                if (marker.position instanceof google.maps.LatLng) return marker.position;
                // since we can't cast to LatLngLiteral for reasons =(
                if (marker.position.lat && marker.position.lng) return new google.maps.LatLng(marker.position.lat, marker.position.lng);
            }
            return new google.maps.LatLng(null);
        }
        return marker.getPosition();
    }
    static getVisible(marker) {
        if (this.isAdvancedMarker(marker)) /**
             * Always return true for Advanced Markers because the clusterer
             * uses getVisible as a way to count legacy markers not as an actual
             * indicator of visibility for some reason. Even when markers are hidden
             * Marker.getVisible returns `true` and this is used to set the marker count
             * on the cluster. See the behavior of Cluster.count
             */ return true;
        return marker.getVisible();
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b91f9f2fdb98b359$export$57ed47926628b770 {
    constructor({ markers: markers, position: position }){
        this.markers = markers;
        if (position) {
            if (position instanceof google.maps.LatLng) this._position = position;
            else this._position = new google.maps.LatLng(position);
        }
    }
    get bounds() {
        if (this.markers.length === 0 && !this._position) return;
        const bounds = new google.maps.LatLngBounds(this._position, this._position);
        for (const marker of this.markers)bounds.extend($b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker));
        return bounds;
    }
    get position() {
        return this._position || this.bounds.getCenter();
    }
    /**
     * Get the count of **visible** markers.
     */ get count() {
        return this.markers.filter((m)=>$b91f9f2fdb98b359$export$87c23728007fa1bd.getVisible(m)).length;
    }
    /**
     * Add a marker to the cluster.
     */ push(marker) {
        this.markers.push(marker);
    }
    /**
     * Cleanup references and remove marker from map.
     */ delete() {
        if (this.marker) {
            $b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(this.marker, null);
            this.marker = undefined;
        }
        this.markers.length = 0;
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the markers visible in a padded map viewport
 *
 * @param map
 * @param mapCanvasProjection
 * @param markers The list of marker to filter
 * @param viewportPaddingPixels The padding in pixel
 * @returns The list of markers in the padded viewport
 */ const $b91f9f2fdb98b359$export$6dcea57a2b662207 = (map, mapCanvasProjection, markers, viewportPaddingPixels)=>{
    const extendedMapBounds = $b91f9f2fdb98b359$export$57247bea612a5e84(map.getBounds(), mapCanvasProjection, viewportPaddingPixels);
    return markers.filter((marker)=>extendedMapBounds.contains($b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker)));
};
/**
 * Extends a bounds by a number of pixels in each direction
 */ const $b91f9f2fdb98b359$export$57247bea612a5e84 = (bounds, projection, numPixels)=>{
    const { northEast: northEast, southWest: southWest } = $b91f9f2fdb98b359$var$latLngBoundsToPixelBounds(bounds, projection);
    const extendedPixelBounds = $b91f9f2fdb98b359$export$8cd793acb3b8e8e8({
        northEast: northEast,
        southWest: southWest
    }, numPixels);
    return $b91f9f2fdb98b359$export$21d7a872d22a0f92(extendedPixelBounds, projection);
};
/**
 * Gets the extended bounds as a bbox [westLng, southLat, eastLng, northLat]
 */ const $b91f9f2fdb98b359$export$6341d7e267bda241 = (bounds, projection, pixels)=>{
    const extended = $b91f9f2fdb98b359$export$57247bea612a5e84(bounds, projection, pixels);
    const ne = extended.getNorthEast();
    const sw = extended.getSouthWest();
    return [
        sw.lng(),
        sw.lat(),
        ne.lng(),
        ne.lat()
    ];
};
/**
 * Returns the distance between 2 positions.
 *
 * @hidden
 */ const $b91f9f2fdb98b359$export$b59117efbc9c7af = (p1, p2)=>{
    const R = 6371; // Radius of the Earth in km
    const dLat = (p2.lat - p1.lat) * Math.PI / 180;
    const dLon = (p2.lng - p1.lng) * Math.PI / 180;
    const sinDLat = Math.sin(dLat / 2);
    const sinDLon = Math.sin(dLon / 2);
    const a = sinDLat * sinDLat + Math.cos(p1.lat * Math.PI / 180) * Math.cos(p2.lat * Math.PI / 180) * sinDLon * sinDLon;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};
/**
 * Converts a LatLng bound to pixels.
 *
 * @hidden
 */ const $b91f9f2fdb98b359$var$latLngBoundsToPixelBounds = (bounds, projection)=>{
    return {
        northEast: projection.fromLatLngToDivPixel(bounds.getNorthEast()),
        southWest: projection.fromLatLngToDivPixel(bounds.getSouthWest())
    };
};
/**
 * Extends a pixel bounds by numPixels in all directions.
 *
 * @hidden
 */ const $b91f9f2fdb98b359$export$8cd793acb3b8e8e8 = ({ northEast: northEast, southWest: southWest }, numPixels)=>{
    northEast.x += numPixels;
    northEast.y -= numPixels;
    southWest.x -= numPixels;
    southWest.y += numPixels;
    return {
        northEast: northEast,
        southWest: southWest
    };
};
/**
 * @hidden
 */ const $b91f9f2fdb98b359$export$21d7a872d22a0f92 = ({ northEast: northEast, southWest: southWest }, projection)=>{
    const sw = projection.fromDivPixelToLatLng(southWest);
    const ne = projection.fromDivPixelToLatLng(northEast);
    return new google.maps.LatLngBounds(sw, ne);
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @hidden
 */ class $b91f9f2fdb98b359$export$1e1bee200f7e743e {
    constructor({ maxZoom: maxZoom = 16 }){
        this.maxZoom = maxZoom;
    }
    /**
     * Helper function to bypass clustering based upon some map state such as
     * zoom, number of markers, etc.
     *
     * ```typescript
     *  cluster({markers, map}: AlgorithmInput): Cluster[] {
     *    if (shouldBypassClustering(map)) {
     *      return this.noop({markers})
     *    }
     * }
     * ```
     */ noop({ markers: markers }) {
        return $b91f9f2fdb98b359$export$8793edee2d425525(markers);
    }
}
/**
 * Abstract viewport algorithm proves a class to filter markers by a padded
 * viewport. This is a common optimization.
 *
 * @hidden
 */ class $b91f9f2fdb98b359$export$d8a438b9a55dba76 extends $b91f9f2fdb98b359$export$1e1bee200f7e743e {
    constructor(_a){
        var { viewportPadding: viewportPadding = 60 } = _a, options = $b91f9f2fdb98b359$var$__rest(_a, [
            "viewportPadding"
        ]);
        super(options);
        this.viewportPadding = 60;
        this.viewportPadding = viewportPadding;
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        if (map.getZoom() >= this.maxZoom) return {
            clusters: this.noop({
                markers: markers
            }),
            changed: false
        };
        return {
            clusters: this.cluster({
                markers: $b91f9f2fdb98b359$export$6dcea57a2b662207(map, mapCanvasProjection, markers, this.viewportPadding),
                map: map,
                mapCanvasProjection: mapCanvasProjection
            })
        };
    }
}
/**
 * @hidden
 */ const $b91f9f2fdb98b359$export$8793edee2d425525 = (markers)=>{
    const clusters = markers.map((marker)=>new $b91f9f2fdb98b359$export$57ed47926628b770({
            position: $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker),
            markers: [
                marker
            ]
        }));
    return clusters;
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default Grid algorithm historically used in Google Maps marker
 * clustering.
 *
 * The Grid algorithm does not implement caching and markers may flash as the
 * viewport changes. Instead use {@link SuperClusterAlgorithm}.
 */ class $b91f9f2fdb98b359$export$dfa3b6d6f10e5cac extends $b91f9f2fdb98b359$export$d8a438b9a55dba76 {
    constructor(_a){
        var { maxDistance: maxDistance = 40000, gridSize: gridSize = 40 } = _a, options = $b91f9f2fdb98b359$var$__rest(_a, [
            "maxDistance",
            "gridSize"
        ]);
        super(options);
        this.clusters = [];
        this.state = {
            zoom: -1
        };
        this.maxDistance = maxDistance;
        this.gridSize = gridSize;
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        const state = {
            zoom: map.getZoom()
        };
        let changed = false;
        if (this.state.zoom >= this.maxZoom && state.zoom >= this.maxZoom) ;
        else changed = !(0, (/*@__PURE__*/$parcel$interopDefault($b0mBv)))(this.state, state);
        this.state = state;
        if (map.getZoom() >= this.maxZoom) return {
            clusters: this.noop({
                markers: markers
            }),
            changed: changed
        };
        return {
            clusters: this.cluster({
                markers: $b91f9f2fdb98b359$export$6dcea57a2b662207(map, mapCanvasProjection, markers, this.viewportPadding),
                map: map,
                mapCanvasProjection: mapCanvasProjection
            })
        };
    }
    cluster({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        this.clusters = [];
        markers.forEach((marker)=>{
            this.addToClosestCluster(marker, map, mapCanvasProjection);
        });
        return this.clusters;
    }
    addToClosestCluster(marker, map, projection) {
        let maxDistance = this.maxDistance; // Some large number
        let cluster = null;
        for(let i = 0; i < this.clusters.length; i++){
            const candidate = this.clusters[i];
            const distance = $b91f9f2fdb98b359$export$b59117efbc9c7af(candidate.bounds.getCenter().toJSON(), $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker).toJSON());
            if (distance < maxDistance) {
                maxDistance = distance;
                cluster = candidate;
            }
        }
        if (cluster && $b91f9f2fdb98b359$export$57247bea612a5e84(cluster.bounds, projection, this.gridSize).contains($b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker))) cluster.push(marker);
        else {
            const cluster = new $b91f9f2fdb98b359$export$57ed47926628b770({
                markers: [
                    marker
                ]
            });
            this.clusters.push(cluster);
        }
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Noop algorithm does not generate any clusters or filter markers by the an extended viewport.
 */ class $b91f9f2fdb98b359$export$f6cacfea2ccd84d3 extends $b91f9f2fdb98b359$export$1e1bee200f7e743e {
    constructor(_a){
        var options = $b91f9f2fdb98b359$var$__rest(_a, []);
        super(options);
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        return {
            clusters: this.cluster({
                markers: markers,
                map: map,
                mapCanvasProjection: mapCanvasProjection
            }),
            changed: false
        };
    }
    cluster(input) {
        return this.noop(input);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ class $b91f9f2fdb98b359$export$3c4c9430ac0fb1eb extends $b91f9f2fdb98b359$export$1e1bee200f7e743e {
    constructor(_a){
        var { maxZoom: maxZoom, radius: radius = 60 } = _a, options = $b91f9f2fdb98b359$var$__rest(_a, [
            "maxZoom",
            "radius"
        ]);
        super({
            maxZoom: maxZoom
        });
        this.state = {
            zoom: -1
        };
        this.superCluster = new (0, $e9eQL.default)(Object.assign({
            maxZoom: this.maxZoom,
            radius: radius
        }, options));
    }
    calculate(input) {
        let changed = false;
        const state = {
            zoom: input.map.getZoom()
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($b0mBv)))(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [
                ...input.markers
            ];
            const points = this.markers.map((marker)=>{
                const position = $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker);
                const coordinates = [
                    position.lng(),
                    position.lat()
                ];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: coordinates
                    },
                    properties: {
                        marker: marker
                    }
                };
            });
            this.superCluster.load(points);
        }
        if (!changed) {
            if (this.state.zoom <= this.maxZoom || state.zoom <= this.maxZoom) changed = !(0, (/*@__PURE__*/$parcel$interopDefault($b0mBv)))(this.state, state);
        }
        this.state = state;
        if (changed) this.clusters = this.cluster(input);
        return {
            clusters: this.clusters,
            changed: changed
        };
    }
    cluster({ map: map }) {
        return this.superCluster.getClusters([
            -180,
            -90,
            180,
            90
        ], Math.round(map.getZoom())).map((feature)=>this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat] }, properties: properties }) {
        if (properties.cluster) return new $b91f9f2fdb98b359$export$57ed47926628b770({
            markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf)=>leaf.properties.marker),
            position: {
                lat: lat,
                lng: lng
            }
        });
        const marker = properties.marker;
        return new $b91f9f2fdb98b359$export$57ed47926628b770({
            markers: [
                marker
            ],
            position: $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker)
        });
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ class $b91f9f2fdb98b359$export$80a71135475bbaa7 extends $b91f9f2fdb98b359$export$d8a438b9a55dba76 {
    constructor(_a){
        var { maxZoom: maxZoom, radius: radius = 60, viewportPadding: viewportPadding = 60 } = _a, options = $b91f9f2fdb98b359$var$__rest(_a, [
            "maxZoom",
            "radius",
            "viewportPadding"
        ]);
        super({
            maxZoom: maxZoom,
            viewportPadding: viewportPadding
        });
        this.superCluster = new (0, $e9eQL.default)(Object.assign({
            maxZoom: this.maxZoom,
            radius: radius
        }, options));
        this.state = {
            zoom: -1,
            view: [
                0,
                0,
                0,
                0
            ]
        };
    }
    calculate(input) {
        const state = {
            zoom: Math.round(input.map.getZoom()),
            view: $b91f9f2fdb98b359$export$6341d7e267bda241(input.map.getBounds(), input.mapCanvasProjection, this.viewportPadding)
        };
        let changed = !(0, (/*@__PURE__*/$parcel$interopDefault($b0mBv)))(this.state, state);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($b0mBv)))(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [
                ...input.markers
            ];
            const points = this.markers.map((marker)=>{
                const position = $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker);
                const coordinates = [
                    position.lng(),
                    position.lat()
                ];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: coordinates
                    },
                    properties: {
                        marker: marker
                    }
                };
            });
            this.superCluster.load(points);
        }
        if (changed) {
            this.clusters = this.cluster(input);
            this.state = state;
        }
        return {
            clusters: this.clusters,
            changed: changed
        };
    }
    cluster({ map: map, mapCanvasProjection: mapCanvasProjection }) {
        /* recalculate new state because we can't use the cached version. */ const state = {
            zoom: Math.round(map.getZoom()),
            view: $b91f9f2fdb98b359$export$6341d7e267bda241(map.getBounds(), mapCanvasProjection, this.viewportPadding)
        };
        return this.superCluster.getClusters(state.view, state.zoom).map((feature)=>this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat] }, properties: properties }) {
        if (properties.cluster) return new $b91f9f2fdb98b359$export$57ed47926628b770({
            markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf)=>leaf.properties.marker),
            position: {
                lat: lat,
                lng: lng
            }
        });
        const marker = properties.marker;
        return new $b91f9f2fdb98b359$export$57ed47926628b770({
            markers: [
                marker
            ],
            position: $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker)
        });
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides statistics on all clusters in the current render cycle for use in {@link Renderer.render}.
 */ class $b91f9f2fdb98b359$export$2deda6e6beba3286 {
    constructor(markers, clusters){
        this.markers = {
            sum: markers.length
        };
        const clusterMarkerCounts = clusters.map((a)=>a.count);
        const clusterMarkerSum = clusterMarkerCounts.reduce((a, b)=>a + b, 0);
        this.clusters = {
            count: clusters.length,
            markers: {
                mean: clusterMarkerSum / clusters.length,
                sum: clusterMarkerSum,
                min: Math.min(...clusterMarkerCounts),
                max: Math.max(...clusterMarkerCounts)
            }
        };
    }
}
class $b91f9f2fdb98b359$export$7db59afbbd5bcace {
    /**
     * The default render function for the library used by {@link MarkerClusterer}.
     *
     * Currently set to use the following:
     *
     * ```typescript
     * // change color if this cluster has more markers than the mean cluster
     * const color =
     *   count > Math.max(10, stats.clusters.markers.mean)
     *     ? "#ff0000"
     *     : "#0000ff";
     *
     * // create svg url with fill color
     * const svg = window.btoa(`
     * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
     *   <circle cx="120" cy="120" opacity=".6" r="70" />
     *   <circle cx="120" cy="120" opacity=".3" r="90" />
     *   <circle cx="120" cy="120" opacity=".2" r="110" />
     *   <circle cx="120" cy="120" opacity=".1" r="130" />
     * </svg>`);
     *
     * // create marker using svg icon
     * return new google.maps.Marker({
     *   position,
     *   icon: {
     *     url: `data:image/svg+xml;base64,${svg}`,
     *     scaledSize: new google.maps.Size(45, 45),
     *   },
     *   label: {
     *     text: String(count),
     *     color: "rgba(255,255,255,0.9)",
     *     fontSize: "12px",
     *   },
     *   // adjust zIndex to be above other markers
     *   zIndex: 1000 + count,
     * });
     * ```
     */ render({ count: count, position: position }, stats, map) {
        // change color if this cluster has more markers than the mean cluster
        const color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
        // create svg literal with fill color
        const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
</svg>`;
        const title = `Cluster of ${count} markers`, // adjust zIndex to be above other markers
        zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
        if ($b91f9f2fdb98b359$export$87c23728007fa1bd.isAdvancedMarkerAvailable(map)) {
            // create cluster SVG element
            const parser = new DOMParser();
            const svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement;
            svgEl.setAttribute("transform", "translate(0 25)");
            const clusterOptions = {
                map: map,
                position: position,
                zIndex: zIndex,
                title: title,
                content: svgEl
            };
            return new google.maps.marker.AdvancedMarkerElement(clusterOptions);
        }
        const clusterOptions = {
            position: position,
            zIndex: zIndex,
            title: title,
            icon: {
                url: `data:image/svg+xml;base64,${btoa(svg)}`,
                anchor: new google.maps.Point(25, 25)
            }
        };
        return new google.maps.Marker(clusterOptions);
    }
}
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Extends an object's prototype by another's.
 *
 * @param type1 The Type to be extended.
 * @param type2 The Type to extend with.
 * @ignore
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b91f9f2fdb98b359$var$extend(type1, type2) {
    /* istanbul ignore next */ // eslint-disable-next-line prefer-const
    for(let property in type2.prototype)type1.prototype[property] = type2.prototype[property];
}
/**
 * @ignore
 */ class $b91f9f2fdb98b359$var$OverlayViewSafe {
    constructor(){
        // MarkerClusterer implements google.maps.OverlayView interface. We use the
        // extend function to extend MarkerClusterer with google.maps.OverlayView
        // because it might not always be available when the code is defined so we
        // look for it at the last possible moment. If it doesn't exist now then
        // there is no point going ahead :)
        $b91f9f2fdb98b359$var$extend($b91f9f2fdb98b359$var$OverlayViewSafe, google.maps.OverlayView);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b91f9f2fdb98b359$export$f87b0506a2cf0bc;
(function(MarkerClustererEvents) {
    MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
    MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
    MarkerClustererEvents["CLUSTER_CLICK"] = "click";
})($b91f9f2fdb98b359$export$f87b0506a2cf0bc || ($b91f9f2fdb98b359$export$f87b0506a2cf0bc = {}));
const $b91f9f2fdb98b359$export$b434dc9855552644 = (_, cluster, map)=>{
    map.fitBounds(cluster.bounds);
};
/**
 * MarkerClusterer creates and manages per-zoom-level clusters for large amounts
 * of markers. See {@link MarkerClustererOptions} for more details.
 *
 */ class $b91f9f2fdb98b359$export$58bd9bb9fcf3dd4f extends $b91f9f2fdb98b359$var$OverlayViewSafe {
    constructor({ map: map, markers: markers = [], algorithmOptions: algorithmOptions = {}, algorithm: algorithm = new $b91f9f2fdb98b359$export$3c4c9430ac0fb1eb(algorithmOptions), renderer: renderer = new $b91f9f2fdb98b359$export$7db59afbbd5bcace(), onClusterClick: onClusterClick = $b91f9f2fdb98b359$export$b434dc9855552644 }){
        super();
        this.markers = [
            ...markers
        ];
        this.clusters = [];
        this.algorithm = algorithm;
        this.renderer = renderer;
        this.onClusterClick = onClusterClick;
        if (map) this.setMap(map);
    }
    addMarker(marker, noDraw) {
        if (this.markers.includes(marker)) return;
        this.markers.push(marker);
        if (!noDraw) this.render();
    }
    addMarkers(markers, noDraw) {
        markers.forEach((marker)=>{
            this.addMarker(marker, true);
        });
        if (!noDraw) this.render();
    }
    removeMarker(marker, noDraw) {
        const index = this.markers.indexOf(marker);
        if (index === -1) // Marker is not in our list of markers, so do nothing:
        return false;
        $b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(marker, null);
        this.markers.splice(index, 1); // Remove the marker from the list of managed markers
        if (!noDraw) this.render();
        return true;
    }
    removeMarkers(markers, noDraw) {
        let removed = false;
        markers.forEach((marker)=>{
            removed = this.removeMarker(marker, true) || removed;
        });
        if (removed && !noDraw) this.render();
        return removed;
    }
    clearMarkers(noDraw) {
        this.markers.length = 0;
        if (!noDraw) this.render();
    }
    /**
     * Recalculates and draws all the marker clusters.
     */ render() {
        const map = this.getMap();
        if (map instanceof google.maps.Map && map.getProjection()) {
            google.maps.event.trigger(this, $b91f9f2fdb98b359$export$f87b0506a2cf0bc.CLUSTERING_BEGIN, this);
            const { clusters: clusters, changed: changed } = this.algorithm.calculate({
                markers: this.markers,
                map: map,
                mapCanvasProjection: this.getProjection()
            });
            // Allow algorithms to return flag on whether the clusters/markers have changed.
            if (changed || changed == undefined) {
                // Accumulate the markers of the clusters composed of a single marker.
                // Those clusters directly use the marker.
                // Clusters with more than one markers use a group marker generated by a renderer.
                const singleMarker = new Set();
                for (const cluster of clusters)if (cluster.markers.length == 1) singleMarker.add(cluster.markers[0]);
                const groupMarkers = [];
                // Iterate the clusters that are currently rendered.
                for (const cluster of this.clusters){
                    if (cluster.marker == null) continue;
                    if (cluster.markers.length == 1) {
                        if (!singleMarker.has(cluster.marker)) // The marker:
                        // - was previously rendered because it is from a cluster with 1 marker,
                        // - should no more be rendered as it is not in singleMarker.
                        $b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(cluster.marker, null);
                    } else // Delay the removal of old group markers to avoid flickering.
                    groupMarkers.push(cluster.marker);
                }
                this.clusters = clusters;
                this.renderClusters();
                // Delayed removal of the markers of the former groups.
                requestAnimationFrame(()=>groupMarkers.forEach((marker)=>$b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(marker, null)));
            }
            google.maps.event.trigger(this, $b91f9f2fdb98b359$export$f87b0506a2cf0bc.CLUSTERING_END, this);
        }
    }
    onAdd() {
        this.idleListener = this.getMap().addListener("idle", this.render.bind(this));
        this.render();
    }
    onRemove() {
        google.maps.event.removeListener(this.idleListener);
        this.reset();
    }
    reset() {
        this.markers.forEach((marker)=>$b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(marker, null));
        this.clusters.forEach((cluster)=>cluster.delete());
        this.clusters = [];
    }
    renderClusters() {
        // Generate stats to pass to renderers.
        const stats = new $b91f9f2fdb98b359$export$2deda6e6beba3286(this.markers, this.clusters);
        const map = this.getMap();
        this.clusters.forEach((cluster)=>{
            if (cluster.markers.length === 1) cluster.marker = cluster.markers[0];
            else {
                // Generate the marker to represent the group.
                cluster.marker = this.renderer.render(cluster, stats, map);
                // Make sure all individual markers are removed from the map.
                cluster.markers.forEach((marker)=>$b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(marker, null));
                if (this.onClusterClick) cluster.marker.addListener("click", /* istanbul ignore next */ (event)=>{
                    google.maps.event.trigger(this, $b91f9f2fdb98b359$export$f87b0506a2cf0bc.CLUSTER_CLICK, cluster);
                    this.onClusterClick(event, cluster, map);
                });
            }
            $b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(cluster.marker, map);
        });
    }
}

});
parcelRegister("b0mBv", function(module, exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("e9eQL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4cd6cdb96430eae$export$2e2bcd8739ae039);

var $gUPtx = parcelRequire("gUPtx");
const $a4cd6cdb96430eae$var$defaultOptions = {
    minZoom: 0,
    maxZoom: 16,
    minPoints: 2,
    radius: 40,
    extent: 512,
    nodeSize: 64,
    log: false,
    // whether to generate numeric ids for input features (in vector tiles)
    generateId: false,
    // a reduce function for calculating custom cluster properties
    reduce: null,
    // properties to use for individual points when running the reducer
    map: (props)=>props // props => ({sum: props.my_value})
};
const $a4cd6cdb96430eae$var$fround = Math.fround || ((tmp)=>(x)=>{
        tmp[0] = +x;
        return tmp[0];
    })(new Float32Array(1));
const $a4cd6cdb96430eae$var$OFFSET_ZOOM = 2;
const $a4cd6cdb96430eae$var$OFFSET_ID = 3;
const $a4cd6cdb96430eae$var$OFFSET_PARENT = 4;
const $a4cd6cdb96430eae$var$OFFSET_NUM = 5;
const $a4cd6cdb96430eae$var$OFFSET_PROP = 6;
class $a4cd6cdb96430eae$export$2e2bcd8739ae039 {
    constructor(options){
        this.options = Object.assign(Object.create($a4cd6cdb96430eae$var$defaultOptions), options);
        this.trees = new Array(this.options.maxZoom + 1);
        this.stride = this.options.reduce ? 7 : 6;
        this.clusterProps = [];
    }
    load(points) {
        const { log: log, minZoom: minZoom, maxZoom: maxZoom } = this.options;
        if (log) console.time("total time");
        const timerId = `prepare ${points.length} points`;
        if (log) console.time(timerId);
        this.points = points;
        // generate a cluster object for each point and index input points into a KD-tree
        const data = [];
        for(let i = 0; i < points.length; i++){
            const p = points[i];
            if (!p.geometry) continue;
            const [lng, lat] = p.geometry.coordinates;
            const x = $a4cd6cdb96430eae$var$fround($a4cd6cdb96430eae$var$lngX(lng));
            const y = $a4cd6cdb96430eae$var$fround($a4cd6cdb96430eae$var$latY(lat));
            // store internal point/cluster data in flat numeric arrays for performance
            data.push(x, y, Infinity, i, -1, 1 // number of points in a cluster
            );
            if (this.options.reduce) data.push(0); // noop
        }
        let tree = this.trees[maxZoom + 1] = this._createTree(data);
        if (log) console.timeEnd(timerId);
        // cluster points on max zoom, then cluster the results on previous zoom, etc.;
        // results in a cluster hierarchy across zoom levels
        for(let z = maxZoom; z >= minZoom; z--){
            const now = +Date.now();
            // create a new set of clusters for the zoom and index them with a KD-tree
            tree = this.trees[z] = this._createTree(this._cluster(tree, z));
            if (log) console.log("z%d: %d clusters in %dms", z, tree.numItems, +Date.now() - now);
        }
        if (log) console.timeEnd("total time");
        return this;
    }
    getClusters(bbox, zoom) {
        let minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
        const minLat = Math.max(-90, Math.min(90, bbox[1]));
        let maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
        const maxLat = Math.max(-90, Math.min(90, bbox[3]));
        if (bbox[2] - bbox[0] >= 360) {
            minLng = -180;
            maxLng = 180;
        } else if (minLng > maxLng) {
            const easternHem = this.getClusters([
                minLng,
                minLat,
                180,
                maxLat
            ], zoom);
            const westernHem = this.getClusters([
                -180,
                minLat,
                maxLng,
                maxLat
            ], zoom);
            return easternHem.concat(westernHem);
        }
        const tree = this.trees[this._limitZoom(zoom)];
        const ids = tree.range($a4cd6cdb96430eae$var$lngX(minLng), $a4cd6cdb96430eae$var$latY(maxLat), $a4cd6cdb96430eae$var$lngX(maxLng), $a4cd6cdb96430eae$var$latY(minLat));
        const data = tree.data;
        const clusters = [];
        for (const id of ids){
            const k = this.stride * id;
            clusters.push(data[k + $a4cd6cdb96430eae$var$OFFSET_NUM] > 1 ? $a4cd6cdb96430eae$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $a4cd6cdb96430eae$var$OFFSET_ID]]);
        }
        return clusters;
    }
    getChildren(clusterId) {
        const originId = this._getOriginId(clusterId);
        const originZoom = this._getOriginZoom(clusterId);
        const errorMsg = "No cluster with the specified id.";
        const tree = this.trees[originZoom];
        if (!tree) throw new Error(errorMsg);
        const data = tree.data;
        if (originId * this.stride >= data.length) throw new Error(errorMsg);
        const r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
        const x = data[originId * this.stride];
        const y = data[originId * this.stride + 1];
        const ids = tree.within(x, y, r);
        const children = [];
        for (const id of ids){
            const k = id * this.stride;
            if (data[k + $a4cd6cdb96430eae$var$OFFSET_PARENT] === clusterId) children.push(data[k + $a4cd6cdb96430eae$var$OFFSET_NUM] > 1 ? $a4cd6cdb96430eae$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $a4cd6cdb96430eae$var$OFFSET_ID]]);
        }
        if (children.length === 0) throw new Error(errorMsg);
        return children;
    }
    getLeaves(clusterId, limit, offset) {
        limit = limit || 10;
        offset = offset || 0;
        const leaves = [];
        this._appendLeaves(leaves, clusterId, limit, offset, 0);
        return leaves;
    }
    getTile(z, x, y) {
        const tree = this.trees[this._limitZoom(z)];
        const z2 = Math.pow(2, z);
        const { extent: extent, radius: radius } = this.options;
        const p = radius / extent;
        const top = (y - p) / z2;
        const bottom = (y + 1 + p) / z2;
        const tile = {
            features: []
        };
        this._addTileFeatures(tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom), tree.data, x, y, z2, tile);
        if (x === 0) this._addTileFeatures(tree.range(1 - p / z2, top, 1, bottom), tree.data, z2, y, z2, tile);
        if (x === z2 - 1) this._addTileFeatures(tree.range(0, top, p / z2, bottom), tree.data, -1, y, z2, tile);
        return tile.features.length ? tile : null;
    }
    getClusterExpansionZoom(clusterId) {
        let expansionZoom = this._getOriginZoom(clusterId) - 1;
        while(expansionZoom <= this.options.maxZoom){
            const children = this.getChildren(clusterId);
            expansionZoom++;
            if (children.length !== 1) break;
            clusterId = children[0].properties.cluster_id;
        }
        return expansionZoom;
    }
    _appendLeaves(result, clusterId, limit, offset, skipped) {
        const children = this.getChildren(clusterId);
        for (const child of children){
            const props = child.properties;
            if (props && props.cluster) {
                if (skipped + props.point_count <= offset) // skip the whole cluster
                skipped += props.point_count;
                else // enter the cluster
                skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
            } else if (skipped < offset) // skip a single point
            skipped++;
            else // add a single point
            result.push(child);
            if (result.length === limit) break;
        }
        return skipped;
    }
    _createTree(data) {
        const tree = new (0, $gUPtx.default)(data.length / this.stride | 0, this.options.nodeSize, Float32Array);
        for(let i = 0; i < data.length; i += this.stride)tree.add(data[i], data[i + 1]);
        tree.finish();
        tree.data = data;
        return tree;
    }
    _addTileFeatures(ids, data, x, y, z2, tile) {
        for (const i of ids){
            const k = i * this.stride;
            const isCluster = data[k + $a4cd6cdb96430eae$var$OFFSET_NUM] > 1;
            let tags, px, py;
            if (isCluster) {
                tags = $a4cd6cdb96430eae$var$getClusterProperties(data, k, this.clusterProps);
                px = data[k];
                py = data[k + 1];
            } else {
                const p = this.points[data[k + $a4cd6cdb96430eae$var$OFFSET_ID]];
                tags = p.properties;
                const [lng, lat] = p.geometry.coordinates;
                px = $a4cd6cdb96430eae$var$lngX(lng);
                py = $a4cd6cdb96430eae$var$latY(lat);
            }
            const f = {
                type: 1,
                geometry: [
                    [
                        Math.round(this.options.extent * (px * z2 - x)),
                        Math.round(this.options.extent * (py * z2 - y))
                    ]
                ],
                tags: tags
            };
            // assign id
            let id;
            if (isCluster || this.options.generateId) // optionally generate id for points
            id = data[k + $a4cd6cdb96430eae$var$OFFSET_ID];
            else // keep id if already assigned
            id = this.points[data[k + $a4cd6cdb96430eae$var$OFFSET_ID]].id;
            if (id !== undefined) f.id = id;
            tile.features.push(f);
        }
    }
    _limitZoom(z) {
        return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
    }
    _cluster(tree, zoom) {
        const { radius: radius, extent: extent, reduce: reduce, minPoints: minPoints } = this.options;
        const r = radius / (extent * Math.pow(2, zoom));
        const data = tree.data;
        const nextData = [];
        const stride = this.stride;
        // loop through each point
        for(let i = 0; i < data.length; i += stride){
            // if we've already visited the point at this zoom level, skip it
            if (data[i + $a4cd6cdb96430eae$var$OFFSET_ZOOM] <= zoom) continue;
            data[i + $a4cd6cdb96430eae$var$OFFSET_ZOOM] = zoom;
            // find all nearby points
            const x = data[i];
            const y = data[i + 1];
            const neighborIds = tree.within(data[i], data[i + 1], r);
            const numPointsOrigin = data[i + $a4cd6cdb96430eae$var$OFFSET_NUM];
            let numPoints = numPointsOrigin;
            // count the number of points in a potential cluster
            for (const neighborId of neighborIds){
                const k = neighborId * stride;
                // filter out neighbors that are already processed
                if (data[k + $a4cd6cdb96430eae$var$OFFSET_ZOOM] > zoom) numPoints += data[k + $a4cd6cdb96430eae$var$OFFSET_NUM];
            }
            // if there were neighbors to merge, and there are enough points to form a cluster
            if (numPoints > numPointsOrigin && numPoints >= minPoints) {
                let wx = x * numPointsOrigin;
                let wy = y * numPointsOrigin;
                let clusterProperties;
                let clusterPropIndex = -1;
                // encode both zoom and point index on which the cluster originated -- offset by total length of features
                const id = ((i / stride | 0) << 5) + (zoom + 1) + this.points.length;
                for (const neighborId of neighborIds){
                    const k = neighborId * stride;
                    if (data[k + $a4cd6cdb96430eae$var$OFFSET_ZOOM] <= zoom) continue;
                    data[k + $a4cd6cdb96430eae$var$OFFSET_ZOOM] = zoom; // save the zoom (so it doesn't get processed twice)
                    const numPoints2 = data[k + $a4cd6cdb96430eae$var$OFFSET_NUM];
                    wx += data[k] * numPoints2; // accumulate coordinates for calculating weighted center
                    wy += data[k + 1] * numPoints2;
                    data[k + $a4cd6cdb96430eae$var$OFFSET_PARENT] = id;
                    if (reduce) {
                        if (!clusterProperties) {
                            clusterProperties = this._map(data, i, true);
                            clusterPropIndex = this.clusterProps.length;
                            this.clusterProps.push(clusterProperties);
                        }
                        reduce(clusterProperties, this._map(data, k));
                    }
                }
                data[i + $a4cd6cdb96430eae$var$OFFSET_PARENT] = id;
                nextData.push(wx / numPoints, wy / numPoints, Infinity, id, -1, numPoints);
                if (reduce) nextData.push(clusterPropIndex);
            } else {
                for(let j = 0; j < stride; j++)nextData.push(data[i + j]);
                if (numPoints > 1) for (const neighborId of neighborIds){
                    const k = neighborId * stride;
                    if (data[k + $a4cd6cdb96430eae$var$OFFSET_ZOOM] <= zoom) continue;
                    data[k + $a4cd6cdb96430eae$var$OFFSET_ZOOM] = zoom;
                    for(let j = 0; j < stride; j++)nextData.push(data[k + j]);
                }
            }
        }
        return nextData;
    }
    // get index of the point from which the cluster originated
    _getOriginId(clusterId) {
        return clusterId - this.points.length >> 5;
    }
    // get zoom of the point from which the cluster originated
    _getOriginZoom(clusterId) {
        return (clusterId - this.points.length) % 32;
    }
    _map(data, i, clone) {
        if (data[i + $a4cd6cdb96430eae$var$OFFSET_NUM] > 1) {
            const props = this.clusterProps[data[i + $a4cd6cdb96430eae$var$OFFSET_PROP]];
            return clone ? Object.assign({}, props) : props;
        }
        const original = this.points[data[i + $a4cd6cdb96430eae$var$OFFSET_ID]].properties;
        const result = this.options.map(original);
        return clone && result === original ? Object.assign({}, result) : result;
    }
}
function $a4cd6cdb96430eae$var$getClusterJSON(data, i, clusterProps) {
    return {
        type: "Feature",
        id: data[i + $a4cd6cdb96430eae$var$OFFSET_ID],
        properties: $a4cd6cdb96430eae$var$getClusterProperties(data, i, clusterProps),
        geometry: {
            type: "Point",
            coordinates: [
                $a4cd6cdb96430eae$var$xLng(data[i]),
                $a4cd6cdb96430eae$var$yLat(data[i + 1])
            ]
        }
    };
}
function $a4cd6cdb96430eae$var$getClusterProperties(data, i, clusterProps) {
    const count = data[i + $a4cd6cdb96430eae$var$OFFSET_NUM];
    const abbrev = count >= 10000 ? `${Math.round(count / 1000)}k` : count >= 1000 ? `${Math.round(count / 100) / 10}k` : count;
    const propIndex = data[i + $a4cd6cdb96430eae$var$OFFSET_PROP];
    const properties = propIndex === -1 ? {} : Object.assign({}, clusterProps[propIndex]);
    return Object.assign(properties, {
        cluster: true,
        cluster_id: data[i + $a4cd6cdb96430eae$var$OFFSET_ID],
        point_count: count,
        point_count_abbreviated: abbrev
    });
}
// longitude/latitude to spherical mercator in [0..1] range
function $a4cd6cdb96430eae$var$lngX(lng) {
    return lng / 360 + 0.5;
}
function $a4cd6cdb96430eae$var$latY(lat) {
    const sin = Math.sin(lat * Math.PI / 180);
    const y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
    return y < 0 ? 0 : y > 1 ? 1 : y;
}
// spherical mercator to longitude/latitude
function $a4cd6cdb96430eae$var$xLng(x) {
    return (x - 0.5) * 360;
}
function $a4cd6cdb96430eae$var$yLat(y) {
    const y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}

});
parcelRegister("gUPtx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c509ce46a93fe9c2$export$2e2bcd8739ae039);
const $c509ce46a93fe9c2$var$ARRAY_TYPES = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
];
/** @typedef {Int8ArrayConstructor | Uint8ArrayConstructor | Uint8ClampedArrayConstructor | Int16ArrayConstructor | Uint16ArrayConstructor | Int32ArrayConstructor | Uint32ArrayConstructor | Float32ArrayConstructor | Float64ArrayConstructor} TypedArrayConstructor */ const $c509ce46a93fe9c2$var$VERSION = 1; // serialized format version
const $c509ce46a93fe9c2$var$HEADER_SIZE = 8;
class $c509ce46a93fe9c2$export$2e2bcd8739ae039 {
    /**
     * Creates an index from raw `ArrayBuffer` data.
     * @param {ArrayBuffer} data
     */ static from(data) {
        if (!(data instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
        const [magic, versionAndType] = new Uint8Array(data, 0, 2);
        if (magic !== 0xdb) throw new Error("Data does not appear to be in a KDBush format.");
        const version = versionAndType >> 4;
        if (version !== $c509ce46a93fe9c2$var$VERSION) throw new Error(`Got v${version} data when expected v${$c509ce46a93fe9c2$var$VERSION}.`);
        const ArrayType = $c509ce46a93fe9c2$var$ARRAY_TYPES[versionAndType & 0x0f];
        if (!ArrayType) throw new Error("Unrecognized array type.");
        const [nodeSize] = new Uint16Array(data, 2, 1);
        const [numItems] = new Uint32Array(data, 4, 1);
        return new $c509ce46a93fe9c2$export$2e2bcd8739ae039(numItems, nodeSize, ArrayType, data);
    }
    /**
     * Creates an index that will hold a given number of items.
     * @param {number} numItems
     * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
     * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
     * @param {ArrayBuffer} [data] (For internal use only)
     */ constructor(numItems, nodeSize = 64, ArrayType = Float64Array, data){
        if (isNaN(numItems) || numItems < 0) throw new Error(`Unpexpected numItems value: ${numItems}.`);
        this.numItems = +numItems;
        this.nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
        this.ArrayType = ArrayType;
        this.IndexArrayType = numItems < 65536 ? Uint16Array : Uint32Array;
        const arrayTypeIndex = $c509ce46a93fe9c2$var$ARRAY_TYPES.indexOf(this.ArrayType);
        const coordsByteSize = numItems * 2 * this.ArrayType.BYTES_PER_ELEMENT;
        const idsByteSize = numItems * this.IndexArrayType.BYTES_PER_ELEMENT;
        const padCoords = (8 - idsByteSize % 8) % 8;
        if (arrayTypeIndex < 0) throw new Error(`Unexpected typed array class: ${ArrayType}.`);
        if (data && data instanceof ArrayBuffer) {
            this.data = data;
            this.ids = new this.IndexArrayType(this.data, $c509ce46a93fe9c2$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $c509ce46a93fe9c2$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = numItems * 2;
            this._finished = true;
        } else {
            this.data = new ArrayBuffer($c509ce46a93fe9c2$var$HEADER_SIZE + coordsByteSize + idsByteSize + padCoords);
            this.ids = new this.IndexArrayType(this.data, $c509ce46a93fe9c2$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $c509ce46a93fe9c2$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = 0;
            this._finished = false;
            // set header
            new Uint8Array(this.data, 0, 2).set([
                0xdb,
                ($c509ce46a93fe9c2$var$VERSION << 4) + arrayTypeIndex
            ]);
            new Uint16Array(this.data, 2, 1)[0] = nodeSize;
            new Uint32Array(this.data, 4, 1)[0] = numItems;
        }
    }
    /**
     * Add a point to the index.
     * @param {number} x
     * @param {number} y
     * @returns {number} An incremental index associated with the added item (starting from `0`).
     */ add(x, y) {
        const index = this._pos >> 1;
        this.ids[index] = index;
        this.coords[this._pos++] = x;
        this.coords[this._pos++] = y;
        return index;
    }
    /**
     * Perform indexing of the added points.
     */ finish() {
        const numAdded = this._pos >> 1;
        if (numAdded !== this.numItems) throw new Error(`Added ${numAdded} items when expected ${this.numItems}.`);
        // kd-sort both arrays for efficient search
        $c509ce46a93fe9c2$var$sort(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0);
        this._finished = true;
        return this;
    }
    /**
     * Search the index for items within a given bounding box.
     * @param {number} minX
     * @param {number} minY
     * @param {number} maxX
     * @param {number} maxY
     * @returns {number[]} An array of indices correponding to the found items.
     */ range(minX, minY, maxX, maxY) {
        if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
        const { ids: ids, coords: coords, nodeSize: nodeSize } = this;
        const stack = [
            0,
            ids.length - 1,
            0
        ];
        const result = [];
        // recursively search for items in range in the kd-sorted arrays
        while(stack.length){
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(let i = left; i <= right; i++){
                    const x = coords[2 * i];
                    const y = coords[2 * i + 1];
                    if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[i]);
                }
                continue;
            }
            // otherwise find the middle index
            const m = left + right >> 1;
            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? minX <= x : minY <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? maxX >= x : maxY >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
    /**
     * Search the index for items within a given radius.
     * @param {number} qx
     * @param {number} qy
     * @param {number} r Query radius.
     * @returns {number[]} An array of indices correponding to the found items.
     */ within(qx, qy, r) {
        if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
        const { ids: ids, coords: coords, nodeSize: nodeSize } = this;
        const stack = [
            0,
            ids.length - 1,
            0
        ];
        const result = [];
        const r2 = r * r;
        // recursively search for items within radius in the kd-sorted arrays
        while(stack.length){
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(let i = left; i <= right; i++)if ($c509ce46a93fe9c2$var$sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
                continue;
            }
            // otherwise find the middle index
            const m = left + right >> 1;
            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if ($c509ce46a93fe9c2$var$sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? qx - r <= x : qy - r <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? qx + r >= x : qy + r >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} nodeSize
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $c509ce46a93fe9c2$var$sort(ids, coords, nodeSize, left, right, axis) {
    if (right - left <= nodeSize) return;
    const m = left + right >> 1; // middle index
    // sort ids and coords around the middle index so that the halves lie
    // either left/right or top/bottom correspondingly (taking turns)
    $c509ce46a93fe9c2$var$select(ids, coords, m, left, right, axis);
    // recursively kd-sort first half and second half on the opposite axis
    $c509ce46a93fe9c2$var$sort(ids, coords, nodeSize, left, m - 1, 1 - axis);
    $c509ce46a93fe9c2$var$sort(ids, coords, nodeSize, m + 1, right, 1 - axis);
}
/**
 * Custom Floyd-Rivest selection algorithm: sort ids and coords so that
 * [left..k-1] items are smaller than k-th item (on either x or y axis)
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} k
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $c509ce46a93fe9c2$var$select(ids, coords, k, left, right, axis) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $c509ce46a93fe9c2$var$select(ids, coords, k, newLeft, newRight, axis);
        }
        const t = coords[2 * k + axis];
        let i = left;
        let j = right;
        $c509ce46a93fe9c2$var$swapItem(ids, coords, left, k);
        if (coords[2 * right + axis] > t) $c509ce46a93fe9c2$var$swapItem(ids, coords, left, right);
        while(i < j){
            $c509ce46a93fe9c2$var$swapItem(ids, coords, i, j);
            i++;
            j--;
            while(coords[2 * i + axis] < t)i++;
            while(coords[2 * j + axis] > t)j--;
        }
        if (coords[2 * left + axis] === t) $c509ce46a93fe9c2$var$swapItem(ids, coords, left, j);
        else {
            j++;
            $c509ce46a93fe9c2$var$swapItem(ids, coords, j, right);
        }
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} i
 * @param {number} j
 */ function $c509ce46a93fe9c2$var$swapItem(ids, coords, i, j) {
    $c509ce46a93fe9c2$var$swap(ids, i, j);
    $c509ce46a93fe9c2$var$swap(coords, 2 * i, 2 * j);
    $c509ce46a93fe9c2$var$swap(coords, 2 * i + 1, 2 * j + 1);
}
/**
 * @param {InstanceType<TypedArrayConstructor>} arr
 * @param {number} i
 * @param {number} j
 */ function $c509ce46a93fe9c2$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
/**
 * @param {number} ax
 * @param {number} ay
 * @param {number} bx
 * @param {number} by
 */ function $c509ce46a93fe9c2$var$sqDist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}

});




parcelRegister("4w9lx", function(module, exports) {

$parcel$export(module.exports, "render", () => $34a1669341b74633$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
function $34a1669341b74633$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", null, [
        (0, $ani5R.renderSlot)(_ctx.$slots, "default")
    ]);
}

});

parcelRegister("hsVOs", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb71e5a080ac3dc4$export$2e2bcd8739ae039);
let $cb71e5a080ac3dc4$var$NOOP = ()=>{};
var $cb71e5a080ac3dc4$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("bpTnL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $84fcfd4833d41ecd$export$2e2bcd8739ae039);

var $1urVZ = parcelRequire("1urVZ");
const $84fcfd4833d41ecd$var$props = {
    options: {
        type: Object,
        required: false,
        default () {
            return {};
        }
    },
    position: {
        type: Object,
        twoWay: true
    },
    zIndex: {
        type: Number,
        twoWay: true
    }
};
const $84fcfd4833d41ecd$var$events = [
    "domready",
    "click",
    "closeclick",
    "content_changed"
];
var $84fcfd4833d41ecd$export$2e2bcd8739ae039 = (0, $1urVZ.default)({
    mappedProps: $84fcfd4833d41ecd$var$props,
    events: $84fcfd4833d41ecd$var$events,
    name: "infoWindow",
    ctr: ()=>google.maps.InfoWindow,
    props: {
        opened: {
            type: Boolean,
            default: true
        }
    },
    inject: {
        $markerPromise: {
            default: null
        }
    },
    mounted () {
        const el = this.$refs.infoWindow;
        el.parentNode.removeChild(el);
    },
    beforeCreate (options) {
        options.content = this.$refs.infoWindow;
        if (this.$markerPromise) {
            delete options.position;
            return this.$markerPromise.then((mo)=>{
                this.$markerObject = mo;
                return mo;
            });
        }
    },
    emits: [
        "closeclick"
    ],
    methods: {
        _openInfoWindow () {
            this.$infoWindowObject.close();
            if (this.opened) this.$infoWindowObject.open(this.$map, this.$markerObject);
            else this.$emit("closeclick");
        }
    },
    afterCreate () {
        this._openInfoWindow();
        this.$watch("opened", ()=>{
            this._openInfoWindow();
        });
    }
});

});

parcelRegister("6fEZy", function(module, exports) {

$parcel$export(module.exports, "render", () => $48d3f0e55a1d56d2$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
const $48d3f0e55a1d56d2$var$_hoisted_1 = {
    ref: "infoWindow"
};
function $48d3f0e55a1d56d2$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $48d3f0e55a1d56d2$var$_hoisted_1, [
        (0, $ani5R.renderSlot)(_ctx.$slots, "default")
    ], 512);
}

});

parcelRegister("27Bgx", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b9246ff6c4fa10$export$2e2bcd8739ae039);
let $18b9246ff6c4fa10$var$NOOP = ()=>{};
var $18b9246ff6c4fa10$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("6CUJS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4d324dde8ae1c98d$export$2e2bcd8739ae039);

var $dNXnK = parcelRequire("dNXnK");

var $jWtid = parcelRequire("jWtid");

var $k22jf = parcelRequire("k22jf");

var $9Voyg = parcelRequire("9Voyg");

var $5aVAo = parcelRequire("5aVAo");

var $1urVZ = parcelRequire("1urVZ");
const $4d324dde8ae1c98d$var$props = {
    center: {
        required: true,
        twoWay: true,
        type: Object,
        noBind: true
    },
    zoom: {
        required: false,
        twoWay: true,
        type: Number,
        noBind: true
    },
    heading: {
        type: Number,
        twoWay: true
    },
    mapTypeId: {
        twoWay: true,
        type: String
    },
    tilt: {
        twoWay: true,
        type: Number
    },
    options: {
        type: Object,
        default () {
            return {};
        }
    }
};
const $4d324dde8ae1c98d$var$events = [
    "bounds_changed",
    "click",
    "dblclick",
    "drag",
    "dragend",
    "dragstart",
    "idle",
    "mousemove",
    "mouseout",
    "mouseover",
    "resize",
    "rightclick",
    "tilesloaded"
];
// Plain Google Maps methods exposed here for convenience
const $4d324dde8ae1c98d$var$linkedMethods = [
    "panBy",
    "panTo",
    "panToBounds",
    "fitBounds"
].reduce((all, methodName)=>{
    all[methodName] = function() {
        if (this.$mapObject) this.$mapObject[methodName].apply(this.$mapObject, arguments);
    };
    return all;
}, {});
// Other convenience methods exposed by Vue Google Maps
const $4d324dde8ae1c98d$var$customMethods = {
    resize () {
        if (this.$mapObject) google.maps.event.trigger(this.$mapObject, "resize");
    },
    resizePreserveCenter () {
        if (!this.$mapObject) return;
        const oldCenter = this.$mapObject.getCenter();
        google.maps.event.trigger(this.$mapObject, "resize");
        this.$mapObject.setCenter(oldCenter);
    },
    /// Override mountableMixin::_resizeCallback
    /// because resizePreserveCenter is usually the
    /// expected behaviour
    _resizeCallback () {
        this.resizePreserveCenter();
    }
};
var $4d324dde8ae1c98d$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $k22jf.default)
    ],
    props: (0, $1urVZ.mappedPropsToVueProps)({
        ...$4d324dde8ae1c98d$var$props,
        ...$4d324dde8ae1c98d$var$events.reduce((obj, eventName)=>({
                ...obj,
                [`on${eventName.charAt(0).toUpperCase()}${eventName.slice(1)}`.replace(/[-_]+(.)?/g, (_, c)=>c ? c.toUpperCase() : "")]: Function
            }), {})
    }),
    inheritAttrs: false,
    provide () {
        this.$mapPromise = new Promise((resolve, reject)=>{
            this.$mapPromiseDeferred = {
                resolve: resolve,
                reject: reject
            };
        });
        return {
            $mapPromise: this.$mapPromise
        };
    },
    emits: [
        "center_changed",
        "zoom_changed",
        "bounds_changed"
    ],
    computed: {
        finalLat () {
            return this.center && typeof this.center.lat === "function" ? this.center.lat() : this.center.lat;
        },
        finalLng () {
            return this.center && typeof this.center.lng === "function" ? this.center.lng() : this.center.lng;
        },
        finalLatLng () {
            return {
                lat: this.finalLat,
                lng: this.finalLng
            };
        }
    },
    watch: {
        zoom (zoom) {
            if (this.$mapObject) this.$mapObject.setZoom(zoom);
        }
    },
    mounted () {
        return this.$gmapApiPromiseLazy().then(()=>{
            // getting the DOM element where to create the map
            const element = this.$refs["vue-map"];
            // creating the map
            const options = {
                ...this.options,
                ...(0, $jWtid.getPropsValues)(this, $4d324dde8ae1c98d$var$props)
            };
            delete options.options;
            this.$mapObject = new google.maps.Map(element, options);
            // binding properties (two and one way)
            (0, $jWtid.bindProps)(this, this.$mapObject, $4d324dde8ae1c98d$var$props);
            // binding events
            (0, $dNXnK.default)(this, this.$mapObject, $4d324dde8ae1c98d$var$events);
            // manually trigger center and zoom
            (0, $9Voyg.default)((increment, decrement, shouldUpdate)=>{
                this.$mapObject.addListener("center_changed", ()=>{
                    if (shouldUpdate()) this.$emit("center_changed", this.$mapObject.getCenter());
                    decrement();
                });
                const updateCenter = ()=>{
                    increment();
                    this.$mapObject.setCenter(this.finalLatLng);
                };
                (0, $5aVAo.default)(this, [
                    "finalLat",
                    "finalLng"
                ], updateCenter);
            });
            this.$mapObject.addListener("zoom_changed", ()=>{
                this.$emit("zoom_changed", this.$mapObject.getZoom());
            });
            this.$mapObject.addListener("bounds_changed", ()=>{
                this.$emit("bounds_changed", this.$mapObject.getBounds());
            });
            this.$mapPromiseDeferred.resolve(this.$mapObject);
            return this.$mapObject;
        }).catch((error)=>{
            throw error;
        });
    },
    methods: {
        ...$4d324dde8ae1c98d$var$customMethods,
        ...$4d324dde8ae1c98d$var$linkedMethods
    }
};

});
parcelRegister("k22jf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e955c92b778e7687$export$2e2bcd8739ae039);
/*
Mixin for objects that are mounted by Google Maps
Javascript API.

These are objects that are sensitive to element resize
operations so it exposes a property which accepts a bus

*/ var $e955c92b778e7687$export$2e2bcd8739ae039 = {
    props: [
        "resizeBus"
    ],
    data () {
        return {
            _actualResizeBus: null
        };
    },
    created () {
        if (typeof this.resizeBus === "undefined") this.$data._actualResizeBus = this.$gmapDefaultResizeBus;
        else this.$data._actualResizeBus = this.resizeBus;
    },
    methods: {
        _resizeCallback () {
            this.resize();
        },
        isFunction (functionToCheck) {
            return functionToCheck && ({}).toString.call(functionToCheck) === "[object Function]";
        },
        _delayedResizeCallback () {
            this.$nextTick(()=>this._resizeCallback());
        }
    },
    watch: {
        resizeBus (newVal) {
            // eslint-disable-line no-unused-vars
            this.$data._actualResizeBus = newVal;
        },
        "$data._actualResizeBus" (newVal, oldVal) {
            if (oldVal) oldVal.$off("resize", this._delayedResizeCallback);
            newVal;
        }
    },
    unmounted () {
        if (this.$data._actualResizeBus && this.isFunction(this.$data._actualResizeBus.$off)) this.$data._actualResizeBus.$off("resize", this._delayedResizeCallback);
    }
};

});

parcelRegister("9Voyg", function(module, exports) {

$parcel$export(module.exports, "default", () => $739c7b5a88f53546$export$2e2bcd8739ae039);
/**
 * When you have two-way bindings, but the actual bound value will not equal
 * the value you initially passed in, then to avoid an infinite loop you
 * need to increment a counter every time you pass in a value, decrement the
 * same counter every time the bound value changed, but only bubble up
 * the event when the counter is zero.
 *
Example:

Let's say DrawingRecognitionCanvas is a deep-learning backed canvas
that, when given the name of an object (e.g. 'dog'), draws a dog.
But whenever the drawing on it changes, it also sends back its interpretation
of the image by way of the @newObjectRecognized event.

<input
  type="text"
  placeholder="an object, e.g. Dog, Cat, Frog"
  v-model="identifiedObject" />
<DrawingRecognitionCanvas
  :object="identifiedObject"
  @newObjectRecognized="identifiedObject = $event"
  />

new TwoWayBindingWrapper((increment, decrement, shouldUpdate) => {
  this.$watch('identifiedObject', () => {
    // new object passed in
    increment()
  })
  this.$deepLearningBackend.on('drawingChanged', () => {
    recognizeObject(this.$deepLearningBackend)
      .then((object) => {
        decrement()
        if (shouldUpdate()) {
          this.$emit('newObjectRecognized', object.name)
        }
      })
  })
})
 */ function $739c7b5a88f53546$export$2e2bcd8739ae039(fn) {
    let counter = 0;
    fn(()=>{
        counter += 1;
    }, ()=>{
        counter = Math.max(0, counter - 1);
    }, ()=>counter === 0);
}

});


parcelRegister("lXrCn", function(module, exports) {

$parcel$export(module.exports, "render", () => $ffc48802cbc780b9$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $3LSrV = parcelRequire("3LSrV");
const $ffc48802cbc780b9$var$_hoisted_1 = {
    class: "vue-map-hidden"
};
function $ffc48802cbc780b9$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        class: (0, $3LSrV.normalizeClass)([
            "vue-map-container",
            _ctx.$attrs.class
        ])
    }, [
        (0, $ani5R.createElementVNode)("div", {
            ref: "vue-map",
            class: "vue-map",
            style: (0, $3LSrV.normalizeStyle)(_ctx.$attrs.style ? _ctx.$attrs.style : "")
        }, null, 4),
        (0, $ani5R.createElementVNode)("div", $ffc48802cbc780b9$var$_hoisted_1, [
            (0, $ani5R.renderSlot)(_ctx.$slots, "default")
        ]),
        (0, $ani5R.renderSlot)(_ctx.$slots, "visible")
    ], 2);
}

});

parcelRegister("5828B", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bbf5ba166313eec$export$2e2bcd8739ae039);
let $3bbf5ba166313eec$var$NOOP = ()=>{};
var $3bbf5ba166313eec$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("ky2Qc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ef592fc2f7c6c56c$export$2e2bcd8739ae039);

var $jWtid = parcelRequire("jWtid");

var $p3ePV = parcelRequire("p3ePV");

var $1urVZ = parcelRequire("1urVZ");
const $ef592fc2f7c6c56c$var$mappedProps = {
    bounds: {
        type: Object
    },
    componentRestrictions: {
        type: Object,
        // Do not bind -- must check for undefined
        // in the property
        noBind: true
    },
    types: {
        type: Array,
        default: function() {
            return [];
        }
    }
};
const $ef592fc2f7c6c56c$var$props = {
    selectFirstOnEnter: {
        required: false,
        type: Boolean,
        default: false
    },
    options: {
        type: Object
    }
};
var $ef592fc2f7c6c56c$export$2e2bcd8739ae039 = {
    mounted () {
        this.$gmapApiPromiseLazy().then(()=>{
            if (this.selectFirstOnEnter) (0, $p3ePV.default)(this.$refs.input);
            if (typeof google.maps.places.Autocomplete !== "function") throw new Error("google.maps.places.Autocomplete is undefined. Did you add 'places' to libraries when loading Google Maps?");
            /* eslint-disable no-unused-vars */ const finalOptions = {
                ...(0, $jWtid.getPropsValues)(this, $ef592fc2f7c6c56c$var$mappedProps),
                ...this.options
            };
            this.$autocomplete = new google.maps.places.Autocomplete(this.$refs.input, finalOptions);
            (0, $jWtid.bindProps)(this, this.$autocomplete, $ef592fc2f7c6c56c$var$mappedProps);
            this.$watch("componentRestrictions", (v)=>{
                if (v !== undefined) this.$autocomplete.setComponentRestrictions(v);
            });
            // Not using `bindEvents` because we also want
            // to return the result of `getPlace()`
            this.$autocomplete.addListener("place_changed", ()=>{
                this.$emit("place_changed", this.$autocomplete.getPlace());
            });
        });
    },
    props: {
        ...(0, $1urVZ.mappedPropsToVueProps)($ef592fc2f7c6c56c$var$mappedProps),
        ...$ef592fc2f7c6c56c$var$props
    }
};

});
parcelRegister("p3ePV", function(module, exports) {

$parcel$export(module.exports, "default", () => $04b4d8f907ead9d3$export$2e2bcd8739ae039);
// This piece of code was orignally written by amirnissim and can be seen here
// http://stackoverflow.com/a/11703018/2694653
// This has been ported to Vanilla.js by GuillaumeLeclerc
var $04b4d8f907ead9d3$export$2e2bcd8739ae039 = (input)=>{
    const _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;
    function addEventListenerWrapper(type, listener) {
        // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
        // and then trigger the original listener.
        if (type === "keydown") {
            const origListener = listener;
            listener = function(event) {
                const suggestionSelected = document.getElementsByClassName("pac-item-selected").length > 0;
                if (event.which === 13 && !suggestionSelected) {
                    const simulatedEvent = document.createEvent("Event");
                    simulatedEvent.keyCode = 40;
                    simulatedEvent.which = 40;
                    origListener.apply(input, [
                        simulatedEvent
                    ]);
                }
                origListener.apply(input, [
                    event
                ]);
            };
        }
        _addEventListener.apply(input, [
            type,
            listener
        ]);
    }
    input.addEventListener = addEventListenerWrapper;
    input.attachEvent = addEventListenerWrapper;
};

});


parcelRegister("f44vf", function(module, exports) {

$parcel$export(module.exports, "render", () => $af7ab8ed8ae61fdf$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
function $af7ab8ed8ae61fdf$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("input", (0, $ani5R.mergeProps)({
        ref: "input"
    }, _ctx.$attrs, (0, $ani5R.toHandlers)(_ctx.$attrs, true)), null, 16);
}

});

parcelRegister("7LMY6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a82e844d0b8824c$export$2e2bcd8739ae039);
let $5a82e844d0b8824c$var$NOOP = ()=>{};
var $5a82e844d0b8824c$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("8vTj4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $632c1eb9876b0be5$export$2e2bcd8739ae039);

var $bpzxk = parcelRequire("bpzxk");
let $632c1eb9876b0be5$var$options = {
    includeScore: true,
    threshold: 0.2,
    includeMatches: true,
    distance: 100,
    keys: [
        "range",
        "name",
        "dimensions",
        "bedrooms"
    ]
};
var // Vue Search
$632c1eb9876b0be5$export$2e2bcd8739ae039 = {
    name: "VueWooSearch",
    data () {
        return {
            searchQuery: "",
            searchIsLoading: true,
            allAttributes: [],
            searchResults: [],
            filteredSearchResults: [],
            fuse: new (0, $bpzxk.default)([], $632c1eb9876b0be5$var$options)
        };
    },
    methods: {
        fetchData: function() {
            fetch(`/wp-json/pemberton/v1/products?per_page=99`).then((response)=>response.json()).then((response)=>{
                this.searchIsLoading = false;
                const data = response;
                data.map((item)=>{
                    this.searchResults.push(item);
                // console.log(item);
                });
                this.fuse.setCollection(this.searchResults);
            });
        },
        filterSearchResults: function(e) {
            searchQuery = e.target.value;
            let filterQuery = this.fuse.search(searchQuery);
            this.filteredSearchResults = filterQuery;
        },
        clearSearchQuery: function(id) {
            this.searchQuery = null;
            this.filteredSearchResults = [];
        }
    },
    mounted () {
        this.fetchData();
    }
};

});
parcelRegister("bpzxk", function(module, exports) {

$parcel$export(module.exports, "default", () => $0224dd4ba904099a$export$2e2bcd8739ae039);
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $0224dd4ba904099a$var$isArray(value) {
    return !Array.isArray ? $0224dd4ba904099a$var$getTag(value) === "[object Array]" : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $0224dd4ba904099a$var$INFINITY = 1 / 0;
function $0224dd4ba904099a$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    let result = value + "";
    return result == "0" && 1 / value == -$0224dd4ba904099a$var$INFINITY ? "-0" : result;
}
function $0224dd4ba904099a$var$toString(value) {
    return value == null ? "" : $0224dd4ba904099a$var$baseToString(value);
}
function $0224dd4ba904099a$var$isString(value) {
    return typeof value === "string";
}
function $0224dd4ba904099a$var$isNumber(value) {
    return typeof value === "number";
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $0224dd4ba904099a$var$isBoolean(value) {
    return value === true || value === false || $0224dd4ba904099a$var$isObjectLike(value) && $0224dd4ba904099a$var$getTag(value) == "[object Boolean]";
}
function $0224dd4ba904099a$var$isObject(value) {
    return typeof value === "object";
}
// Checks if `value` is object-like.
function $0224dd4ba904099a$var$isObjectLike(value) {
    return $0224dd4ba904099a$var$isObject(value) && value !== null;
}
function $0224dd4ba904099a$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $0224dd4ba904099a$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $0224dd4ba904099a$var$getTag(value) {
    return value == null ? value === undefined ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
const $0224dd4ba904099a$var$EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
const $0224dd4ba904099a$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $0224dd4ba904099a$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $0224dd4ba904099a$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $0224dd4ba904099a$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $0224dd4ba904099a$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $0224dd4ba904099a$var$hasOwn = Object.prototype.hasOwnProperty;
class $0224dd4ba904099a$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $0224dd4ba904099a$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $0224dd4ba904099a$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($0224dd4ba904099a$var$isString(key) || $0224dd4ba904099a$var$isArray(key)) {
        src = key;
        path = $0224dd4ba904099a$var$createKeyPath(key);
        id = $0224dd4ba904099a$var$createKeyId(key);
    } else {
        if (!$0224dd4ba904099a$var$hasOwn.call(key, "name")) throw new Error($0224dd4ba904099a$var$MISSING_KEY_PROPERTY("name"));
        const name = key.name;
        src = name;
        if ($0224dd4ba904099a$var$hasOwn.call(key, "weight")) {
            weight = key.weight;
            if (weight <= 0) throw new Error($0224dd4ba904099a$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $0224dd4ba904099a$var$createKeyPath(name);
        id = $0224dd4ba904099a$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $0224dd4ba904099a$var$createKeyPath(key) {
    return $0224dd4ba904099a$var$isArray(key) ? key : key.split(".");
}
function $0224dd4ba904099a$var$createKeyId(key) {
    return $0224dd4ba904099a$var$isArray(key) ? key.join(".") : key;
}
function $0224dd4ba904099a$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$0224dd4ba904099a$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$0224dd4ba904099a$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($0224dd4ba904099a$var$isString(value) || $0224dd4ba904099a$var$isNumber(value) || $0224dd4ba904099a$var$isBoolean(value))) list.push($0224dd4ba904099a$var$toString(value));
            else if ($0224dd4ba904099a$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $0224dd4ba904099a$var$isString(path) ? path.split(".") : path, 0);
    return arr ? list : list[0];
}
const $0224dd4ba904099a$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $0224dd4ba904099a$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $0224dd4ba904099a$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $0224dd4ba904099a$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $0224dd4ba904099a$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $0224dd4ba904099a$var$Config = {
    ...$0224dd4ba904099a$var$BasicOptions,
    ...$0224dd4ba904099a$var$MatchOptions,
    ...$0224dd4ba904099a$var$FuzzyOptions,
    ...$0224dd4ba904099a$var$AdvancedOptions
};
const $0224dd4ba904099a$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $0224dd4ba904099a$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($0224dd4ba904099a$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $0224dd4ba904099a$var$FuseIndex {
    constructor({ getFn: getFn = $0224dd4ba904099a$var$Config.getFn, fieldNormWeight: fieldNormWeight = $0224dd4ba904099a$var$Config.fieldNormWeight } = {}){
        this.norm = $0224dd4ba904099a$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($0224dd4ba904099a$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($0224dd4ba904099a$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$0224dd4ba904099a$var$isDefined(doc) || $0224dd4ba904099a$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$0224dd4ba904099a$var$isDefined(value)) return;
            if ($0224dd4ba904099a$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$0224dd4ba904099a$var$isDefined(value)) continue;
                    if ($0224dd4ba904099a$var$isString(value) && !$0224dd4ba904099a$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($0224dd4ba904099a$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($0224dd4ba904099a$var$isString(value) && !$0224dd4ba904099a$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $0224dd4ba904099a$var$createIndex(keys, docs, { getFn: getFn = $0224dd4ba904099a$var$Config.getFn, fieldNormWeight: fieldNormWeight = $0224dd4ba904099a$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $0224dd4ba904099a$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($0224dd4ba904099a$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $0224dd4ba904099a$var$parseIndex(data, { getFn: getFn = $0224dd4ba904099a$var$Config.getFn, fieldNormWeight: fieldNormWeight = $0224dd4ba904099a$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $0224dd4ba904099a$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $0224dd4ba904099a$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $0224dd4ba904099a$var$Config.distance, ignoreLocation: ignoreLocation = $0224dd4ba904099a$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $0224dd4ba904099a$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $0224dd4ba904099a$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $0224dd4ba904099a$var$MAX_BITS = 32;
function $0224dd4ba904099a$var$search(text, pattern, patternAlphabet, { location: location = $0224dd4ba904099a$var$Config.location, distance: distance = $0224dd4ba904099a$var$Config.distance, threshold: threshold = $0224dd4ba904099a$var$Config.threshold, findAllMatches: findAllMatches = $0224dd4ba904099a$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $0224dd4ba904099a$var$Config.minMatchCharLength, includeMatches: includeMatches = $0224dd4ba904099a$var$Config.includeMatches, ignoreLocation: ignoreLocation = $0224dd4ba904099a$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $0224dd4ba904099a$var$MAX_BITS) throw new Error($0224dd4ba904099a$var$PATTERN_LENGTH_TOO_LARGE($0224dd4ba904099a$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $0224dd4ba904099a$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $0224dd4ba904099a$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $0224dd4ba904099a$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $0224dd4ba904099a$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $0224dd4ba904099a$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $0224dd4ba904099a$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $0224dd4ba904099a$var$BitapSearch {
    constructor(pattern, { location: location = $0224dd4ba904099a$var$Config.location, threshold: threshold = $0224dd4ba904099a$var$Config.threshold, distance: distance = $0224dd4ba904099a$var$Config.distance, includeMatches: includeMatches = $0224dd4ba904099a$var$Config.includeMatches, findAllMatches: findAllMatches = $0224dd4ba904099a$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $0224dd4ba904099a$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $0224dd4ba904099a$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $0224dd4ba904099a$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $0224dd4ba904099a$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $0224dd4ba904099a$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $0224dd4ba904099a$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $0224dd4ba904099a$var$MAX_BITS), i);
                i += $0224dd4ba904099a$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $0224dd4ba904099a$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $0224dd4ba904099a$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $0224dd4ba904099a$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $0224dd4ba904099a$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $0224dd4ba904099a$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $0224dd4ba904099a$var$ExactMatch extends $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "exact";
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $0224dd4ba904099a$var$InverseExactMatch extends $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $0224dd4ba904099a$var$PrefixExactMatch extends $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "prefix-exact";
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $0224dd4ba904099a$var$InversePrefixExactMatch extends $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-prefix-exact";
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $0224dd4ba904099a$var$SuffixExactMatch extends $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "suffix-exact";
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $0224dd4ba904099a$var$InverseSuffixExactMatch extends $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-suffix-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $0224dd4ba904099a$var$FuzzyMatch extends $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern, { location: location = $0224dd4ba904099a$var$Config.location, threshold: threshold = $0224dd4ba904099a$var$Config.threshold, distance: distance = $0224dd4ba904099a$var$Config.distance, includeMatches: includeMatches = $0224dd4ba904099a$var$Config.includeMatches, findAllMatches: findAllMatches = $0224dd4ba904099a$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $0224dd4ba904099a$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $0224dd4ba904099a$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $0224dd4ba904099a$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $0224dd4ba904099a$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return "fuzzy";
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $0224dd4ba904099a$var$IncludeMatch extends $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "include";
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $0224dd4ba904099a$var$searchers = [
    $0224dd4ba904099a$var$ExactMatch,
    $0224dd4ba904099a$var$IncludeMatch,
    $0224dd4ba904099a$var$PrefixExactMatch,
    $0224dd4ba904099a$var$InversePrefixExactMatch,
    $0224dd4ba904099a$var$InverseSuffixExactMatch,
    $0224dd4ba904099a$var$SuffixExactMatch,
    $0224dd4ba904099a$var$InverseExactMatch,
    $0224dd4ba904099a$var$FuzzyMatch
];
const $0224dd4ba904099a$var$searchersLen = $0224dd4ba904099a$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $0224dd4ba904099a$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $0224dd4ba904099a$var$OR_TOKEN = "|";
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $0224dd4ba904099a$var$parseQuery(pattern, options = {}) {
    return pattern.split($0224dd4ba904099a$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($0224dd4ba904099a$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $0224dd4ba904099a$var$searchersLen){
                const searcher = $0224dd4ba904099a$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $0224dd4ba904099a$var$searchersLen){
                const searcher = $0224dd4ba904099a$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $0224dd4ba904099a$var$MultiMatchSet = new Set([
    $0224dd4ba904099a$var$FuzzyMatch.type,
    $0224dd4ba904099a$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $0224dd4ba904099a$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $0224dd4ba904099a$var$Config.isCaseSensitive, includeMatches: includeMatches = $0224dd4ba904099a$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $0224dd4ba904099a$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $0224dd4ba904099a$var$Config.ignoreLocation, findAllMatches: findAllMatches = $0224dd4ba904099a$var$Config.findAllMatches, location: location = $0224dd4ba904099a$var$Config.location, threshold: threshold = $0224dd4ba904099a$var$Config.threshold, distance: distance = $0224dd4ba904099a$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $0224dd4ba904099a$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($0224dd4ba904099a$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $0224dd4ba904099a$var$registeredSearchers = [];
function $0224dd4ba904099a$var$register(...args) {
    $0224dd4ba904099a$var$registeredSearchers.push(...args);
}
function $0224dd4ba904099a$var$createSearcher(pattern, options) {
    for(let i = 0, len = $0224dd4ba904099a$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $0224dd4ba904099a$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $0224dd4ba904099a$var$BitapSearch(pattern, options);
}
const $0224dd4ba904099a$var$LogicalOperator = {
    AND: "$and",
    OR: "$or"
};
const $0224dd4ba904099a$var$KeyType = {
    PATH: "$path",
    PATTERN: "$val"
};
const $0224dd4ba904099a$var$isExpression = (query)=>!!(query[$0224dd4ba904099a$var$LogicalOperator.AND] || query[$0224dd4ba904099a$var$LogicalOperator.OR]);
const $0224dd4ba904099a$var$isPath = (query)=>!!query[$0224dd4ba904099a$var$KeyType.PATH];
const $0224dd4ba904099a$var$isLeaf = (query)=>!$0224dd4ba904099a$var$isArray(query) && $0224dd4ba904099a$var$isObject(query) && !$0224dd4ba904099a$var$isExpression(query);
const $0224dd4ba904099a$var$convertToExplicit = (query)=>({
        [$0224dd4ba904099a$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $0224dd4ba904099a$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $0224dd4ba904099a$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$0224dd4ba904099a$var$isExpression(query)) return next($0224dd4ba904099a$var$convertToExplicit(query));
        if ($0224dd4ba904099a$var$isLeaf(query)) {
            const key = isQueryPath ? query[$0224dd4ba904099a$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$0224dd4ba904099a$var$KeyType.PATTERN] : query[key];
            if (!$0224dd4ba904099a$var$isString(pattern)) throw new Error($0224dd4ba904099a$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $0224dd4ba904099a$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $0224dd4ba904099a$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($0224dd4ba904099a$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$0224dd4ba904099a$var$isExpression(query)) query = $0224dd4ba904099a$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $0224dd4ba904099a$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $0224dd4ba904099a$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $0224dd4ba904099a$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$0224dd4ba904099a$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$0224dd4ba904099a$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $0224dd4ba904099a$var$transformScore(result, data) {
    data.score = result.score;
}
function $0224dd4ba904099a$var$format(results, docs, { includeMatches: includeMatches = $0224dd4ba904099a$var$Config.includeMatches, includeScore: includeScore = $0224dd4ba904099a$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($0224dd4ba904099a$var$transformMatches);
    if (includeScore) transformers.push($0224dd4ba904099a$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $0224dd4ba904099a$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$0224dd4ba904099a$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $0224dd4ba904099a$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $0224dd4ba904099a$var$FuseIndex)) throw new Error($0224dd4ba904099a$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $0224dd4ba904099a$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$0224dd4ba904099a$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $0224dd4ba904099a$var$isString(query) ? $0224dd4ba904099a$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $0224dd4ba904099a$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($0224dd4ba904099a$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $0224dd4ba904099a$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $0224dd4ba904099a$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$0224dd4ba904099a$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $0224dd4ba904099a$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $0224dd4ba904099a$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($0224dd4ba904099a$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $0224dd4ba904099a$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$0224dd4ba904099a$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$0224dd4ba904099a$var$isDefined(value)) return [];
        let matches = [];
        if ($0224dd4ba904099a$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$0224dd4ba904099a$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$0224dd4ba904099a$export$2e2bcd8739ae039.version = "6.6.2";
$0224dd4ba904099a$export$2e2bcd8739ae039.createIndex = $0224dd4ba904099a$var$createIndex;
$0224dd4ba904099a$export$2e2bcd8739ae039.parseIndex = $0224dd4ba904099a$var$parseIndex;
$0224dd4ba904099a$export$2e2bcd8739ae039.config = $0224dd4ba904099a$var$Config;
$0224dd4ba904099a$export$2e2bcd8739ae039.parseQuery = $0224dd4ba904099a$var$parse;
$0224dd4ba904099a$var$register($0224dd4ba904099a$var$ExtendedSearch);

});


parcelRegister("hDUKP", function(module, exports) {

$parcel$export(module.exports, "render", () => $cd821a62e688bf3c$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $dDLnc = parcelRequire("dDLnc");
var $3LSrV = parcelRequire("3LSrV");
const $cd821a62e688bf3c$var$_hoisted_1 = {
    class: "search-wrapper"
};
const $cd821a62e688bf3c$var$_hoisted_2 = [
    "disabled"
];
const $cd821a62e688bf3c$var$_hoisted_3 = {
    key: 0
};
const $cd821a62e688bf3c$var$_hoisted_4 = {
    key: 0,
    class: "loader-wrapper"
};
const $cd821a62e688bf3c$var$_hoisted_5 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("div", {
    class: "loader"
}, null, -1);
const $cd821a62e688bf3c$var$_hoisted_6 = [
    $cd821a62e688bf3c$var$_hoisted_5
];
const $cd821a62e688bf3c$var$_hoisted_7 = {
    class: "searchList"
};
const $cd821a62e688bf3c$var$_hoisted_8 = [
    "href"
];
const $cd821a62e688bf3c$var$_hoisted_9 = {
    key: 0,
    class: "searchList-item-image-wrapper"
};
const $cd821a62e688bf3c$var$_hoisted_10 = [
    "src",
    "alt"
];
const $cd821a62e688bf3c$var$_hoisted_11 = {
    class: "searchList-item-content"
};
const $cd821a62e688bf3c$var$_hoisted_12 = {
    class: "searchList-item-content-inner"
};
const $cd821a62e688bf3c$var$_hoisted_13 = [
    "innerHTML"
];
const $cd821a62e688bf3c$var$_hoisted_14 = {
    class: "searchList-item-subheading"
};
const $cd821a62e688bf3c$var$_hoisted_15 = {
    key: 0,
    class: "searchList-item-subheading-attr dimensions"
};
const $cd821a62e688bf3c$var$_hoisted_16 = {
    key: 1,
    class: "searchList-item-subheading-attr bedrooms"
};
function $cd821a62e688bf3c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, [
        (0, $ani5R.createElementVNode)("div", $cd821a62e688bf3c$var$_hoisted_1, [
            (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                type: "search",
                placeholder: "Search",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>this.searchQuery = $event),
                onKeydown: _cache[1] || (_cache[1] = (0, $dDLnc.withKeys)((...args)=>$options.clearSearchQuery && $options.clearSearchQuery(...args), [
                    "esc"
                ])),
                onKeyup: _cache[2] || (_cache[2] = (...args)=>$options.filterSearchResults && $options.filterSearchResults(...args)),
                disabled: this.searchIsLoading
            }, null, 40, $cd821a62e688bf3c$var$_hoisted_2), [
                [
                    (0, $dDLnc.vModelText),
                    this.searchQuery
                ]
            ]),
            this.searchQuery ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("button", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = (0, $dDLnc.withModifiers)((...args)=>$options.clearSearchQuery && $options.clearSearchQuery(...args), [
                    "prevent"
                ])),
                class: "searchInput-icon clear unstyled-button"
            })) : (0, $ani5R.createCommentVNode)("", true)
        ]),
        $data.filteredSearchResults.length > 0 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $cd821a62e688bf3c$var$_hoisted_3, [
            this.searchIsLoading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $cd821a62e688bf3c$var$_hoisted_4, $cd821a62e688bf3c$var$_hoisted_6)) : (0, $ani5R.createCommentVNode)("", true),
            (0, $ani5R.createElementVNode)("ul", $cd821a62e688bf3c$var$_hoisted_7, [
                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($data.filteredSearchResults, (post, index)=>{
                    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
                        class: "searchList-item",
                        key: post.item.id
                    }, [
                        (0, $ani5R.createElementVNode)("a", {
                            class: "searchList-item-link",
                            href: post.item.term_link
                        }, [
                            post.item.image ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $cd821a62e688bf3c$var$_hoisted_9, [
                                (0, $ani5R.createElementVNode)("img", {
                                    loading: "lazy",
                                    class: "searchList-item-image",
                                    src: post.item.image,
                                    width: "170",
                                    alt: post.item.name
                                }, null, 8, $cd821a62e688bf3c$var$_hoisted_10)
                            ])) : (0, $ani5R.createCommentVNode)("", true),
                            (0, $ani5R.createElementVNode)("div", $cd821a62e688bf3c$var$_hoisted_11, [
                                (0, $ani5R.createElementVNode)("div", $cd821a62e688bf3c$var$_hoisted_12, [
                                    (0, $ani5R.createElementVNode)("h3", {
                                        class: "searchList-item-heading",
                                        innerHTML: post.item.range
                                    }, null, 8, $cd821a62e688bf3c$var$_hoisted_13),
                                    (0, $ani5R.createElementVNode)("div", $cd821a62e688bf3c$var$_hoisted_14, [
                                        post.item.dimensions ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $cd821a62e688bf3c$var$_hoisted_15, " Size: " + (0, $3LSrV.toDisplayString)(post.item.dimensions + " "), 1)) : (0, $ani5R.createCommentVNode)("", true),
                                        post.item.bedrooms ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $cd821a62e688bf3c$var$_hoisted_16, " Bedrooms: " + (0, $3LSrV.toDisplayString)(post.item.bedrooms + " "), 1)) : (0, $ani5R.createCommentVNode)("", true)
                                    ])
                                ])
                            ])
                        ], 8, $cd821a62e688bf3c$var$_hoisted_8)
                    ]);
                }), 128))
            ])
        ])) : (0, $ani5R.createCommentVNode)("", true)
    ], 64);
}

});

parcelRegister("16hh2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cd3c039abc726c6$export$2e2bcd8739ae039);
let $0cd3c039abc726c6$var$NOOP = ()=>{};
var $0cd3c039abc726c6$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("jlDH2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e15ec4b274d60f2e$export$2e2bcd8739ae039);
let $e15ec4b274d60f2e$var$url = new URL(window.location);
let $e15ec4b274d60f2e$var$params = new URLSearchParams($e15ec4b274d60f2e$var$url.search);
let $e15ec4b274d60f2e$var$panelParam = $e15ec4b274d60f2e$var$params.get("panel");
let $e15ec4b274d60f2e$var$rangeParam = $e15ec4b274d60f2e$var$params.get("ranges");
let $e15ec4b274d60f2e$var$modelParam = $e15ec4b274d60f2e$var$params.get("model");
var $e15ec4b274d60f2e$export$2e2bcd8739ae039 = {
    name: "VueWhereToView",
    mounted () {
        this.fetchData();
    },
    data () {
        return {
            isLoading: true,
            allParks: [],
            allRegions: [],
            allRanges: [],
            allModels: [],
            availableParks: [],
            availableModels: [],
            selectedRegion: "All Regions",
            selectedRegionItems: [],
            selectedRange: "Select Range",
            selectedRangeItems: [],
            selectedModel: "Select Model",
            selectedModelItems: [],
            selectedPanel: "region",
            showRegionPanel: true,
            showProductPanel: false,
            openedMarkerID: null,
            icon: {
                url: `/wp-content/themes/pemberton/assets/images/map-pin.png`,
                scaledSize: {
                    height: 50,
                    width: 34
                }
            },
            center: {
                lat: 54.3781,
                lng: -3.75
            }
        };
    },
    methods: {
        fetchData: async function() {
            // Helper function to fetch all paginated data
            const fetchAllPages = async (url, perPage = 100)=>{
                let allData = [];
                let page = 1;
                let data;
                do {
                    const response = await fetch(`${url}?per_page=${perPage}&page=${page}`);
                    data = await response.json();
                    allData = allData.concat(data);
                    page++;
                }while (data.length === perPage); // Continue if we have more pages
                return allData;
            };
            // Fetch regions
            const regions = await fetchAllPages("/wp-json/wp/v2/region", 99);
            regions.forEach((item)=>{
                this.allRegions.push(item);
                this.selectedRegionItems.push(item);
            });
            // Fetch ranges
            const ranges = await fetchAllPages("/wp-json/wp/v2/ranges", 99);
            ranges.forEach((item)=>{
                this.allRanges.push(item);
                this.selectedRangeItems.push(item);
            });
            // Fetch products
            const products = await fetchAllPages("/wp-json/pemberton/v1/products", 100);
            products.forEach((item)=>{
                this.allModels.push(item);
                this.selectedModelItems.push(item);
            });
            // Fetch parks
            const parks = await fetchAllPages("/wp-json/wp/v2/parks", 99);
            parks.forEach((item)=>{
                this.allParks.push(item);
                this.availableParks.push(item);
            });
            // When all data is fetched, handle loading and query string processing
            this.queryStringGetter();
            this.isLoading = false;
        },
        // Shuffle parks
        shuffleArray: function(array) {
            for(var i = array.length - 1; i > 0; i--){
                var j = Math.floor(Math.random() * (i + 1));
                var temp = array[i];
                array[i] = array[j];
                array[j] = temp;
            }
            return array;
        },
        // URL Setter
        queryStringSetter: function(key, value) {
            $e15ec4b274d60f2e$var$params.set(key, value);
            window.history.replaceState({}, "", `${location.pathname}?${$e15ec4b274d60f2e$var$params}`);
        },
        // URL Setter
        queryStringGetter: async function() {
            let regionParam = $e15ec4b274d60f2e$var$params.get("region");
            if ($e15ec4b274d60f2e$var$panelParam) this.selectedPanel = $e15ec4b274d60f2e$var$panelParam;
            if (regionParam) {
                this.selectedRegion = regionParam;
                this.availableParks = this.allParks.filter((item)=>item?.acf?.region?.name === regionParam);
            }
            if ($e15ec4b274d60f2e$var$rangeParam) {
                this.selectedRange = $e15ec4b274d60f2e$var$rangeParam;
                this.availableParks = this.allParks.filter((item)=>item?.acf?.stock?.some((item)=>item?.acf?.range?.name?.includes(this.selectedRange)));
                this.availableModels = this.allModels.filter((item)=>item.range === this.selectedRange);
            }
            if ($e15ec4b274d60f2e$var$modelParam) {
                this.selectedModel = $e15ec4b274d60f2e$var$modelParam;
                this.availableModels = this.allModels.filter((item)=>item.range === this.selectedRange);
                this.availableParks = this.allParks.filter((item)=>item?.acf?.stock?.some((item)=>item.ID === this.selectedModel && (item?.acf?.range?.name === this.selectedRange || this.selectedRange === "Select Range")));
            }
            window.history.replaceState({}, "", `${location.pathname}?${$e15ec4b274d60f2e$var$params}`);
        },
        handleRegionSelect: function(event) {
            event.target.value !== "All Regions" ? this.availableParks = this.allParks.filter((item)=>item?.acf?.region?.name === event.target.value) : this.availableParks = this.allParks;
            this.queryStringSetter("region", event.target.value);
        },
        handleRangeSelect: function(event) {
            if (event.target.value !== "Select Range") {
                this.selectedModel = "Select Model";
                this.availableModels = this.allModels.filter((item)=>item?.range === this.selectedRange);
                this.availableParks = this.allParks.filter((item)=>item?.acf?.stock?.some((item)=>item?.acf?.range?.name?.includes(event.target.value)));
            } else {
                this.availableParks = this.allParks;
                this.availableModels = this.allModels;
            }
            this.queryStringSetter("ranges", event.target.value);
        },
        handleModelSelect: function(event) {
            event.target.value !== "Select Model" ? this.availableParks = this.allParks.filter((item)=>item?.acf?.stock?.some((item)=>item.ID === event.target.value && (item?.acf?.range?.name === this.selectedRange || this.selectedRange === "Select Range"))) : this.availableParks = this.allParks;
            this.queryStringSetter("model", event.target.value);
        },
        handlePanelToggle: function(event) {
            this.selectedPanel = event.target.value;
            this.selectedRegion = "All Regions";
            this.availableParks = this.allParks;
            this.availableModels = this.allModels;
            this.selectedRange = "Select Range";
            this.selectedModel = "Select Model";
            $e15ec4b274d60f2e$var$params.delete("region");
            $e15ec4b274d60f2e$var$params.delete("model");
            $e15ec4b274d60f2e$var$params.delete("ranges");
            this.queryStringSetter("panel", event.target.value);
        },
        openMarker (id) {
            this.openedMarkerID = id;
        }
    }
};

});

parcelRegister("jFcsw", function(module, exports) {

$parcel$export(module.exports, "render", () => $e50b82c47234eec8$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $3LSrV = parcelRequire("3LSrV");
var $dDLnc = parcelRequire("dDLnc");
const $e50b82c47234eec8$var$_hoisted_1 = {
    class: "section-wrapper background-grey"
};
const $e50b82c47234eec8$var$_hoisted_2 = {
    key: 0,
    class: "loader-wrapper"
};
const $e50b82c47234eec8$var$_hoisted_3 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("div", {
    class: "loader"
}, null, -1);
const $e50b82c47234eec8$var$_hoisted_4 = [
    $e50b82c47234eec8$var$_hoisted_3
];
const $e50b82c47234eec8$var$_hoisted_5 = {
    key: 1
};
const $e50b82c47234eec8$var$_hoisted_6 = {
    class: "button-wrapper centered tabs"
};
const $e50b82c47234eec8$var$_hoisted_7 = {
    class: "tabs-select-wrapper"
};
const $e50b82c47234eec8$var$_hoisted_8 = {
    class: "tabs-select"
};
const $e50b82c47234eec8$var$_hoisted_9 = {
    class: "select-wrapper"
};
const $e50b82c47234eec8$var$_hoisted_10 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("option", {
    value: "All Regions",
    selected: ""
}, "All Regions", -1);
const $e50b82c47234eec8$var$_hoisted_11 = [
    "value"
];
const $e50b82c47234eec8$var$_hoisted_12 = {
    class: "tabs-select"
};
const $e50b82c47234eec8$var$_hoisted_13 = {
    class: "select-wrapper"
};
const $e50b82c47234eec8$var$_hoisted_14 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("option", {
    value: "Select Range",
    selected: "",
    disabled: ""
}, "Select Range", -1);
const $e50b82c47234eec8$var$_hoisted_15 = [
    "value"
];
const $e50b82c47234eec8$var$_hoisted_16 = {
    class: "select-wrapper"
};
const $e50b82c47234eec8$var$_hoisted_17 = [
    "disabled"
];
const $e50b82c47234eec8$var$_hoisted_18 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("option", {
    value: "Select Model",
    selected: "",
    disabled: ""
}, "Select Model", -1);
const $e50b82c47234eec8$var$_hoisted_19 = [
    "value"
];
const $e50b82c47234eec8$var$_hoisted_20 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("a", {
    href: "#results",
    class: "read-more-link"
}, "View your results below", -1);
const $e50b82c47234eec8$var$_hoisted_21 = {
    style: {
        "max-width": "10rem",
        "line-height": "1.75"
    }
};
const $e50b82c47234eec8$var$_hoisted_22 = [
    "innerHTML"
];
const $e50b82c47234eec8$var$_hoisted_23 = {
    id: "results"
};
const $e50b82c47234eec8$var$_hoisted_24 = {
    class: "section-header-inline<?php if($first_subheading || $second_subheading || $heading) { echo ' divider';}?>"
};
const $e50b82c47234eec8$var$_hoisted_25 = {
    class: "section-header-content"
};
const $e50b82c47234eec8$var$_hoisted_26 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("p", {
    class: "section-subheading"
}, "Your results", -1);
const $e50b82c47234eec8$var$_hoisted_27 = {
    class: "section-heading"
};
const $e50b82c47234eec8$var$_hoisted_28 = {
    class: "cardList"
};
const $e50b82c47234eec8$var$_hoisted_29 = {
    class: "cardList-item-inner"
};
const $e50b82c47234eec8$var$_hoisted_30 = {
    class: "cardList-item-content-wrapper"
};
const $e50b82c47234eec8$var$_hoisted_31 = [
    "href"
];
const $e50b82c47234eec8$var$_hoisted_32 = {
    class: "cardList-item-image-wrapper"
};
const $e50b82c47234eec8$var$_hoisted_33 = [
    "src"
];
const $e50b82c47234eec8$var$_hoisted_34 = {
    class: "cardList-item-content"
};
const $e50b82c47234eec8$var$_hoisted_35 = [
    "href",
    "innerHTML"
];
const $e50b82c47234eec8$var$_hoisted_36 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("strong", null, "LOCATION:", -1);
const $e50b82c47234eec8$var$_hoisted_37 = [
    "href"
];
const $e50b82c47234eec8$var$_hoisted_38 = {
    key: 0,
    class: "cardList-item-stock"
};
const $e50b82c47234eec8$var$_hoisted_39 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("h3", null, "Models available to view:", -1);
const $e50b82c47234eec8$var$_hoisted_40 = {
    class: "unstyled-list check-list"
};
const $e50b82c47234eec8$var$_hoisted_41 = {
    class: "button-wrapper"
};
const $e50b82c47234eec8$var$_hoisted_42 = [
    "href"
];
function $e50b82c47234eec8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_GMapInfoWindow = (0, $ani5R.resolveComponent)("GMapInfoWindow");
    const _component_GMapMarker = (0, $ani5R.resolveComponent)("GMapMarker");
    const _component_GMapMap = (0, $ani5R.resolveComponent)("GMapMap");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $e50b82c47234eec8$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("section", null, [
            $data.isLoading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $e50b82c47234eec8$var$_hoisted_2, $e50b82c47234eec8$var$_hoisted_4)) : (0, $ani5R.createCommentVNode)("", true),
            !$data.isLoading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $e50b82c47234eec8$var$_hoisted_5, [
                (0, $ani5R.createElementVNode)("div", $e50b82c47234eec8$var$_hoisted_6, [
                    (0, $ani5R.createElementVNode)("button", {
                        onClick: _cache[0] || (_cache[0] = (...args)=>this.handlePanelToggle && this.handlePanelToggle(...args)),
                        value: "region",
                        class: (0, $3LSrV.normalizeClass)(this.selectedPanel == "region" ? "button flag is-active" : "button flag")
                    }, "Find your Park", 2),
                    (0, $ani5R.createElementVNode)("button", {
                        onClick: _cache[1] || (_cache[1] = (...args)=>this.handlePanelToggle && this.handlePanelToggle(...args)),
                        value: "model",
                        class: (0, $3LSrV.normalizeClass)(this.selectedPanel == "model" ? "button flag is-active" : "button flag")
                    }, "Find by Model", 2)
                ]),
                (0, $ani5R.createElementVNode)("div", $e50b82c47234eec8$var$_hoisted_7, [
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", $e50b82c47234eec8$var$_hoisted_8, [
                        (0, $ani5R.createElementVNode)("div", $e50b82c47234eec8$var$_hoisted_9, [
                            (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("select", {
                                onChange: _cache[2] || (_cache[2] = (...args)=>this.handleRegionSelect && this.handleRegionSelect(...args)),
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>this.selectedRegion = $event)
                            }, [
                                $e50b82c47234eec8$var$_hoisted_10,
                                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($data.allRegions, (region, index)=>{
                                    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("option", {
                                        key: region.id,
                                        value: region.name
                                    }, (0, $3LSrV.toDisplayString)(region.name), 9, $e50b82c47234eec8$var$_hoisted_11);
                                }), 128))
                            ], 544), [
                                [
                                    (0, $dDLnc.vModelSelect),
                                    this.selectedRegion
                                ]
                            ])
                        ])
                    ], 512), [
                        [
                            (0, $dDLnc.vShow),
                            this.selectedPanel == "region"
                        ]
                    ]),
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", $e50b82c47234eec8$var$_hoisted_12, [
                        (0, $ani5R.createElementVNode)("div", $e50b82c47234eec8$var$_hoisted_13, [
                            (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("select", {
                                onChange: _cache[4] || (_cache[4] = (...args)=>this.handleRangeSelect && this.handleRangeSelect(...args)),
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>this.selectedRange = $event)
                            }, [
                                $e50b82c47234eec8$var$_hoisted_14,
                                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($data.allRanges, (range, index)=>{
                                    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("option", {
                                        key: range.id,
                                        value: range.name
                                    }, (0, $3LSrV.toDisplayString)(range.name), 9, $e50b82c47234eec8$var$_hoisted_15);
                                }), 128))
                            ], 544), [
                                [
                                    (0, $dDLnc.vModelSelect),
                                    this.selectedRange
                                ]
                            ])
                        ]),
                        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", $e50b82c47234eec8$var$_hoisted_16, [
                            (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("select", {
                                onChange: _cache[6] || (_cache[6] = (...args)=>this.handleModelSelect && this.handleModelSelect(...args)),
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>this.selectedModel = $event),
                                disabled: this.selectedRange == "Select Range"
                            }, [
                                $e50b82c47234eec8$var$_hoisted_18,
                                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($data.availableModels, (model, index)=>{
                                    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("option", {
                                        key: model.id,
                                        value: model.id
                                    }, (0, $3LSrV.toDisplayString)(model.range + " - " + model.name), 9, $e50b82c47234eec8$var$_hoisted_19);
                                }), 128))
                            ], 40, $e50b82c47234eec8$var$_hoisted_17), [
                                [
                                    (0, $dDLnc.vModelSelect),
                                    this.selectedModel
                                ]
                            ])
                        ], 512), [
                            [
                                (0, $dDLnc.vShow),
                                this.selectedPanel == "model"
                            ]
                        ])
                    ], 512), [
                        [
                            (0, $dDLnc.vShow),
                            this.selectedPanel == "model"
                        ]
                    ]),
                    $e50b82c47234eec8$var$_hoisted_20
                ]),
                (0, $ani5R.createVNode)(_component_GMapMap, {
                    center: $data.center,
                    zoom: 5.5,
                    "map-type-id": "roadmap",
                    style: {
                        "width": "100%",
                        "margin": "1rem 0",
                        "height": "35rem"
                    }
                }, {
                    default: (0, $ani5R.withCtx)(()=>[
                            ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($data.availableParks, (park, index)=>{
                                return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_GMapMarker, {
                                    key: index,
                                    position: {
                                        lat: parseFloat(park.acf.lat),
                                        lng: parseFloat(park.acf.lng)
                                    },
                                    icon: {
                                        url: $data.icon.url,
                                        scaledSize: $data.icon.scaledSize
                                    },
                                    clickable: true,
                                    draggable: false,
                                    onClick: ($event)=>$options.openMarker(park.id)
                                }, {
                                    default: (0, $ani5R.withCtx)(()=>[
                                            (0, $ani5R.createVNode)(_component_GMapInfoWindow, {
                                                closeclick: true,
                                                opened: $data.openedMarkerID === park.id
                                            }, {
                                                default: (0, $ani5R.withCtx)(()=>[
                                                        (0, $ani5R.createElementVNode)("div", $e50b82c47234eec8$var$_hoisted_21, [
                                                            (0, $ani5R.createElementVNode)("h3", {
                                                                style: {
                                                                    "margin": "0 0 .5rem 0"
                                                                },
                                                                innerHTML: park.title.rendered
                                                            }, null, 8, $e50b82c47234eec8$var$_hoisted_22),
                                                            (0, $ani5R.createTextVNode)(" " + (0, $3LSrV.toDisplayString)(park.acf.address), 1)
                                                        ])
                                                    ]),
                                                _: 2
                                            }, 1032, [
                                                "opened"
                                            ])
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "position",
                                    "icon",
                                    "onClick"
                                ]);
                            }), 128))
                        ]),
                    _: 1
                }, 8, [
                    "center"
                ]),
                (0, $ani5R.createElementVNode)("div", $e50b82c47234eec8$var$_hoisted_23, [
                    (0, $ani5R.createElementVNode)("div", $e50b82c47234eec8$var$_hoisted_24, [
                        (0, $ani5R.createElementVNode)("div", $e50b82c47234eec8$var$_hoisted_25, [
                            $e50b82c47234eec8$var$_hoisted_26,
                            (0, $ani5R.createElementVNode)("h2", $e50b82c47234eec8$var$_hoisted_27, (0, $3LSrV.toDisplayString)($data.availableParks.length) + " parks", 1)
                        ])
                    ]),
                    (0, $ani5R.createElementVNode)("ul", $e50b82c47234eec8$var$_hoisted_28, [
                        ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($data.availableParks, (park, index)=>{
                            return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
                                class: "cardList-item park",
                                key: park.id
                            }, [
                                (0, $ani5R.createElementVNode)("div", $e50b82c47234eec8$var$_hoisted_29, [
                                    (0, $ani5R.createElementVNode)("div", $e50b82c47234eec8$var$_hoisted_30, [
                                        (0, $ani5R.createElementVNode)("div", null, [
                                            park.acf?.gallery ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                                                key: 0,
                                                href: park.link,
                                                class: "cardList-item-image-link"
                                            }, [
                                                (0, $ani5R.createElementVNode)("div", $e50b82c47234eec8$var$_hoisted_32, [
                                                    (0, $ani5R.createElementVNode)("img", {
                                                        class: "cardList-item-image",
                                                        src: park.acf.gallery[0]?.sizes.medium_large
                                                    }, null, 8, $e50b82c47234eec8$var$_hoisted_33)
                                                ])
                                            ], 8, $e50b82c47234eec8$var$_hoisted_31)) : (0, $ani5R.createCommentVNode)("", true),
                                            (0, $ani5R.createElementVNode)("div", $e50b82c47234eec8$var$_hoisted_34, [
                                                (0, $ani5R.createElementVNode)("h2", null, [
                                                    (0, $ani5R.createElementVNode)("a", {
                                                        href: park.link,
                                                        innerHTML: park.title.rendered
                                                    }, null, 8, $e50b82c47234eec8$var$_hoisted_35)
                                                ]),
                                                (0, $ani5R.createElementVNode)("p", null, [
                                                    $e50b82c47234eec8$var$_hoisted_36,
                                                    (0, $ani5R.createTextVNode)(" " + (0, $3LSrV.toDisplayString)(park.acf.address) + " ", 1),
                                                    (0, $ani5R.createElementVNode)("a", {
                                                        class: "read-more-link",
                                                        href: park.link
                                                    }, "About this park", 8, $e50b82c47234eec8$var$_hoisted_37)
                                                ]),
                                                park.acf.stock ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $e50b82c47234eec8$var$_hoisted_38, [
                                                    $e50b82c47234eec8$var$_hoisted_39,
                                                    (0, $ani5R.createElementVNode)("ul", $e50b82c47234eec8$var$_hoisted_40, [
                                                        ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(park.acf.stock, (stock, index)=>{
                                                            return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
                                                                class: "checklist-item",
                                                                key: stock.id
                                                            }, (0, $3LSrV.toDisplayString)(stock.acf?.year?.name ? stock.acf?.year?.name + ", " : "") + " " + (0, $3LSrV.toDisplayString)(stock.post_title ? stock.post_title + ", " : "") + " ", 1);
                                                        }), 128))
                                                    ])
                                                ])) : (0, $ani5R.createCommentVNode)("", true)
                                            ])
                                        ]),
                                        (0, $ani5R.createElementVNode)("div", $e50b82c47234eec8$var$_hoisted_41, [
                                            (0, $ani5R.createElementVNode)("a", {
                                                href: park.link,
                                                class: "button"
                                            }, "More info", 8, $e50b82c47234eec8$var$_hoisted_42)
                                        ])
                                    ])
                                ])
                            ]);
                        }), 128))
                    ])
                ])
            ])) : (0, $ani5R.createCommentVNode)("", true)
        ])
    ]);
}

});

parcelRegister("dt9Bz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ce56f202e0215f7$export$2e2bcd8739ae039);
let $9ce56f202e0215f7$var$NOOP = ()=>{};
var $9ce56f202e0215f7$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("adWSZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7718cbc7d94ff89a$export$2e2bcd8739ae039);

var $3I1WV = parcelRequire("3I1WV");

var $c83FD = parcelRequire("c83FD");
var $7718cbc7d94ff89a$export$2e2bcd8739ae039 = {
    name: "VueSalesManagerMap",
    components: {
        SVGMap: $c83FD.default
    },
    mounted () {
        this.fetchRegions();
    },
    data () {
        return {
            store: $3I1WV.store,
            regionsLoading: true,
            allRegions: []
        };
    },
    methods: {
        fetchRegions: async function() {
            fetch(`/wp-json/wp/v2/region?per_page=100`).then((response)=>response.json()).then((response)=>{
                this.regionsLoading = false;
                const data = response;
                data.map((item)=>{
                    this.allRegions.push(item);
                });
            });
        },
        // URL Setter
        queryStringSetter: function(key, value) {
            let url = new URL(window.location);
            let params = new URLSearchParams(url.search);
            params.set(key, value);
            window.history.replaceState({}, "", `${location.pathname}?${params}`);
        }
    }
};

});
parcelRegister("3I1WV", function(module, exports) {

$parcel$export(module.exports, "store", () => $2b36fe41c7ae1d47$export$6f57813fe9f31bf9);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
const $2b36fe41c7ae1d47$export$6f57813fe9f31bf9 = (0, $8bTPG.reactive)({
    selectedRegionPath: ""
});

});

parcelRegister("c83FD", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d4914484027b234$export$2e2bcd8739ae039);
let $8d4914484027b234$var$script;



let $8d4914484027b234$var$initialize = ()=>{
    $8d4914484027b234$var$script = (parcelRequire("dZkVt"));
    if ($8d4914484027b234$var$script.__esModule) $8d4914484027b234$var$script = $8d4914484027b234$var$script.default;
    $8d4914484027b234$var$script.render = (parcelRequire("90new")).render;
    (parcelRequire("ffsih")).default($8d4914484027b234$var$script);
    $8d4914484027b234$var$script.__scopeId = "data-v-2bcf2f";
    $8d4914484027b234$var$script.__file = "SVGMap.vue";
};
$8d4914484027b234$var$initialize();
var $8d4914484027b234$export$2e2bcd8739ae039 = $8d4914484027b234$var$script;

});
parcelRegister("dZkVt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a2f1345a874dcb33$export$2e2bcd8739ae039);

var $3I1WV = parcelRequire("3I1WV");
var $a2f1345a874dcb33$export$2e2bcd8739ae039 = {
    data () {
        return {
            store: $3I1WV.store
        };
    },
    methods: {
        handleRegionSelect: function(region) {
            (0, $3I1WV.store).selectedRegionPath = region;
        }
    }
};

});

parcelRegister("90new", function(module, exports) {

$parcel$export(module.exports, "render", () => $68e622ca3afa7a21$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $3LSrV = parcelRequire("3LSrV");
const $68e622ca3afa7a21$var$_hoisted_1 = {
    id: "svgMap",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 674 805",
    fill: "none"
};
const $68e622ca3afa7a21$var$_hoisted_2 = /*#__PURE__*/ (0, $ani5R.createStaticVNode)('<g id="Group_2" data-name="Group 2"><path id="Vector_3" data-name="Vector 3" fill="#b2b2b2" stroke-width="0" d="M42.3,366.5c.8,0,.9-1,1-2.4.2-1.3.3-2.4-.5-2.4s-1.5.9-1.7,2.2c-.2,1.3.4,2.5,1.1,2.6h.1Z"></path></g><g id="Group_3" data-name="Group 3"><path id="Vector_5" data-name="Vector 5" fill="#b2b2b2" stroke-width="0" d="M114.6,350.6c-1.2-1-6,1.6-6.4,3.2-1.2,4.3,3.1,2.9,5.6,3.3s.5.6.2.9c-.8.5-.8,1.2-1,1.9s-.9.4-.9-.2c0-1.2-.2-2.7-1.6-1.7-.4.3-1.1,2.8-1,3.6.2,1.9,1.2,1.1,1.5,2.7,1.3,5.6-2.9-2.6-5.4-3.4-2.4-.8-4,.4-6.2-.5-2.5-1-3.3-3.7-6.5-3.4-3.6.3-2.3,2-3.7,4.6-1,1.9-3,2.8-3.6,5.3-.6-1.1.9-2,.6-3-.4-1.1-1-1.2-1.5-2.2-.3-.6.4-1.7,0-2.4-.2-.2-.6,0-1.2,0s-.8-.3-.5-.7c2.1-3.2-1.2-6-5.1-7h-.2c-.6.2-1.1.3-1.7.5,0,0-4.9-1.2-5.4-1.3-1.9-.6-4.4-.2-6.3-.7-1.6-.4-9.2-5.7-10.1-1.1-.5,2.6,6.8,2.8.6,3.7-1.7.2-2.3.4-4.1-.9-2.4-1.7-2.1-4.8-6-.7-1.7,1.8-1.5,3.6-2.1,5.9-.4,1.7-.7,1-.9,3.1-.1,1.3,1.1,2.3,3.5,1,.5-.3.7-1.5,1.1-2.1.5-.8.2-1,1.2-1,.6,0,1.2.8,1.8,1.4.2.2.2.6-.1.7-.7.3.5,2,.3,2.5-.2.4.2,1.4,0,1.9s-1.1.2-1.3.6c-.4.8-3,3.4.2,4,.5,0,.9-.1,1.3-.5s1,.1.7.6c-1,1.6-2.1,3.3-1.9,3.9.6,1.5,2.4-.5,3.3,1.8s-.1.6-.4.6c-1.2,0-2.5,1.3-3.1,2.7,0-.3.2-.6.1-.7,0-2.2,0-2.1-.8-1.9s-1.1-.5-.8-1.1c.8-1.6,1.6-3.1,0-4.7,0,0-2.8-.9-3.4-1.1h-.3c-.9.2-5.2,0-5.5,0-1,.2-4.4,2.9-4.1,3.8.8,1.9,4,.5,5.4.9,3.5,1,1.2,1.1,2.1,3.9.2.5,3,4.1,4.5,5.7s1.1.3,1.3-.3.6-1.8.8-2.7h0c-.2,1.6.5,3,2.5,3.2,2.5.3,4.7-.4,7.3,0,2.1.4,7.1,0,6.7,1.3-.6.8-1.1,1.7-1.4,2.5s-2.4.3-2.4,1.3c0,.2,2.2,2.4,2,3.1-.4,1.1-3-.7-4-1s-.3,0-.4,0c-.3.2-.5.3-.8.4-.8.4-1.8.3-2.4-.4s-.5-.5-.7-.7c0,0-.2-.2-.3-.2-5,0-7.1,1.2-8.2,6.5-.4,1.9-.3,7.1-3.1,7.7-1.1.2-2.6-2.7-3.9-1.8-2.2,1.4,3.9,5.6,1.4,5.7-.4,0-7.3-2.3-7.6-2.4-1.7-.9-3.5.7-3,2.3.7,2.8,6,3.5,6.7,5.4-.5.1-5.1,1.6-5.2,2-.2.6-3.8,3.3-.3,4.3h3.2c.2,0,.3,0,.4.2.5.6.3,1.9,1,2.4,1.3.9,3.8,2.3,5.2,1,.3-.3,1.1-5.6,2.3-2.9.4.9-2.7,1-1.2,2.6,1,1.1,4.7-2,4.4,0-.2,2-6.7,1.4-4.7,5.9.4.8,2,1.8,2.4,2.1.7.5,2.5.7,3.4.5,1.2-.3,6.2-6.4,6.3-6.4,1.4,1-2.3,1.9-.6,3.2,1,.8,2.7-1.7,3.9-.9.6.6-2.7,5.2-2.7,5.9v.2c-.4,1-1,3.6.3,4,1.4.5,1.4-1,1.8-2s.7-.4.8,0c1.8,3.7,3.7,2.5,7.6,2.5,4.6,0,9.4,1.1,13.9,1,1.5,0,2.5-1.2,3.5-.1,1,1-.9,2-.7,2.4.9,2.1,1.5,1.3,2.9,2.1.2-.6-.1,3.3-.2,3.3-.6.2-1-2.2-1.7-2.4-.8-.2-3.3.2-3.9.5-2.2,1.2-1.2,1.5-.9,2.5s-.1.6-.4.6c-.7,0-1.4.1-2.1.2s-.3,0-.4-.2c-.4-.6-.8-1.2-1.2-1.7h-.1c-2-1.1-4.4-1.7-6.3-.4-.4.3-1.4,2.2-1.8,2.7-1.2,1.5-3,2.9-4.1,4.7-.9,1.5-1.4,2.1-2.4,3.2-1.1,1.3,0-.1-1.2,1.9-2.1,3.6.2,3,3.6,2.6.4,0,.7.4.4.7-.9,1.2-2.6,1.7-3.5,3.1-1.3,2.1-2,3.6-3.6,5.6-.7.9-.7,2.3-1.6,2.9-1.4,1-3.3.1-4.8,1-1.3.8-2.2,2.5-3.3,3.4-.7.6-2.8,1.7-3.6,2.3-1.5,1-2.9,2.6-4.4,3.5s-3.1.6-4.4,1.9c-4.4,4.4,1.5,2.5,4,1.8,1.3-.4,3.2,0,4.3-.4,1.4-.5,5.2-2.2,6.1-2.5,0,0,1.9-1.4,2.4-2.4,0-.1.2-.2.4-.3.4,0,.7,0,.8.1,1.3,1.1-1.2,4.1.2,5.2,1,.8.9-1.8,1.3-1.9.4,0,3.6,2,4.8,2,.5,0,5.5-1.8,5.7-.8.3,1.2-5,1.4-4.2,3.8,1,2.9,4.8-1.2,5.8-1.5,1.9-.5,3.1.2,4.8-1,1.5-1.1,1.9-3.4,3.2-4.6,1.2-1.1,3.2-.8,4-2.4.3-.6-3.4-.5-.8-2.8,2.4-2.1,3.7.2,3.7,2.4,0,1.4-1.8,1.6-1.1,3,.5,1,1.7-.2,2.2,0,1.3.5,5.3.6,7.5,1.4s.4.9-.1.9c-1.3,0-2.4.5-3.7.4-1,0-1.9-1-3.1-.9-2.6.2-4,1.9-6,2.5-.5.2-1.5,0-2.1.3-1.3.6-1,1.3-1.7,1.7-1.8.8-9.9,2.4-11.3,2.1-1.4-.3-2.3-2.3-3.6-2.4-.7,0-1.5.4-2.2.4-.2,0-.3.1-.4.2-.4.8-1.4,0-1.4,0-.6-.6-1.3-1-2.2-1.1,0,0-5-1.6-6.7.4-.9,1-1.4,2.9-.8,4.2s-.1.6-.4.6c-2-.1-4.1,1.6-6.2,1.7-1.2,0-5.2-2-6-1-1.7,2.1,1.8,2.7,2.7,3.8,1.5,2,.8,3.8.3,6.4s-.4.5-.7.3c-.5-.3-.7-.9-1.1,0-.2.5.5,1.4.4,1.7-1,1.6.3,1.6-1.8,2.3-.8.3-3.7-.1-4.4-.8-1.5-1.5.3-7.1-3.5-4.8h0c-.8.6-1.7,3.5-1.2,3.1-.7.8-2,1.1-3.2,1.4-.4,0-.7-.3-.5-.7,2-3.6-2.3-3.8-5-2.9-.9.3-3.9,1.6-4.5,2.1-.6.6-.3,3.4-1.2,3.2-1-.2.6-2.2-1.9-1.9-3.2.4-1.8,2.1-2.2,3.6-.9,3.1-1.1,5.3,3.3,4.8,2-.2,1-1.4,1.8-1.8-.6.4,6,2.1,5.9,2,2.6.5,3.7,1.3,6.5,1.2,1.3,0,2.2-.8,3.5-.3,1,.3,1.9,3,3.2,2.8,2.6-.4,0-1.2.6-2.5.4-.8,4.4-.4,6.1-.3s.5.4.4.7c-1.2,2.5-3.3.8-4.1,1.1-.3.1-.6,0-1.3.5-.6.4-1.8,3.1-2,3.7-.8-1.7,1.1-1.7-1.1-1.9-.2,0-2.7,2.5-3.4,2.6-1.4.3-3.1-.6-4.5-.5-2.3.2-7.8,2.4-9.1,4.1-.7.9-.7,1-1.2,1.8-.1.2,1.5.5,1.3.8-.9,1.5-1.8-.4-3.7-.2-1.5.1-3.3.9-3.6,2.8,0,.7,3.4,4.5,3.5,4.8.2.8-1.2,2-.9,2.4,2.5,4.1,6.6-4.4,7.1,1,0,1-2.1.7-1.5,2.1.6,1.4,2.6.6,3.3,1.4,1.4,1.5-.3,2.3,2.1,2.5,1.6.1,5.4-2,7.2-2.4,2.6-.6.7-1.3,2.6-.9,1,.2-1,1.9,0,2.2,1.8.4,7.3-5.4,10.1-4.9.5,0,.5.8,0,.9-2.4.7-6.3,3.6-6.3,5.7s-.4.6-.7.3-.7-.6-1.3-.6c-.4,0-.6.4-.9.8-.2.3-.6.2-.8-.1-.6-1.2-2.8,0-3.9.9-.4.3-1.6,1.3-1.7,1.3-.4.3,1,1,.1,1.5-1.6.9-4.6-.5-5.6.5-1.4,1.4,1,2.8,0,4.3-.5.8-5.3.9-4.1,3.5.8,1.7,1.4-.4,2.6-.4,2.3,0,3.9.3,6.2-.6.9-.4,2.3-1.6,3.5-2.2s.8.3.6.7c-.8,1.5.2,1.8,1.9,1.6,2.5-.2,4-3.2,6.2-3.8,2.5-.7,4.1,1,6.9-.3,1-.5,3.5-3.4,3.9-3.4.9-.1,2.2,2.7,2.1,3.4-.2,1.8-1.7,2.1-3.1,2.9-3.5,1.9-7.4,1.7-10.9,3.7-3.4,1.9-6.5,4.3-1.1,4.4,2.1,0,4.3-1,6.3-1.9.5-.2.9.5.5.8-1.6,1.2-3,1.9-5.4,2.6-1.8.5-4.2.6-5.3,2.5-.3.4-.8,3.8-.6,4.1,1.4,1.8,1.7.2,2.6-.3s.5,0,.6.2c.9,1.3,1.2,1.9,3.2-.3,1.8-1.9.5-2.5,3.3-3,1-.2,3.5-.3,5.3-.8.3,0,3.1-.9,4.7-1.4s.7.4.4.7c-.5.5-1.1,1-.6,1.5,1.5,1.4,3.3-1.7,4.3-.6,1.2,1.4-1.3,1.7-2.2,1.6s-.4.1-.5.4c-.2,1-.4,3-.1,3.4,2,2,3.7-1.6,5.6-2.2,1.2-.4,1.8.8,3.5.2,1.3-.5.7-2.1,1.5-2.8.2-.2,1.2,1.1,1.9.6.6-.4.7-.7.6-1-.1-.5.5-.8.8-.4s.7.9,1.4,1c1,0,2.1-1.5,2.3-1.5,1.4.1.5.9,1.5,1.5.7.4,2.9,2.2,3.2,2.2,2,0,3.6-2.5,3.9-4.5s.5-.6.8-.3c1.3,1.3,2.9,4,4.8,3.8,4.6-.6,2.1-5.8,3.7-6.8-.6.5,2.5,1.6,3,1.7h.2c.7.6,2.8,2.6,3.5,2.7,2,.5,1.6-3.6.8-5.2s0-.6.3-.7c2.5-.6.2-1.4,1-2.7.4-.6,1.3,2,1.9,2,1.2,0,1.2-.4,1.1-.9,0-.5.5-.8.8-.4,0,0,0,.1.1.2.1.2.3.3.5.2.9-.3,1.7-.6,2.6-.9h0c1.5-.4,2.8-1.1,3.8-2.2v-.3c0-.5.3-2.3.3-2.3,0-1.1.7-2.4-.3-3.4-.2-.2-.1-.5,0-.6.3-.3-.9-1.3,0-1.4.7.4,1.1,1.7,1.5,1.6s.6.2.6.5c-.3,4.3,4.1,5.3,8.1,3.5,2.8-1.2,5-3.6,7.9-4.6,3.2-1.1,5.2,0,2.5-2.9s-.1-.6.2-.8c1.6-.6,2.5-1.9,2.6-3.6s.6-.6.8-.2c.8,1.3.2,3.1,2.8,3.5,1.7.3,5-1.4,6.4-2.1.8-.4,5.1-3.1,5.4-4.2.6-2.3-1.5-1.7-2.2-2.4-.2-.2-.1-.7.2-.8,1.7-.5,8.3-3.8,9.2-4,1.2-.3,11.6,1.6,13.7,0s.9.1.7.5-.4,1.2,0,1.7c0,.1.2.2.4.2.7,0,3.3-.1,3.5-.2,1.2-.5,2.8-2.2,3.5-3.3.6-1-1.2-1.6-.5-2.5.2-.2,1.7.4,1.8.6.6,1.2,0,1.5-.2,3.1-.2.9-2.5,3.4-.2,3.2.1,0,.2,0,.3-.2.5-.6,3.6-3.1,4-3.5l.1-.1c.7-1.2.4-3.1,1.3-4.3s.9-.1.8.4c-.5,1.8,2.6,1.2,5.1,1.3.4,0,.6.6.2.8,0,0-.1.1-.1.2,0,.5,4,2.6,4.5,2.7,1.8.4,4.1-.5,5.9-1.3s.6,0,.7.4c.2,1.3,3.8,1.3,4.9-.7.3-.5,1.8-5.8-.2-8.2-.2-.2-.4-.5-.6-.3-1.3.6-4.6,1.2-1.9-1.4.8-.7,2,.3,2.5-.3,1.1-1.2.8-1.7,1.5-3.4.8-2.1,6.8-7.3,7.1-7.9.3-.5,1.4-4.3,1.6-5.5.5-3.7-2.1-5,.5-8.7.9-1.3,2.4-1.9,3.2-3.3.7-1.3.6-2.7,1.2-4,1-2.2,3.1-3.4,4.2-5.6.9-1.8.7-3.9,1.5-5.6.1-.3.5-.3.7,0h0c.1.2.3.2.5.1,1.6-.9-1.9-5.8-2-6.1-.9-3.5,2-7,1.5-10.7-.2-2-.4-8.5-.7-10.1-.2-1.3-1.7-3.9-2.9-5.3s-.1-.7.3-.8c2.7-.2,9.2-1.1,7.3-3.5-.3-.4-1.9,0-2.8-1.3-1-1.3-.9-5.4-1.2-6.9-.8-5-4.5-17.6-4.2-19.5.2-1,1.2-.4,1.3-3.1,0-.2-.7-2.8-.7-2.3-.8-.3-1-.7-.6-1.2.2-.5.5-1,.9-1.4s.1-.2.2-.3c.3-2.2,1.5-.9,0-3-.8-1-3.2-.3-4.2-1.5-.9-1.1-1-3.1-.7-4.4l-11.5-.3h-1.4c-1.5,0-2.7-1.2-2.7-2.7v-5.7l-3.1-7.8s-3.9-6.9-4.5-9.2-2.9-10.9-2.9-10.9h-11.4l-6.3,7-5.7,13.2-7.6,7.8-5.9,3.9c-1.4.9-3.3,1-4.7,0l-6.4-3.9-6.4-7.8-1.2-5.7-5.9-12-.6-2.4,11.7-8.4,8.1-6.2,6-9-10.6-5.3-1.1-4.1c-.4-1.4.2-2.8,1.4-3.6l7.3-4.3h25.2l7-5.6,8.7-8.6c-2-.4-1-.6-2.7-1.3-.2,0,0-.5,0-.7,2.2-2.7,6.7-6.3,7.5-6.8,1.8-1.3,9-4.5,7.5-7.2-.7-1.2-3.9-1.6-5-2.2-.3-.1-3.4-2.4-3.6-2.6-1.4-1.6-1.1-3.4-3-4.8-.7-.5-5.8-2.6-6.5-2.1-.2.1.7,4.6,1,5,.7,1,3.5,1.8,3,3.2-1.8-2-3.5-2.2-5.6-2.2-1.2,0-4.8-.1-5.8.6-1.1.8-2.1,3.8-2.3,5.2,0,.7.3,4.3.2,4.3-2.3,1.6-1.3-5.2-1.2-5.7h0c.2-4.6-.8-4-3.9-2.8-2,.7-4.3,1.1-3.9,4,.1,1,2,3.5,3.2,3.4s.5.2.5.4c0,.5,0,1.1-.2,1.6-.1.4-.6.4-.8.1-1-1.5-2.4-2.1-3.3-3.4-1.1-1.8,1.3-4.2.4-5.6-.6-.9-5.2,2-5.2,3.2-.1,2.6,2,1.9,1.3,4.3-.1.4-.7.5-.9,0-.4-.8-.9-1.7-1.2-2.1v-.3c0-.4,0-.8-.2-1.1,0,0-.1-.1-.2-.2-.6-.2-1.2-.2-1.8.1-.5-.3-2,.7-2.3.1-.1-.3,3.3-6.3-.9-3.9-.8.5-1.2,2.9-2.2,3.7-.4.4-2.6,1.8-3.8,2.5s-.8-.1-.7-.5.2-1,0-1c-.5,0-1.5.5-1.7.5-.7-.2-3.8-.9-4.7-.5-1.9.9-1.9,4.5-2.2,7.1s-.6.6-.9.2c-.7-1.2-1,1.5-2.4,1.1-1-.2-2.5-3.9-2.6-1.1,0,1,2,1.8,1.3,3.3,0,0-1.8.7-2.7,1.1-.2.1-.5,0-.6-.3-1-3.1-4.2-5.1-3.6-.5.3,2.6,1.1,1.1,2.9,2.1.5.2,4,1.8,3.7,2.5-.5,1.1-3.2-.9-2,2.8.6,1.9,2,1.7,2.9,1.6.3,0,.5.4.3.6-.5.6-1.3,2-1.4,2.3,0,.1,0,.2-.2.2-.9.6-.7.3-2.2.4-1.2,0-5-1.7-5.6.9-.3,1.1,1.6,2.1,3.1,2.9s.3.8-.1.9c-.8.2-1.2.6-2.5.8-2,.2-3.7-.6-5.8,0-2.2.6-3,1.7-4.6,3-.2.2-2.2,1.6-2.3,1.8-1,2.5.1,2.5,1.3,4.3l.2.2c.9.4,1.6,1,2,2,.4,1.3,1.2,1.7,2.3,1s.4,0,.5,0c.8.5,2.2,1.6,3.3,1.7,1.3.1,3.3-2.1,4.2-1.6.8.4-.6,1.8.5,2.5.7.5,1-.4,1.4-1,.2-.3.6-.3.8,0,1.2,2.3-2.4,1.4-3,4.1-.7,2.9,3.8-1.1,4-1.3,3.9-3,2.3-.6,5-.9.4,0,7.2-3.4,6.2-.4,0,.3-.4.4-.7.2-2-1.1-4.9,3.4-5.7,6s-.6.4-.8.2c-.4-.5-.7-.3-1.2.2-.2.2-.6.1-.7-.2-.3-.8-1.7-.2-1.9.8-.2.9,2.6,0,1.2,2.1-1.2,1.8-5.6,0-6.3.3M165.7,303.5c1.3-.8,2.7-1.8,3-2.2.7-1.2.4-2.3.4-3.5,0-.4.5-.5.7-.2.7,1.1,1.5,1.7.3,4-.3.6-4.3,2.8-1.5,3.7.3.1.4.5,0,.7-.5.3-1.2.7-1.9,1.1-.4.2-.8-.3-.5-.6.2-.2.3-.5.4-.7.2-1.4-.1-1.6-.7-1.5-.4,0-.6-.5-.3-.7h0l.1-.1Z"></path></g><g><path id="Vector_5-2" data-name="Vector 5-2" fill="#b2b2b2" stroke-width="0" d="M168.1,323.6l-23.1-.4-6.6,2c-1.1.7-1.7,2-1.3,3.3l1.2,4.3,10.6,5.3-6,9-19.8,14.6.6,2.4,5.9,12,1.2,5.7,6.4,7.8,6.6,1.7c1.3.8,3.7-1.6,5-2.5l4.4-4.7,5.3-6.9,5-13.1,8.5-6.4,12.2.8,4.6,16.1,3.8,7.2,3.1,7.8v5.6c0,1.5,2.7,1,4.2,1.1h8.8c1.5-5.8,7-.5,10.3.4,1.4.4,7.5.3,8.4-.4.2-.1.4,0,.9-.4,0,0,.9-2,1.4-3.1-1.3-.3-2.4-.8-3.3-1.3-4.4-2.3-6.5-5.8-8.9-6.4.4-.8.8-1.4,1.5-1.6.9-.2,1.7.2,4.8,2.5,4.8,3.7,5.2,4.4,6.3,4.4,2.8-.2,4.6-5.6,5.2-7.2,1.9-5.4.6-8.9,2.4-9.6,2.3-.8,4.5,3.4,8.2,2.7,2.5-.5,4.7-3,4.9-5.6,0-.2.2-3-1.4-4.1-1.8-1.2-4.3.6-4.8-.1-.6-.9,3.4-3.2,3.5-6.9,0-.7-.1-.5-1-4.1-1.1-4.5-.9-5.1-.6-5.4.8-.7,2.8-.3,4.1.8,2.7,2.5,1.3,8.5,1.1,9.2-.6,2.2-1.3,3.1-.8,4.4.6,1.6,2.7,2.9,4.1,2.4,2.6-.9,1.5-10,1.1-12.8-.7-5.8-1.2-9.8-4.1-11.3h0c-2.3-1.2-5.1-.3-8,.7-5,1.6-7.1,4.2-7.9,3.5-.9-.8.6-5.2,3.8-8.5,3.4-3.4,7.2-4,7-5.6-.1-1.3-2.3-1-3.8-3.2-1.5-2.3.1-3.8-1.1-6.8-1.4-3.4-4.3-3.4-4.5-6.1-.2-2.2,1.7-3.4,1-4.5-.8-1.2-3.4,0-4.4-1.1-1.1-1.3,1.6-3.6,1.4-7.3-.2-3.6-2.9-7.1-5.1-7-1.4,0-1.7,1.6-3.2,1.7-2.1.2-2.8-2.6-5.5-3.9-2.8-1.4-5.9-.5-9.8.7-4.9,1.5-5.2,3-8.6,3.1-3.4,0-4.6-1.4-6.2-.4-2.3,1.4-.7,4.7-3.2,7-2.6,2.4-7,1.6-7.3,1.5l-18.7,17h.2Z"></path></g><g id="Group_56" data-name="Group 56"><path id="Vector_113" data-name="Vector 113" fill="#b2b2b2" stroke-width="0" d="M307.9,377.6c-.6-1.1-2.1-.6-3-1.9-1.4-2.2,2-5.7,1.1-6.8-.8-.9-4.8.2-7.6,3-3.7,3.7-3,8.1-6.5,9.5-1.5.6-2.3.1-3.2,1.1-1.4,1.4,0,3.3-.8,6.1-1,3.5-4,4.4-3.6,5.5.5,1.3,5,1.3,8.9-.2,3.1-1.2,5.4-3.6,9.9-8.5,4.8-5.2,5.3-6.9,4.9-7.8h-.1Z"></path></g>', 4);
const $68e622ca3afa7a21$var$_hoisted_6 = [
    $68e622ca3afa7a21$var$_hoisted_2
];
const $68e622ca3afa7a21$var$_hoisted_7 = /*#__PURE__*/ (0, $ani5R.createStaticVNode)('<g id="Group_4" data-name="Group 4"><path id="Vector_7" data-name="Vector 7" fill="#b2b2b2" stroke-width="0" d="M304.5,92.2s0-.1-.3-.4c.2.2.3.4.3.4Z"></path></g><g id="Group_5" data-name="Group 5"><path id="Vector_9" data-name="Vector 9" fill="#b2b2b2" stroke-width="0" d="M371.5,325.8c1.3-.6,2.1.4,4,.4,3.4,0,3.9-3.5,9.4-6.8,3.4-2.1,5.2-1.9,6.3-4.1.8-1.7,0-2.3.8-4.4.8-2.3,3-5,5.8-5.5,3.2-.5,5.3,2.4,6.9,1.4,1.2-.8,0-2.7,1.3-4.8,1.9-3.5,7.2-2.1,8.2-4.8.6-1.6-.7-3.7-3.4-8-1.8-2.9-3-4.2-2.5-5.3.5-1.1,2.2-1.3,3.8-1.3,0,0,5-3.7,7-5.4,1.6-1.3,3.4-3.1,5.3-5.5-.2-.5-.4-1-.6-1.7-2-5.5-2.8-6.3-3.2-6.7-2.1-1.8-3.3-.6-6.6-2.3-4.3-2.2-4.2-5.2-7.6-5.9-2.7-.5-4.5,1.2-5.5.1-1.3-1.2.8-3.9-.4-5.6-1.5-2.1-6.9-.6-7.5-.5-7.1,2-9.7,8-12.7,6.9-1.7-.6-1.5-2.6-3.8-3.2-1.7-.5-2.5.4-4.3-.2-1.7-.5-1.7-1.5-3.2-2.3-2.5-1.4-4,.2-7.3-.6-3.5-.9-6.3-3.8-5.9-4.6.2-.5,1.3-.4,2.3-.3,5,.4,7,3.2,10.6,2.5.6-.1.3-.2,1.9-.7,3.4-1.2,5.5-1.2,6.9-1.5,5.8-1.3,6.4-9,10.8-9,1.9,0,1.8,1.4,4.5,1.6,1.9.2,3.8-.5,7.4-1.9,3.7-1.4,4-2,4.1-2.3.8-2-1.4-5.2-3.9-6-1-.3-1.3,0-2.6-.1-2.9-.4-5.8-2.5-5.6-4,.2-1.7,4.3-1.7,4.3-3,0-1-2.6-2.1-4.9-2.3-1.8-.2-3.1.2-5.3.8-5.6,1.5-8.5,2.3-8.7,1.9-.4-.7,3.2-4.6,7.9-5.3,2.8-.4,3.5.7,6.9.7,2.7,0,4.8-.9,8.9-2.6,6.1-2.6,10.2-4.3,10.6-7.3.2-1.6-.8-2.8,0-4.1.8-1.1,1.9-.9,3-2,1.2-1.2,1.2-2.7,1.4-3.9,1.1-5.4,8.1-5.2,10.1-11.1.8-2.5,0-3.6,1.3-5.5,1.2-1.6,2.6-1.6,4.4-3.9.7-.9,1.1-1.7,1.7-2.9,1-2.1,1.6-3.9,1.9-5,1-3.6.5-4.5,1.4-9.9.7-4.3,1.3-5.3,2.1-6,1.3-1.1,2.1-.5,4.2-1.6,2.2-1.1,3.3-2.7,4.9-4.8,1.9-2.5,2.9-3.9,3.1-5.9,0-.6.2-2-2-6.8-2.7-5.8-4-8.7-7.1-9.8-.9-.3-2.5-.7-4.3-.6-2.3.2-2.8,1-4.5.7-2-.3-2.6-1.7-4.1-1.5-1.1.2-1.5.9-2.2,1.5-3.6,2.7-11.9-1.5-15.2-3.2-3.4-1.7-4.2-2.6-6.1-2.4-2.4.3-3.6,2.1-6.2,1.7-.9-.1-1.6-.5-2.6,0-1.2.5-1.6,1.6-2,1.4-.5-.2.3-2,0-3.4-.7-2.6-5.2-4.2-8.7-4.1-5.5,0-10,4.2-10.5,4.6-.8.8-2.6,2.6-2.9,2.3-.3-.2.8-1.6.3-2.4-.4-.7-1.7-.6-1.9-.6-3.6.3-5.9,6.1-6.9,5.7-.4-.2-.3-1.6-.8-1.6h-.2c-.6.5-3.1.9-5.4.4-2.2-.5-3-1.7-3.6-1.2-.4.3-.2,1-.3,1.8-.3,2.1-2.6,3.4-4.1,4.2-3.8,2.1-9.6,3.3-10.5,1.6-.5-1,.5-2.9,1.4-3,.5,0,.6.4,1.3.7,1.7.8,4.2.2,4.7-1,.3-.7-.3-1.1,0-1.8.3-1.2,2.1-1.5,4.1-2.2.8-.3,6.2-2.3,6.4-4.8,0-.9-.6-1.9-1.3-2.1-1.3-.4-2.5,1.7-4,1.3-.9-.3-.9-1.2-1.9-1.5s-1.9.4-2.7.9c-2,1.3-5.6,3.3-5.9,2.9-.4-.4,2.1-5,6.1-5.9,2.2-.5,3,.6,5.4-.2,2.6-.8,3.9-2.6,4.7-2.1.8.5,0,2.4.9,3.1.7.5,1.9.3,2.5-.3.9-.8.3-1.7.8-3.1.8-2,2.6-1.8,4.9-4.3,1.4-1.5,2.2-3.3,1.9-3.5-.5-.5-4.6,3.9-5.8,3-.7-.5,0-2.2-.6-2.6-.8-.5-2.3,2-4,1.6-1-.2-1-1.1-2.3-1.3-.9-.2-1.1.3-2,0-1.1-.2-1.2-1.1-2.3-1.6-1.4-.7-2.2.2-3.5-.3-2-.8-2.8-3.8-2.4-4,.3-.2,1.1,1.4,3.3,2.3.8.4,1.7.6,3.7.7,4.2.2,6.3.3,7.5-.5,3-2.1.9-6.9,3.8-8.5,1.7-.9,3.4.1,4.9-1.3.9-.8,1-1.9,1.2-2.5,1.3-4.4,7.9-3.6,14.1-9,3.5-3,3.6-5.2,7.3-6.6,2-.8,3-.5,4.9-1.6s3-2.6,5-5.6c1.1-1.6,4.2-6,3.2-7-.5-.5-1.4.3-2.2-.3-.9-.7-1-2.6-.5-4,.8-2.4,2.7-2.3,4.1-5,.7-1.4,1.3-3.5.6-4.1-.9-.8-3.4,1.5-5,.4-.5-.3-.3-.6-1-1.1-1-.7-2.4-.9-3.6-.6-1.3.3-1.5,1.1-2.2.9-1.2-.2-1.4-2.3-2.1-2.2-.5,0-.9,1-.9,1.8,0,1.4,1.2,1.9,1,2.9-.2.9-1.2,1.6-1.7,1.4-.6-.2-.3-1.3-1-1.8-1.1-.9-3.4.7-3.8,0-.3-.4.6-1,.4-1.6-.3-1.1-4.1-1.9-7-.4-2.7,1.4-3.6,4.3-4.6,3.9-.7-.2-.4-1.4-1.2-1.7-1.2-.5-2.8,2-3.8,1.5-.7-.3-.4-1.4-1.1-1.7-.9-.4-1.9,1-2.5.6-.7-.4,0-2.5-.6-2.7-.6-.3-1.3,1.7-3,2-1.3.2-1.6-.8-2.9-.7-2,.2-2.6,2.9-4.1,2.8-1.1,0-1.2-1.5-2.3-1.7-2.5-.5-5.6,5.9-6.4,5.6-.3-.2,0-1.7.5-2.9,1-2.3,2.5-2.7,2.4-3.7-.1-1.4-3.5-3.2-5.9-2.3-3.9,1.4-4.9,9.4-5,9.3,0,0,.6-1.6,0-2.3-.6-.6-1.6-.1-1.9-.6-.6-.9,2.9-3.2,2.7-6-.1-2.1-2.4-4.2-3.8-3.9-1.8.4-2.2,4.4-2.7,4.3-.5,0,.5-3-.9-5.3-1.4-2.2-4.8-3.4-6.8-2.3-2.5,1.5-1.6,6.8-3.4,7.2-.9.2-1.5-1.1-2.5-.8-1.2.3-2.2,2.7-1.5,4,1.1,2.1,6,.7,6.6,2.4.2.7-.3,1.7-.9,1.8-1.1.3-2.3-2.3-3.2-1.8-.6.3-.8,1.2-.8,1.4-.3,2.3,2.6,4.4,2.4,4.6-.2.3-3.9-3.7-5.5-2.9-1.5.7-1.5,5.4.6,8.9.5.7,1,1.4,1.6,2,2.4.6,5.3,3.2,5.3,3.3s-2.9-1-5.3-3.3c-.7-.2-1.4-.2-1.9.1-1.1.6-1.1,2.1-1.9,2.2-1.5.1-2.7-4.2-3.7-3.9-.8.2-.6,2.8-1.4,2.9-.9.2-1.6-2.7-3.1-2.8-.8,0-1.9.7-2.1,1.6-.5,2.1,3.5,3.2,4.7,7.6.1.5,1,3.4-.5,4.8-.7.7-1.6.8-2.4.9-3.1.4-4.8-1.5-5.4-.9-.8.7.8,4.4,3.5,7.4,2.2,2.4,3.1,2.2,4.8,4,4.1,4.3,4.1,10.7,3.6,10.9-.5.2-1.6-6-5.4-7.1-1-.3-2.1-.1-2.8-1-.9-1.1-.1-2.3-1-3.2-.8-.9-2.7-.9-3.2-.2-.7.9,1,3.4,2.5,5.2.7.7,1.2,1.4,1.5,1.9.2.2.3.4.3.4,0,0-.1-.1-.3-.4-.3-.4-.9-1.1-1.5-1.9-.8-.8-1.9-1.5-3.1-1.6-2-.1-2.5,1.6-4.4,1.4-2.8-.3-4.5-4.2-4.8-4s1.6,2.5,1.4,5.3c-.2,3.1-2.9,5.6-3.6,5.3-.9-.4,1.6-4.9-.4-7.1-1.2-1.3-3.7-1.4-5.2-.4-2.5,1.6-2.3,6-.8,8.7,1.4,2.5,4.1,3.8,3.8,4.2-.2.3-1.3-.4-2.6,0-1.5.5-2.7,2.5-2.6,4.2,0,1,.5,2.1,4.8,5.9,3.9,3.4,5.4,4.2,5.2,4.6-.3.7-4.8.6-7.9-2-2.3-1.9-2.7-4.4-4-4.2-1.1.1-1.8,2-2,2.6s-.5,1.8-.2,4.4c.3,2,.6,2.4,1,4.4.9,4.2.3,5.6,1.2,6.1,1.7,1,5.4-3.3,6.5-2.4.6.5-.6,2.2.2,3.2,1.1,1.4,4.7-.1,4.8.4.2.5-3.2,3.2-5.8,2.2-1.2-.4-1.7-1.5-2.4-1.2-.8.3-1.1,1.8-.8,3,0,0,.4,1.5,1.6,2.2,2.9,1.7,8.3-2.2,8.5-1.8.1.2-1.6.8-2,2.2-.7,2.3,2.4,5.1,2.2,5.3-.3.3-4.8-5.4-6.9-4.4-.8.4-.5,1.5-2,3.8-1.1,1.7-1.7,1.7-1.8,2.4-.5,3,9.3,6.1,8.9,7.5-.2.7-3.3,1.1-5.4-.2-.7-.4-.9-.8-2.6-2-1.3-.9-2-1.5-2.5-1.5-2.6,0-4.9,2.3-4.8,4,0,.8.6.9,2.4,3.4,1.7,2.2,1.5,2.6,2.3,3,1.8.9,3.6-.8,4.6.2.5.5.6,1.5.3,2-.8,1.3-4.9,1.2-6.8-.9-.5-.6-.7-1.2-1.7-2-.4-.3-2.2-1.5-3.5-.7-.9.5-1.5,1.9-1.1,2.8.5,1.1,2,1.1,5.4,1.9,2.4.6,6.4,1.7,6.3,2.2,0,.4-2.7.8-5.4.1-4.1-.9-5-3.2-7.2-2.8-2.5.5-4.2,4-3.5,4.9.6.8,3-1,5.7,0,1.6.7,3,2.2,2.7,2.9-.2.5-1,.4-3.8,1.1-2.1.5-2.4.7-2.4.9-.3,1.1,4.1,2.9,3.9,3.4s-2.8-.9-5.1.3c-.9.5-1.2,1-2,1-1.1,0-1.7-1.1-2.4-1.8-2.7-2.7-10.4-1.4-11.6,1.8-.4,1.1-.1,2.6.7,3.2,1.1.8,2.2-.6,3.9,0,2.2.6,2.4,3.4,4.1,3.4,1.2,0,1.5-1.4,3-1.4,1.3,0,1.6,1.1,2.9,1.3,1.9.3,2.4-1.8,5-2.3,2-.4,4.5.3,5.5,2,.5.8.8,2.2.3,2.6-.7.6-2.3-1.5-5.4-2-.5,0-3.5-.5-4.8,1.1-.9,1.1-.4,2.7-.9,2.8s-.9-2.3-2.5-2.9c-1.1-.4-2.8.2-3.4,1.2-1.5,2.4,1.8,8.3,5.1,8.6,1.4.1,3-.7,3.4-.1.2.3-.1.6-.1,1.1,0,1.5,2.7,3.4,5.4,3.4,3,0,5.9-2.7,6.7-5.5.5-1.7.2-3.4,1-3.7s1.4,1,2.6.8,1-1.7,2.8-3.2c.9-.7,1.8-1.1,2.8-1.5,1.8-.8,2.3-.5,3-1.1,1-1,.6-2.2,1.1-3.6,1.2-3.3,6.6-4.7,7.1-4,.6.9-7.5,6.2-6.5,8.1.8,1.5,6.4-.5,6.7.5.2.7-1.7,2.5-3.5,2.3-1.4-.2-1.9-1.5-3-1.3-.7.2-.6.8-1.4,1.4-1.5,1-3.1,0-3.8.7-.5.6.2,1.1,0,2.1-.5,2-4,1.6-5.2,3.9-.6,1.1-.5,2.7.2,3.4,1.5,1.3,5.4-1.4,5.6-1.1.1.2-1.6,2-4.1,2.4-2.1.3-3.5-.6-4,0-.4.6.2,1.8.9,2.6,1.2,1.3,2.7,1.2,2.7,1.7,0,1-7.2.9-8.6,4.2,0,.1-.6,1.5,0,2.3.5.7,1.7.7,1.7.8,0,.3-3.2-.4-4.2.9-.7,1,.5,2.2-.3,3.9-.6,1.3-1.6,1.6-1.5,2.2.2.8,1.9.5,2.4,1.3,1.1,1.8-4.9,6.9-4.3,7.7.4.5,3.7-1.6,4-1.1.2.3-1.7,1.4-2,3.2-.3,2,1.5,3.9,1.2,4-.2.2-1.4-2.1-2.9-2.2-3-.1-6.3,8.7-5.2,9.4.9.6,4.6-4.2,5.1-3.8.3.2-.5,2.2-2.1,3.7-2,1.8-3.8,1.4-4.6,3-.6,1.1-.4,2.7.3,3.2,1.1.7,3.2-1,3.4-.7.3.4-5.5,4.1-4.8,6.2.4,1.1,2.2,1,2.6,2.5.2,1-.5,1.8-.1,2.2.4.3,1.3-.3,1.7-.5,3.5-2.1,6.2-4.1,6.3-4,0,.1-2.1,1.8-4.6,4.7-.9,1-1.6,1.9-3,2.4-1.1.4-1.6,0-2.1.5-1,.9-.3,2.5-.6,4.3-.4,2.8-2.5,2.8-3.9,5.6-2.3,4.5,1.3,8.1-1.2,10.8-1.5,1.6-3.6,1.4-4.1,3.2-.3,1,.4,1.4.1,2.9-.3,2.1-1.7,2.8-1.4,3.6,0,.3.4.8,3.6.9,3.7.2,5.6.3,7.1-.9.3-.2,1.9-1.5,2.1-3.6.2-2.2-1.5-2.7-1.3-4.7.2-2.2,2.3-2,3.1-5,.5-1.7,0-2.9,1.1-4.2.6-.7.9-.6,1.5-1.2,1.4-1.3.9-3.2,1.5-4.8,1.6-3.7,3-5,4.4-8.4.6-1.6,1.3-3.3,1.4-5.6.3-5.6-3-9.1-1.7-12.7.2-.4.5-1.4,1.3-1.6,1.1-.3,1.9,1.1,2.7.7.9-.3.4-2.2,1.6-3.6.8-.9,1.3-.6,2.6-1.4,2.4-1.6,1.8-3.5,3.9-4.8,1.8-1.1,2.5,0,4-1.1,1.9-1.4,1.3-3.5,3.6-4.9.6-.4,1.1-.5,2.1-.8.8-.2,3.2-.9,3.6-.3.2.4-.5,1.5-1.4,2-1.1.7-1.8.3-2.8.7-2.1.8-1.4,2.9-3.6,4.5-1.9,1.4-3.2.3-4.8,1.9-1,1-.5,1.5-1.7,2.9-1.4,1.6-2.6,1.5-3.4,2.9-.6,1-.2,1.4-.5,3-.9,3.6-4,4.3-3.6,6.5.2,1.3,1.5,1.7,1.3,3.2,0,.9-.6,1.1-.5,1.8.2,1.6,3.6,2.9,4.4,2.1.3-.3,0-.8,0-2.3,0-1.6.3-2.8.6-4,0-.3.9-3.2,1.4-3.2.3,0,.1,1.1.7,2.4,1,1.9,3.4,3.1,4.1,2.5.5-.4.2-1.8-.1-3.2-.4-1.8-1.1-2.7-.9-2.8s2,1.4,2.4,3.6c.4,2.2-1,3.4-.3,4.7.5,1,1.9,1.5,3,1.4,2.6-.3,4.9-4.5,4.2-7.5-.2-1-.9-2.3-.5-2.6.3-.3.9.4,1.4.1.8-.4,0-2.2.6-4.1.7-2.3,2.9-3.8,3.3-3.5.3.2-.2,1.3-1,3.4-1,2.5-1.4,3-1.1,3.8.3,1,1.5,1.8,2.4,2,1.4.3,2.3-.6,3.4-.1.9.4,1,1.5,1.3,2.4,1.4,3.7,7,4.9,6.9,5,0,0-4.2-.7-9.1-3.7-1.9-1.2-2.9-2.1-4.2-1.8-2.1.5-2.9,3.6-3.2,4.4-1.2,4.3,1.3,5.5.3,9.3-.9,3.5-3.8,5.5-2.9,7.1.4.7,1,.6,1.6,1.6.8,1.2.2,2,.6,3,.9,2.6,5.3,2,5.9,4.3.3.9-.4,1.2-.1,2.8.2,1.4.8,1.8,1.1,2.9.5,1.7,0,4.1-1.3,5.4-2,2-5.2.7-6,2.4-.4.9.6,1.4.2,2.7-.6,1.9-3.1,1.6-4.2,3.8-.5,1.1,0,1.5-.6,3-.6,1.6-1.8,2.5-2.2,2.8-2.3,1.9-11.4,11.6-10,19.3.5,3,2.6,5.1,1.6,6.1-.7.7-2.4.6-3.1-.2-.7-.8.2-1.8,0-4,0-.3-.4-3.4-1.9-3.8-1.1-.3-2.8,1.1-3.2,2.8-.5,2.1,1.6,3.2,1.1,5.7-.3,1.5-1.2,1.5-1.4,2.8-.3,1.9,1.4,3,4.3,6.9,2.6,3.5,3.9,5.2,3.6,7.3-.2,1.7-1.2,2.1-1,3.5.3,2.1,2.8,4,4.1,3.4.7-.3.9-1.2,1-1.6.5-1.8-.4-3.5-.7-4.1-.4-.8-3.3-7.1-1.5-10.3,1.1-1.9,3.9-3,5.5-2.2,1.4.7.9,2.3,2.6,4.3,1.8,2.2,3.3,1.3,5.4,3.1,2.9,2.5,1.4,5.2,4.4,8.1,1.7,1.6,4.4,3,6,2.1.8-.4,1.1-1.5,1.7-3.8.8-2.8,1.2-4.2.7-5.7-.6-2.1-2.2-1.8-3.1-4.2-1.1-2.9-.9-6.6.3-7.1.7-.3,1.9.5,2.3,1.3.5,1.1-.5,1.9-.3,3.4.2,1.8,1.8,3.6,3.5,3.9s3-1.1,3.6-.5c.4.4,0,1.1,0,2.1,0,2.5,2.4,5.2,3.8,5,1.6-.3,2.2-4.3,2.6-4.2.3,0-.7,2.7.6,4.3,1,1.2,2.8,1.2,3.3,1.2,2.5,0,4.2-1.7,4.8-2.3,2.7-2.7,1.6-5,3.4-6,3.1-1.7,8.6,4.1,10.3,2.5.4-.3.4-1,.5-2.4.1-2.4-.5-3.1-.5-5.1,0-1.5.5-3.5,1.2-3.6.8,0,1.1,2.9,2.9,3.4,1.2.4,1.9-.7,3.3-1.2,4.6-1.8,10.4,4.3,13.5,2.9.8-.3,1.4-.8,1.4-.8.6-.4,1.1-.8,1.4-1.2.2-1.9.8-3.9,2.3-4.6h0l-1.7.2Z"></path></g><g id="Group_6" data-name="Group 6"><path id="Vector_11" data-name="Vector 11" fill="#b2b2b2" stroke-width="0" d="M323.9,64.7c0-.1-2.8-2.7-5.3-3.3,2.3,2.3,5.2,3.5,5.3,3.3Z"></path></g><g id="Group_7" data-name="Group 7"><path id="Vector_13" data-name="Vector 13" fill="#b2b2b2" stroke-width="0" d="M302.8,90c.6.8,1.2,1.5,1.5,1.9-.3-.4-.8-1.2-1.5-1.9Z"></path></g><g id="Group_8" data-name="Group 8"><path id="Vector_15" data-name="Vector 15" fill="#b2b2b2" stroke-width="0" d="M397.1,25.9c.8,1.6-.8,2.8,0,4.5.6,1.3,2.2,2.3,3.6,2.1,2.4-.3,3.8-3.8,3.3-6.4-.3-1.5-1.1-2.4-2.2-3.6-1.5-1.7-2.9-3.3-4.7-3-1.8.2-3.5,2.3-3.2,3.6.3,1.3,2.4,1,3.2,2.7v.1Z"></path></g><g id="Group_9" data-name="Group 9"><path id="Vector_17" data-name="Vector 17" fill="#b2b2b2" stroke-width="0" d="M403,16.9c1.2.8.2,2.9,1.4,3.8.9.7,2.5.3,5.7-.6,2.7-.7,3-1.1,3.6-.8,1.7.8.8,3.7,3.2,5.9.2.2,1.7,1.4,2.6,1,.6-.3.4-.9,1.1-1.7,1.1-1.3,2.5-.7,3.3-1.7.7-1,.6-2.8-.2-3.3-1.2-.8-3.8,1.2-4.1.7-.3-.4,1.8-2.2,1.4-2.7-.3-.5-2.1.8-3.4,0-1-.6-.6-1.7-1.6-2.3-.8-.5-1.9-.3-3.2,0-1.6.3-2.2.9-2.8.5-.5-.3-.8-.9-.7-1.5.3-1.4,3-1.1,3.8-2.6.9-1.7-1.3-4.4-2.5-5.7-.4-.4-3.3-3.1-7.1-2.6-.7,0-2.6.3-3.4,1.7-.6,1,0,1.5-.1,3.4,0,1.7-.5,2.5-1.4,7.3,0,.5-.2,1,0,1.3.7.8,2.9-.8,4.2,0h0l.2-.1Z"></path></g><g id="Group_10" data-name="Group 10"><path id="Vector_19" data-name="Vector 19" fill="#b2b2b2" stroke-width="0" d="M411.5,28.7c-.3.2-.3.5-.3,2,0,3.5.2,4.2.3,4.6.2.7.7,2.3,1.3,2.3.7,0,1.1-1.8,1.4-3,.5-2.1.9-3.6,0-4.7-.7-1-2.2-1.7-2.8-1.2h.1Z"></path></g><g id="Group_11" data-name="Group 11"><path id="Vector_21" data-name="Vector 21" fill="#b2b2b2" stroke-width="0" d="M415.4,5.4c.5-.4.8-1.2.6-1.8-.2-.6-.6-.7-1.5-1.4-1.5-1.3-1.5-2.2-2.2-2.2s-1.4.8-1.6,1.5c-.4,1.2.3,2.3.5,2.5,1,1.4,3.2,2.2,4.2,1.4h0Z"></path></g><g id="Group_12" data-name="Group 12"><path id="Vector_23" data-name="Vector 23" fill="#b2b2b2" stroke-width="0" d="M406.5,28.8c.1.8.9,1.6,1.4,1.5.9-.2,1.2-3.6.5-3.9-.5-.2-2.2,1-1.9,2.4Z"></path></g><g id="Group_13" data-name="Group 13"><path id="Vector_25" data-name="Vector 25" fill="#b2b2b2" stroke-width="0" d="M431,11.5c.8.4,2.3-.3,2.7-1.3.5-1.5-1.5-3.2-2.6-4.2-.7-.6-1.9-1.6-2.2-1.3-.3.2.7,1.2,1.3,3.2.6,2.1.1,3.2.8,3.6h0Z"></path></g><g id="Group_14" data-name="Group 14"><path id="Vector_27" data-name="Vector 27" fill="#b2b2b2" stroke-width="0" d="M420.2,14.2c1,0,2.2-.7,2.3-1.6.1-1.2-1.9-2.7-3.6-2.4-.9.1-2,.7-2.1,1.5-.2,1.2,1.7,2.7,3.4,2.5h0Z"></path></g><g id="Group_15" data-name="Group 15"><path id="Vector_29" data-name="Vector 29" fill="#b2b2b2" stroke-width="0" d="M425.1,5.8c.7-.3,1.2-2.5,0-3.8-1.1-1.1-3-1.1-3.4-.4-.6,1.1,2.4,4.7,3.5,4.2h-.1Z"></path></g><g id="Group_16" data-name="Group 16"><path id="Vector_31" data-name="Vector 31" fill="#b2b2b2" stroke-width="0" d="M241.8,61.4s.7-1.4.8-3.2c-.7,1.6-.9,3.2-.8,3.2Z"></path></g><g id="Group_17" data-name="Group 17"><path id="Vector_33" data-name="Vector 33" fill="#b2b2b2" stroke-width="0" d="M234.4,90.5c1.6-.3,1.3-2.5,4.3-4.4,1.7-1.1,2.8-1,3.2-2.2.6-1.6-.8-3.3-.3-3.8.5-.4,1.5,1,2.8.7,1-.2,1.9-1.4,1.9-2.4,0-1.1-1.3-1.3-1.6-2.4-.6-2,1.9-4.9,2.8-4.6,1,.4-.8,4.5,1.2,6.2,1.5,1.2,4.2.4,5.6-.4.7-.4,1.8-1,2.1-2.2.5-1.6-.8-3.1-.3-3.5s1.9,1.4,3.8,1.1c.1,0,1.2-.2,1.6-1.1.3-.7-.1-1.3-.4-2.4-.6-2.4.3-3.2-.3-4-1.3-1.8-6.5.4-6.7-.3-.2-.5,2.3-2.6,5.1-2.4,1.6,0,2.2.8,3.1.4,1.4-.7.5-2.8,1.7-4,2-1.9,6.3,1.6,9-.4,1.7-1.3,1.9-4.2,1.3-4.4-.6-.3-1.8,2.6-4.3,2.8-1.8.1-3.9-1.1-3.9-2.3,0-2,6.6-2.1,8.1-6.3,0-.2.2-.5.1-2.8,0-6,0-9-1.1-9.7-1.6-1-4.7.8-10.2,4.2-2,1.2-2.3,1.5-4.2,2.6-.5.3-2.9,1.5-6.9,3.1-3.1,1.2-5.5,2-5.4,2.6,0,.5,1.8.5,1.9,1.1,0,.5-1.3.5-1.6,1.3-.6,1.4,2.5,3,2.6,5.9,0,1.1-.4,2-.7,2s-.2-1.8-1.3-2.6c-.9-.6-2.2-.3-3.1.1-.9.5-1.6,1.4-2,2.3-.2,1.8-.8,3.2-.8,3.2,0,0,.1-1.6.8-3.2v-2.4c0-.4-.2-1.1-.6-1.8-.2-.5-1.6-3.2-3.6-3.1-.8,0-1.7.6-2,1.3-.6,1.3.6,2.9.3,3.1-.3.2-.9-1.2-1.9-1.2-1.5,0-2.5,3.6-2.6,3.8-.2.6-.9,3.5.3,4.3.9.6,2.2-.3,2.6.3.4.6-1.2,1.9-.8,2.7.5,1.2,4.2.3,4.3.7,0,.4-2.7,2-5.9,1.6-2.3-.3-3.4-1.5-3.8-1.1-.5.6.8,3.3,3.1,5,1.3,1,1.7.7,3.2,1.8,2.9,2,4.2,4.9,4,5-.1,0-1.5-1.9-2-1.6-.6.3.6,3.3-.1,3.8-.6.4-1.8-1.6-3-1.3-1.5.3-1.1,3.6-3,4.3-1.3.5-2.5-.8-3-.4-.9.9,3.3,8.2,6.3,7.7h0l.3-.3Z"></path></g><g id="Group_18" data-name="Group 18"><path id="Vector_35" data-name="Vector 35" fill="#b2b2b2" stroke-width="0" d="M262.6,151.5c.2,1,2.7,1.9,4.4,1.1,1.4-.7.9-1.8,2.6-3.4,1.9-1.8,3.6-1,4.6-2.8.6-1.1.4-2.1,1.3-2.8s1.7-.2,2.8-.7c2.3-1,3.2-5,2.1-6.1-.3-.3-.5-.1-1.3-.4-1.6-.5-1.9-1.2-2.8-1.5-1.8-.6-2.6,1.3-4.4.9-1.7-.4-1.5-2.1-3.5-3-2.2-.9-4.4.5-5-.4-.4-.6.5-1.3.1-2.3-.4-1.1-1.7-.9-2-1.8-.4-1.1,1.3-1.8,1.5-3.8.1-1.6-1.1-2.1-.9-3.8,0-1.2.8-1.4,1.5-2.8.9-1.7.5-2.6.9-8.3.3-3.6.4-3.4.3-3.9-.8-3.1-4-3.9-3.9-6.5,0-1.1.6-1.5.3-2.3-.5-1-2.2-1.5-3-.9-.5.3-.3.9-.5,1.8-.7,2.5-3.4,2.6-3.5,4.3-.1,1.5,2,2.3,1.6,3.4-.3.9-1.9.5-2.1,1.3-.4,1.2,2.9,2.7,2.6,4.7,0,.5-.4.9-.4,1.9,0,.8.3,1.3.1,1.3-.2.1-1-1.8-2.8-3.4-1.2-1.1-1.5-.8-3.1-2-.8-.6-2.1-1.7-3.1-3.4-1.2-2.1-1-3.7-1.6-3.8-.7,0-1.9,1.7-1.9,3.6s2.1,4.4,1.7,4.7c-.3.2-1.4-1.1-2-.8-1.1.5.2,5.2,0,5.3-.1,0-.4-2.1-1.9-4.2-.6-.8-1.8-2.1-2.3-1.9-.8.4.4,4.4-.3,4.6-.3,0-.5-.7-1.2-.8-.9,0-2.2,1.3-2,2.4.1.9,1.1.9,2,2.2.9,1.3.4,2,1.1,3.2,1.1,2.1,4,3.5,5.4,2.7,1.3-.8.6-3.2,1.5-3.4.8-.2,1.2,2.3,3.8,3.8,1.2.7,2,.7,2.3,1.5.3.9-.2,2.2-.9,2.4-1.3.5-2.7-2.2-3.5-1.9-1.1.5-.5,6.4,2.1,7.4,1.4.5,3-.4,3.2.1.3.6-2.1,1.9-1.7,3,.3.9,2.4,1.5,2.4,1.5,0,0,1.6.7,2.7.9,2.2.5,3-.8,4.2-.3,1.9.9,1.5,5,2.1,5s.6-3.3,2.3-3.9c.4-.1.7-.1,1.7.1,2.7.6,4.9,1.1,4.8,1.8,0,.9-4.5.5-5.5,2.8-.5,1.1.4,1.7,0,3.2-.6,2.4-3.1,2.9-2.8,4h0l-.1.4Z"></path></g><g id="Group_19" data-name="Group 19"><path id="Vector_37" data-name="Vector 37" fill="#b2b2b2" stroke-width="0" d="M270,115.8c-.6-.3-2.3,1.6-3.2,3.2-1.4,2.6-1.3,4.9-1.2,7.1,0,1.4.2,1.8.5,1.9.6.3,2-.8,2.4-2.2.4-1.3-.5-1.8-.3-3.4s1.2-1.7,1.7-3.6c.3-1.1.5-2.8,0-3.1h0l.1.1Z"></path></g><g id="Group_20" data-name="Group 20"><path id="Vector_39" data-name="Vector 39" fill="#b2b2b2" stroke-width="0" d="M268.8,128.7c-.5,0-.8.5-.9.6-.5.6-.6,1.7,0,2.2.8.8,2.7.3,2.9-.7.3-.9-.9-2.2-2-2.1h0Z"></path></g><g id="Group_21" data-name="Group 21"><path id="Vector_41" data-name="Vector 41" fill="#b2b2b2" stroke-width="0" d="M271.2,114c.7,0,1.8-1.9,1.8-3.7,0-.4,0-1.6-.5-1.8-.7-.2-2.6,2.1-2.1,4.1,0,.1.3,1.3.8,1.3v.1Z"></path></g><g id="Group_22" data-name="Group 22"><path id="Vector_43" data-name="Vector 43" fill="#b2b2b2" stroke-width="0" d="M253.5,150.9c0-1.2-2.3-2.8-4.7-2.7-1.7.1-3.6,1.1-4,2.7-.2.6,0,1,.8,3.1,1.6,4.4,1.7,4.6,2.1,4.8,2.1.9,6.1-2.8,5.6-4.2-.2-.7-1.5-.7-1.6-1.4-.1-.9,1.7-1.3,1.8-2.4h0v.1Z"></path></g><g id="Group_23" data-name="Group 23"><path id="Vector_45" data-name="Vector 45" fill="#b2b2b2" stroke-width="0" d="M255.5,164.5c1,0,1.7-.8,1.9-1,1.4-1.6,1.3-4.6,0-5.2-1.3-.7-4.3,1.1-4.3,3.3,0,1.3,1,2.9,2.3,2.9h.1Z"></path></g><g id="Group_24" data-name="Group 24"><path id="Vector_47" data-name="Vector 47" fill="#b2b2b2" stroke-width="0" d="M226.7,186.6c2-.9,1.6-1.7,3.1-2.2,1.9-.6,2.6.4,4.2-.3,1.2-.6.9-1.3,2.6-2.8,2-1.8,3.5-1.8,3.6-2.8,0-.7-.6-1.6-1.3-1.8-.9-.3-1.9.2-3.5,1.3-3.3,2.4-3.3,3.4-5.7,5-1.6,1.1-3,1.6-5.8,2.6-1.6.6-2.4.7-3.3.4-1.2-.4-1.3-1.4-2.4-1.5-1,0-2.2.8-2.4,1.7,0,.6.3.7.5,1.6.2,1.2-.3,1.5,0,2.5,0,.2.2,1.1.9,1.7.9.8,2.4,1.1,3,.5s-.3-1.6.3-2.3c.7-.8,2.4.2,3-.6.3-.4-.1-.8.1-1.5.4-.9,1.6-.9,3.3-1.7h0l-.2.2Z"></path></g><g id="Group_25" data-name="Group 25"><path id="Vector_49" data-name="Vector 49" fill="#b2b2b2" stroke-width="0" d="M263.4,194.1c-3-1.3-3.4-1.2-4.1-2-1.9-2.2-.6-4.3-2.5-7.1-1.3-1.9-3.7-3.5-5.3-2.9-1.5.5-1.3,2.6-3,3.2-1.6.6-3.4-.8-3.7-.3-.2.4,1.4,1.5,1.1,2.2-.2.5-1.1.3-1.5.9-.4.6-.2,1.7.4,2.4,1.3,1.6,3.9.2,5,1.6.9,1.1-.2,2.5.6,3.4,1.4,1.5,5.9-.6,6-.3,0,.2-2.1,1.1-4.4,2.3-4.2,2.1-4.7,2.9-4.9,3.6-.3,1.1.2,2.4,1.1,3.2,2.3,1.8,7.2-1.1,7.4-.7.1.2-1.9,2.1-4.8,2.5-2.7.3-3.7-1-7.8-1.1-1.9,0-3.4,0-4,.9-.7,1.1,0,2.9,1.1,3.9,1.2,1.1,2.8.9,3.8.9,1.5-.1,2.2-.6,3.3-.9,3.3-1.1,4.4.9,7.9.4,3.7-.6,5.3-3.3,6.7-2.4,1.1.7.2,2.6,1.3,3.2,1.5.9,5.2-1.2,5.6-3.6.2-1.2-.5-2.1,0-2.6.6-.6,2,.3,2.7-.5.3-.3.2-.5.5-2,.2-1.2.3-1.3.3-1.5.2-2.4-6.4-5.3-8.7-6.3h0l-.1-.4Z"></path></g><g id="Group_26" data-name="Group 26"><path id="Vector_51" data-name="Vector 51" fill="#b2b2b2" stroke-width="0" d="M249.2,196c.4-.3,0-2.1-1.1-2.9-1.2-.8-3-.4-3.2.2-.1.6,1.3,1.4,2.4,2,1,.6,1.6.9,1.9.7h0Z"></path></g><g id="Group_27" data-name="Group 27"><path id="Vector_53" data-name="Vector 53" fill="#b2b2b2" stroke-width="0" d="M287.9,259.5c.2.2,1.8,1.4,2.7.9,1.5-.8.7-5.5-.8-8.9-1.1-2.4-3-5.1-3.8-4.7-.3.1-.4.7-.4,2.3,0,5.6,0,8.6,2.3,10.4h0Z"></path></g><g id="Group_28" data-name="Group 28"><path id="Vector_55" data-name="Vector 55" fill="#b2b2b2" stroke-width="0" d="M284.8,264c-.7-2.2-3.4-3.9-5.8-3.7-3.6.2-5.9,4.5-5.8,7.7,0,1.8.8,1.9,1.6,4.5,1.5,5.1-.6,7.3,1.1,9.6,1.5,2.1,5.3,2.9,7.8,1.4,2.6-1.5,3.6-5.4,2.5-6.6-.6-.7-1.8-.3-2-.9-.3-.9,2.4-2.2,2.2-3.7,0-.7-.7-.8-1.2-1.5-1.5-2,.5-4.3-.3-6.8h-.1Z"></path></g><g id="Group_29" data-name="Group 29"><path id="Vector_57" data-name="Vector 57" fill="#b2b2b2" stroke-width="0" d="M257.7,257.3c-1.2,1.7-.7,4,0,4.1,1,.3,3.7-4.9,2.9-5.7-.4-.4-2,.4-2.8,1.5h0l-.1.1Z"></path></g><g id="Group_30" data-name="Group 30"><path id="Vector_59" data-name="Vector 59" fill="#b2b2b2" stroke-width="0" d="M265.5,224.3c-.5-.3-1.7,1.3-4.5,3-2.5,1.5-2.9,1.1-5,2.5-1.6,1.1-4.7,3.5-4.2,4.8.3.9,2.2,1.1,3.2,1,1.4,0,2.4-.7,2.4-.7,0,0-3.3,1.7-6.5,3.5-3.5,2-3.9,2.6-4.2,3.1-1.2,2.1-1.2,5.5.9,7.3,1,.8,2.8,1.6,3.9.9,1.7-1.1.6-4.7,2.3-5.5.7-.3,1.1.2,1.8,0,1.7-.5,1.5-3.5,2.8-6.9,1.7-4.2,4.1-4.2,6.4-9.7.3-.6,1.3-3.1.7-3.5h0v.2Z"></path></g><g id="Group_31" data-name="Group 31"><path id="Vector_61" data-name="Vector 61" fill="#b2b2b2" stroke-width="0" d="M246.1,221.4c-1.2-.7-6.2,3.8-5.4,5.9.3.9,1.8,1.2,2.8,1,2.9-.6,3.7-6.2,2.6-6.9h0Z"></path></g><g id="Group_32" data-name="Group 32"><path id="Vector_63" data-name="Vector 63" fill="#b2b2b2" stroke-width="0" d="M241.1,231.7c.3-.3.1-1.1-.4-1.4-.7-.5-1.7.2-1.7.6,0,.5,1.7,1.2,2.1.8h0Z"></path></g><g id="Group_33" data-name="Group 33"><path id="Vector_65" data-name="Vector 65" fill="#b2b2b2" stroke-width="0" d="M267.6,218.2c.2.8,1.4,1.3,2.3,1.1,1.5-.4,1.7-3.3,2-6.4.2-2.4-.1-2.7-.3-2.8-.6-.3-1.7.4-1.8,1.2,0,.8,1.1,1,1.3,1.9.4,1.8-3.7,3.4-3.4,5h-.1Z"></path></g><g id="Group_34" data-name="Group 34"><path id="Vector_67" data-name="Vector 67" fill="#b2b2b2" stroke-width="0" d="M236.8,262.3c.9-.9,2.3,0,3.8-.3,2.5-.4,4.5-3.3,5-5.7.5-2.1,0-3.9-1.1-7-1.3-3.9-2.5-4.5-2.1-6.5.5-2.5,2.8-3.6,2.3-4.6-.3-.7-1.8-.9-2.9-.7-4.3.7-6.2,7.1-7.2,6.8-.8-.3.6-4.6-.4-5-.6-.3-1.4,1.1-4,3.4-2.5,2.1-3.9,2.7-3.8,3.9,0,1,1,1.1,1.2,2.2.4,2.4-3.6,4.4-3.1,5.4.3.7,2.7.8,4.4-.4,2.1-1.5,1.7-3.8,3.8-4.8,1.1-.5,2.5-.5,2.7,0,.5.9-3,2.6-2.7,4.6.2,1.8,2.9,2.4,2.7,3.4-.2.9-2.1.4-3.3,1.8-1,1.2-1.4,3.5-.1,4.8,1,1.1,3,1.3,3.8.5.6-.6.3-1.3.9-1.9h0l.1.1Z"></path></g><g id="Group_35" data-name="Group 35"><path id="Vector_69" data-name="Vector 69" fill="#b2b2b2" stroke-width="0" d="M199.4,150.1c.4-.6-.6-1.6-.1-2.4.3-.5,1-.2,2-.7.7-.3,1-.9,1.7-1.9.9-1.3,1.5-2.2,1.2-2.8s-1-.3-1.7-.9c-1-1-.6-2.8-.8-2.8s0,1.2-.8,2-1.7.3-2.1,1c-.5.7.3,1.4,0,2.6-.3,1-.9.9-1.6,2.2-.3.5-1.1,2-.5,3s2.4,1.1,2.8.5h0l-.1.2Z"></path></g><g id="Group_36" data-name="Group 36"><path id="Vector_71" data-name="Vector 71" fill="#b2b2b2" stroke-width="0" d="M206.1,134.9c1.1,1.8,3.6,2.8,4.6,2.1.5-.4.7-1.4.4-1.9-.4-.6-1.4-.2-2-.9-.5-.6-.5-1.7,0-2.1.3-.3.6,0,1.1-.2.9-.4,1.5-2.1,1.1-3.4-.5-1.6-2.2-2.3-2.1-2.6.2-.3,1.9.9,2.8.3.5-.4.2-.9.7-2.2.6-1.5,1.5-1.4,1.6-2.5,0-.7-.4-.9-.5-2.4v-1.1c-.2-1.3-1.6-1.7-2.9-2.8-2-1.8-2.3-4.3-2.6-4.2-.2,0,.1,1.2.3,2.6.2,1.5.6,5.4-1.1,8.5-1,1.8-1.9,1.8-2.3,3.6-.2.9,0,1.3.1,3.6.4,4.4,0,4.7.7,5.7h0l.1-.1Z"></path></g><g id="Group_37" data-name="Group 37"><path id="Vector_73" data-name="Vector 73" fill="#b2b2b2" stroke-width="0" d="M216.3,109.4c.1-.7-1.7-2.3-3.6-1.9-1.2.3-2.1,1.3-2.3,2.5-.3,1.8,1.6,3.2,2.6,3.9,1,.7,2.4,1.3,2.7.9.2-.2-.2-.7,0-1.7,0-.7.2-.7.2-1.2,0-.8-.6-1-.5-1.4.1-.6.9-.6,1-1.1h-.1Z"></path></g><g id="Group_38" data-name="Group 38"><path id="Vector_75" data-name="Vector 75" fill="#b2b2b2" stroke-width="0" d="M209.1,97c.6.7.1,1.3.6,1.8.6.6,1.4,0,2.5.3,1.1.4,1.6,1.4,2,2.4,1.1,2.2.3,3.4,1.3,4.2.6.5.9.1,2.9.4,2.6.4,3.3,1.1,4,.6.8-.6.6-2.6,0-2.8-.5-.2-1.2,1-1.7.7-.3-.1-.2-.5-.5-.9-.7-.9-2.3-.2-2.7-.8-.5-.7,1.2-2.9,1.8-2.7.3.1,0,.8.5,1.5.7,1,2.7,1.6,3.7.6.6-.5.8-1.5.5-2.1-.4-.6-1.1-.3-1.6-.8-.8-.8-.4-2.7.2-2.9.6-.2,1.1,1.9,2.7,2.2.8.1,1.8-.2,2-.8.4-.9-.8-2.4-2.1-2.7-1.1-.3-2,.3-2.3,0-.5-.6,1.2-2.1.7-2.8-.4-.6-2.1-.2-3.4.4-1.3.7-1.3,1.2-2.1,1.3-1.5.2-2.2-1.8-3.6-1.5-1.2.2-1.8,1.9-2.2,1.7-.3-.1.1-.9-.3-1.6-.4-.6-1.4-1-2-.6-.7.4,0,1.5-.8,2.6-.6.9-1.7.9-1.7,1.3s.9.3,1.5,1.1h0l.1-.1Z"></path></g><g id="Group_39" data-name="Group 39"><path id="Vector_77" data-name="Vector 77" fill="#b2b2b2" stroke-width="0" d="M243.1,147.2c.6-.6.4-2.3-.5-3-1.4-1.1-3.9.5-3.9,1.4,0,1.1,3.4,2.6,4.4,1.6h0Z"></path></g><g id="Group_40" data-name="Group 40"><path id="Vector_79" data-name="Vector 79" fill="#b2b2b2" stroke-width="0" d="M233.3,78.1c.8-.9.5-2.5-.2-2.8-1-.5-3.3,1.6-3,2.6.2.7,2.2,1.4,3.2.3h0v-.1Z"></path></g><g id="Group_41" data-name="Group 41"><path id="Vector_81" data-name="Vector 81" fill="#b2b2b2" stroke-width="0" d="M222.2,90c.2.4.9.7,1.3.5,1.1-.3,1.2-2.7.7-3s-2.4,1.5-2,2.4v.1Z"></path></g><g id="Group_42" data-name="Group 42"><path id="Vector_83" data-name="Vector 83" fill="#b2b2b2" stroke-width="0" d="M223.3,86.3c.7-.3.9-1.6.4-2.1-.6-.5-2.1,0-2.2.7,0,.7,1,1.7,1.8,1.3v.1Z"></path></g><g id="Group_43" data-name="Group 43"><path id="Vector_85" data-name="Vector 85" fill="#b2b2b2" stroke-width="0" d="M229.3,91.1c.5-.1,1.1-.8.9-1.2-.2-.8-2.5-1.1-2.8-.6s.8,2.1,1.8,1.8h.1Z"></path></g><g id="Group_44" data-name="Group 44"><path id="Vector_87" data-name="Vector 87" fill="#b2b2b2" stroke-width="0" d="M248,82.9c0-.7-1.2-1.3-1.9-.9-.4.2-.6.6-.5,1.1,0,.5.5,1,.9,1.1.8.2,1.6-.6,1.5-1.3h0Z"></path></g><g id="Group_45" data-name="Group 45"><path id="Vector_89" data-name="Vector 89" fill="#b2b2b2" stroke-width="0" d="M201.3,102.3c.4-.2.8-.6.8-1,0-.8-1.8-1.4-2.4-.9-.3.3-.3.9,0,1.3.3.6,1.1.8,1.7.6h-.1Z"></path></g><g id="Group_46" data-name="Group 46"><path id="Vector_91" data-name="Vector 91" fill="#b2b2b2" stroke-width="0" d="M195.9,155.9c.6,0,1.1-.5,1.2-1.1,0-.6-.5-1.2-1.1-1.2-.5,0-1,.5-1,1,0,.6.3,1.2,1,1.3h-.1Z"></path></g><g id="Group_47" data-name="Group 47"><path id="Vector_93" data-name="Vector 93" fill="#b2b2b2" stroke-width="0" d="M194.6,158.1c.3-.5,0-1.4-.6-1.5-.8-.2-1.8,1.1-1.6,1.6s1.8.7,2.2,0v-.1Z"></path></g><g id="Group_48" data-name="Group 48"><path id="Vector_95" data-name="Vector 95" fill="#b2b2b2" stroke-width="0" d="M192.7,161.2c.1.5,1.9.9,2.3.2.3-.4,0-1.1-.3-1.3-.7-.4-2.1.7-2,1.2v-.1Z"></path></g><g id="Group_49" data-name="Group 49"><path id="Vector_97" data-name="Vector 97" fill="#b2b2b2" stroke-width="0" d="M196.7,151.3c-.1.6.9,1.8,1.8,1.5.8-.3,1.1-1.5.8-2-.5-.7-2.4-.2-2.6.5h0Z"></path></g><g id="Group_50" data-name="Group 50"><path id="Vector_99" data-name="Vector 99" fill="#b2b2b2" stroke-width="0" d="M207.9,137.8c-.5,0-1,.6-.9,1.2.1.5.6.8,1,.7.7,0,1.2-.8,1-1.4-.2-.4-.7-.6-1.1-.5Z"></path></g><g id="Group_51" data-name="Group 51"><path id="Vector_101" data-name="Vector 101" fill="#b2b2b2" stroke-width="0" d="M206.2,141.3c.2-.2,0-1.1-.6-1.2-.4,0-.8.4-.8.7,0,.5,1.2.8,1.4.5h0Z"></path></g><g id="Group_52" data-name="Group 52"><path id="Vector_103" data-name="Vector 103" fill="#b2b2b2" stroke-width="0" d="M252.3,167.4c1-.4,1.2-1.9.8-2.4-.6-.8-3.2,0-3.3.9,0,.7,1.3,2,2.5,1.5Z"></path></g><g id="Group_53" data-name="Group 53"><path id="Vector_105" data-name="Vector 105" fill="#b2b2b2" stroke-width="0" d="M236.9,203.5c-1.2.5-1,2.7-.4,3,.7.3,2.6-1.6,2.2-2.5-.2-.5-1.2-.8-1.8-.5h0Z"></path></g><g id="Group_54" data-name="Group 54"><path id="Vector_107" data-name="Vector 107" fill="#b2b2b2" stroke-width="0" d="M266.5,219.7c-.9-.5-2.7.7-2.6,1.8,0,.5.5,1,1,1.2.6.3,1.3.1,1.8-.3.8-.8.5-2.3-.2-2.7h0Z"></path></g><g id="Group_55" data-name="Group 55"><path id="Vector_109" data-name="Vector 109" fill="#b2b2b2" stroke-width="0" d="M279.4,197.2c1.5-1.8,2.6-3.8,2.4-4s-1.9,1.8-2.6,2.7c-1,1.2-3.1,3.9-2.9,4.1.2.2,1.8-1.2,3.2-2.8h-.1Z"></path></g>', 52);
const $68e622ca3afa7a21$var$_hoisted_59 = [
    $68e622ca3afa7a21$var$_hoisted_7
];
const $68e622ca3afa7a21$var$_hoisted_60 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("path", {
    fill: "#b2b2b2",
    "stroke-width": "0",
    d: "M426.6,417.2h-.1c0-.1-1-3.9-1-3.9h0c0-.1-4.5-7.3-4.5-7.3h0l-2-5h0c0-.1-3.4-3.7-3.4-3.7,0,0-.1-.1-.2-.1h-8.2c-.07,0-.13-.03-.2-.1-.4-.4-2.6-2.6-4.1-5-1.6-2.6-.6-7.3-.6-7.6h0l1.6-3.3s0-.1.1-.1l3.3-2.5,5.1-4c.1-.1.1-.3,0-.4l-2.3-1.8h0l-1.9-2.7h0l-2.8-2.5h0l-4.4-2.5s-.1,0-.1-.1l-2.7-4c-.1-.1,0-.2,0-.3l3.2-2.9,3.8-3.4s.1-.1.1-.2v-1.3c0-.1,0-.2-.1-.2l-3.2-1.9h-.1c-.2-.8-2-6.8-3-7.6s-3.7-4.1-4.1-4.7c0-.1-.1-.1-.2-.1h-3.4c-.2,0-.3-.3-.1-.4.7-.6,1.8-1.6,1.9-2.4.2-1,2.7-2.5,3.3-2.8.1,0,.1-.1.1-.2v-5.3h0c-.3-.5-2.2-2.7-3.3-3.7-.4-.4-2.3-1.3-4.5-2.3h0c-.9.4-2.1.9-3.5,1.8-5.4,3.3-5.9,6.8-9.4,6.8s-2.7-1-4-.4c-1.5.7-2.1,2.7-2.3,4.6.4-.4.6-.7.7-.7.6.4-1.1,5.4-3.2,5.5-1.2.1-1.5-1.4-3.4-1.8-1.7-.4-3.9.2-4.6,1.6-.9,1.6.8,3.3,0,4.2-.9,1-3-.9-4.8,0-2.2,1-1,4.4-3.4,8.3-1.9,3.1-3.5,1.8-5.4,5-2,3.3-1.1,5.3-3.6,9.7-1.6,2.8-2.5,3-2.4,4.3.3,2.9,5,3.3,5.6,6.9.4,2.1-1,3.4,0,4.7.9,1.2,2.5.5,3.2,1.6.9,1.3-1,3-1.1,5.9-.1,3,1.9,6.5,4,6.7,1.2.2,2.5-.8,3.6-1.9h0c.9-1.5,1.9-2.5,2.2-2.8h.1c0-.07-.03-.07-.1,0-.3.4-1.1,1.7-2.2,2.8h0c-.5.8-.9,1.7-1.2,2.8-.7,2.9-.2,6.9,2.1,8.2.3.2.8.4,1.3.4,3.7-.1,6.2-10.4,6.9-10.2.4.1-.9,3.4.5,4.8s3.2.5,3.8.4c4.3-1.1,6.6-5.8,6.9-5.7.1.1-1.2,1.5-1.7,3.6-.9,3.6,1.6,6,.3,7.7-.8,1-1.7.3-3.1,1.3-2.3,1.8-2.5,5.8-1.6,6.2.8.4,2.5-2.7,3.1-2.4.6.3-.1,4.7-2.5,6.5h0c-.2.2-.5.3-.8.4-2.4,1.1-4.9-.6-5.4.3-.7,1.1,3.5,4.3,2.8,5.3-.3.4-1.2.3-1.9,0-2.8-1.1-2.7-5.1-3.9-5.1-1.4-.1-4.4,5.9-2.6,11.2.3.8,1.2,3.4,3.8,5,3.9,2.4,8.6.5,8.7,1.1.3,1.1-15.6,4.2-16.7,11-.1.5.9,2.9,3,7.7,2.3,5.4,3.4,7.9,5.9,10.2,2.6,2.3,4,2.1,4.4,2,1.2-.3,1.8-1.3,2.4-1.1.6.3.9,1.9.3,3-1.1,1.8-5.5,2.2-8.5.5-5-2.9-3.1-10.3-7-11.6-2.5-.8-6.1,1.3-6.7,3.8-1,4.2.3,4.3,2,5.2-.1.1,7.1,4.1,7,4.2,7.3,3.7.4,3.3.2,4-.2.7,4.3,2.7,5.3,5.6s1.8,5.2,2.6,7.1c.3.8.5,1.6.6,2.2s.6,1.5,1.2,2.1l2.4,2.2c.5.6.6,1.5.3,2.3-1.8,4.4-3.3,5.2-4.4,5.2-1.7-.1-2.1-3.6-5.1-4.4-2.8-.8-5.6,1.4-7.2,2.5-1.8,1.3-5.5,4.8-4.6,7.2.8,2,4.2,1.2,6.1,4,1.1,1.6,1.1,3.3,1.1,4.2-.1,4.1-1.6,6.2-3.9,8.5-.2.2.2.3-.4.9.5.6.1,1,.3,1.8.4,1.9,1.5,4.9.7,6.1-.8.7,1.2,1.5-1.3,1.8-3.6.5-6.7.9-8.6,1.4-.4.8-2.7,1.2,4,4,1.7.7,7.5-.6,7.5-.7,12.2-5.6,12.5.7,15.8-5.5,4.3,3.2,5.2-5.8,10.1-4.1l6.8-4c.1,0-.9-3.3,8.2-5.9l-1.5-6.2c-.2-.9.2-1.8,1.1-2.2,1.9-.9,5.3-2.4,7.4-3.4s2.1,0,2.4,1.1l1.9,6c.3.8.3,1.6.2,2.5-.3,2.6-1.1,7.9-1.1,8l8.5,2.3c.2,0,7.1,2.8,9.6,5,3.6,1.9,11.3,10.3,11.3,10.3h1.1c1.2-.1,2.4,0,2.6,0,0-.2-.6-11.9-.6-12.1l-.6-1.2c-.4-.9.1-2,1.1-2.2l1.8-.3,4.2-3.8h0l-1.9-4.9h0l1.4-7.4h0l-1.5-7v-.3l4.1-6v-.2l-.5-2.7h0c0-.1.3-4.5.3-4.5h0c0-.1,3.4-7.8,3.4-7.8,0-.1.1-.1.1-.1l5.3-2.3h.1l1.8-1.6c.1-.1.1-.3,0-.3l-4.4-3.4h-.1c0-.1.5-5.3.5-5.3v-.9l-3.3-2.6s-.1-.1-.1-.2c0-.5.4-2.3-1.1-3.5-1.5-1.3-2.9-.5-3.3-.3l-3.1-.5-2.5-.5h-.1l-4.3-1.1h0l-5.2-1.9s-.1,0-.1-.1l-2.4-2.7h-.1c0-.1-.4-3.8-.4-3.8,0-.07.03-.13.1-.2l2.8-3.2h.1v-3.8h0c0-.1,1.4-1.9,1.4-1.9h0v-3.1h0c0-.1-1.5-3.9-1.5-3.9,0-.1-.1-.1-.1-.1l-7.8-3.5c-.1,0-.1-.1-.1-.2v-4h0c0-.1-1.9-3.9-1.9-3.9h0v-2.3c0-.1,0-.2.2-.2h4l7.6-.6-1.6-1.5-2.5-1.2h0Z"
}, null, -1);
const $68e622ca3afa7a21$var$_hoisted_61 = [
    $68e622ca3afa7a21$var$_hoisted_60
];
const $68e622ca3afa7a21$var$_hoisted_62 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("g", {
    id: "Group_57",
    "data-name": "Group 57"
}, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("path", {
        id: "Vector_115",
        "data-name": "Vector 115",
        fill: "#b2b2b2",
        "stroke-width": "0",
        d: "M274.1,454c1,1.1.6,2.7,1.1,2.8.4,0,.5-1.1,1.2-1.4,1-.3,2.7,1.3,3.4,3.2.8,2.2-.3,3.4.6,4.3,1.1,1.2,3.6,0,4.1,1,.5.9-1.2,2.2-.9,2.8.4.6,3-.1,5.2-1.7,2-1.4,1.7-2.2,3.8-3.8,2.1-1.6,2.8-1.2,4.8-2.8,1.8-1.5,3.3-3.6,2.9-4.1-.2-.3-1.3,0-3.5.7-1.8.5-2.1.8-2.5.6-1-.6.3-2.7-.9-4.5-.9-1.4-2.1-1.2-2.4-2.4-.3-1.3,1-2,.6-3-.2-.6-.9-.9-4.3-1.3-6.2-.7-7.3,0-7.8.5-.8.7-1.2,1.7-1.3,1.8-.7,1.7,0,2.7-.9,3.6-.5.5-1.3.8-2,.7-.9-.2-1.1-1-1.7-.9-.8.1-1.5,1.9-1,2.9.3.6.8.4,1.4,1.1h0l.1-.1Z"
    })
], -1);
const $68e622ca3afa7a21$var$_hoisted_63 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("g", {
    id: "Group_58",
    "data-name": "Group 58"
}, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("path", {
        id: "Vector_117",
        "data-name": "Vector 117",
        fill: "#b2b2b2",
        "stroke-width": "0",
        d: "M320.5,504.4c6.4-.2,12.1,6.3,12.1,6.3l6-5.5,7.3-2.8c1.9-2.1,2.6-3.1,4.4-4.5,1.5-1.2,2.7-2.8,6.8-3.7,2.9,0,4.8-.4,6.9,4,1.1,0,1.2,2,2.6-2.9.5-1.4-2.6-3.2-2.6-3.2-3.4-1.5-.3-6.5-5.8-12.3-1.4-1.7-5.8-5.2-5.3-6.3.5-1.1,1.7-.5,1.9-1.1.3-.7-.7-1.1-8-4.9-.8-.4-2.6-1.2-2.8-1.3-4.6-1.4-3.6-7.8-7.5-9.5-2.1-.9-2.4.7-8.7,1.3-5.3.5-8.6.9-11.3-1.1-2.2-1.6-3.1-4.2-5-4-.1,0-1.1.1-1.5.8-.7,1.2,1.3,2.7,1,3.9-.5,2.2-6.3,2.7-14,4.9-4.2,1.3-7.9,3.9-11.4,7.6-2.3,2.4-.3,3.1-1.7,5.6-1.8,3.3-5.8,3.7-11.9,6.6-6.4,3-11.7,7.3-10.8,9.1.5,1,3,1.3,4.7.6,1.8-.7,2.4-2.4,3.2-2.1.8.3.3,1.9,1.4,3.1.9,1,2.7,1.5,3.7.9,1.2-.7.5-2.3,1.3-4.1,1.8-4.2,9.4-4.5,11.5-4.6,1.4,0,7.3-.3,8,1.7s-4.7,3.9-4.5,7.9c0,2.8,2.8,5,3,5.2,2.1,1.7,4,1.3,4.1,2.2.4,1.8-7.1,3.7-7.8,6.6,6.4-2,13.8-3.8,21.1-4.2,8.1-.5,8.1-.3,9.5-.1h0l.1-.1Z"
    })
], -1);
const $68e622ca3afa7a21$var$_hoisted_64 = [
    $68e622ca3afa7a21$var$_hoisted_62,
    $68e622ca3afa7a21$var$_hoisted_63
];
const $68e622ca3afa7a21$var$_hoisted_65 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("path", {
    id: "Vector_119",
    "data-name": "Vector 119",
    fill: "#b2b2b2",
    "stroke-width": "0",
    d: "M321.5,507.4c-2.5-.2-1.4-.4-9.5.1-7.3.5-14.7,2.2-21.1,4.2v.5c0,1,1.2,2.2,3.6,4.5,1.5,1.5,2.5,2.2,2.3,2.7-.2.7-1.9.1-3.3.7-2.7,1.1-2.1,5.3-3.7,10.4-2,6.1-6.7,12.4-11.2,12.4-1.1,0-1.3-.4-2.5-.3-3.4.3-4.4,3.5-7.5,5.4-3.7,2.2-5.2-.7-10.7.8-6.1,1.7-6.5,5.8-11.2,5.8-3.6,0-5.7-2.5-7.6-1.2-1.5,1-.4,2.7-1.8,4.4-2.4,3-7.4.2-10.8,3.5-.9.9-2.1,2.6-1.6,3.6,1,2.2,8.7-.8,9.8,1.9.6,1.5-.3,3.5-1.4,4.7-2.2,2.5-5.2,1.5-5.9,3.3-.8,1.9,1.3,5.1,2.9,5,1.5,0,2-3.1,3.6-3,1.2,0,1.3,1.8,2.8,2.2.4.1,1.4.3,5.1-2.3,3.1-2.1,3.6-3.1,4.3-2.8,1.3.5,1.7,4.8,0,6.3-1.5,1.2-3.3-.5-7.1.5-1.2.3-3.4.9-3.9,2.4-.7,2.2,2,5.6,4.4,5.6,1.1,0,1.4-.7,2.8-1.4,3.3-1.6,5.3.8,8.3,0,4.1-1.1,3.4-6.4,7.4-7.3,3-.7,5.5,1.9,7.4.4,1-.8.7-1.9,2-2.7,1-.6,2.7-.9,3.7,0,.8.8.8,2.2.4,3-.4.7-.9.7-1.2,1.3-.6,1.1,0,3,1,3.8s1.9.3,4.4.4c.9,0,5.9.2,6.5,2,.3.9-.7,2.3-1.8,2.7-1.9.6-3.2-1.8-4.9-1.4-2,.5-5.1,7.4-2.5,7,10.9-1.8,13.7,3.1,15.1-.4.4-1-.1-2,.6-2.7,1.1-1.1,3.9-.7,5.7.6,2.7,1.9,2.2,5,3.7,9,2.4,6.3,8,9.5,9.6,10.4,7,4,16.2,4.1,17.7,1.1.7-1.3-.2-3.3.9-3.9.8-.4,1.6.2,2.7.3,2.9.1,5.8,0,7-.3,2.4,0-2.2-2.9-4-4-1.3-2.5-2.6-4.7-4.4-8.2v-.4c.4-3.8-.5-4-1.9-5.6s-2.5-2-3.7-2.8c.3-1.2,0-7.4,0-10.5v-8.4c0-1.8,2.4-2.6,3.4-1.1l6.6,9.3,2.2-5.6,2.3-5.7,4.1-10.1c.1-3.2.2-3.1.6-5.2,1.2-2,1.9-2.9,3-4.1,1.1-1.2,1.4-1.5,2.3-2.5,1.3-1.7,3.4-4.2,3.4-5.3,0-1.3-5.9,1.2-9.5-1.6-2.8-2.2-3.1-2.6-2.1-4.3.6-1,2.9-1.6,6.4-2.1,2.5-.3,2.7-.8,3.5-1.5,1.5-1.3.4-5.3-.6-7.9.2-.8,1,.2,1.4-1.5.2-.4,1.2-.9,1.2-1,0,0,.7-.8,1.4-1.7.3-.4,1.6-1.4,1.5-3,0-2.4-.5-2.2-1.8-5.1,0-.7-2.6-1.1-4.4-1.8s-1-1.2-1.5-2.1v-.7c-.3-.4-.5-.7-1-.9s0,0,0,0c-.2,0-.6-.2-.9-.1l-4.3,1.9-6.8,6.9s-6-6.6-10.8-7"
}, null, -1);
const $68e622ca3afa7a21$var$_hoisted_66 = [
    $68e622ca3afa7a21$var$_hoisted_65
];
const $68e622ca3afa7a21$var$_hoisted_67 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("path", {
    fill: "#b2b2b2",
    "stroke-width": "0",
    d: "M511,476.7h0c-1.9-3.9-2.8-5.5-4.3-7.3-1.5-1.7-1.9-1.7-5.6-5-.3-.3-.6-.6-1-.8-3.9-3.5-5.9-5.3-6.9-6.9-1.7-2.9-2-5-4.1-5.9-.9-.3-1.1-.1-3.5,0-4.8.2-7.3.3-9.7-.9-1.3-.7-2.2-1.5-3.1-1.1-1,.4-.9,1.7-1.7,2-1.2.4-3.6-1.6-3.3-2.8.3-1.4,3.9-2.3,6.9-1.4,1.9.6,1.7,1.4,3.5,1.9,2.2.6,3.3-.3,7.6-.9,2.7-.4,4.1-.6,4.8-.4,4.5,1.4,4.3,8.7,8.3,9.4,1.3.2,1.7-.5,3.7-.1.5.1,3.2.6,4.1,2.6.7,1.3.2,2.6.5,2.6.4.1,1.6-1.9,1.5-3.9-.1-2.2-1.5-3.8-2.4-4.8-3-3.6-1.5-4.6-5-11.8-3.4-7-5-6.6-5.8-10.8-.9-4.3-.1-9.2,2-10,1.4-.5,3.1.9,4.1,0,.5-.5.7-1.5.5-2.2-.8-2.8-6.7-2.2-7.7-5.2-.4-1.2.5-1.4.2-2.8-.5-2.8-3.9-2.5-6.1-5.6-2.3-3.3-.1-6.4-2.8-8.7-.8-.7-1.7-1.1-2.1-2.2-.4-1.2.3-2,.4-3,.2-2.1-2.8-3.8-10-8.2-.6-.4-1.2-.7-1.8-1.1h0c-2.2-1.3-4.5-2.6-6.7-4h0c-3.2-2.2-4.3-3.2-6.4-3.2-3.5-.1-6.2,2.9-6.4,2.7s2.2-1.4,3.6-3.8c.3-.5,1.6-2.8,1.3-5.3-.3-3-2.7-4-4.7-6.6-3.4-4.3-.8-7-3.2-18.3-1.2-5.6-3-11.1-3-11.1-1.7-5.1-2.8-7.2-2.1-10.3.5-2.5,1.7-3.3,1.4-5.6-.3-2.7-2.2-3-2.4-5.5-.2-2.7,2-3.2,2.2-6.7.1-1.1-.4-2.6-1.3-5.7-1.3-4.4-2.1-5.1-2.8-5.3-1-.3-1.8.4-2.3-.1-.7-.6.3-1.9-.3-2.7-.7-1-2.7.1-3.6-.8s.1-1.9-.2-3.5c-.5-2.5-3.3-2.4-5.6-5.3-1-1.3-.7-1.5-2.1-5.8-1.9,2.5-3.7,4.2-5.3,5.5-2,1.7-7,5.4-7,5.4-1.5,0-3.3.3-3.8,1.3-.5,1.1.8,2.4,2.5,5.3,2.7,4.3,4,6.4,3.4,8-1,2.7-6.3,1.3-8.2,4.8-1.2,2.1,0,3.9-1.3,4.8-1.6,1.1-3.6-1.9-6.9-1.4-2.8.5-5,3.2-5.8,5.5-.8,2.1,0,2.8-.8,4.4-.6,1.3-1.5,1.8-2.8,2.4,2.2,1,4.1,2,4.5,2.3,1.2,1.1,3.4,3.6,3.4,3.6v5.5s-3.2,1.8-3.4,2.9c-.2,1.1-2.4,2.8-2.4,2.8h4.2s3.1,3.9,4.2,4.7,3.1,7.6,3.1,7.6l3.3,2v1.5l-3.9,3.4-3.3,3.1,2.8,4.2,4.5,2.5,2.8,2.5,2,2.8,2.5,2-5.3,4.2-3.3,2.5-1.7,3.3s-1.1,5,.6,7.6c1.7,2.7,4.2,4.1,4.2,4.1h8.4l3.5,4.7,2,5.1,4.6,7.3,1,3.9,2.5,2.2,1.5,2-7.4,1.1h-4.2v2.5l2,1.9v4.2l8.1,3.6,1.5,3.9v3.1l-1.5,2v3.9l-2.9,3.3.4,3.9,2.5,2.8,5.7,1.5,2,.9,3.8.5s2.8-1.3,4.5,0c2.4,1.3,1.8,4.2,1.8,4.2l3.3,3,1.5,6.7,4.6,3.6-2,1.8-5.4,2.4-3.5,7.8-.3,4.5.6,2.8-4.2,6.3,1.4,7.1-1.4,7.4,2,5,.5,2.5v.8c.1,0,.5,1.9.5,1.9l9.5-6.8c2.1-1.5,5,0,5,2.6v3.3l12.5,2.1c2.2.4,4.4-1,5.1-3.1l2.8-9.3,1-5.9,9.3-13.3,19-18.1c-.3-1.6-.8-2-1.2-2.5h.2Z"
}, null, -1);
const $68e622ca3afa7a21$var$_hoisted_68 = [
    $68e622ca3afa7a21$var$_hoisted_67
];
const $68e622ca3afa7a21$var$_hoisted_69 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("path", {
    id: "Vector_123",
    "data-name": "Vector 123",
    fill: "#b2b2b2",
    "stroke-width": "0",
    d: "M319.7,672.3l-5.9-7.3c-1.7-.6.6.2-10.7-4.1s-1.8-3.9-4.3-4.6,8.1-1.2,6.7-2.6c-2.4-2.4-11-2.4-12.2-4.7-4.5-8.3-6.8-11.3-8.2-12.4-1.6-1.6-2.6-2.6-4.1-4.1l-2.6-.8c-1.2-.4-1.6-1.8-.8-2.8,1.8-2.3,2.1-2.4,4.1-5.2-2.3,0,.9.4-9.5.9-2.7.1,1.5,4.5,0,8.1-1.7,4-6.8,5.3-7,5.4-4.6,1.1-9.2-3.3-9.1-.5,0,2.7.8,6.4-3.2,7.7-2,.7,1.1,4.9,0,7.3-3.2,7.3-15.1,8.3-14,15,.8,4.9-10.3,0-11.7,3.2-1.8,4.3-1.6,6.2-6.6,10.3-6.7,5.6-14,10-15.2,12-.8,1.4-4.5,1.9-6.3-.1-1-1.1-11.5,4.3-12.6,6.2-.1.2-.5.4-.7.9-.4.9-.5,2.5-.2,3.3,1,2.8.2,4,1.1,4.5.3.2.6,0,2.1-.5,3.8-1.4,4-1.1,4.5-1.7,1.6-1.6.4-3.7,1.6-4.3,1-.6,2.2.8,5.5,2.3,4.2,1.9,5.3,1.2,6.2,2.6,1.5,2.2-1,4.6.7,7.4,1,1.6,2.9,2.6,3.6,2.1.8-.5.1-2.2,1.1-2.8.7-.4,1.2.2,2.5,0,1.6-.2,3.3-1.5,3.5-3.1.1-1.2-.6-2.2-.8-2.4-1.5-2-4.6-2.1-4.5-2.2,0,0,1.5.5,3,0,1.9-.5,2.8-2.3,2.9-2.5.6-1.1.2-1.6.5-3.3.1-.8.8-4.5,2.6-4.9,1.2-.3,2.7.8,2.7,1.7s-1.7,1-2.8,2.8c-.3.5-.9,1.5-.5,2.5.5,1.1,2.1,1.8,2.8,1.3,1.1-.6,0-3.1,1.2-3.7.7-.4,1.3.5,2.4.2,1.4-.3,1.4-1.8,2.7-2.3,1.8-.7,3.1,1.5,4.5.9,2.3-.9,1-7.7,3-8.4,1.1-.3,1.9,1.3,3.2,1,1.9-.5,2.4-4.3,2.7-4.2.3,0-.9,3.1.3,4.3s4.3.2,4.9,0c1.2-.4,1.4-.9,2.7-1.2,1.4-.4,2.6-.2,4.6,0,2.5.4,3.8.6,5.2,1.5,1.7,1.1,2.2,2.4,2.8,2.1.6-.2.9-1.9.2-2.9-.9-1.4-3.1-.9-3.3-1.7-.3-1.1,3-3.8,4.7-2.9,1.2.6.6,2.4,2.4,6.3.8,1.7,1.3,2.3,1.6,2.6.5.5,2.3,2.5,4.2,2.2,1.9-.3,2.7-2.5,3.5-2.1.8.3.1,2.5,1.2,3.1,1,.6,2.5-.7,3-.2.6.6-1.5,2.5-.9,4.7.2.9.9,1.9,1.7,2,1.7.2,3-4,3.8-3.7.8.2-.6,4.1,1,5.3,1,.7,2.9.3,3.9-.7,1.8-1.8.2-4.5,2.1-6.3,1-.9,2-.8,2.2-1.7.3-1.1-.8-2.2-1-2.5-.9-1-1.5-.8-2.1-1.7-.8-1.1-.9-2.6-.4-2.9.5-.3,1.7.8,1.8.9.7.6.8,1.2,1.3,2,.7,1.3,1.5,2.7,2.4,2.7,1.6.1,3.4-3.5,2.6-4.4-.4-.4-1.1,0-1.7-.6-.5-.5-.7-1.5-.3-2.1.5-.7,1.5-.3,3-1.2.5-.3,1.1-.6,1.1-1.1,0-.7-1-.9-1.3-1.9-.4-1.2.6-1.8.2-2.7-.5-1.2-2.6-1.4-2.5-1.6,0-.1.9,0,1.7,0s2.8,0,3.7-.7c1.2-1,1.1-3.4.9-4.9-.1-.4-.2-.8-.2-1.1v-.2.2c0,.2.1.6.2,1.1.1.4.3.8.6,1.1.9.9,2.4.8,2.8.8,2-.1,3.4-1.2,4.3-1.9,1.9-1.3.2-1.2,3.1-1.7s1.7-.3,3-.5"
}, null, -1);
const $68e622ca3afa7a21$var$_hoisted_70 = [
    $68e622ca3afa7a21$var$_hoisted_69
];
const $68e622ca3afa7a21$var$_hoisted_71 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("g", {
    id: "Group_60",
    "data-name": "Group 60"
}, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("path", {
        id: "Vector_127-2",
        "data-name": "Vector 127-2",
        fill: "#b2b2b2",
        "stroke-width": "0",
        d: "M446.2,531.4c-.1,0-1.5-6.6-1.5-6.8-1.4.3-3.2,4.8-4,4.9-.8.2-3.8-2.9-3.5-.9l1.8,3.4c-.1,1,.4,14.9,0,16.9,0,.2-4.9,17.4-4.1,22.5l7.7,30.6,3.3,10.6,3.4.5,4.1,7.6,2,7.7c.2.7.7,1.3,1.5,1.6l13.8,4.6c.7.5,2.3.3,3.3.5,1.9.5,1.7,4,4.6,6.1.9.6,2.4-1.4,2.7-1.4,1.3,0,1.6,0,2.6-.3,2.1-.6.7,3.1,3,2.9,2.2-.1,3-5.1,3.3-8.3.1-1.9,1.5-3.2,2.3-4.4.8-1.1,4.5-1.4,5.3-.9.3,0,2.3.6,2.9,1.2,2.5,1,1.8,1,3.4,1.7,1.7.8,4,2.3,7.9,1.6.6-.6,2.7-2.8,4.1-3.4,1.6-.7,2.1-.4,5.3-1.1,3.1-.7,2.9-1,4.2-1,2.3,0,3.1,1.1,4.7.5,1-.4,2-1.2,1.9-1.9,0-.7-1.2-.8-1.2-1.4s1.1-1.3,2.2-1.3c1.6,0,2.1,1.4,3.2,1.2,1.2-.2,2.1-2.1,1.6-2.9-.5-.8-2.1-.5-2.2-1,0-.4,1.2-.7,2.1-1.6,2-2,1.1-6.7-.4-7.3-.4-.1-.7.2-1.9.4-1.7.2-3.1-.3-3.1-.4,0,0,.8.2,1.6-.2,1.3-.6.7-2.2,1.8-3.6,1.3-1.7,3.3-.8,4.3-2.5.8-1.2.4-2.8.6-2.8s0,2.4,1.2,3.3c1.1.8,2.4,0,3,.7.8,1-1.1,3.2-.5,3.9.8,1,5.3-1.1,8.6-4,1.4-1.3,3-2.8,2.8-4.6,0-1.2-.9-2.2-1.5-2.9-.3-.4-1.4-1.6-3.3-2.4-2.5-1.1-4.6-.6-4.6-.9s1.7-1.2,3.7-1c2.6.2,4.2,1.9,4.5,1.5.2-.2-.1-.7-1.2-2.4-1.9-3-2.7-4-2.5-4.2.2-.3,1.5.5,2.3,1,1.1.7,1.5,1.4,2.5,2.5,1.9,2.1,2.9,3.2,3.5,3,1-.3.5-2.9,1.9-3.5.9-.4,1.7.5,2.5,0,1.1-.6.3-2.4,1.4-3.2,1.1-.9,2.3.3,3.5-.5,1.4-.9,1.1-3.5,1.1-3.9-.3-2.8-2.2-4.2-1.6-4.9.4-.6,2.1-.6,3,.2,2.5,2.2-1.3,9.8-.9,10,.3.1,2.5-3.3,3.5-8.4.8-3.8,0-4.7.7-8,.8-4.1,2.6-4,4.7-9.6,1.6-4.1,4.7-12.1,1.7-14.9-.8-.8-2.2-1.3-2.1-1.7h0c.1-.5,2,.1,2.8-.6,1.9-1.6-.9-9.1-5.2-15-3-4.2-6.1-6.6-9.2-9.1-5.9-4.7-6.2-3.2-15.7-9-.6-.4-3.3-2-4-1.3-.4.4.2,1.2,0,1.7-1,1.3-7.4-3.8-15.6-3.7-2.7,0-4.9,0-6.8,1.5-5.4,4.2-2.7,15.7-4.7,16.1-1.2.2-1.9-3.9-5.4-4.8-.6-.2-1.1-.2-1.5-.1-.8,0-1.4.4-2.4,0-3.4-1.3-2.5-6.9-5.6-8.1-2.1-.8-4,1.2-4.8.2-.9-1,.1-3.9,1.6-4.3,1.3-.3,2,1.4,3.6,1.3,1.6,0,2.7-1.8,3.8-3.5,2.2-3.4,1.6-4.7,3.4-6.4,1.6-1.4,2.6-.8,4.1-2,2.6-2.1-4.8-16.2-4.8-18.1l-17.5,16.4-10.2,14.2-2.4,13.5c-.8,4.3-4.8,7.2-9.1,6.5l-1.4-.2-12.6-2.6.2-4.7c0-1.6-1.8-2.6-3.1-1.6l-6.4,5.2"
    })
], -1);
const $68e622ca3afa7a21$var$_hoisted_72 = [
    $68e622ca3afa7a21$var$_hoisted_71
];
const $68e622ca3afa7a21$var$_hoisted_73 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("g", {
    id: "Group_61",
    "data-name": "Group 61"
}, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("path", {
        id: "Vector_129",
        "data-name": "Vector 129",
        fill: "#b2b2b2",
        "stroke-width": "0",
        d: "M418.2,638.7h-1.2c-1.6,0-.9-.1-3.6,0-1.6,0-2.7-.4-4.4-.2-1.6.5-10.2-.9-15.6-1.6s-3.4,1.6-2.7,3.4l.9,4.6c.2.5.2,1.1.1,1.6l-1.2,5.9-7.3,4.6-4.3-2.8c-1.5-1-3.6-.4-4.3,1.3l-4.1,9.2-8,2.1-9.5,6.5-7.3,5c4.4,2.2,6.7,3.4,9,5.9,1.7,2,2.9,4,3.2,4.7,2,3.8,1.9,6.4,2.7,6.4.9,0,2.3-3.5,1.1-4.9-.7-.9-2-.6-2.2-1.3-.3-.8.9-2.1,2.1-2.7,2-1,4.4-.2,5.3.2,1.8.7,1.6,1.2,3.1,1.7,2.6.9,3.4-.4,6,.2,3,.7,3.3,2.7,5.5,2.5,1.4-.1,2.8-1.1,3.4-2.3.9-1.7-.2-2.7.5-3.9,1-1.7,3.5-.7,8.8-2.2,2.8-.8,3-1.4,4.4-1.2h0c2.9.4,4.1,3.2,5.6,2.7s1-3.2,2.8-3.8c1.2-.5,2,.6,3.6,0,1.1-.4,1.1-1,2.2-1.3,1.5-.4,2.1.4,2.9,0,.9-.6,1-2.4.7-3.7-.6-2.7-3.2-4-2.8-4.5.3-.5,1.9,0,2.5.3.6.2,2.2.8,2.8,2.2.6,1.2-.1,1.6.2,2.9.6,2.2,3.1,3.3,5.7,4.3.9.4,3,1.3,3.4.7.5-.6-1.7-2.7-1.2-3.3.2-.3.8-.1,1.7,0,1.7.2,1.9,0,3.9,0,2.5,0,4.2.1,5.7,1.1,1.7,1.1,2.6,2.8,2.3,3.1-.2.3-1.3-.6-2.5,0-.1,0-1,.4-1.1.9-.3,1.4,3.6,4.7,7.2,4.2,2.2-.3,2.2-1.8,5.1-2.9,1-.4,2.2-.7,7.4-.7s4.8.3,7.9.2c5.1-.1,6-.9,10.2-.5,1.6.1,3.3.4,5.1,1,.5.2,1.9.7,3.6,1.6,3.8,2.1,3.7,3.4,6.4,4.4.7.3,3.2,1.2,5.6.3,1.5-.6,2.3-1.5,3.1-2.3,1.2-1.1,2.1-1.5,11.3-4.1,7.4-2.1,8.8-2.4,10.1-4,.9-1.2,1.2-2.3,2.4-2.6,1.6-.4,2.5,1.1,5.9,1.8,1.3.3,3.1.6,4-.3.4-.4.5-.9.7-2.1.7-4,.6-4.3.8-4.9.2-.5.6-1.5,4.5-3.6,3.5-1.9,5.5-2.4,10.2-4.7,2.5-1.3,3.3-1.8,3.9-2.7.3-.5.9-1.5,1-6,.1-4.6-.4-5.3.3-7.2.9-2.5,2.5-3.1,2.2-4h0c-.7-2.1-8.4-1.3-9.7-1.2-5,.5-10.7,1.9-13.5,2.6-3,.8-7,1.9-8.1.3-.5-.8-.2-1.9-1.1-2.5-.6-.4-1.1-.2-2.2,0-1.8.2-4,.4-5.4-.6-.8-.6-1.6-1.8-1.3-2.6.6-1.7,5-.9,5.4-2.4.2-.8-.7-1.9-1.5-2.4-.4-.3-1.7-1-7.4,0-2.3.4-2.4.5-3.3.5h-2.6c-1.6-.6-2.83-1.23-3.7-1.9-1.5-.7-2.9-2.7-5.1-2.5-.6,0-3.1.4-4.2,1.8-.8,1.2-1.2,3.5-1.4,5.4-.3,3.3-2.6,7-4.7,7.2-2.3.1-3.8-3.9-5.9-3.4-1.1.3-1.4,1.5-2.7,1.5-.4,0-.9-.1-1.8-.7-2.9-2.1-2.6-5.1-4.5-5.6h-.9c-.6.1-1,.4-1.5,0l-14.4-4.9c-1-.3-1.7-1.2-2-2.2l-1.9-7.3-3.6-6.7-4.1-.5-2.6,5.5-1.9,1.9-1.3,3.3v6.4l-6.6-.5-12.9,6.7.7-.4Z"
    })
], -1);
const $68e622ca3afa7a21$var$_hoisted_74 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("g", {
    id: "Group_62",
    "data-name": "Group 62"
}, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("path", {
        id: "Vector_131",
        "data-name": "Vector 131",
        fill: "#b2b2b2",
        "stroke-width": "0",
        d: "M425.6,685.1c-1.5-.4-2.5.2-3.7-.6-1-.7-1.2-1.6-1.8-1.5-.7,0-.8,1.4-1.5,1.4-.8,0-1-2.1-2.1-2.4-1.5-.3-3.3,3.8-4.3,3.4-.6-.2,0-1.6-.8-2.2-1.6-1.4-8.2,2.4-7.8,4.3.2.9,2,.5,5.5,2.4,1,.6,2,1.3,3.9,2.7,3.9,2.9,4.2,3.5,5.6,3.7,1.6.2,3.6-.3,4.7-1.6,1.2-1.4.5-2.5,1.8-3.8,1.6-1.6,3.8-.7,4.2-1.8.4-1.1-1.5-3.5-3.7-4.1h0v.1Z"
    })
], -1);
const $68e622ca3afa7a21$var$_hoisted_75 = [
    $68e622ca3afa7a21$var$_hoisted_73,
    $68e622ca3afa7a21$var$_hoisted_74
];
const $68e622ca3afa7a21$var$_hoisted_76 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("path", {
    id: "Vector_133",
    "data-name": "Vector 133",
    fill: "#b2b2b2",
    "stroke-width": "0",
    d: "M665.3,614.9l-10.3,14.3-6.4,8.3-10.3,7.3-21.9,6-11.6,5.8s0-2.5,7.7,6l7.7,8.4,1.3,17.8-1.3,10.6-5.2,13.7-5.2,10.8h-95.9l6.3,11.6h5.7l-9.4,14.2-20.3,7.8s-.2-3.9-5.9,0-22.7,0-22.7,0l-25.6,1.7-19.6-10.8-7.7-9-7.2-6.5-5.9-1.3-7.3,6.5s-7.7,1.3,1.3,7.8l9,6.5,14.9,6.9,1.9,13.8s1.8,3.9,2.2,7.8c.4,3.9,1.9,9,1.9,9l3.2,9.1h242v-184.1h-5.5.1Z"
}, null, -1);
const $68e622ca3afa7a21$var$_hoisted_77 = [
    $68e622ca3afa7a21$var$_hoisted_76
];
const $68e622ca3afa7a21$var$_hoisted_78 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("path", {
    fill: "#b2b2b2",
    "stroke-width": "0",
    d: "M336.5,620.5l4.3-4.3,19.5-15.2c.5-.4,0-1.2-.6-.9l-8.8,5.5c-2.5,1.5-5.3,2.4-8.2,2.4l-6.1-.6c-1.1-.1-2-.8-2.5-1.7l-3.8-7.3v-2.3c0-1.9-.9-3.7-2.3-4.8l-3.1-2.5-.4-4.3-.3-5.6v-5.1c0-1,.8-1.2,1.4-.4l6.9,11.2,11.2-25.6.2-3c.1-1.8.9-3.5,2.1-4.8l4.5-5,2.5-4.3,6.3-1.2,5-1.2c1.1-.3,2.1-.8,2.9-1.6l1.7-1.7,3.1.5,3.7-4.5,4-.5,6.6-4.6,2.2-3.2,7.1-2.2-1.1-5.7c-.2-1.2.4-2.4,1.4-3l4.7-2.5c.6-.3,1.4,0,1.6.7l1.3,6.1c.2.8.2,1.7,0,2.5l-1,4.7c-.3,1.6.6,3.2,2.2,3.6l2,.6,7.9,2.2,3.7,2.2,5.9,3.5,4.3,3.7,4.8,4.1h4.2l-4.4,16-1.8,8.5,1.7,5.3,2.8,11.4,1.1,3.9c.5,4,.9,4.8,1.2,7.2l1.4,4.1,3.5,11.9-6.3,9.5-1.2,6.8-5.1-.4-8.3,5.3c-.9.6-3.6,1.6-4.6,1.6-3.5.2-10.4-.2-10.4-.2,0,0-10.9-.8-16.3-1s-.7,9.1-1.2,11.6-.4,3.4-.4,3.4l-5.6,3.7-2.7-1.7c-2.8-1.8-6.6-.6-7.9,2.5l-3.1,7.5-8.2,2.5-16.2,11.6-4.7-2.6c-3.6-1.3-7.4-1.7-11.2-1.1l-6.9.2-5.7-7.8-10.4-3.9-4-3.4h0c18.7-2.8-5-6.4-6.2-7.9h0l-4-8.2-3.2-3.8-4.1-4.1h0l-3.7-1.6c-.9-.4-1.2-1.6-.6-2.4l1.3-1.6,2.5-3,6.3-.8,3.3-.2c1.6-.1,3.2.2,4.7.9l1.4.6,4,1.2,5.2,1.5c.9.2,1.7.6,2.5,1.1l4,2.5,2.3,1.4c2.4,1.4,5.2,1.9,7.9,1.2s8-4,10.2-12.8l.1-.3Z"
}, null, -1);
const $68e622ca3afa7a21$var$_hoisted_79 = [
    $68e622ca3afa7a21$var$_hoisted_78
];
const $68e622ca3afa7a21$var$_hoisted_80 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("g", null, [
    /*#__PURE__*/ (0, $ani5R.createElementVNode)("g", {
        id: "Group"
    }, [
        /*#__PURE__*/ (0, $ani5R.createElementVNode)("path", {
            id: "Vector",
            fill: "#b2b2b2",
            "stroke-width": "0",
            d: "M234.9,283.3c1.4.9,1.3,2.5,1.9,2.5.8,0,2-2.7,1.2-3.7-.4-.5-1.1-.1-2.5-.8-1.2-.6-1.4-1.1-2-1-.8.2-1.4,1.5-1.1,2.1.3.7,1.4.2,2.5.9h0Z"
        })
    ])
], -1);
function $68e622ca3afa7a21$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("svg", $68e622ca3afa7a21$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("g", {
            id: "ireland",
            onMouseleave: _cache[0] || (_cache[0] = ($event)=>$data.store.selectedRegionPath = ""),
            onMouseenter: _cache[1] || (_cache[1] = ($event)=>$data.store.selectedRegionPath = "ireland"),
            class: (0, $3LSrV.normalizeClass)($data.store.selectedRegionPath == "ireland" ? "is-active" : ""),
            onClick: _cache[2] || (_cache[2] = ($event)=>$options.handleRegionSelect("ireland"))
        }, $68e622ca3afa7a21$var$_hoisted_6, 34),
        (0, $ani5R.createElementVNode)("g", {
            id: "scotland",
            onMouseleave: _cache[3] || (_cache[3] = ($event)=>$data.store.selectedRegionPath = ""),
            onMouseenter: _cache[4] || (_cache[4] = ($event)=>$data.store.selectedRegionPath = "scotland"),
            class: (0, $3LSrV.normalizeClass)($data.store.selectedRegionPath == "scotland" ? "is-active" : ""),
            onClick: _cache[5] || (_cache[5] = ($event)=>$options.handleRegionSelect("scotland"))
        }, $68e622ca3afa7a21$var$_hoisted_59, 34),
        (0, $ani5R.createElementVNode)("g", {
            id: "north_west",
            "data-name": "north west",
            onMouseleave: _cache[6] || (_cache[6] = ($event)=>$data.store.selectedRegionPath = ""),
            onMouseenter: _cache[7] || (_cache[7] = ($event)=>$data.store.selectedRegionPath = "north-west"),
            class: (0, $3LSrV.normalizeClass)($data.store.selectedRegionPath == "north-west" ? "is-active" : ""),
            onClick: _cache[8] || (_cache[8] = ($event)=>$options.handleRegionSelect("north-west"))
        }, $68e622ca3afa7a21$var$_hoisted_61, 34),
        (0, $ani5R.createElementVNode)("g", {
            id: "north-wales",
            onMouseleave: _cache[9] || (_cache[9] = ($event)=>$data.store.selectedRegionPath = ""),
            onMouseenter: _cache[10] || (_cache[10] = ($event)=>$data.store.selectedRegionPath = "north-wales"),
            class: (0, $3LSrV.normalizeClass)($data.store.selectedRegionPath == "north-wales" ? "is-active" : ""),
            onClick: _cache[11] || (_cache[11] = ($event)=>$options.handleRegionSelect("north-wales"))
        }, $68e622ca3afa7a21$var$_hoisted_64, 34),
        (0, $ani5R.createElementVNode)("g", {
            id: "south-wales",
            onMouseleave: _cache[12] || (_cache[12] = ($event)=>$data.store.selectedRegionPath = ""),
            onMouseenter: _cache[13] || (_cache[13] = ($event)=>$data.store.selectedRegionPath = "south-wales"),
            class: (0, $3LSrV.normalizeClass)($data.store.selectedRegionPath == "south-wales" ? "is-active" : ""),
            onClick: _cache[14] || (_cache[14] = ($event)=>$options.handleRegionSelect("south-wales"))
        }, $68e622ca3afa7a21$var$_hoisted_66, 34),
        (0, $ani5R.createElementVNode)("g", {
            id: "north_east",
            "data-name": "north east",
            onMouseleave: _cache[15] || (_cache[15] = ($event)=>$data.store.selectedRegionPath = ""),
            onMouseenter: _cache[16] || (_cache[16] = ($event)=>$data.store.selectedRegionPath = "north-east"),
            class: (0, $3LSrV.normalizeClass)($data.store.selectedRegionPath == "north-east" ? "is-active" : ""),
            onClick: _cache[17] || (_cache[17] = ($event)=>$options.handleRegionSelect("north-east"))
        }, $68e622ca3afa7a21$var$_hoisted_68, 34),
        (0, $ani5R.createElementVNode)("g", {
            id: "south-west",
            onMouseleave: _cache[18] || (_cache[18] = ($event)=>$data.store.selectedRegionPath = ""),
            onMouseenter: _cache[19] || (_cache[19] = ($event)=>$data.store.selectedRegionPath = "south-west"),
            class: (0, $3LSrV.normalizeClass)($data.store.selectedRegionPath == "south-west" ? "is-active" : ""),
            onClick: _cache[20] || (_cache[20] = ($event)=>$options.handleRegionSelect("south-west"))
        }, $68e622ca3afa7a21$var$_hoisted_70, 34),
        (0, $ani5R.createElementVNode)("g", {
            id: "east",
            onClick: _cache[21] || (_cache[21] = ($event)=>$options.handleRegionSelect("east")),
            class: (0, $3LSrV.normalizeClass)($data.store.selectedRegionPath == "east" ? "is-active" : ""),
            onMouseleave: _cache[22] || (_cache[22] = ($event)=>$data.store.selectedRegionPath = ""),
            onMouseenter: _cache[23] || (_cache[23] = ($event)=>$data.store.selectedRegionPath = "east")
        }, $68e622ca3afa7a21$var$_hoisted_72, 34),
        (0, $ani5R.createElementVNode)("g", {
            id: "south-east",
            onMouseleave: _cache[24] || (_cache[24] = ($event)=>$data.store.selectedRegionPath = ""),
            onMouseenter: _cache[25] || (_cache[25] = ($event)=>$data.store.selectedRegionPath = "south-east"),
            class: (0, $3LSrV.normalizeClass)($data.store.selectedRegionPath == "south-east" ? "is-active" : ""),
            onClick: _cache[26] || (_cache[26] = ($event)=>$options.handleRegionSelect("south-east"))
        }, $68e622ca3afa7a21$var$_hoisted_75, 34),
        (0, $ani5R.createElementVNode)("g", {
            id: "france",
            onMouseleave: _cache[27] || (_cache[27] = ($event)=>$data.store.selectedRegionPath = ""),
            onMouseenter: _cache[28] || (_cache[28] = ($event)=>$data.store.selectedRegionPath = "france"),
            class: (0, $3LSrV.normalizeClass)($data.store.selectedRegionPath == "france" ? "is-active" : ""),
            onClick: _cache[29] || (_cache[29] = ($event)=>$options.handleRegionSelect("france"))
        }, $68e622ca3afa7a21$var$_hoisted_77, 34),
        (0, $ani5R.createElementVNode)("g", {
            id: "bristol",
            onMouseleave: _cache[30] || (_cache[30] = ($event)=>$data.store.selectedRegionPath = ""),
            onMouseenter: _cache[31] || (_cache[31] = ($event)=>$data.store.selectedRegionPath = "bristol"),
            class: (0, $3LSrV.normalizeClass)($data.store.selectedRegionPath == "bristol" ? "is-active" : ""),
            onClick: _cache[32] || (_cache[32] = ($event)=>$options.handleRegionSelect("bristol"))
        }, $68e622ca3afa7a21$var$_hoisted_79, 34),
        $68e622ca3afa7a21$var$_hoisted_80
    ]);
}

});

parcelRegister("ffsih", function(module, exports) {

$parcel$export(module.exports, "default", () => $b19e344fdb5fa174$export$2e2bcd8739ae039);
let $b19e344fdb5fa174$var$NOOP = ()=>{};
var $b19e344fdb5fa174$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("fhIcJ", function(module, exports) {

$parcel$export(module.exports, "render", () => $b20abb974ed01971$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $3LSrV = parcelRequire("3LSrV");
const $b20abb974ed01971$var$_hoisted_1 = {
    class: "section-wrapper background-white"
};
const $b20abb974ed01971$var$_hoisted_2 = {
    class: "map-section"
};
const $b20abb974ed01971$var$_hoisted_3 = {
    key: 0,
    class: "loader-wrapper"
};
const $b20abb974ed01971$var$_hoisted_4 = /*#__PURE__*/ (0, $ani5R.createElementVNode)("div", {
    class: "loader"
}, null, -1);
const $b20abb974ed01971$var$_hoisted_5 = [
    $b20abb974ed01971$var$_hoisted_4
];
const $b20abb974ed01971$var$_hoisted_6 = {
    key: 1,
    class: "svgMap-wrapper"
};
const $b20abb974ed01971$var$_hoisted_7 = [
    "id"
];
const $b20abb974ed01971$var$_hoisted_8 = [
    "src"
];
const $b20abb974ed01971$var$_hoisted_9 = {
    class: "svgMap-pop-up-content"
};
const $b20abb974ed01971$var$_hoisted_10 = {
    key: 0,
    class: "svgMap-pop-up-subheading"
};
const $b20abb974ed01971$var$_hoisted_11 = {
    class: "svgMap-pop-up-heading"
};
const $b20abb974ed01971$var$_hoisted_12 = {
    key: 1,
    class: "svgMap-pop-up-subheading"
};
const $b20abb974ed01971$var$_hoisted_13 = [
    "href"
];
const $b20abb974ed01971$var$_hoisted_14 = [
    "href"
];
function $b20abb974ed01971$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SVGMap = (0, $ani5R.resolveComponent)("SVGMap");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $b20abb974ed01971$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("section", $b20abb974ed01971$var$_hoisted_2, [
            $data.regionsLoading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $b20abb974ed01971$var$_hoisted_3, $b20abb974ed01971$var$_hoisted_5)) : (0, $ani5R.createCommentVNode)("", true),
            !$data.regionsLoading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $b20abb974ed01971$var$_hoisted_6, [
                (0, $ani5R.createVNode)(_component_SVGMap),
                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($data.allRegions, (region, index)=>{
                    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                        key: region.id
                    }, [
                        region.acf.region_sales_manager && $data.store.selectedRegionPath == region.slug ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                            key: 0,
                            class: "svgMap-pop-up",
                            id: region.slug
                        }, [
                            region.acf.region_sales_manager?.acf.image ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("img", {
                                key: 0,
                                class: "svgMap-pop-up-image",
                                src: region.acf.region_sales_manager?.acf.image.sizes.thumbnail
                            }, null, 8, $b20abb974ed01971$var$_hoisted_8)) : (0, $ani5R.createCommentVNode)("", true),
                            (0, $ani5R.createElementVNode)("div", $b20abb974ed01971$var$_hoisted_9, [
                                region.name ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $b20abb974ed01971$var$_hoisted_10, (0, $3LSrV.toDisplayString)(region.name), 1)) : (0, $ani5R.createCommentVNode)("", true),
                                (0, $ani5R.createElementVNode)("h2", $b20abb974ed01971$var$_hoisted_11, (0, $3LSrV.toDisplayString)(region.acf.region_sales_manager?.post_title), 1),
                                region.acf.region_sales_manager?.acf.role ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $b20abb974ed01971$var$_hoisted_12, (0, $3LSrV.toDisplayString)(region.acf.region_sales_manager?.acf.role), 1)) : (0, $ani5R.createCommentVNode)("", true),
                                region.acf.region_sales_manager?.acf.phone ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                                    key: 2,
                                    href: `tel:${region.acf.region_sales_manager?.acf.phone}`
                                }, (0, $3LSrV.toDisplayString)(region.acf.region_sales_manager?.acf.phone), 9, $b20abb974ed01971$var$_hoisted_13)) : (0, $ani5R.createCommentVNode)("", true),
                                region.acf.region_sales_manager?.acf.email ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                                    key: 3,
                                    class: "email",
                                    href: `mailto:${region.acf.region_sales_manager?.acf.email}`
                                }, (0, $3LSrV.toDisplayString)(region.acf.region_sales_manager?.acf.email), 9, $b20abb974ed01971$var$_hoisted_14)) : (0, $ani5R.createCommentVNode)("", true)
                            ])
                        ], 8, $b20abb974ed01971$var$_hoisted_7)) : (0, $ani5R.createCommentVNode)("", true)
                    ]);
                }), 128))
            ])) : (0, $ani5R.createCommentVNode)("", true)
        ])
    ]);
}

});

parcelRegister("2anfQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $193e8dcdaa5272bb$export$2e2bcd8739ae039);
let $193e8dcdaa5272bb$var$NOOP = ()=>{};
var $193e8dcdaa5272bb$export$2e2bcd8739ae039 = (script)=>{};

});

// globalThis.__VUE_OPTIONS_API__ = true;
// globalThis.__VUE_PROD_DEVTOOLS__ = false;
parcelRequire("ey4ci");
var $dDLnc = parcelRequire("dDLnc");
// lazy-value by sindresorhus
var $bf8cfc1460a46dce$export$2e2bcd8739ae039 = (fn)=>{
    let called = false;
    let result;
    return ()=>{
        if (!called) {
            called = true;
            result = fn();
        }
        return result;
    };
};


class $d62581baafc08af4$export$6c0517834721cef7 {
    static isServer() {
        return typeof document === "undefined";
    }
}


function $fdba17075e748ef3$export$525e1b7a5f1b82d2(options) {
    const googleMapScript = document.createElement("SCRIPT");
    if (typeof options !== "object") throw new Error("options should  be an object");
    // libraries
    /* eslint-disable no-prototype-builtins */ if (Array.prototype.isPrototypeOf(options.libraries)) options.libraries = options.libraries.join(",");
    if (!options.v) options.v = 3.47;
    options["callback"] = "vueGoogleMapsInit";
    let baseUrl = "https://maps.googleapis.com/maps/api/js?";
    let url = baseUrl + Object.keys(options).map((key)=>encodeURIComponent(key) + "=" + encodeURIComponent(options[key])).join("&");
    googleMapScript.setAttribute("src", url);
    googleMapScript.setAttribute("async", "");
    googleMapScript.setAttribute("defer", "");
    return googleMapScript;
}


let $eab4f362b266ff91$var$isApiSetUp = false;
function $eab4f362b266ff91$export$c252d38e271f16f7(options) {
    if ((0, $d62581baafc08af4$export$6c0517834721cef7).isServer()) return;
    if (!$eab4f362b266ff91$var$isApiSetUp) {
        $eab4f362b266ff91$var$isApiSetUp = true;
        const googleMapScript = (0, $fdba17075e748ef3$export$525e1b7a5f1b82d2)(options);
        document.head.appendChild(googleMapScript);
    } else throw new Error("You already started the loading of google maps");
}


parcelRequire("ey4ci");
var $dDLnc = parcelRequire("dDLnc");

var $1urVZ = parcelRequire("1urVZ");
const $fadb064e15c9d9f5$var$props = {
    draggable: {
        type: Boolean
    },
    editable: {
        type: Boolean
    },
    options: {
        twoWay: false,
        type: Object
    },
    path: {
        type: Array,
        twoWay: true
    }
};
const $fadb064e15c9d9f5$var$events = [
    "click",
    "dblclick",
    "drag",
    "dragend",
    "dragstart",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "rightclick"
];
var $fadb064e15c9d9f5$export$2e2bcd8739ae039 = (0, $1urVZ.default)({
    mappedProps: $fadb064e15c9d9f5$var$props,
    props: {
        deepWatch: {
            type: Boolean,
            default: false
        }
    },
    events: $fadb064e15c9d9f5$var$events,
    name: "polyline",
    ctr: ()=>google.maps.Polyline,
    afterCreate () {
        let clearEvents = ()=>{};
        this.$watch("path", (path)=>{
            if (path) {
                clearEvents();
                this.$polylineObject.setPath(path);
                const mvcPath = this.$polylineObject.getPath();
                const eventListeners = [];
                const updatePaths = ()=>{
                    this.$emit("path_changed", this.$polylineObject.getPath());
                };
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("insert_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("remove_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("set_at", updatePaths)
                ]);
                clearEvents = ()=>{
                    eventListeners.map(([obj, listenerHandle] // eslint-disable-line no-unused-vars
                    )=>google.maps.event.removeListener(listenerHandle));
                };
            }
        }, {
            deep: this.deepWatch,
            immediate: true
        });
    }
});



var $1urVZ = parcelRequire("1urVZ");
const $0b3ab13388046781$var$props = {
    draggable: {
        type: Boolean
    },
    editable: {
        type: Boolean
    },
    options: {
        type: Object
    },
    path: {
        type: Array,
        twoWay: true,
        noBind: true
    },
    paths: {
        type: Array,
        twoWay: true,
        noBind: true
    }
};
const $0b3ab13388046781$var$events = [
    "click",
    "dblclick",
    "drag",
    "dragend",
    "dragstart",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "rightclick"
];
var $0b3ab13388046781$export$2e2bcd8739ae039 = (0, $1urVZ.default)({
    props: {
        deepWatch: {
            type: Boolean,
            default: false
        }
    },
    events: $0b3ab13388046781$var$events,
    mappedProps: $0b3ab13388046781$var$props,
    name: "polygon",
    ctr: ()=>google.maps.Polygon,
    beforeCreate (options) {
        if (!options.path) delete options.path;
        if (!options.paths) delete options.paths;
    },
    afterCreate (inst) {
        let clearEvents = ()=>{};
        // Watch paths, on our own, because we do not want to set either when it is
        // empty
        this.$watch("paths", (paths)=>{
            if (paths) {
                clearEvents();
                inst.setPaths(paths);
                const updatePaths = ()=>{
                    this.$emit("paths_changed", inst.getPaths());
                };
                const eventListeners = [];
                const mvcArray = inst.getPaths();
                for(let i = 0; i < mvcArray.getLength(); i++){
                    let mvcPath = mvcArray.getAt(i);
                    eventListeners.push([
                        mvcPath,
                        mvcPath.addListener("insert_at", updatePaths)
                    ]);
                    eventListeners.push([
                        mvcPath,
                        mvcPath.addListener("remove_at", updatePaths)
                    ]);
                    eventListeners.push([
                        mvcPath,
                        mvcPath.addListener("set_at", updatePaths)
                    ]);
                }
                eventListeners.push([
                    mvcArray,
                    mvcArray.addListener("insert_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcArray,
                    mvcArray.addListener("remove_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcArray,
                    mvcArray.addListener("set_at", updatePaths)
                ]);
                clearEvents = ()=>{
                    eventListeners.map(([obj, listenerHandle] // eslint-disable-line no-unused-vars
                    )=>google.maps.event.removeListener(listenerHandle));
                };
            }
        }, {
            deep: this.deepWatch,
            immediate: true
        });
        this.$watch("path", (path)=>{
            if (path) {
                clearEvents();
                inst.setPaths(path);
                const mvcPath = inst.getPath();
                const eventListeners = [];
                const updatePaths = ()=>{
                    this.$emit("path_changed", inst.getPath());
                };
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("insert_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("remove_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("set_at", updatePaths)
                ]);
                clearEvents = ()=>{
                    eventListeners.map(([obj, listenerHandle] // eslint-disable-line no-unused-vars
                    )=>google.maps.event.removeListener(listenerHandle));
                };
            }
        }, {
            deep: this.deepWatch,
            immediate: true
        });
    }
});



var $1urVZ = parcelRequire("1urVZ");
const $50d44b2daf10dca6$var$props = {
    center: {
        type: Object,
        twoWay: true,
        required: true
    },
    radius: {
        type: Number,
        twoWay: true
    },
    draggable: {
        type: Boolean,
        default: false
    },
    editable: {
        type: Boolean,
        default: false
    },
    options: {
        type: Object,
        twoWay: false
    }
};
const $50d44b2daf10dca6$var$events = [
    "click",
    "dblclick",
    "drag",
    "dragend",
    "dragstart",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "rightclick"
];
var $50d44b2daf10dca6$export$2e2bcd8739ae039 = (0, $1urVZ.default)({
    mappedProps: $50d44b2daf10dca6$var$props,
    name: "circle",
    ctr: ()=>google.maps.Circle,
    events: $50d44b2daf10dca6$var$events
});



var $1urVZ = parcelRequire("1urVZ");
const $8af248f7a352323c$var$props = {
    bounds: {
        type: Object,
        twoWay: true
    },
    draggable: {
        type: Boolean,
        default: false
    },
    editable: {
        type: Boolean,
        default: false
    },
    options: {
        type: Object,
        twoWay: false
    }
};
const $8af248f7a352323c$var$events = [
    "click",
    "dblclick",
    "drag",
    "dragend",
    "dragstart",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "rightclick"
];
var $8af248f7a352323c$export$2e2bcd8739ae039 = (0, $1urVZ.default)({
    mappedProps: $8af248f7a352323c$var$props,
    name: "rectangle",
    ctr: ()=>google.maps.Rectangle,
    events: $8af248f7a352323c$var$events
});


let $a4342518e9062702$var$script;



let $a4342518e9062702$var$initialize = ()=>{
    $a4342518e9062702$var$script = (parcelRequire("6RNdh"));
    if ($a4342518e9062702$var$script.__esModule) $a4342518e9062702$var$script = $a4342518e9062702$var$script.default;
    $a4342518e9062702$var$script.render = (parcelRequire("agJEu")).render;
    (parcelRequire("hTatZ")).default($a4342518e9062702$var$script);
    $a4342518e9062702$var$script.__scopeId = "data-v-54a4b4";
    $a4342518e9062702$var$script.__file = "marker.vue";
};
$a4342518e9062702$var$initialize();
var $a4342518e9062702$export$2e2bcd8739ae039 = $a4342518e9062702$var$script;


let $cad5231a8facae96$var$script;



let $cad5231a8facae96$var$initialize = ()=>{
    $cad5231a8facae96$var$script = (parcelRequire("d3luP"));
    if ($cad5231a8facae96$var$script.__esModule) $cad5231a8facae96$var$script = $cad5231a8facae96$var$script.default;
    $cad5231a8facae96$var$script.render = (parcelRequire("4w9lx")).render;
    (parcelRequire("hsVOs")).default($cad5231a8facae96$var$script);
    $cad5231a8facae96$var$script.__scopeId = "data-v-1acbb9";
    $cad5231a8facae96$var$script.__file = "cluster.vue";
};
$cad5231a8facae96$var$initialize();
var $cad5231a8facae96$export$2e2bcd8739ae039 = $cad5231a8facae96$var$script;


let $87d5a624f9182b05$var$script;



let $87d5a624f9182b05$var$initialize = ()=>{
    $87d5a624f9182b05$var$script = (parcelRequire("bpTnL"));
    if ($87d5a624f9182b05$var$script.__esModule) $87d5a624f9182b05$var$script = $87d5a624f9182b05$var$script.default;
    $87d5a624f9182b05$var$script.render = (parcelRequire("6fEZy")).render;
    (parcelRequire("27Bgx")).default($87d5a624f9182b05$var$script);
    $87d5a624f9182b05$var$script.__scopeId = "data-v-6643c3";
    $87d5a624f9182b05$var$script.__file = "infoWindow.vue";
};
$87d5a624f9182b05$var$initialize();
var $87d5a624f9182b05$export$2e2bcd8739ae039 = $87d5a624f9182b05$var$script;


let $d8c419c978404cb6$var$script;




let $d8c419c978404cb6$var$initialize = ()=>{
    $d8c419c978404cb6$var$script = (parcelRequire("6CUJS"));
    if ($d8c419c978404cb6$var$script.__esModule) $d8c419c978404cb6$var$script = $d8c419c978404cb6$var$script.default;
    $d8c419c978404cb6$var$script.render = (parcelRequire("lXrCn")).render;
    $d8c419c978404cb6$var$script.__cssModules = {};
    (parcelRequire("5828B")).default($d8c419c978404cb6$var$script);
    $d8c419c978404cb6$var$script.__scopeId = "data-v-4c6d24";
    $d8c419c978404cb6$var$script.__file = "map.vue";
};
$d8c419c978404cb6$var$initialize();
var $d8c419c978404cb6$export$2e2bcd8739ae039 = $d8c419c978404cb6$var$script;



var $1urVZ = parcelRequire("1urVZ");
const $729ce053c07ba377$var$props = {
    options: {
        type: Object,
        twoWay: false,
        default: ()=>{}
    },
    data: {
        type: Array,
        twoWay: true
    }
};
const $729ce053c07ba377$var$events = [];
var $729ce053c07ba377$export$2e2bcd8739ae039 = (0, $1urVZ.default)({
    mappedProps: $729ce053c07ba377$var$props,
    name: "heatmap",
    ctr: ()=>google.maps.visualization.HeatmapLayer,
    events: $729ce053c07ba377$var$events
});


let $c8afb7cf5ff4fd09$var$script;



let $c8afb7cf5ff4fd09$var$initialize = ()=>{
    $c8afb7cf5ff4fd09$var$script = (parcelRequire("ky2Qc"));
    if ($c8afb7cf5ff4fd09$var$script.__esModule) $c8afb7cf5ff4fd09$var$script = $c8afb7cf5ff4fd09$var$script.default;
    $c8afb7cf5ff4fd09$var$script.render = (parcelRequire("f44vf")).render;
    (parcelRequire("7LMY6")).default($c8afb7cf5ff4fd09$var$script);
    $c8afb7cf5ff4fd09$var$script.__scopeId = "data-v-b5d82e";
    $c8afb7cf5ff4fd09$var$script.__file = "autocomplete.vue";
};
$c8afb7cf5ff4fd09$var$initialize();
var $c8afb7cf5ff4fd09$export$2e2bcd8739ae039 = $c8afb7cf5ff4fd09$var$script;



var $buWLO = parcelRequire("buWLO");

var $1urVZ = parcelRequire("1urVZ");

var $k22jf = parcelRequire("k22jf");

let $9436fa9da8111cb0$var$GMapApi = null;
function $9436fa9da8111cb0$export$2e2bcd8739ae039(Vue, options) {
    options = {
        installComponents: true,
        autobindAllEvents: false,
        ...options
    };
    $9436fa9da8111cb0$var$GMapApi = (0, $dDLnc.createApp)({
        data: function() {
            return {
                gmapApi: null
            };
        }
    });
    const defaultResizeBus = (0, $dDLnc.createApp)();
    // Use a lazy to only load the API when
    // a VGM component is loaded
    let gmapApiPromiseLazy = $9436fa9da8111cb0$var$makeGMapApiPromiseLazy(options);
    Vue.mixin({
        created () {
            this.$gmapDefaultResizeBus = defaultResizeBus;
            this.$gmapOptions = options;
            this.$gmapApiPromiseLazy = gmapApiPromiseLazy;
        }
    });
    Vue.$gmapDefaultResizeBus = defaultResizeBus;
    Vue.$gmapApiPromiseLazy = gmapApiPromiseLazy;
    if (options.installComponents) {
        Vue.component("GMapMap", (0, $d8c419c978404cb6$export$2e2bcd8739ae039));
        Vue.component("GMapMarker", (0, $a4342518e9062702$export$2e2bcd8739ae039));
        Vue.component("GMapInfoWindow", (0, $87d5a624f9182b05$export$2e2bcd8739ae039));
        Vue.component("GMapCluster", (0, $cad5231a8facae96$export$2e2bcd8739ae039));
        Vue.component("GMapPolyline", (0, $fadb064e15c9d9f5$export$2e2bcd8739ae039));
        Vue.component("GMapPolygon", (0, $0b3ab13388046781$export$2e2bcd8739ae039));
        Vue.component("GMapCircle", (0, $50d44b2daf10dca6$export$2e2bcd8739ae039));
        Vue.component("GMapRectangle", (0, $8af248f7a352323c$export$2e2bcd8739ae039));
        Vue.component("GMapAutocomplete", (0, $c8afb7cf5ff4fd09$export$2e2bcd8739ae039));
        Vue.component("GMapHeatmap", (0, $729ce053c07ba377$export$2e2bcd8739ae039));
    }
}
function $9436fa9da8111cb0$var$makeGMapApiPromiseLazy(options) {
    // Things to do once the API is loaded
    function onApiLoaded() {
        $9436fa9da8111cb0$var$GMapApi.gmapApi = {};
        return window.google;
    }
    if (options.load) // If library should load the API
    return (0, $bf8cfc1460a46dce$export$2e2bcd8739ae039)(()=>{
        // Load the
        // This will only be evaluated once
        if ((0, $d62581baafc08af4$export$6c0517834721cef7).isServer()) return new Promise(()=>{}).then(onApiLoaded);
        else return new Promise((resolve, reject)=>{
            try {
                window["vueGoogleMapsInit"] = resolve;
                (0, $eab4f362b266ff91$export$c252d38e271f16f7)(options.load);
            } catch (err) {
                reject(err);
            }
        }).then(onApiLoaded);
    });
    else {
        // If library should not handle API, provide
        // end-users with the global `vueGoogleMapsInit: () => undefined`
        // when the Google Maps API has been loaded
        const promise = new Promise((resolve)=>{
            if ((0, $d62581baafc08af4$export$6c0517834721cef7).isServer()) return;
            window["vueGoogleMapsInit"] = resolve;
        }).then(onApiLoaded);
        return (0, $bf8cfc1460a46dce$export$2e2bcd8739ae039)(()=>promise);
    }
}


let $552fee0b0f851a0b$var$script;



let $552fee0b0f851a0b$var$initialize = ()=>{
    $552fee0b0f851a0b$var$script = (parcelRequire("8vTj4"));
    if ($552fee0b0f851a0b$var$script.__esModule) $552fee0b0f851a0b$var$script = $552fee0b0f851a0b$var$script.default;
    $552fee0b0f851a0b$var$script.render = (parcelRequire("hDUKP")).render;
    (parcelRequire("16hh2")).default($552fee0b0f851a0b$var$script);
    $552fee0b0f851a0b$var$script.__scopeId = "data-v-e087a8";
    $552fee0b0f851a0b$var$script.__file = "VueWooSearch.vue";
};
$552fee0b0f851a0b$var$initialize();
var $552fee0b0f851a0b$export$2e2bcd8739ae039 = $552fee0b0f851a0b$var$script;


let $c02927dea892856c$var$script;



let $c02927dea892856c$var$initialize = ()=>{
    $c02927dea892856c$var$script = (parcelRequire("jlDH2"));
    if ($c02927dea892856c$var$script.__esModule) $c02927dea892856c$var$script = $c02927dea892856c$var$script.default;
    $c02927dea892856c$var$script.render = (parcelRequire("jFcsw")).render;
    (parcelRequire("dt9Bz")).default($c02927dea892856c$var$script);
    $c02927dea892856c$var$script.__scopeId = "data-v-268b6f";
    $c02927dea892856c$var$script.__file = "VueWhereToView.vue";
};
$c02927dea892856c$var$initialize();
var $c02927dea892856c$export$2e2bcd8739ae039 = $c02927dea892856c$var$script;


let $83e3eca2072f01b9$var$script;



let $83e3eca2072f01b9$var$initialize = ()=>{
    $83e3eca2072f01b9$var$script = (parcelRequire("adWSZ"));
    if ($83e3eca2072f01b9$var$script.__esModule) $83e3eca2072f01b9$var$script = $83e3eca2072f01b9$var$script.default;
    $83e3eca2072f01b9$var$script.render = (parcelRequire("fhIcJ")).render;
    (parcelRequire("2anfQ")).default($83e3eca2072f01b9$var$script);
    $83e3eca2072f01b9$var$script.__scopeId = "data-v-992d74";
    $83e3eca2072f01b9$var$script.__file = "VueSalesManagerMap.vue";
};
$83e3eca2072f01b9$var$initialize();
var $83e3eca2072f01b9$export$2e2bcd8739ae039 = $83e3eca2072f01b9$var$script;


const $050cabe060aa1d86$var$searchApp = (0, $dDLnc.createApp)((0, $552fee0b0f851a0b$export$2e2bcd8739ae039));
const $050cabe060aa1d86$var$salesManagerMapApp = (0, $dDLnc.createApp)((0, $83e3eca2072f01b9$export$2e2bcd8739ae039));
const $050cabe060aa1d86$var$whereToViewApp = (0, $dDLnc.createApp)((0, $c02927dea892856c$export$2e2bcd8739ae039)).use((0, $9436fa9da8111cb0$export$2e2bcd8739ae039), {
    load: {
        key: "AIzaSyBv1OoJYBvAm53BKnOcc_nuV4ixeMQNWl8"
    }
});
if (document.getElementById("where-to-view-app")) $050cabe060aa1d86$var$whereToViewApp.mount("#where-to-view-app");
if (document.getElementById("sales-manager-map-app")) $050cabe060aa1d86$var$salesManagerMapApp.mount("#sales-manager-map-app");
if (document.getElementById("search-app")) $050cabe060aa1d86$var$searchApp.mount("#search-app");

})();
//# sourceMappingURL=index.js.map
